/* tslint:disable:quotemark */

/* tslint:disable:max-line-length */

// DO NOT EDIT OR CHANGE THIS FILE!!

import { AvailableTranslations } from '../../api';

const translations: AvailableTranslations = {
  "defaults": {
    "newEmail.text": "New Email Address",
    "newEmail.error": "This email is incorrect",
    "localsME.label": "Montenegro",
    "localsMF.label": "Reunion",
    "localsRS.label": "Serbia",
    "localsTP.label": "East Timor",
    "localsAD.label": "Andorra",
    "localsAE.label": "Vereinigte Arabische Emirate",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua und Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albanien",
    "localsAM.label": "Armenien",
    "localsAN.label": "Niederländische Antillen",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarktis",
    "localsAR.label": "Argentinien",
    "localsAS.label": "Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australien",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Aserbaidschan",
    "localsBA.label": "Bosnien-Herzegowina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgien",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "Bulgarien",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermudas",
    "localsBN.label": "Brunei",
    "localsBO.label": "Bolivien",
    "localsBR.label": "Brasilien",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet-Inseln",
    "localsBW.label": "Botswana",
    "localsBY.label": "Weißrussland",
    "localsBZ.label": "Belize",
    "localsCA.label": "Kanada",
    "localsCC.label": "Kokosinseln",
    "localsCD.label": "Demokratische Republik Kongo (ehemals ZR: Zaire)",
    "localsCF.label": "Zentralafrikanische Republik",
    "localsCG.label": "Kongo",
    "localsCH.label": "Schweiz",
    "localsCI.label": "Elfenbeinküste",
    "localsCK.label": "Cook-Inseln",
    "localsCL.label": "Chile",
    "localsCM.label": "Kamerun",
    "localsCN.label": "China",
    "localsCO.label": "Kolumbien",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Serbien und Montenegro (früher Tschechoslowakei)",
    "localsCU.label": "Kuba",
    "localsCV.label": "Kap Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Zypern",
    "localsCZ.label": "Tschechische Republik",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibuti",
    "localsDK.label": "Dänemark",
    "localsDM.label": "Dominika",
    "localsDO.label": "Dominikanische Republik",
    "localsDZ.label": "Algerien",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Estland",
    "localsEG.label": "Ägypten",
    "localsEH.label": "Westsahara",
    "localsER.label": "Eritrea",
    "localsES.label": "Spanien",
    "localsET.label": "Äthiopien",
    "localsFI.label": "Finnland",
    "localsFJ.label": "Fidschi-Inseln",
    "localsFK.label": "Falkland-Inseln",
    "localsFM.label": "Mikronesien",
    "localsFO.label": "Färöer Inseln",
    "localsFR.label": "Frankreich",
    "localsFX.label": "Frankreich (nur Europa)",
    "localsGA.label": "Gabun",
    "localsGB.label": "Großbritannien (UK)",
    "localsGD.label": "Grenada",
    "localsGE.label": "Georgien",
    "localsGF.label": "französisch Guyana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Grönland",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Äquatorial Guinea",
    "localsGR.label": "Griechenland",
    "localsGS.label": "South Georgia und South Sandwich Islands",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong",
    "localsHM.label": "Heard und McDonald Islands",
    "localsHN.label": "Honduras",
    "localsHR.label": "Kroatien",
    "localsHT.label": "Haiti",
    "localsHU.label": "Ungarn",
    "localsID.label": "Indonesien",
    "localsIE.label": "Irland",
    "localsIL.label": "Israel",
    "localsIN.label": "Indien",
    "localsIO.label": "Britisch-Indischer Ozean",
    "localsIQ.label": "Irak",
    "localsIR.label": "Iran",
    "localsIS.label": "Island",
    "localsIT.label": "Italien",
    "localsJM.label": "Jamaika",
    "localsJO.label": "Jordanien",
    "localsJP.label": "Japan",
    "localsKE.label": "Kenia",
    "localsKG.label": "Kirgisistan",
    "localsKH.label": "Kambodscha",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Komoren",
    "localsKN.label": "St. Kitts Nevis Anguilla",
    "localsKP.label": "Nordkorea",
    "localsKR.label": "Südkorea",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Kaiman-Inseln",
    "localsKZ.label": "Kasachstan",
    "localsLA.label": "Laos",
    "localsLB.label": "Libanon",
    "localsLC.label": "Saint Lucia",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Litauen",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Lettland",
    "localsLY.label": "Libyen",
    "localsMA.label": "Marokko",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldavien",
    "localsMG.label": "Madagaskar",
    "localsMH.label": "Marshall-Inseln",
    "localsMK.label": "Mazedonien",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar",
    "localsMN.label": "Mongolei",
    "localsMO.label": "Macao",
    "localsMP.label": "Marianen",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretanien",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Malediven",
    "localsMW.label": "Malawi",
    "localsMX.label": "Mexiko",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mocambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "Neukaledonien",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk-Inseln",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Niederlande",
    "localsNO.label": "Norwegen",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "Neuseeland",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama",
    "localsPE.label": "Peru",
    "localsPF.label": "Französisch-Polynesien",
    "localsPG.label": "Papua Neuguinea",
    "localsPH.label": "Philippinen",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polen",
    "localsPM.label": "St. Pierre und Miquelon",
    "localsPN.label": "Pitcairn",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palästinensische Selbstverwaltungsgebiete",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "Rumänien",
    "localsRU.label": "Russland",
    "localsRW.label": "Ruanda",
    "localsSA.label": "Saudi-Arabien",
    "localsSB.label": "Solomon-Inseln",
    "localsSC.label": "Seychellen",
    "localsSD.label": "Sudan",
    "localsSE.label": "Schweden",
    "localsSG.label": "Singapur",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slowenien",
    "localsSJ.label": "Svalbard und Jan Mayen Islands",
    "localsSK.label": "Slowakei (Slowakische Republik)",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Senegal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Surinam",
    "localsST.label": "Sao Tome",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syrien",
    "localsSZ.label": "Swasiland",
    "localsTC.label": "Turks- und Kaikos-Inseln",
    "localsTD.label": "Tschad",
    "localsTF.label": "Französisches Süd-Territorium",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand",
    "localsTJ.label": "Tadschikistan",
    "localsTK.label": "Tokelau",
    "localsTL.label": "Ost-Timor",
    "localsTM.label": "Turkmenistan",
    "localsTN.label": "Tunesien",
    "localsTO.label": "Tonga",
    "localsTR.label": "Türkei",
    "localsTT.label": "Trinidad Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan",
    "localsTZ.label": "Tansania",
    "localsUA.label": "Ukraine",
    "localsUG.label": "Uganda",
    "localsUK.label": "Großbritannien",
    "localsUM.label": "US- kleinere Inseln außerhalb",
    "localsUS.label": "Vereinigte Staaten von Amerika",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Usbekistan",
    "localsVA.label": "Vatikan",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Virgin Island (Brit.)",
    "localsVI.label": "Virgin Island (USA)",
    "localsVN.label": "Vietnam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis et Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Jemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "Südafrika",
    "localsZM.label": "Sambia",
    "localsZW.label": "Zimbabwe",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "NavigationUser.configurationName": "Configuration Overview",
    "NavigationUser.accountName": "Login & Security",
    "NavigationUser.adressesName": "List of constructions",
    "CheckoutHeadline.checkout": "Overview",
    "CheckoutBackButton.checkout": "Back to Configuration",
    "CheckoutConfigurationHeadline.checkout": "Configured Washbasin",
    "CheckoutPartsHeadline.checkout": "Assembly Parts",
    "CheckoutPartsHeadlineLink.checkout": "Configuration Overview",
    "Archive.headline": "Are you sure you want to archive your configuration?",
    "Archive.button": "Accept",
    "ConfigurationCountry.headline": "What country does your configuration belong to?",
    "ConfigurationCountry.button": "Accept",
    "ConfigurationCountry.select": "Please select a country...",
    "ConfigurationCountry.running": "(running)",
    "Delete.headline": "Are you sure you want to delete your configuration?",
    "Delete.button": "Accept",
    "Assemblies.note": "Note:",
    "Assemblies.message.with": "All assembly accessories are designed for solid walls only.",
    "Assemblies.message.without": "Mounting by customer.",
    "Assemblies.message.alwaysTriggerSafety": "Trigger safety always included.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Assembly accessories",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Selection",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Assembly Accessories",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Washbasin Dimensions",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Type of installation",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Angle of the Niche",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Corner Design",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Plate Dimensions",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Position of the troughs",
    "ConfigurationDetail.ApronBacksplash.apron": "Apron",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Surge edge / Back splash",
    "ConfigurationDetail.Recesses.tapHole": "Tap Hole",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Soap Dispenser Hole",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Cut-outs in the plate for ejector or paper towel dispense",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Cosmetic tissue dispenser",
    "ConfigurationDetail.Recesses.towelRail": "Towel Rail",
    "ConfigurationDetail.plateSurface.colour": "Colour",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Bottom Side",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Apron / Backsplash",
    "ConfigurationDetail.Drain.drainTitle": "Drain Accessories",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Drain Accessories",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Complete Configuration",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Recesses / Built-in Parts",
    "ConfigurationDetail.colour.colourTitle": "Colour",
    "ConfigurationDetail.troughs.troughsTitle": "Troughs",
    "ConfigurationDetail.Drain.note": "Note:",
    "ConfigurationDetail.Drain.noteMessage": "No options for selected trough.",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "Theft-proof drain cover with InoxPlus coating is included for Exos troughs.",
    "ConfigurationDetail.Drain.noteExos": "Theft-proof drain cover with InoxPlus coating.",
    "ConfigurationProject.headline": "Which object does your configuration belong to?",
    "ConfigurationProject.tabexisting": "Select existing object",
    "ConfigurationProject.tabnew": "Define new object",
    "ConfigurationProject.tabEXISTING": "EXISTING",
    "ConfigurationProject.tabNEW": "NEW",
    "ConfigurationProject.tabWITHOUT": "WITHOUT",
    "ConfigurationDuplicate.headline": "Want to duplicate your configuration?",
    "ConfigurationDuplicate.button": "Duplicate",
    "ConfigurationNew.headline": "Please give your configuration details:",
    "ConfigurationNewFormName.error": "Name is required.",
    "ConfigurationNewFormName.label": "Name",
    "ConfigurationNewFormName.placeholder": "Name",
    "ConfigurationNewFormPricingsAccessories.error": "Time period is required.",
    "ConfigurationNewFormPricingsAccessories.label": "Time Period Accessories",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Please select...",
    "ConfigurationNewFormPricingsWashbasin.error": "Time period is required.",
    "ConfigurationNewFormPricingsWashbasin.label": "Time Period Washbasin",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Please select...",
    "ConfigurationRename.headline": "How would you like to call your configuration?",
    "Unarchive.headline": "Are you sure you want to restore your configuration?",
    "Unarchive.button": "Accept",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "Email change request successful",
    "ChangeEmailSucceededPageComponent.emailChangedText": "You will recieve an e-mail with an activation link. Please click it to activate your new email.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Go back to login",
    "ChangePasswordPage.changePasswordHeading": "Create your new password",
    "ChangePasswordPage.changePasswordText": "Please make sure your password have one capital case letter and one special character.",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Your password has been changed successfully",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Please go back to the login page and use your new password.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Go back to login",
    "HomeLink.imprint": "Imprint",
    "HomeLink.legals": "Terms and Conditions",
    "HomeLink.privacy": "Privacy Policy",
    "Login.newUser": "Create new account",
    "Login.forgotPassword": "Forgot password?",
    "Login.Label.Email": "E-Mail",
    "Login.Placeholder.Email": "E-Mail",
    "Login.Error.Email": "E-mail is required.",
    "Login.Label.Password": "Password",
    "Login.Placeholder.Password": "Password",
    "Login.Error.Password": "Password is required.",
    "Login.mustLogin": "To start the configuration, you must log in. If you do not yet have an account, create a new account.",
    "ResetPassword.button": "Back to Login",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Your password has been successfully reset.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Please login using your new password.",
    "ResetPasswordChangeSucceededPageComponent.button": "Login",
    "ChangePwOld.label": "Old Password",
    "ChangePwOld.placeholder": "Old Password",
    "ChangePwOld.error": "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
    "ChangePwNew.label": "New Password",
    "ChangePwNew.error": "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
    "ChangePwNew.placeholder": "New Password",
    "ChangePwNewRepeat.label": "Repeat password",
    "ChangePwNewRepeat.error": "Passwords doesn't match.",
    "ChangePwNewRepeat.placeholder": "Repeat password",
    "ResetPasswordSucceededPageComponent.resetPassword": "You have requested to reset your password.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Please check your e-mail for verification link.",
    "ResetPasswordSucceededPageComponent.button": "Login",
    "PageNotFound.message": "Sorry, we didn't found the page you are looking for.",
    "AccountProfile.name": "Name",
    "AccountProfile.telephone": "Telephone number",
    "AccountProfile.street": "Street",
    "AccountProfile.zip": "ZIP",
    "AccountProfile.surname": "Surname",
    "AccountProfile.mobile": "Mobile number",
    "AccountProfile.city": "City",
    "AccountProfile.country": "Country",
    "AccountProfile.userbutton": "Edit Form",
    "AccountProfile.email": "Email address",
    "AccountProfile.password": "Password",
    "AccountProfile.loginbutton": "Edit Form",
    "AccountProfile.headline": "Login & Security",
    "AccountProfile.button": "Save",
    "projectsNewHeadline.headline": "Create a new project",
    "projectsOverviewHeadline.headline": "Addresses Building Projects",
    "ProjectsDelete.headline": "Are you sure you want to delete your project?",
    "ProjectsDelete.button": "Accept",
    "ProjectsEdit.headline": "Please edit your project:",
    "ProjectsNew.headline": "Please give your object a name:",
    "RegisterPage.registerText": "Please enter a valid e-mail address and the password for your account.",
    "RegisterPage.registerButton": "Back to Login",
    "RegisterMail.error": "E-mail is required.",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
    "RegisterPw.name": "Password",
    "RegisterPwRepeat.error": "Passwords doesn't match.",
    "RegisterPwRepeat.name": "Repeat password",
    "RegisterUserGender.error": "Salutation is required",
    "RegisterUserGender.label": "Salutation",
    "RegisterUserGender.mr": "Mr.",
    "RegisterUserGender.mrs": "Mrs.",
    "registerUserFirstName.error": "First name is required and should contain at least 2 characters.",
    "registerUserFirstName.label": "First name",
    "registerUserLastName.error": "Last name is required and should contain at least 2 characters.",
    "registerUserLastName.label": "Last name",
    "registerUserPhone.label": "Phone",
    "registerUserMobile.label": "Mobile",
    "registerUserCompany.label": "Company",
    "registerUserStreet.error": "Street is required and should contain at least 2 characters.",
    "registerUserStreet.label": "Street",
    "registerUserHouse.error": "House number is required and should contain at least 1 character.",
    "registerUserHouse.label": "House number",
    "registerUserZip.error": "Zip is required and should contain at least 2 characters.",
    "registerUserZip.label": "Zip number",
    "registerUserCity.error": "City is required and should contain at least 2 characters.",
    "registerUserCity.label": "City",
    "registerUserAddressAdditional.label": "Address additional",
    "registerUserCountry.error": "Country is required.",
    "registerUserCountry.label": "Country",
    "registerUserCountryLabel.label": "Choose country",
    "registerUserClientNr.label": "Client number (if available)",
    "registerUserBranch.error": "Branch is required",
    "registerUserBranch.label": "Branch",
    "registerUserBranchSanitary.label": "Sanitary wholesale",
    "registerUserBranchPlanner.label": "Planner / Architect",
    "registerUserBranchPlumber.label": "Plumber",
    "registerUserBranchRetail.label": "Retail customer",
    "editUserGender.error": "Salutation is required",
    "editUserGender.label": "Salutation",
    "editUserGenderMr.label": "Mr.",
    "editUserGenderMrs.label": "Mrs.",
    "editUserFirstName.error": "First name is required and should contain at least 2 characters.",
    "editUserFirstName.label": "First name",
    "editUserLastName.error": "Last name is required and should contain at least 2 characters.",
    "editUserLastName.label": "Last name",
    "editUserPhone.label": "Phone",
    "editUserMobile.label": "Mobile",
    "editUserStreet.error": "Street is required and should contain at least 2 characters.",
    "editUserStreet.label": "Street",
    "editUserHouse.error": "House number is required and should contain at least 1 character.",
    "editUserHouse.label": "House number",
    "editUserAddressAdditional.label": "Address additional",
    "editUserZip.error": "Zip is required and should contain at least 2 characters.",
    "editUserZip.label": "Zip",
    "editUserCity.error": "City is required and should contain at least 2 characters.",
    "editUserCity.label": "City",
    "editUserCountry.error": "Country is required.",
    "editUserCountry.label": "Country",
    "editUserCountryLabel.label": "Choose country",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "We have sent you a link by email, your account will be activated after confirmation.",
    "RegisterSucceededComponent.registerSucceededHeading": "Thank you for your registration",
    "RegisterSucceededComponent.resendSucceededHeading": "Resend activation link successfully",
    "RegisterSucceededComponent.registerSucceededText": "You will recieve an e-mail with an activation link. Please click it to activate your account.",
    "RegisterSucceededComponent.registerSucceededButton": "Go back to login",
    "ThankYou.headline": "Thank you for your configuration!",
    "ThankYou.message": "We have sent you a confirmation email with all the details of your order.",
    "ThankYou.order": "Your order number: ",
    "ThankYou.pdfbutton": "Export as 2D PDF",
    "ThankYou.tenderdocuments": "Tender Documents",
    "ThankYou.overviewbutton": "Go to configuration overview",
    "ThankYou.orderPdf": "Order (PDF)",
    "ThankYou.manufacturingPdf": "2D view (PDF)",
    "ThankYou.troughPdf": "Technical Drawing (PDF)",
    "Troughs.toStart": "To start the configuration, you must {login}. If you do not yet have an account, {create}.",
    "Troughs.toStartLogin": "log in",
    "Troughs.toStartCreate": "create a new account",
    "UserList.deleteUser": "Width",
    "Configuration3dAlert.attention": "How to begin?",
    "Configuration3dAlert.message": "At first, select your favorite trough via the button. And now you can start with your individual washbasin. Have a lot of fun with our new 3D configurator!",
    "ActivationSucceeded.activationSucceededText": "Congratulations your account have been successfully registered. Launch the application now.",
    "ActivationSucceeded.activationSucceededButton": "Lets go",
    "ActivationFailed.activationInvalid": "Unfortunately activation is failed!",
    "ActivationFailed.activationInvalidToken": "Your token is expired. Please check if your account is already activated. Try to log in.",
    "ActivationFailed.activationInvalidTokenButton": "Send me new link",
    "ActivationFailed.activaionUserNotFound": "This user doesn't exist. Please register a new account.",
    "ActivationFailed.activaionUserNotFoundButton": "Register",
    "ActivationFailed.ActivationResend": "Resend activation Link",
    "ChangeEmailForm.button": "Update Email Address",
    "ChangePassword.button": "Update Password",
    "LoginForm.button": "Login",
    "Logout.button": "Logout",
    "RegisterUserDataForm.headline": "Please enter your personal data here.",
    "RegisterUserDataForm.button": "Register now",
    "RegisterUserDataForm.logout": "Return to login",
    "RegisterUserForm.button": "Register now",
    "ResetPasswordForm.button": "Reset password",
    "ResetPasswordChangeForm.button": "Reset password",
    "Checkout.WashBasinDimensions": "Wash basin dimensions",
    "Checkout.PlateDimensions.Width": "Width",
    "Checkout.PlateDimensions.Depth": "Depth",
    "Checkout.TypeOfInstallation": "Type of Installation",
    "Checkout.TypeOfInstallation.Left": "Wall left",
    "Checkout.TypeOfInstallation.Right": "Wall right",
    "Checkout.TypeOfInstallation.With": "Wall left and right",
    "Checkout.CornerDesign": "Corner Design",
    "Checkout.CornerDesign.Radius": "Radius 100 mm",
    "Checkout.CornerDesign.Bevel": "Bevel, 100 mm",
    "Checkout.Left": "left",
    "Checkout.Right": "right",
    "Checkout.OrderPdf": "Download configuration",
    "Checkout.ManufacturingPdf": "Download drawing",
    "Checkout.ApronBackSplash.Headline": "Apron / Backsplash",
    "Checkout.ApronBackSplash.Apron": "Apron: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Surge edge: {position} / Height: 3 mm.",
    "Checkout.ApronBackSplash.apronBackSplash": "Back splash: {position} - Height: {height} mm.",
    "ElementsPositionsBack.back": "back",
    "ElementsPositionsFront.front": "front",
    "ElementsPositionsLeft.left": "left",
    "ElementsPositionsRight.right": "right",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Recesses / Built-in Parts",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x Drill hole for taps",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x Drill hole for Soap dispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x Cut out",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Cut out for paper towel dispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x Cut out for cosmetic tissue dispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x Cut out for towel rail",
    "Checkout.Surface.Title": "Surface",
    "Checkout.Surface.Color": "Color: {color}",
    "Checkout.Surface.GelCoat": "Gel coat on bottom side",
    "Checkout.AssemblyAccessories.Title": "Assembly Accessories",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x Console {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x Angle bar for mounting at side wall.",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x Safety catch for mounting at back wall.",
    "Checkout.GeneralInfo.Headline": "General",
    "Checkout.GeneralInfo.ConfName": "Congifuration Name: ",
    "Checkout.TotalPrice.Washbasin": "Washbasin",
    "Checkout.TotalPrice.Parts": "Assembly parts",
    "Checkout.TotalPrice.DeliveryCosts": "Delivery costs",
    "Checkout.TotalPrice.Vat": "VAT",
    "Checkout.TotalPrice.Total": "Total",
    "Checkout.TotalPrice.Note": "Note:",
    "Checkout.TotalPrice.NoteText": "It is expected that 19 % VAT will apply again from 01.01.2021.",
    "Checkout.Trough.Headline": "Trough",
    "Checkout.Trough.Name": "Name of trough:",
    "Checkout.Trough.Qty": "Quantity:",
    "Checkout.Trough.Dimensions": "Basin dimensions:",
    "ColorCheckout.white": "white",
    "ColorCheckout.black": "black",
    "ColorCheckout.blackWhite": "black-white",
    "ColorCheckout.lightGray": "light-gray",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/en_GB/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "checkoutPartsPdfButton.button": "Download PDF",
    "submitAsRequest.label": "Request offer",
    "submitAsOffer.label": "SAP transfer offer",
    "submitAsOrder.label": "SAP transfer order",
    "checkoutSave.label": "Save",
    "checkoutSave.orderIsFailed": "Order has failed to submit to the SAP system. Please duplicate the configuration and try again later.",
    "checkoutSave.orderIsQueued": "Order has failed to submit to the SAP system. It has been queued for later submission.",
    "checkoutParts.timePeriodNote": "Note:",
    "checkoutParts.timePeriodNoteText": "Please select the period for the price validity",
    "checkoutParts.timePeriodAccessoriesLabel": "Time Period Accessories",
    "checkoutParts.timePeriodWashbasinLabel": "Time Period Washbasin",
    "CutoutPartDetail.article": "Article Number",
    "ApronAffects.position": "Attention: Apron width of 18 mm leads to the displacement of the trough position.",
    "Apron.height": "Height of apron in mm",
    "ApronHeightRequiredHint.hint": "Note:",
    "ApronHeightAndDimensionsRequiredMessage.message": "To position a towel rail, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "To position a towel rail, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "To position a cosmetic tissue dispenser, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "To position this cut out, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your plate needs to be enlarged. Would you like to continue?",
    "ApronHeightRequiredMessage.message": "Activate apron and set apron height to {requiredHeight} mm. Continue?",
    "apronHeightForTowelRailRequiredMessage.message": "Activate apron and set apron height to {requiredHeight} mm. Continue?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Activate apron and set apron height to {requiredHeight} mm. Continue?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Activate apron and set apron height to {requiredHeight} mm. Continue?",
    "ApronHeightRequiredChoiceMessage.message": "For a better look of your washbasin, we recommend you to select an apron to use:",
    "apronHeightRequiredChoice60.60": "Change the apron height to 60 mm",
    "apronHeightRequiredChoice150.150": "Change the apron height to 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Maintain apron height",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Maintain apron height and continue without the sleeve",
    "ApronHeightError.message": "Your value is out of range",
    "SurgeEdgeLabelWithout.without": "without",
    "SurgeEdgeLabelWith.with": "with surge edge (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "with backsplash",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "at the back (Standard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Height of backsplash in mm",
    "ApronLabel.with": "with apron",
    "ApronLabel.without": "without apron (Standard)",
    "ApronForcedWidthIncrease.message": "If you deselect the apron, the original dimensions of your configuration will be restored.",
    "WithoutAssemblyAccessories.without": "without assembly accessories",
    "WithAssemblyAccessories.with": "with assembly accessories",
    "WithAssemblyAccessoriesTooltipHint.hint": "Note:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Mounting by customer.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Stainless Steel",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Console",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Trigger Protection",
    "AssemblyAccessoriesListAngleBar.anglebar": "Angle Bar",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Fixing Material",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Stainless Steel White",
    "ConsolesOverlapChoice.message": "Configuration not possible, please increase distance or select stainless steel console.",
    "ConsolesOverlapChoice.continue": "Return to original value (with MIRANIT console)",
    "ConsolesOverlapChoice.return": "Return to original value (with MIRANIT console)",
    "ConsolesOverlapChoice.change": "Change to stainless steel console(s)",
    "WithNicheHint.hint": "Note:",
    "WithNicheMessage.message": "Length of washbasin = dimensions of finished niche minus 8 mm. Please subtract 4 mm per washbasin side during configuration. Please consider structural projections.",
    "DepthRequiredHint.hint": "Note:",
    "DepthRequiredMessage.message": "The washbasin depth you have chosen is not sufficient. Would you like to set the required depth of {requiredDepth} mm for this disposal?",
    "CornerDesignLabelWithout.without": "Without corner design",
    "CornerDesignLabelRadius.radius": "Radius (100 mm)",
    "CornerDesignLabelBevel.bevel": "Bevel (side length 100 mm)",
    "DistancesPosition.symmetrically": "Position Symmetrically",
    "DistancesPosition.evenly": "Position Evenly",
    "DistancesPositionOfTroughs.distances": "Input of the trough center distance",
    "DistancesPositionOfTroughsHint.hint": "Note:",
    "DistancesPositionOfTroughsMessage.message": "Advantages and recommendations for use",
    "DistancesPositionOfTroughsFromPlate.plate": "From plate to rear edge of trough",
    "PlateDimensionsWidth.width": "Plate width",
    "PlateDimensionsDepth.depth": "Plate depth",
    "PlateDimensionsDepth.470": "Recommendation for wall fittings",
    "PlateDimensionsDepth.550": "Recommendation for stand fittings",
    "PlateDimensionsDepth.depthIndividual": "Individual",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "Your value is out of range",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Left side",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Right side",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Only possible in combination with type of installation \"with, left or right\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Only possible in combination with type of installation \"without, left or right\".",
    "Configuration.Inputs.message": "Your value is out of range",
    "Configuration.Inputs.distancesInmm": "(distances in mm)",
    "PlateDimensionsRequired.hint": "Note:",
    "PlateDimensionsRequired.message": "The width of your washbasin is not sufficient. To place an apron, the plate must be enlarged. Would you like to continue?",
    "PlateDimensionsRequiredLimit.message": "Maximum washbasin width reached. No apron selection possible.",
    "PlateDimensionsChoice.message": "There is not enough space for an apron on your washbasin. You have the following options to proceed:",
    "PlateDimensionsChoiceLimit.message": "There is not enough space for an apron on your washbasin. Maximum washbasin width reached. You have the following options to proceed:",
    "PlateDimensionsChoice.increase": "Change the width of the washbasin",
    "PlateDimensionsChoice.move": "Move the trough(s) and keep the width of the washbasin",
    "PlateDimensionsChoice.cancel": "Cancel (keep the dimensions without an apron)",
    "DrainLabelWithoutDrain.withoutdrain": "without Drain accessories",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Hood drain valve chrome",
    "DrainLabelHoodDrain.hooddrain": "Hood drain valve",
    "DrainLabelSieveDrain.sievedrain": "Sieve drain valve",
    "DrainLabelEccentric.eccentric": "Eccentric waste and overflow fitting",
    "DrainLabelSiphon.siphon": "Siphon XINX140",
    "CutoutPartDetail.name": "Name",
    "CutoutPartDetail.dimensions": "Dimensions",
    "CutoutPartDetail.type": "Type",
    "CosmeticTissueDispenser.cosmeticTissue": "Cosmetic tissue dispenser",
    "PaperTowelDispenser.paperTowelDispenser": "Paper towel dispenser",
    "CosmeticTissueDispenser.without": "without paper tissue dispenser",
    "CosmeticTissueDispenser.with": "with paper tissue dispenser",
    "CosmeticTissueDispenserSquare.square": "square (with Gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(for cosmetic tissue dispenser „model number“)",
    "CosmeticTissueDispenserPosition.position": "(Position between the troughs)",
    "CutOutLabel.CustomRound": "Round discharge (with gelcoat)",
    "CutOutLabel.CustomSquare": "Square discharge (with gelcoat)",
    "CutOutLabel.roundSleeve": "Round discharge with discharge sleeve",
    "CutOutLabel.squareSleeve": "Square discharge with discharge sleeve",
    "CutOutLabel.roundBasket": "Round discharge with basket",
    "CutOutLabel.roundRail": "Round discharge with rail system",
    "CutOutLabel.squareBasket": "Square discharge with basket",
    "CutOutLabel.squareRail": "Square discharge with rail system",
    "CutOutLabel.roundSleeveBasket": "Round discharge with discharge sleeve and basket",
    "CutOutLabel.roundSleeveRail": "Round discharge with discharge sleeve and rail",
    "CutOutLabel.squareSleeveBasket": "Square discharge with discharge sleeve and basket",
    "CutOutLabel.squareSleeveRail": "Square discharge with discharge sleeve and rail",
    "CutOutLabel.flap": "Discharge flap",
    "CutOutLabel.flapBasket": "Discharge flap with basket",
    "CutOutLabel.flapRail": "Discharge flap with rail system",
    "CutOutLabel.provider": "Paper towel dispenser",
    "CutOutLabel.cosmetic": "Cosmetic tissue dispenser",
    "CutOutLabelCustomInput.diameter": "Diameter",
    "CutOutLabelCustomInput.width": "Width",
    "CutOutLabelCustomInput.depth": "Depth",
    "CutOutLabelSelect.select": "Please select",
    "CutOutLabelNone.none": "No cut-out selected",
    "CutOutDisposalsDefaultsWithout.without": "without cut-out",
    "CutOutDisposalsDefaultsWith.with": "with cut-out",
    "SoapDispenserHoleLabelWithout.without": "without",
    "SoapDispenserHoleLabelSD80.sd80": "for soap dispenser SD80",
    "SoapDispenserHoleLabelSD100.sd100": "for soap dispenser SD100",
    "SoapDispenserHoleLabel25.dispensers": "for dispensers provided by others (Ø 25 mm)",
    "TapHoleWithout.taphole": "without drilling",
    "TapHoleWithoutDrilling.tapholedrilling": "with drilling (Ø 35 mm)",
    "TowelRailWithout.towelrailwithout": "without cut-out",
    "TowelRailWithout.towelrailwith": "with cut-out",
    "SquareCustom.square": "square",
    "RoundCustom.round": "round",
    "ColorLabel.alpinewhite": "Alpine white (standard)",
    "ColorLabel.alpinewhitetext": "Temperature resistant up to 80° C",
    "ColorLabel.graniteblack": "Granite Black",
    "ColorLabel.graniteblacktext": "Temperature resistant up to 65° C",
    "ColorLabel.graniteblackwhite": "Granite Black-White",
    "ColorLabel.graniteblackwhitetext": "Temperature resistant up to 65° C",
    "ColorLabel.graniteLightGray": "Granite light Gray",
    "ColorLabel.granitelightgraytext": "Temperature resistant up to 65° C",
    "ColorBottomSideUncoated.uncoated": "uncoated (Standard)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Note: ",
    "ColorBottomSideMessage.message": "Advantages and recommendations for use",
    "checkboxPositions.noSpace": "Not enough space available",
    "checkboxPositions.tissueConflict": "Waste rail has changed",
    "ElementNext.button": "Next",
    "ElementsPositionsRight.warning": "Disabled, please increase distance between troughs.",
    "ConfigurationListHeading.text": "Un-assigned Configurations",
    "ConfigurationListAdd.text": "Add New Configuration",
    "ConfigurationListNone.text": "No configurations available yet",
    "FolderListNestedHeading.test": "Construction Phases",
    "FolderListHeading.text": "Folders",
    "FolderListHeadingAll.text": "All Folders",
    "FolderListNone.text": "No folders available yet",
    "FolderListSeeAll.text": "See all folders",
    "FolderListToday.text": "Today",
    "FolderList7Days.text": "Last 7 Days",
    "FolderList30Days.text": "Last 30 Days",
    "FolderList.SortByDate": "Sort by Date",
    "FolderList.SortByName": "Sort by Name",
    "ConfigurationEditFolder.heading": "Edit Folder",
    "FolderListItemDelete.text": "Delete Folder",
    "ConfigurationEditFolderNested.heading": "Edit Construction Phase",
    "FolderListItemNestedDelete.text": "Delete Construction Phase",
    "ListItem.rename": "Rename",
    "ListItem.duplicate": "Duplicate",
    "ListItem.delete": "Delete",
    "ListItem.archive": "Archive",
    "ListItem.unarchive": "Restore",
    "ListItem.order": "Make Order",
    "ListItem.orderShow": "Show Order",
    "ListItem.linkTitle": "Settings",
    "ListItem.orderPdf": "Download configuration",
    "ListItem.manufacturingPdf": "Download drawing",
    "ListItem.troughPdf": "Download technical drawing",
    "ListItem.downloadPdfs": "Download PDFs",
    "ListItem.moveToGroup": "Move to Folder",
    "ListItem.goBack": "Go back",
    "ListItem.moveToThisGroup": "Move to this folder",
    "ListItem.moveToDashboard": "Move to Dashboard",
    "ListItemDetail.basin": "Basin dimensions:",
    "ListItemDetail.number": "Number of Troughs:",
    "ListItemDetail.price": "Total price: 1.690,00 €",
    "ListItemDetail.draft": "Draft",
    "ListItemDetail.request": "Request",
    "ListItemDetail.offer": "Offer",
    "ListItemDetail.order": "Order",
    "ListItemDetail.date": "Last modified on",
    "ListItemDetail.failed": "Failed",
    "ListItemDetail.queued": "Queued",
    "ListItemBuilding.number": "Building number",
    "ListItemOpportunity.number": "Opportunity number",
    "ConfigurationNewForm.button": "Accept",
    "ConfigurationDeleteFolder.cancel": "Cancel",
    "ConfigurationDeleteFolder.heading": "Delete Folder",
    "ConfigurationDeleteNestedFolder.heading": "Delete Construction Phase",
    "ConfigurationDeleteFolder.note": "Note:",
    "ConfigurationDeleteNestedFolder.body": "If you delete this construction phase, the configurations it contains will still remain, they will simply be moved to the folder storage.",
    "ConfigurationDeleteFolder.body": "If you delete this folder, the configurations it contains will still remain, they will simply be moved to the dashboard.",
    "ConfigurationDeleteFolder.confirm": "Confirm",
    "ConfigurationEditFolder.cancel": "Cancel",
    "ConfigurationEditFolder.confirm": "Confirm",
    "BuildingNumber.number": "Building number (CRM)",
    "OpportunityNumber.number": "Opportunity number (CRM)",
    "FolderName.name": "Folder Name",
    "ConfigurationNewFolder.create": "Create",
    "ConfigurationNewFolder.cancel": "Cancel",
    "ConfigurationNewFolder.newHeading": "New Folder",
    "ConfigurationNewFolderNested.newHeading": "New Construction Phase",
    "ConfigurationSwitchView.mine": "My Configurations",
    "ConfigurationSwitchView.connected": "Connected",
    "ConfigurationSwitchView.archived": "Archived",
    "FolderSwitchView.mine": "My Configurations",
    "FolderSwitchView.goBack": "Go back",
    "NewButtonsNewFolder.text": "New Folder",
    "NewButtonsNewConfiguration.text": "Create Configuration",
    "ConfigurationDownload3D.text": "Download 3D Scene",
    "Warning.RequireReset.Trough": "Due to changes to your configuration, if you want to choose a new trough and increase or decrease the quantity, all listed items has to be reset:",
    "Warning.RequireReset.Qty": "Due to changes to your configuration, if you want to increase or decrease the quantity, all listed items has to be reset:",
    "Warning.RequireReset.TypeOfInstallation": "Due to changes to your configuration, if you want to change the type of the installation, all listed items has to be reset:",
    "Warning.RequireReset.plateWidth": "Plate width",
    "Warning.RequireReset.PlateDepth": "Due to changes to your configuration, if you want to change the plate depth, all listed items has to be reset:",
    "Warning.RequireReset.distances": "Distances",
    "Warning.RequireReset.cornerDesign": "Corner design",
    "Warning.RequireReset": "Reset required: ",
    "Warning.RequireReset.Default": "Due to changes to your configuration you need to reset it.",
    "Warning.RequireReset.ResetAll": "Reset all?",
    "Warning.RequireReset.console": "Consoles",
    "Warning.RequireReset.qty": "Trough quantity",
    "Warning.RequireReset.drain": "Drain Accessories",
    "Warning.RequireReset.typeOfInstallation": "Type of installation",
    "Warning.RequireReset.paperTowelDispensers": "Cut out for towel dispenser",
    "Warning.RequireReset.plateDepth": "Plate depth",
    "Warning.RequireReset.siphon": "Siphon",
    "Warning.RequireReset.soapDispenserHole": "Drill hole for soap dispenser.",
    "Warning.RequireReset.tapHole": "Drill hole for tap",
    "Warning.RequireReset.tissueDispenser": "Cut out for tissue dispenser",
    "Warning.RequireReset.apron": "Apron",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Surge edge / Splashback",
    "Warning.RequireReset.cutOutDisposals": "Cut out disposals",
    "ConfigurationDetail.error.default": "Your selected value isn't assignable, please check your input.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "Your selected value isn't assignable, please check your color bottom side.",
    "LogoTitle.default": "Configuration Overview",
    "LogoTitle.fallback": "KWC 3D Configurator",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:",
    "MetaNavigationImprint.imprint": "Imprint",
    "MetaNavigationLegals.legals": "Legals",
    "MetaNavigationPrivacy.privacy": "Privacy Policy",
    "NavigationTrough.name": "Trough",
    "NavigationTrough.title": "Trough",
    "NavigationBasin.name": "Basin dimensions",
    "NavigationBasin.title": "Basin dimensions",
    "NavigationApron.name": "Apron / Backsplash",
    "NavigationApron.title": "Apron / Backsplash",
    "NavigationRecesses.name": "Recesses / built-in parts",
    "NavigationRecesses.title": "Recesses / built-in parts",
    "NavigationColour.name": "Colour",
    "NavigationColour.title": "Colour",
    "NavigationAssembly.name": "Assembly accessories",
    "NavigationAssembly.title": "Assembly accessories",
    "NavigationDrain.name": "Drain",
    "NavigationDrain.title": "Drain",
    "ProjectsEditFormButton.button": "Save project",
    "ProjectListItemEdit.edit": "Edit",
    "ProjectListItemDelete.delete": "Delete",
    "ProjectListItemLinkTitle.title": "Settings",
    "projectListHeadline.headline": "List of Constructions",
    "ProjectListAdd.addText": "Add New Adress",
    "ProjectNewFormButton.button": "Create project",
    "ProjectName.error": "Name is required.",
    "ProjectName.name": "Object name:",
    "BuildingNumber.error": "Building number is required.",
    "OpportunityNumber.error": "Opportunity number is required.",
    "ProjectStreet.error": "Street is required and should contain at least 2 characters.",
    "ProjectStreet.name": "Street",
    "ProjectStreetNr.error": "No. is required and should contain at least 1 characters.",
    "ProjectStreetNr.name": "No.",
    "ProjectZip.error": "Zip is required and should contain at least 2 characters.",
    "ProjectZip.name": "Zip",
    "ProjectCity.error": "City is required and should contain at least 2 characters.",
    "ProjectCity.name": "City",
    "ProjectCountry.error": "Country is required.",
    "ProjectCountry.name": "Country",
    "ProjectCountry.label": "Choose country",
    "ConnectedFolder.label": "Yes, I would like to create a new folder with the object name in my dashboard.",
    "ProjectSelectExistingProject.text": "Select existing Object",
    "ProjectSelectCreateProject.text": "No existing Object yet, please create one",
    "ProjectSelectButton.button": "Accept",
    "ProjectSelectWithout.without": "I´d like to proceed without an object",
    "ProjectSelectButtonTitle.title": "Edit Object",
    "ProjectWithout.label": "Yes, I´d like to proceed without an object",
    "ProjectWithout.button": "Accept",
    "SearchPlaceholder.placeholder": "What are you looking for?",
    "SearchPlaceholder.placeholderTroughs": "Search for a trough",
    "SelectedTroughListButton.button": "Trough added",
    "SelectedTroughListItemWidth.width": "Width",
    "SelectedTroughListItemWidth.minWidth": "Min Width",
    "SelectedTroughListItemDepth.depth": "Depth",
    "SelectedTroughListItemDepth.minDepth": "Min Depth",
    "SelectedTroughListItemHeight.height": "Height",
    "SelectedTroughListItemHeight.minDimensions": "min. washbasin width x depth",
    "TroughDetailModalWidth.width": "Width",
    "TroughDetailModalWidth.minWidth": "Min Width",
    "TroughDetailModalDepth.depth": "Depth",
    "TroughDetailModalDepth.minDepth": "Min Depth",
    "TroughDetailModalDepth.minDimensions": "min. washbasin width x depth",
    "TroughDetailModalHeight.height": "Height",
    "TroughDetailModalButton.button": "Technical Drawing",
    "TroughFilterButton.button": "Deselect",
    "TroughFilterExos.error": "EXOS. is required.",
    "TroughFilterExos.label": "EXOS",
    "TroughFilterVarius.error": "VARIUSsign is required.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "VARIUSmed is required.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterMedcare.error": "MEDCARE is required.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughFilterSquare.error": "Square is required.",
    "TroughFilterSquare.label": "Square",
    "TroughFilterOval.error": "Oval is required.",
    "TroughFilterOval.label": "Oval",
    "TroughFilterRound.error": "Round is required.",
    "TroughFilterRound.label": "Round",
    "TroughFilterWithOverflow.error": "With overflow is required.",
    "TroughFilterWithOverflow.label": "With overflow",
    "TroughFilterWithoutOverflow.error": "Without overflow is required.",
    "TroughFilterWithoutOverflow.label": "Without overflow",
    "TroughFilterWithBackwall.error": "With prepared backwall is required.",
    "TroughFilterWithBackwall.label": "With backwall",
    "TroughFilterWithoutBackwall.error": "Without backwall is required.",
    "TroughFilterWithoutBackwall.label": "Without backwall",
    "TroughFilter.modelLine": "Model line",
    "TroughFilter.characteristics": "Characteristics",
    "TroughListButtonSelect.select": "Select trough",
    "TroughListButtonClose.close": "Close trough menu",
    "TroughListButtonFilterOptions.filter": "Show Filter Options",
    "TroughListSorryMsg.message": "Sorry, we didn't found any Trough matching your selected filter options.",
    "TroughListItemWidth.width": "Width",
    "TroughListItemWidth.minWidth": "Min Width",
    "TroughListItemDepth.depth": "Depth",
    "TroughListItemDepth.minDepth": "Min Depth",
    "TroughListItemDepth.minDimensions": "min. washbasin width x depth",
    "TroughListItemHeight.height": "Height",
    "TroughListItemHeight.unavailable": "available from August 2023",
    "TroughListItem.min": "Washbasin min.",
    "TroughListItem.start": "Start Configuration",
    "TroughListItem.startWithLogin": "Start Configuration with Login",
    "TroughListMinValuesText.text": "min. washbasin width x depth",
    "TroughBanner.label": "Which troughs are available?",
    "TroughBanner.text": "Take a look in advance here."
  },
  "en": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "China | 中国",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Configuration Overview",
    "NavigationUser.accountName": "Login & Security",
    "NavigationUser.adressesName": "List of constructions",
    "CheckoutHeadline.checkout": "Overview",
    "CheckoutBackButton.checkout": "Back to Configuration",
    "CheckoutConfigurationHeadline.checkout": "Configured Washbasin",
    "CheckoutPartsHeadline.checkout": "Assembly Parts",
    "CheckoutPartsHeadlineLink.checkout": "Configuration Overview",
    "Delete.headline": "Are you sure you want to delete your configuration?",
    "Delete.button": "Accept",
    "Assemblies.note": "Note:",
    "Assemblies.message.with": "All assembly accessories are designed for solid walls only.",
    "Assemblies.message.without": "Mounting by customer.",
    "Assemblies.message.alwaysTriggerSafety": "Trigger safety always included.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Assembly accessories",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Selection",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Assembly Accessories",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Washbasin Dimensions",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Type of installation",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Angle of the Niche",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Corner Design",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Plate Dimensions",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Position of the troughs",
    "ConfigurationDetail.ApronBacksplash.apron": "Apron",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Surge edge / Splashback",
    "ConfigurationDetail.Recesses.tapHole": "Tap Hole",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Soap Dispenser Hole",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Disposal",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Paper tissue dispenser",
    "ConfigurationDetail.Recesses.towelRail": "Towel Rail",
    "ConfigurationDetail.plateSurface.colour": "Colour",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Bottom Side",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Apron / Splashback",
    "ConfigurationDetail.Drain.drainTitle": "Drain Accessories",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Drain Accessories",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Complete Configuration",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Recesses / Built-in Parts",
    "ConfigurationDetail.colour.colourTitle": "Colour",
    "ConfigurationDetail.troughs.troughsTitle": "Troughs",
    "ConfigurationProject.headline": "Which object does your configuration belong to?",
    "ConfigurationProject.tabexisting": "Select existing object",
    "ConfigurationProject.tabnew": "Define new object",
    "ConfigurationProject.tabEXISTING": "EXISTING",
    "ConfigurationProject.tabNEW": "NEW",
    "ConfigurationProject.tabWITHOUT": "WITHOUT",
    "ConfigurationDuplicate.headline": "Want to duplicate your configuration?",
    "ConfigurationDuplicate.button": "Duplicate",
    "ConfigurationNew.headline": "Please give your configuration details:",
    "ConfigurationRename.headline": "How would you like to call your configuration?",
    "ChangePasswordPage.changePasswordHeading": "Create your new password",
    "ChangePasswordPage.changePasswordText": "Please make sure your password have one capital case letter and one special character.",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Your password has been changed successfully",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Please go back to the login page and use your new password.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Go back to login",
    "HomeLink.imprint": "Imprint",
    "HomeLink.legals": "Terms & Conditions",
    "HomeLink.privacy": "Privacy & Cookie Policy",
    "Login.newUser": "Create new account",
    "Login.forgotPassword": "Forgot password?",
    "Login.Label.Email": "E-mail",
    "Login.Placeholder.Email": "E-mail",
    "Login.Error.Email": "E-mail is required.",
    "Login.Label.Password": "Password",
    "Login.Placeholder.Password": "Password",
    "Login.Error.Password": "Password is required.",
    "ResetPassword.button": "Back to Login",
    "ResetPasswordSucceededPageComponent.resetPassword": "You have requested to reset your password.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Please check your e-mail for verification link.",
    "ResetPasswordSucceededPageComponent.button": "Login",
    "ChangePwOld.label": "Old Password",
    "ChangePwOld.placeholder": "Old Password",
    "ChangePwOld.error": "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
    "ChangePwNew.label": "New Password",
    "ChangePwNew.error": "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
    "ChangePwNew.placeholder": "New Password",
    "ChangePwNewRepeat.label": "Repeat password",
    "ChangePwNewRepeat.error": "Passwords doesn't match.",
    "ChangePwNewRepeat.placeholder": "Repeat password",
    "PageNotFound.message": "Sorry, we didn't found the page you are looking for.",
    "AccountProfile.name": "Name",
    "AccountProfile.telephone": "Telephone number",
    "AccountProfile.street": "Street",
    "AccountProfile.zip": "ZIP",
    "AccountProfile.surname": "Surname",
    "AccountProfile.mobile": "Mobile number",
    "AccountProfile.city": "City",
    "AccountProfile.country": "Country",
    "AccountProfile.userbutton": "Edit Form",
    "AccountProfile.email": "Email address",
    "AccountProfile.password": "Password",
    "AccountProfile.loginbutton": "Edit Form",
    "AccountProfile.headline": "Login & Security",
    "projectsNewHeadline.headline": "Create a new project",
    "projectsOverviewHeadline.headline": "Addresses Building Projects",
    "ProjectsDelete.headline": "Are you sure you want to delete your project?",
    "ProjectsDelete.button": "Accept",
    "ProjectsEdit.headline": "Please edit your project:",
    "ProjectsNew.headline": "Please give your object a name:",
    "RegisterPage.registerText": "Please enter a valid e-mail address and the password for your account.",
    "RegisterPage.registerButton": "Back to Login",
    "RegisterMail.error": "E-mail is required.",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "The password must meet at least 2 out of 3 of the following conditions: Letters (eg ABCD ...) - Numbers (eg 0123 ...) - Special characters (eg # $% ...)",
    "RegisterPw.name": "Password",
    "RegisterPwRepeat.error": "Passwords doesn't match.",
    "RegisterPwRepeat.name": "Repeat password",
    "RegisterUserGender.error": "Salutation is required",
    "RegisterUserGender.label": "Salutation",
    "RegisterUserGender.mr": "Mr.",
    "RegisterUserGender.mrs": "Mrs.",
    "registerUserFirstName.error": "First name is required and should contain at least 2 characters.",
    "registerUserFirstName.label": "First name",
    "registerUserLastName.error": "Last name is required and should contain at least 2 characters.",
    "registerUserLastName.label": "Last name",
    "registerUserPhone.label": "Phone",
    "registerUserMobile.label": "Mobile",
    "registerUserCompany.label": "Company",
    "registerUserStreet.error": "Street is required and should contain at least 2 characters.",
    "registerUserStreet.label": "Street",
    "registerUserHouse.error": "House number is required and should contain at least 1 character.",
    "registerUserHouse.label": "House number",
    "registerUserZip.error": "ZIP is required and should contain at least 2 characters.",
    "registerUserZip.label": "ZIP number",
    "registerUserCity.error": "City is required and should contain at least 2 characters.",
    "registerUserCity.label": "City",
    "registerUserAddressAdditional.label": "Address additional",
    "registerUserCountry.error": "Country is required.",
    "registerUserCountry.label": "Country",
    "registerUserCountryLabel.label": "Choose country",
    "registerUserClientNr.label": "Client number (if available)",
    "registerUserBranch.error": "Branch is required",
    "registerUserBranch.label": "Branch",
    "registerUserBranchSanitary.label": "Sanitary wholesale",
    "registerUserBranchPlanner.label": "Planner / Architect",
    "registerUserBranchPlumber.label": "Plumber",
    "registerUserBranchRetail.label": "Retail customer",
    "editUserGender.error": "Salutation is required",
    "editUserGender.label": "Salutation",
    "editUserGenderMr.label": "Mr.",
    "editUserGenderMrs.label": "Mrs.",
    "editUserFirstName.error": "First name is required and should contain at least 2 characters.",
    "editUserFirstName.label": "First name",
    "editUserLastName.error": "Last name is required and should contain at least 2 characters.",
    "editUserLastName.label": "Last name",
    "editUserPhone.label": "Phone",
    "editUserMobile.label": "Mobile",
    "editUserStreet.error": "Street is required and should contain at least 2 characters.",
    "editUserStreet.label": "Street",
    "editUserHouse.error": "House number is required and should contain at least 1 character.",
    "editUserHouse.label": "House number",
    "editUserAddressAdditional.label": "Address additional",
    "editUserZip.error": "ZIP is required and should contain at least 2 characters.",
    "editUserZip.label": "ZIP",
    "editUserCity.error": "City is required and should contain at least 2 characters.",
    "editUserCity.label": "City",
    "editUserCountry.error": "Country is required.",
    "editUserCountry.label": "Country",
    "editUserCountryLabel.label": "Choose country",
    "RegisterSucceededComponent.registerSucceededHeading": "Thank you. Your registration is now almost complete.",
    "RegisterSucceededComponent.registerSucceededText": "In a few moments you will receive an email from us containing a link. After you have confirmed your e-mail address by clicking on this link, you can log in.",
    "RegisterSucceededComponent.registerSucceededButton": "Back to login",
    "ThankYou.headline": "Thank you for your configuration!",
    "ThankYou.message": "We have sent you a confirmation email with all the details of your offer.",
    "ThankYou.order": "Your offer number:",
    "ThankYou.pdfbutton": "Export as 2D PDF",
    "ThankYou.tenderdocuments": "Tender Documents",
    "ThankYou.overviewbutton": "Go to configuration overview",
    "Configuration3dAlert.attention": "How to begin?",
    "Configuration3dAlert.message": "At first, select your favorite trough via the button. And now you can start with your individual washbasin. Have a lot of fun with our new 3D configurator!",
    "ActivationSucceeded.activationSucceededText": "Congratulations your account has been successfully registered. Launch the application now.",
    "ActivationSucceeded.activationSucceededButton": "Let's go",
    "ActivationFailed.activaionUserNotFound": "This user doesent exist. Please register a new account.",
    "ActivationFailed.activaionUserNotFoundButton": "Register",
    "ChangeEmailForm.button": "Update Email Address",
    "ChangePassword.button": "Update Password",
    "LoginForm.button": "Login",
    "Logout.button": "Logout",
    "RegisterUserDataForm.headline": "Please enter your personal data here.",
    "RegisterUserDataForm.button": "Register now",
    "RegisterUserDataForm.logout": "Return to login",
    "RegisterUserForm.button": "Register now",
    "ResetPasswordForm.button": "Reset password",
    "ResetPasswordChangeForm.button": "Reset password",
    "Checkout.WashBasinDimensions": "Wash basin dimensions",
    "Checkout.PlateDimensions.Width": "Width",
    "Checkout.PlateDimensions.Depth": "Depth",
    "Checkout.TypeOfInstallation": "Type of Installation",
    "Checkout.TypeOfInstallation.Left": "Wall left",
    "Checkout.TypeOfInstallation.Right": "Wall right",
    "Checkout.TypeOfInstallation.With": "Wall left and right",
    "Checkout.CornerDesign": "Corner Design",
    "Checkout.CornerDesign.Radius": "Radius 100 mm",
    "Checkout.CornerDesign.Bevel": "Bevel, 100 mm",
    "Checkout.Left": "left",
    "Checkout.Right": "right",
    "Checkout.ApronBackSplash.Headline": "Apron / Splashback",
    "Checkout.ApronBackSplash.Apron": "Apron: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Surge edge: {position} / 3 mm",
    "Checkout.ApronBackSplash.apronBackSplash": "Splashback: {position} / {height} mm",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Recesses / Built-in Parts",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x Drill hole for taps",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x Drill hole for Soap dispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x Cut out “{name}”",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x Cut out for cosmetic tissue dispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x Cut out for towel rail",
    "Checkout.Surface.Title": "Surface",
    "Checkout.Surface.Color": "Color: {color}",
    "Checkout.Surface.GelCoat": "Gelcoat on bottom side",
    "Checkout.AssemblyAccessories.Title": "Assembly Accessories",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x Console {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x Angle bar for mounting at side wall",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x Safety catch for mounting at back wall",
    "Checkout.GeneralInfo.Headline": "General",
    "Checkout.GeneralInfo.ConfName": "Congifuration Name:",
    "Checkout.TotalPrice.Washbasin": "Washbasin",
    "Checkout.TotalPrice.Parts": "Assembly parts",
    "Checkout.TotalPrice.DeliveryCosts": "Delivery costs",
    "Checkout.TotalPrice.Vat": "VAT",
    "Checkout.TotalPrice.Total": "Total",
    "Checkout.TotalPrice.Note": "Note:",
    "Checkout.TotalPrice.NoteText": "Price available until ",
    "Checkout.Trough.Headline": "Trough",
    "Checkout.Trough.Name": "Name of trough:",
    "Checkout.Trough.Qty": "Quantity:",
    "Checkout.Trough.Dimensions": "Trough dimensions:",
    "checkoutPartsPdfButton.button": "Download PDF",
    "Apron.height": "Height of apron in mm",
    "ApronHeightRequiredHint.hint": "Note:",
    "ApronHeightRequiredMessage.message": "To choose a cosmetic tissue dispenser, you need a {requiredHeight} mm apron. Do you want to continue?",
    "ApronHeightError.message": "Your value is out of range",
    "SurgeEdgeLabelWithout.without": "without",
    "SurgeEdgeLabelWith.with": "with surge edge (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "with splashback",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "at the back (Standard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Height of splashback in mm",
    "WithoutAssemblyAccessories.without": "without assembly accessories",
    "WithAssemblyAccessories.with": "with assembly accessories",
    "WithAssemblyAccessoriesTooltipHint.hint": "Note:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Mounting by customer.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Stainless Steel",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Console",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Trigger Protection",
    "AssemblyAccessoriesListAngleBar.anglebar": "Angle Bar",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Fixing Material",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Stainless Steel White",
    "CornerDesignLabelWithout.without": "Without corner design",
    "CornerDesignLabelRadius.radius": "Radius (100 mm)",
    "CornerDesignLabelBevel.bevel": "Bevel (side length 100 mm)",
    "DistancesPositionOfTroughs.distances": "Input of the trough center distance",
    "DistancesPositionOfTroughsHint.hint": "Note:",
    "DistancesPositionOfTroughsMessage.message": "Advantages and recommendations for use",
    "DistancesPositionOfTroughsFromPlate.plate": "From plate to rear edge of trough",
    "PlateDimensionsWidth.width": "Plate width",
    "PlateDimensionsDepth.depth": "Plate depth",
    "PlateDimensionsDepth.depthIndividual": "Individual",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "Your value is out of range",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Left side",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Right side",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Only possible in combination with type of installation \"with, left or right\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Only possible in combination with type of installation \"without, left or right\".",
    "Configuration.Inputs.message": "Your value is out of range",
    "DrainLabelWithoutDrain.withoutdrain": "without drain accessories",
    "DrainLabelHoodDrain.hooddrain": "dome waste valve",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "dome waste valve chrome",
    "DrainLabelSieveDrain.sievedrain": "strainer waste",
    "DrainLabelEccentric.eccentric": "eccentric drain and overflow",
    "DrainLabelSiphon.siphon": "siphon XINX140",
    "CosmeticTissueDispenser.without": "without paper tissue dispenser",
    "CosmeticTissueDispenserSquare.square": "square (with Gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(for cosmetic tissue dispenser „model number“)",
    "CosmeticTissueDispenserPosition.position": "(position between the troughs)",
    "CutOutLabelCustomInput.diameter": "Diameter",
    "CutOutLabelCustomInput.width": "Width",
    "CutOutLabelCustomInput.depth": "Depth",
    "CutOutLabelSelect.select": "Please select",
    "CutOutDisposalsDefaultsWithout.without": "without cut-out",
    "CutOutDisposalsDefaultsWith.with": "with cut-out",
    "SoapDispenserHoleLabelWithout.without": "without",
    "SoapDispenserHoleLabelSD80.sd80": "for soap dispenser SD80",
    "SoapDispenserHoleLabelSD100.sd100": "for soap dispenser SD100",
    "SoapDispenserHoleLabel25.dispensers": "for dispensers provided by others (Ø 25 mm)",
    "TapHoleWithout.taphole": "without drilling",
    "TapHoleWithoutDrilling.tapholedrilling": "with drilling (Ø 35 mm)",
    "TowelRailWithout.towelrailwithout": "without cut-out",
    "TowelRailWithout.towelrailwith": "with cut-out",
    "ColorLabel.alpinewhite": "Alpine white (standard)",
    "ColorLabel.alpinewhitetext": "Temperature resistant up to 80° C",
    "ColorLabel.graniteblack": "Granite Black",
    "ColorLabel.graniteblacktext": "Temperature resistant up to 65° C",
    "ColorLabel.graniteblackwhite": "Granite Black-White",
    "ColorLabel.graniteblackwhitetext": "Temperature resistant up to 65° C",
    "ColorLabel.graniteLightGray": "Granite light Gray",
    "ColorLabel.granitelightgraytext": "Temperature resistant up to 65° C",
    "ColorBottomSideUncoated.uncoated": "uncoated (Standard)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Note:",
    "ColorBottomSideMessage.message": "Advantages and recommendations for use",
    "ElementNext.button": "Next",
    "ElementsPositionsLeft.left": "left",
    "ElementsPositionsBack.back": "rear",
    "ElementsPositionsFront.front": "front",
    "ElementsPositionsRight.right": "right",
    "ElementsPositionsRight.warning": "Disabled, please increase distance between troughs.",
    "ConfigurationListAdd.text": "Add New Configuration",
    "ListItem.rename": "Rename",
    "ListItem.duplicate": "Duplicate",
    "ListItem.delete": "Delete",
    "ListItem.order": "Make Offer",
    "ListItem.orderShow": "Show Offer",
    "ListItem.linkTitle": "Settings",
    "ListItemDetail.price": "Total price: 1.690,00 €",
    "ListItemDetail.offer": "Offer",
    "ListItemDetail.order": "Order",
    "ListItemDetail.date": "Last modified on",
    "ConfigurationNewForm.button": "Accept",
    "Warning.RequireReset.Trough": "Due to changes to your configuration, if you want to choose a new trough and increase or decrease the quantity, all listed items has to be reset:",
    "Warning.RequireReset.Qty": "Due to changes to your configuration, if you want to increase or decrease the quantity, all listed items has to be reset:",
    "Warning.RequireReset.TypeOfInstallation": "Due to changes to your configuration, if you want to change the type of the installation, all listed items has to be reset:",
    "Warning.RequireReset.plateDepth": "Plate depth",
    "Warning.RequireReset.PlateDepth": "Due to changes to your configuration, if you want to change the plate depth, all listed items has to be reset:",
    "Warning.RequireReset.distances": "Distances",
    "Warning.RequireReset.cornerDesign": "Corner design",
    "Warning.RequireReset": "Reset required:",
    "Warning.RequireReset.Default": "Due to changes to your configuration you need to reset it.",
    "Warning.RequireReset.ResetAll": "Reset all?",
    "Warning.RequireReset.console": "Consoles",
    "Warning.RequireReset.drain": "Drain Accessories",
    "Warning.RequireReset.typeOfInstallation": "Type of installation",
    "Warning.RequireReset.paperTowelDispensers": "Cut out for towel dispenser",
    "Warning.RequireReset.plateWidth": "Plate width",
    "Warning.RequireReset.siphon": "Siphon",
    "Warning.RequireReset.soapDispenserHole": "Drill hole for soap dispenser.",
    "Warning.RequireReset.tapHole": "Drill hole for tap",
    "Warning.RequireReset.tissueDispenser": "Cut out for tissue dispenser",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Surge edge / Splashback",
    "ConfigurationDetail.error.default": "Your selected value isn't assignable, please check your input.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "Your selected value isn't assignable, please check your color bottom side.",
    "LogoTitle.default": "Configuration Overview",
    "LogoTitle.fallback": "KWC 3D Configurator",
    "MetaNavigationImprint.imprint": "Imprint",
    "MetaNavigationLegals.legals": "Legals",
    "MetaNavigationPrivacy.privacy": "Privacy Policy",
    "NavigationTrough.name": "Trough",
    "NavigationTrough.title": "Trough",
    "NavigationBasin.name": "Basin dimensions",
    "NavigationBasin.title": "Basin dimensions",
    "NavigationApron.name": "Apron / Splashback",
    "NavigationApron.title": "Apron / Splashback",
    "NavigationRecesses.name": "Recesses / built-in parts",
    "NavigationRecesses.title": "Recesses / built-in parts",
    "NavigationColour.name": "Colour",
    "NavigationColour.title": "Colour",
    "NavigationAssembly.name": "Assembly accessories",
    "NavigationAssembly.title": "Assembly accessories",
    "NavigationDrain.name": "Drain",
    "NavigationDrain.title": "Drain",
    "ProjectsEditFormButton.button": "Save project",
    "ProjectListItemEdit.edit": "Edit",
    "ProjectListItemDelete.delete": "Delete",
    "ProjectListItemLinkTitle.title": "Settings",
    "projectListHeadline.headline": "List of constructions",
    "ProjectListAdd.addText": "Add new adress",
    "ProjectNewFormButton.button": "Create project",
    "ProjectName.error": "Name is required.",
    "ProjectName.name": "Object name:",
    "ProjectStreet.error": "Street is required and should contain at least 2 characters.",
    "ProjectStreet.name": "Street",
    "ProjectStreetNr.error": "No. is required and should contain at least 2 characters.",
    "ProjectStreetNr.name": "No.",
    "ProjectZip.error": "Zip is required and should contain at least 2 characters.",
    "ProjectZip.name": "Zip",
    "ProjectCity.error": "City is required and should contain at least 2 characters.",
    "ProjectCity.name": "City",
    "ProjectCountry.error": "Country is required.",
    "ProjectCountry.name": "Country",
    "ProjectCountry.label": "Choose country",
    "ProjectSelectExistingProject.text": "Select existing object",
    "ProjectSelectCreateProject.text": "No existing object yet, please create one",
    "ProjectSelectButton.button": "Accept",
    "ProjectSelectWithout.without": "I´d like to proceed without an object",
    "ProjectSelectButtonTitle.title": "Edit Object",
    "ProjectWithout.label": "Yes, I´d like to proceed without an object",
    "ProjectWithout.button": "Accept",
    "SelectedTroughListButton.button": "Trough added",
    "SelectedTroughListItemWidth.width": "Width",
    "SelectedTroughListItemWidth.minWidth": "Min Width",
    "SelectedTroughListItemDepth.depth": "Depth",
    "SelectedTroughListItemDepth.minDepth": "Min Depth",
    "SelectedTroughListItemHeight.height": "Height",
    "TroughDetailModalButton.button": "Technical Drawing",
    "TroughFilterButton.button": "Deselect",
    "TroughFilterExos.error": "EXOS. is selected.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "VARIUSsign is selected.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "VARIUSmed is selected.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Square is selected.",
    "TroughFilterSquare.label": "square",
    "TroughFilterOval.error": "Oval is selected.",
    "TroughFilterOval.label": "oval",
    "TroughFilterRound.error": "Round is selected.",
    "TroughFilterRound.label": "round",
    "TroughFilterWithOverflow.error": "With overflow is selected.",
    "TroughFilterWithOverflow.label": "with overflow",
    "TroughFilterWithoutOverflow.error": "Without overflow is selected.",
    "TroughFilterWithoutOverflow.label": "without overflow",
    "TroughFilterWithBackwall.error": "With back panel is selected.",
    "TroughFilterWithBackwall.label": "with back panel",
    "TroughFilterWithoutBackwall.error": "With brackets is selected.",
    "TroughFilterWithoutBackwall.label": "with brackets",
    "TroughListButtonSelect.select": "Select trough",
    "TroughListButtonClose.close": "Close trough menu",
    "TroughListButtonFilterOptions.filter": "Show Filter Options",
    "TroughListSorryMsg.message": "Sorry, we didn't found any trough matching your selected filter options.",
    "TroughListItemWidth.width": "Width",
    "TroughListItemWidth.minWidth": "Min Width",
    "TroughListItemDepth.depth": "Depth",
    "TroughListItemDepth.minDepth": "Min Depth",
    "TroughListItemHeight.height": "Height",
    "TroughListMinValuesText.text": "min. washbasin width x depth",
    "RegisterSucceededComponent.resendSucceededHeading": "Resend activation link successfully",
    "ActivationFailed.activationInvalid": "Unfortunately activation is failed!",
    "ActivationFailed.activationInvalidToken": "Your token is expired. Please check if your account is already activated. Try to log in.",
    "ActivationFailed.activationInvalidTokenButton": "Send me new link",
    "ActivationFailed.ActivationResend": "Resend activation link",
    "Configuration.Inputs.distancesInmm": "(distances in mm)",
    "newEmail.text": "New Email Address",
    "newEmail.error": "This email is incorrect",
    "AccountProfile.button": "Save",
    "ApronLabel.with": "with apron",
    "ApronLabel.without": "without apron (Standard)",
    "SquareCustom.square": "square",
    "RoundCustom.round": "round",
    "SearchPlaceholder.placeholder": "What are you looking for?",
    "ColorCheckout.white": "white",
    "ColorCheckout.black": "Granite Black",
    "ColorCheckout.blackWhite": "Granite Black-White",
    "ColorCheckout.lightGray": "Granite light Gray",
    "ConfigurationDetail.Drain.note": "Note:",
    "ConfigurationDetail.Drain.noteMessage": "No options for selected trough.",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "The standpipe valve is included for the VARIUSmed MZB.",
    "ConfigurationDetail.Drain.noteExos": "Theft-proof drain cover with InoxPlus coating is included for EXOS troughs.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "Email change request successful",
    "ChangeEmailSucceededPageComponent.emailChangedText": "You will recieve an e-mail with an activation link. Please click it to activate your new email.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Go back to login",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Your password has been successfully reset.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Please login using your new password.",
    "ResetPasswordChangeSucceededPageComponent.button": "Login",
    "Warning.RequireReset.apron": "Apron",
    "submitAsOrder.label": "SAP transfer order",
    "ListItemDetail.draft": "Draft",
    "TroughDetailModalWidth.minWidth": "Min Width",
    "TroughDetailModalDepth.minDepth": "Min Depth",
    "TroughDetailModalWidth.width": "Width",
    "TroughDetailModalDepth.depth": "Depth",
    "TroughDetailModalHeight.height": "Height",
    "ConfigurationCountry.headline": "What country does your configuration belong to?",
    "ConfigurationCountry.button": "Accept",
    "ConfigurationCountry.select": "Please select a country...",
    "SelectedTroughListItemHeight.minDimensions": "min. washbasin width x depth",
    "TroughDetailModalDepth.minDimensions": "min. washbasin width x depth",
    "TroughListItemDepth.minDimensions": "min. washbasin width x depth",
    "CosmeticTissueDispenser.cosmeticTissue": "Cosmetic tissue dispenser",
    "PaperTowelDispenser.paperTowelDispenser": "Paper towel dispenser",
    "CutOutLabelNone.none": "Please select a disposal",
    "DistancesPosition.symmetrically": "Identical storage surfaces",
    "DistancesPosition.evenly": "Identical washbasin width",
    "CutOutLabel.CustomRound": "Round disposal",
    "CutOutLabel.CustomSquare": "Square disposal",
    "CutOutLabel.roundSleeve": "Round disposal with sleeve",
    "CutOutLabel.squareSleeve": "Square disposal with sleeve",
    "CutOutLabel.roundBasket": "Round disposal with basket",
    "CutOutLabel.roundRail": "Round disposal with waste bin with sliding frame",
    "CutOutLabel.squareBasket": "Square disposal with basket",
    "CutOutLabel.squareRail": "Square disposal with waste bin with sliding frame",
    "CutOutLabel.roundSleeveBasket": "Round disposal with sleeve and basket",
    "CutOutLabel.roundSleeveRail": "Round disposal with sleeve and waste bin with sliding frame",
    "CutOutLabel.squareSleeveBasket": "Square disposal with sleeve and basket",
    "CutOutLabel.squareSleeveRail": "Square disposal with sleeve and waste bin with sliding frame",
    "CutOutLabel.flap": "Disposal flap",
    "CutOutLabel.flapBasket": "Disposal flap with basket",
    "CutOutLabel.flapRail": "Disposal flap with waste bin with sliding frame",
    "CutOutLabel.provider": "Paper towel dispenser",
    "ApronHeightRequiredChoiceMessage.message": "For a better look of your washbasin, we recommend you to select an apron to use:",
    "apronHeightRequiredChoice60.60": "Change the apron height to 60 mm",
    "apronHeightRequiredChoice150.150": "Change the apron height to 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Maintain apron height",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Maintain apron height and continue without the sleeve",
    "CosmeticTissueDispenser.with": "with paper tissue dispenser",
    "PlateDimensionsDepth.470": "Recommendation for wall fittings",
    "PlateDimensionsDepth.550": "Recommendation for stand fittings",
    "Warning.RequireReset.cutOutDisposals": "Cut out disposals",
    "checkboxPositions.noSpace": "Not enough space available",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Cut out for paper towel dispenser",
    "ApronAffects.position": "Attention: Apron width of 18 mm leads to the displacement of the trough position.",
    "DepthRequiredHint.hint": "Note:",
    "DepthRequiredMessage.message": "The washbasin depth you have chosen is not sufficient. Would you like to set the required depth of {requiredDepth} mm for this disposal?",
    "ThankYou.orderPdf": "Configuration washbasin (PDF)",
    "ThankYou.manufacturingPdf": "Drawing washbasin (PDF)",
    "ThankYou.troughPdf": "Drawing trough (PDF)",
    "PlateDimensionsRequired.hint": "Note:",
    "PlateDimensionsRequired.message": "The width of your washbasin is not sufficient. To place an apron, the washbasin width must be enlarged. Would you like to continue?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "If you deselect the apron, the original dimensions of your configuration will be restored.",
    "PlateDimensionsChoice.message": "There is not enough space at your washbasin for an apron. You have the following options to proceed:",
    "PlateDimensionsChoice.increase": "Change the width of the washbasin",
    "PlateDimensionsChoice.move": "Move the bowl(s) and keep the width of the washbasin",
    "PlateDimensionsChoice.cancel": "Cancel (the dimensions without apron are kept)",
    "ApronHeightAndDimensionsRequiredMessage.message": "To position a towel rail, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your washbasin width must be enlarged. Would you like to continue?",
    "Checkout.OrderPdf": "Configuration washbasin (PDF)",
    "Checkout.ManufacturingPdf": "Drawing washbasin (PDF)",
    "submitAsRequest.label": "Request offer",
    "checkoutSave.label": "Save",
    "submitAsOffer.label": "SAP transfer offer",
    "ListItemDetail.request": "Request",
    "ListItem.orderPdf": "Configuration washbasin (PDF)",
    "ListItem.manufacturingPdf": "Drawing washbasin (PDF)",
    "ListItem.troughPdf": "Drawing trough (PDF)",
    "PlateDimensionsRequiredLimit.message": "Maximum washbasin width reached. No apron selection possible.",
    "PlateDimensionsChoiceLimit.message": "Maximum washbasin width reached:",
    "CutoutPartDetail.name": "Name",
    "CutoutPartDetail.dimensions": "Dimensions",
    "CutoutPartDetail.type": "Type",
    "CutoutPartDetail.article": "Article Number",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "To position a towel rail, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your washbasin width must be enlarged. Would you like to continue?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "To position a cosmetic tissue dispenser, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your washbasin width must be enlarged. Would you like to continue?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "To position this cut out, you need a 150 mm apron. As the width of your washbasin is not sufficient for an apron placement, your washbasin width must be enlarged. Would you like to continue?",
    "apronHeightForTowelRailRequiredMessage.message": "To choose a towel rail, you need a {requiredHeight} mm apron. Do you want to continue?",
    "apronHeightForTissueDispenserRequiredMessage.message": "To choose a cosmetic tissue dispenser, you need a {requiredHeight} mm apron. Do you want to continue?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "To choose this cut out, you need a {requiredHeight} mm apron. Do you want to continue?",
    "ListItem.archive": "Archive",
    "ConfigurationSwitchView.mine": "My Configurations",
    "FolderSwitchView.mine": "My Configurations",
    "ConfigurationSwitchView.connected": "Connected",
    "ConfigurationSwitchView.archived": "Archived",
    "Archive.headline": "Are you sure you want to archive your configuration?",
    "Archive.button": "Accept",
    "Unarchive.headline": "Are you sure you want to restore your configuration?",
    "Unarchive.button": "Accept",
    "ListItem.unarchive": "Restore",
    "WithNicheHint.hint": "Note:",
    "WithNicheMessage.message": "Length of washbasin = dimensions of finished niche minus 8 mm. Please subtract 4 mm per washbasin side during configuration. Please consider structural projections.",
    "checkboxPositions.tissueConflict": "Waste rail has changed",
    "CutOutLabel.cosmetic": "Cosmetic tissue dispenser",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "We have sent you a link by email, your account will be activated after confirmation.",
    "ConsolesOverlapChoice.message": "Configuration not possible, please increase distance or select stainless steel console.",
    "ConsolesOverlapChoice.continue": "Return to original value (with MIRANIT console)",
    "ConsolesOverlapChoice.return": "Return to original value (with MIRANIT console)",
    "ConsolesOverlapChoice.change": "Change to stainless steel console(s)",
    "checkoutSave.orderIsFailed": "Order has failed to submit to the SAP system. Please duplicate the configuration and try again later.",
    "Warning.RequireReset.qty": "Trough quantity",
    "ConfigurationNewFormName.error": "Name is required.",
    "ConfigurationNewFormName.label": "Name",
    "ConfigurationNewFormName.placeholder": "Name",
    "ConfigurationNewFormPricingsAccessories.error": "Time period is required.",
    "ConfigurationNewFormPricingsAccessories.label": "Time Period Accessories",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Please select...",
    "ConfigurationNewFormPricingsWashbasin.error": "Time period is required.",
    "ConfigurationNewFormPricingsWashbasin.label": "Time Period Washbasin",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Please select...",
    "checkoutParts.timePeriodNote": "Note:",
    "checkoutParts.timePeriodNoteText": "Please select the period for the price validity",
    "checkoutParts.timePeriodAccessoriesLabel": "Time Period Accessories",
    "checkoutParts.timePeriodWashbasinLabel": "Time Period Washbasin",
    "checkoutSave.orderIsQueued": "Order has failed to submit to the SAP system. It has been queued for later submission.",
    "ListItemDetail.failed": "Failed",
    "ListItemDetail.queued": "Queued",
    "TroughFilterMedcare.error": "MEDCARE is required.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "available from August 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/en_GB/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(running)",
    "Login.mustLogin": "To start the configuration, you must log in. If you do not yet have an account, create a new account.",
    "Troughs.toStart": "To start the configuration, you must {login}. If you do not yet have an account, {create}.",
    "TroughFilter.modelLine": "Model line",
    "TroughFilter.characteristics": "Characteristics",
    "TroughListItem.min": "Washbasin min.",
    "TroughListItem.start": "Start Configuration",
    "TroughListItem.startWithLogin": "Start Configuration with Login",
    "TroughBanner.label": "Which troughs are available?",
    "TroughBanner.text": "Take a look in advance here.",
    "SearchPlaceholder.placeholderTroughs": "Search for a trough",
    "Troughs.toStartLogin": "log in",
    "Troughs.toStartCreate": "create a new account",
    "ConfigurationDownload3D.text": "Download 3D Scene",
    "ConfigurationNewFolder.newHeading": "New Folder",
    "NewButtonsNewFolder.text": "New Folder",
    "NewButtonsNewConfiguration.text": "Create Configuration",
    "FolderListHeading.text": "Folders",
    "FolderListNone.text": "No folders available yet",
    "ConfigurationListHeading.text": "Un-assigned Configurations",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "See all folders",
    "ListItem.moveToGroup": "Move to Folder",
    "ListItem.goBack": "Go back",
    "FolderSwitchView.goBack": "Go back",
    "ListItem.downloadPdfs": "Download PDFs",
    "ConfigurationDeleteFolder.cancel": "Cancel",
    "ConfigurationEditFolder.cancel": "Cancel",
    "ConfigurationNewFolder.cancel": "Cancel",
    "ConfigurationNewFolder.create": "Create",
    "ConnectedFolder.label": "Yes, I would like to create a new folder with the object name on my dashboard. ",
    "FolderListHeadingAll.text": "All Folders",
    "FolderListToday.text": "Today",
    "FolderList7Days.text": "Previous 7 days",
    "FolderList30Days.text": "Previous 30 days",
    "FolderListItemNestedDelete.text": "Delete Construction Phase",
    "ConfigurationDeleteNestedFolder.heading": "Delete Construction Phase",
    "ConfigurationNewFolderNested.newHeading": "New Construction Phase",
    "ListItem.moveToThisGroup": "Move to this folder",
    "ConfigurationDeleteFolder.note": "Note:",
    "ConfigurationDeleteNestedFolder.body": "If you delete this construction phase, the configurations it contains will still remain, they will simply be moved to the folder storage.",
    "ConfigurationDeleteFolder.body": "If you delete this construction phase, the configurations it contains will still remain, they will simply be moved to the folder storage.",
    "FolderListNestedHeading.test": "Construction Phases",
    "BuildingNumber.error": "Building number is required.",
    "OpportunityNumber.error": "Opportunity number is required.",
    "FolderListItemDelete.text": "Delete Folder",
    "ConfigurationDeleteFolder.heading": "Delete Folder",
    "ConfigurationDeleteFolder.confirm": "Confirm",
    "ConfigurationEditFolder.heading": "Edit Folder",
    "ConfigurationEditFolderNested.heading": "Edit Construction Phase",
    "ConfigurationEditFolder.confirm": "Confirm",
    "ConfigurationListNone.text": "No configurations available yet",
    "ListItemDetail.basin": "Washbasin",
    "ListItemDetail.number": "Troughs",
    "ListItem.moveToDashboard": "Move to Dashboard",
    "FolderList.SortByDate": "Sort by Date",
    "FolderList.SortByName": "Sort by Name",
    "FolderName.name": "Folder Name",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "de": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "中国 | China",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Konfigurationsübersicht",
    "NavigationUser.accountName": "Login und Sicherheit",
    "NavigationUser.adressesName": "Liefer- und Rechnungsadressen",
    "CheckoutHeadline.checkout": "Übersicht",
    "CheckoutBackButton.checkout": "Zurück zur Konfiguration",
    "CheckoutConfigurationHeadline.checkout": "Konfiguration Waschtisch",
    "CheckoutPartsHeadline.checkout": "Zubehör",
    "CheckoutPartsHeadlineLink.checkout": "Konfigurationsübersicht",
    "Delete.headline": "Sind Sie sicher, dass Sie diese Konfiguration löschen möchten?",
    "Delete.button": "Akzeptieren",
    "Assemblies.note": "Hinweis:",
    "Assemblies.message.with": "Das gesamte Montagezubehör ist nur für Massivwände ausgerichtet.",
    "Assemblies.message.without": "Befestigung bauseits.",
    "Assemblies.message.alwaysTriggerSafety": "Abzugssicherung immer inklusive.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Montagezubehör",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Auswahl",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Montagezubehör",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Waschtischabmessungen",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Einbauart",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Winkel der Nische",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Eckengestaltung",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Plattenmaße",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Muldenpositionen",
    "ConfigurationDetail.ApronBacksplash.apron": "Schürze",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Schwallkante / Aufkantung",
    "ConfigurationDetail.Recesses.tapHole": "Armaturenbohrung",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Seifenspenderbohrung",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Abwurf",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Papiertuchspender",
    "ConfigurationDetail.Recesses.towelRail": "Handtuchhalter",
    "ConfigurationDetail.plateSurface.colour": "Farbe",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Unterseite",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Schürze / Aufkantung",
    "ConfigurationDetail.Drain.drainTitle": "Ablaufzubehör",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Ablaufzubehör",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Konfiguration abschließen",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Aussparungen / Einbauteile",
    "ConfigurationDetail.colour.colourTitle": "Farbe",
    "ConfigurationDetail.troughs.troughsTitle": "Mulden",
    "ConfigurationProject.headline": "Zu welchem Objekt gehört Ihre Konfiguration?",
    "ConfigurationProject.tabexisting": "Bestehendes Objekt auswählen",
    "ConfigurationProject.tabnew": "Neues Objekt anlegen",
    "ConfigurationProject.tabEXISTING": "EXISTING",
    "ConfigurationProject.tabNEW": "NEW",
    "ConfigurationProject.tabWITHOUT": "WITHOUT",
    "ConfigurationDuplicate.headline": "Möchten Sie diese Konfiguration duplizieren?",
    "ConfigurationDuplicate.button": "Duplizieren",
    "ConfigurationNew.headline": "Bitte geben Sie Ihre Konfigurationsdetails an:",
    "ConfigurationRename.headline": "Wie möchten Sie Ihre Konfiguration benennen?",
    "ChangePasswordPage.changePasswordHeading": "Legen Sie Ihr neues Passwort fest",
    "ChangePasswordPage.changePasswordText": "Das Passwort muss mindesten 2 von 3 der folgenden Bedingungen erfüllen: Buchstaben (e.g. ABCD...) - Nummern (e.g. 0123...) - Sonderzeichen (e.g. #$%...)",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Ihr Passwort wurde erfolgreich geändert.",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Gehen Sie zurück zum Login und geben Ihr neues Passwort ein.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Zurück zum Login",
    "HomeLink.imprint": "Impressum",
    "HomeLink.legals": "Allgemeine Geschäftsbedingungen",
    "HomeLink.privacy": "Datenschutz- und Cookies-Richtlinie",
    "Login.newUser": "Neues Konto erstellen",
    "Login.forgotPassword": "Passwort vergessen?",
    "Login.Label.Email": "E-Mail",
    "Login.Placeholder.Email": "E-Mail",
    "Login.Error.Email": "E-mail ist ein Pflichtfeld.",
    "Login.Label.Password": "Passwort",
    "Login.Placeholder.Password": "Passwort",
    "Login.Error.Password": "Passwort ist ein Pflichtfeld.",
    "ResetPassword.button": "Zurück zum Login",
    "ResetPasswordSucceededPageComponent.resetPassword": "Ihr Passwort wurde erfolgreich geändert.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Bitte prüfen Sie Ihre E-Mail und klicken Sie auf den Bestätigungslink.",
    "ResetPasswordSucceededPageComponent.button": "Login",
    "ChangePwOld.label": "Altes Passwort",
    "ChangePwOld.placeholder": "Altes Passwort",
    "ChangePwOld.error": "Das Passwort muss mindesten 2 von 3 der folgenden Bedingungen erfüllen: Buchstaben (e.g. ABCD...) - Nummern (e.g. 0123...) - Sonderzeichen (e.g. #$%...)",
    "ChangePwNew.label": "Neues Passwort",
    "ChangePwNew.error": "Das Passwort muss mindesten 2 von 3 der folgenden Bedingungen erfüllen: Buchstaben (e.g. ABCD...) - Nummern (e.g. 0123...) - Sonderzeichen (e.g. #$%...)",
    "ChangePwNew.placeholder": "Neues Passwort",
    "ChangePwNewRepeat.label": "Passwort erneut eingeben",
    "ChangePwNewRepeat.error": "Passwörter stimmen nicht überein.",
    "ChangePwNewRepeat.placeholder": "Passwort erneut eingeben",
    "PageNotFound.message": "Ein Fehler ist aufgetreten. Die von Ihnen gesuchte Seite existiert nicht.",
    "AccountProfile.name": "Name",
    "AccountProfile.telephone": "Telefonnummer",
    "AccountProfile.street": "Straße",
    "AccountProfile.zip": "PLZ",
    "AccountProfile.surname": "Nachname",
    "AccountProfile.mobile": "Mobilnummer",
    "AccountProfile.city": "Stadt",
    "AccountProfile.country": "Land",
    "AccountProfile.userbutton": "Formular bearbeiten",
    "AccountProfile.email": "E-Mail Adresse",
    "AccountProfile.password": "Passwort",
    "AccountProfile.loginbutton": "Formular bearbeiten",
    "AccountProfile.headline": "Login und Sicherheit",
    "projectsNewHeadline.headline": "Neues Projekt anlegen",
    "projectsOverviewHeadline.headline": "Liefer- und Rechnungsadressen",
    "ProjectsDelete.headline": "Sind Sie sicher, dass Sie dieses Projekt löschen möchten?",
    "ProjectsDelete.button": "Akzeptieren",
    "ProjectsEdit.headline": "Ihr Projekt bearbeiten:",
    "ProjectsNew.headline": "Bitte legen Sie einen Namen für Ihr Objekt fest:",
    "RegisterPage.registerText": "Bitte geben Sie eine gültige E-Mail Adresse und ein Passwort für Ihr Konto ein.",
    "RegisterPage.registerButton": "Zurück zum Login",
    "RegisterMail.error": "E-Mail ist ein Pflichtfeld.",
    "RegisterMail.name": "E-Mail",
    "RegisterPw.error": "Das Passwort muss mindesten 2 von 3 der folgenden Bedingungen erfüllen: Buchstaben (e.g. ABCD...) - Nummern (e.g. 0123...) - Sonderzeichen (e.g. #$%...)",
    "RegisterPw.name": "Passwort",
    "RegisterPwRepeat.error": "Passwörter stimmen nicht überein.",
    "RegisterPwRepeat.name": "Passwort erneut eingeben",
    "RegisterUserGender.error": "Anrede ist ein Pflichtfeld",
    "RegisterUserGender.label": "Anrede",
    "RegisterUserGender.mr": "Herr",
    "RegisterUserGender.mrs": "Frau",
    "registerUserFirstName.error": "Vorname ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "registerUserFirstName.label": "Vorname",
    "registerUserLastName.error": "Nachname ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "registerUserLastName.label": "Nachname",
    "registerUserPhone.label": "Telefon",
    "registerUserMobile.label": "Mobil",
    "registerUserCompany.label": "Unternehmen",
    "registerUserStreet.error": "Straße ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "registerUserStreet.label": "Straße",
    "registerUserHouse.error": "Hausnummer ist ein Pflichtfeld und muss mindestens 1 Zeichen haben.",
    "registerUserHouse.label": "Hausnummer",
    "registerUserZip.error": "PLZ ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "registerUserZip.label": "PLZ",
    "registerUserCity.error": "Stadt ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "registerUserCity.label": "Stadt",
    "registerUserAddressAdditional.label": "Adressenzusatz",
    "registerUserCountry.error": "Land ist ein Pflichtfeld.",
    "registerUserCountry.label": "Land",
    "registerUserCountryLabel.label": "Wählen Sie ein Land",
    "registerUserClientNr.label": "Kundennummer (falls vorhanden)",
    "registerUserBranch.error": "Branche ist ein Pflichtfeld",
    "registerUserBranch.label": "Branche",
    "registerUserBranchSanitary.label": "Sanitärgroßhandel",
    "registerUserBranchPlanner.label": "Planer / Architekt",
    "registerUserBranchPlumber.label": "Installateur",
    "registerUserBranchRetail.label": "Endkunde",
    "editUserGender.error": "Anrede ist ein Pflichtfeld",
    "editUserGender.label": "Anrede",
    "editUserGenderMr.label": "Herr",
    "editUserGenderMrs.label": "Frau",
    "editUserFirstName.error": "Vorname ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "editUserFirstName.label": "Vorname",
    "editUserLastName.error": "Nachname ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "editUserLastName.label": "Nachname",
    "editUserPhone.label": "Telefon",
    "editUserMobile.label": "Mobil",
    "editUserStreet.error": "Straße ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "editUserStreet.label": "Straße",
    "editUserHouse.error": "Hausnummer ist ein Pflichtfeld und muss mindestens 1 Zeichen haben.",
    "editUserHouse.label": "Hausnummer",
    "editUserAddressAdditional.label": "Adressenzusatz",
    "editUserZip.error": "PLZ ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "editUserZip.label": "PLZ",
    "editUserCity.error": "Stadt ist ein Pflichtfeld und muss mindestens 2 Zeichen haben.",
    "editUserCity.label": "Stadt",
    "editUserCountry.error": "Land ist ein Pflichtfeld.",
    "editUserCountry.label": "Land",
    "editUserCountryLabel.label": "Wählen Sie ein Land",
    "RegisterSucceededComponent.registerSucceededHeading": "Vielen Dank. Ihre Registrierung ist jetzt fast abgeschlossen.",
    "RegisterSucceededComponent.registerSucceededText": "In wenigen Augenblicken erhalten Sie von uns eine E-Mail, die einen Link enthält. Nachdem <b>Sie mit einem Klick auf diesen Link Ihre E-Mail-Adresse bestätigt haben</b>, können Sie sich einloggen.",
    "RegisterSucceededComponent.registerSucceededButton": "Zurück zum Login",
    "ThankYou.headline": "Vielen Dank für Ihre Konfiguration!",
    "ThankYou.message": "Wir haben Ihnen eine Bestätigung per E-Mail mit allen Details zu Ihrem Angebot gesendet.",
    "ThankYou.order": "Ihre Angebotsnummer:",
    "ThankYou.pdfbutton": "Exportieren als 2D PDF",
    "ThankYou.tenderdocuments": "Ausschreibungstexte",
    "ThankYou.overviewbutton": "Zur Konfigurationsübersicht",
    "Configuration3dAlert.attention": "Wie starten?",
    "Configuration3dAlert.message": "Bitte wählen Sie Ihre gewünschte Mulde mit Klick auf den Button (Mulde auswählen) aus und starten Sie Ihre Konfiguration. Viel Spaß beim Konfigurieren!",
    "ActivationSucceeded.activationSucceededText": "Glückwunsch, Ihr Konto wurde erfolgreich eingerichtet. Gehen Sie zurück zum Login und geben Ihre Nutzerdaten ein.",
    "ActivationSucceeded.activationSucceededButton": "Los geht´s",
    "ActivationFailed.activaionUserNotFound": "Dieser Benutzer existiert nicht. Bitte legen Sie ein neues Konto an.",
    "ActivationFailed.activaionUserNotFoundButton": "Registrieren",
    "ChangeEmailForm.button": "E-Mail Adresse ändern",
    "ChangePassword.button": "Passwort ändern",
    "LoginForm.button": "Login",
    "Logout.button": "Logout",
    "RegisterUserDataForm.headline": "Bitte geben Sie hier Ihre persönlichen Daten ein.",
    "RegisterUserDataForm.button": "Neuen Account erstellen",
    "RegisterUserDataForm.logout": "Zurück zum Login",
    "RegisterUserForm.button": "Neuen Account erstellen",
    "ResetPasswordForm.button": "Passwort zurücksetzen",
    "ResetPasswordChangeForm.button": "Passwort zurücksetzen",
    "Checkout.WashBasinDimensions": "Waschtischabmessungen",
    "Checkout.PlateDimensions.Width": "Breite",
    "Checkout.PlateDimensions.Depth": "Tiefe",
    "Checkout.TypeOfInstallation": "Einbauart",
    "Checkout.TypeOfInstallation.Left": "Nische links",
    "Checkout.TypeOfInstallation.Right": "Nische rechts",
    "Checkout.TypeOfInstallation.With": "Nische links und rechts",
    "Checkout.CornerDesign": "Eckengestaltung",
    "Checkout.CornerDesign.Radius": "Radius 100 mm",
    "Checkout.CornerDesign.Bevel": "Abschrägung, 100 mm",
    "Checkout.Left": "links",
    "Checkout.Right": "rechts",
    "Checkout.ApronBackSplash.Headline": "Schürze / Aufkantung",
    "Checkout.ApronBackSplash.Apron": "Schürze: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Schwallkante: {position} / 3 mm",
    "Checkout.ApronBackSplash.apronBackSplash": "Aufkantung: {position} / {height} mm",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Aussparungen / Einbauteile",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x Armaturenbohrungen",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x Seifenspenderbohrung",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x Ausschnitt “{name}”",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x Ausschnitt für Kosmetiktuchspender",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x Ausschnitt für Handtuchhalter",
    "Checkout.Surface.Title": "Farbe",
    "Checkout.Surface.Color": "Farbe: {color}",
    "Checkout.Surface.GelCoat": "Gelcoat Unterseite",
    "Checkout.AssemblyAccessories.Title": "Montagezubehör",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x Konsole {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x Winkelleiste zur Montage an der Seitenwand",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x Abzugssicherung zur Montage an der Rückwand",
    "Checkout.GeneralInfo.Headline": "Übersicht",
    "Checkout.GeneralInfo.ConfName": "Konfigurationsname:",
    "Checkout.TotalPrice.Washbasin": "Waschtisch",
    "Checkout.TotalPrice.Parts": "Zubehör",
    "Checkout.TotalPrice.DeliveryCosts": "Transportkosten",
    "Checkout.TotalPrice.Vat": "MwSt.",
    "Checkout.TotalPrice.Total": "Gesamtsumme",
    "Checkout.TotalPrice.Note": "Hinweis:",
    "Checkout.TotalPrice.NoteText": "Preise gültig bis ",
    "Checkout.Trough.Headline": "Mulde",
    "Checkout.Trough.Name": "Name der Mulde:",
    "Checkout.Trough.Qty": "Anzahl:",
    "Checkout.Trough.Dimensions": "Muldenabmessungen:",
    "checkoutPartsPdfButton.button": "PDF Herunterladen",
    "Apron.height": "Höhe der Schürze in mm",
    "ApronHeightRequiredHint.hint": "Hinweis:",
    "ApronHeightRequiredMessage.message": "Für die Auswahl eines Kosmetiktuchspenders benötigen Sie eine {requiredHeight} mm Schürze. Möchten Sie fortfahren?",
    "ApronHeightError.message": "Der Wert liegt außerhalb der Maße",
    "SurgeEdgeLabelWithout.without": "ohne",
    "SurgeEdgeLabelWith.with": "mit Schwallkante (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "mit Aufkantung",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "hinten (Standard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Höhe der Aufkantung in mm",
    "WithoutAssemblyAccessories.without": "ohne Montagezubehör",
    "WithAssemblyAccessories.with": "mit Montagezubehör",
    "WithAssemblyAccessoriesTooltipHint.hint": "Hinweis:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Befestigung bauseits.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Edelstahl",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Konsole",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Abzugssicherung",
    "AssemblyAccessoriesListAngleBar.anglebar": "Winkelleiste",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Befestigungsmaterial",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Edelstahl weiß",
    "CornerDesignLabelWithout.without": "Ohne Eckengestaltung",
    "CornerDesignLabelRadius.radius": "Radius (100 mm)",
    "CornerDesignLabelBevel.bevel": "Abschrägung (Seitenlänge 100 mm)",
    "DistancesPositionOfTroughs.distances": "Eingabe der Muldenmittenentfernung",
    "DistancesPositionOfTroughsHint.hint": "Hinweis:",
    "DistancesPositionOfTroughsMessage.message": "Vorteile und Anwendungsempfehlungen",
    "DistancesPositionOfTroughsFromPlate.plate": "Von der Platte bis zum hinteren Rand der Mulde",
    "PlateDimensionsWidth.width": "Plattenbreite",
    "PlateDimensionsDepth.depth": "Plattentiefe",
    "PlateDimensionsDepth.depthIndividual": "Individuell",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "Ihr Wert liegt außerhalb des zulässigen Bereichs",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Linke Seite",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Rechte Seite",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Nur möglich in Kombination mit Art der Installation \"mit, links oder rechts\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Nur möglich in Kombination mit Art der Installation \"ohne, links oder rechts\".",
    "Configuration.Inputs.message": "Ihr Wert liegt außerhalb des zulässigen Bereichs",
    "DrainLabelWithoutDrain.withoutdrain": "ohne Ablaufzubehör",
    "DrainLabelHoodDrain.hooddrain": "Haubenablaufventil",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Haubenablaufventil verchromt",
    "DrainLabelSieveDrain.sievedrain": "Siebablaufventil",
    "DrainLabelEccentric.eccentric": "Exzenterab- und Überlaufgarnitur",
    "DrainLabelSiphon.siphon": "Siphon XINX140",
    "CosmeticTissueDispenser.without": "ohne Papiertuchspender",
    "CosmeticTissueDispenserSquare.square": "eckig (mit Gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(für Papiertuchspender „Modellnummer“)",
    "CosmeticTissueDispenserPosition.position": "(Position zwischen den Mulden)",
    "CutOutLabelCustomInput.diameter": "Durchmesser",
    "CutOutLabelCustomInput.width": "Breite",
    "CutOutLabelCustomInput.depth": "Tiefe",
    "CutOutLabelSelect.select": "Bitte wählen Sie aus",
    "CutOutDisposalsDefaultsWithout.without": "ohne Abwurf",
    "CutOutDisposalsDefaultsWith.with": "mit Abwurf",
    "SoapDispenserHoleLabelWithout.without": "ohne",
    "SoapDispenserHoleLabelSD80.sd80": "für Seifenspender SD80",
    "SoapDispenserHoleLabelSD100.sd100": "für Seifenspender SD100",
    "SoapDispenserHoleLabel25.dispensers": "für Spender von Fremdfabrikaten (Ø 25 mm)",
    "TapHoleWithout.taphole": "ohne Bohrung",
    "TapHoleWithoutDrilling.tapholedrilling": "mit Bohrung (Ø 35 mm)",
    "TowelRailWithout.towelrailwithout": "ohne Ausschnitt",
    "TowelRailWithout.towelrailwith": "mit Ausschnitt",
    "ColorLabel.alpinewhite": "Alpinweiß (Standard)",
    "ColorLabel.alpinewhitetext": "Temperaturbeständig bis 80 ° C",
    "ColorLabel.graniteblack": "Granitschwarz",
    "ColorLabel.graniteblacktext": "Temperaturbeständig bis 65 ° C",
    "ColorLabel.graniteblackwhite": "Granit Schwarz-Weiß",
    "ColorLabel.graniteblackwhitetext": "Temperaturbeständig bis 65 ° C",
    "ColorLabel.graniteLightGray": "Granit hellgrau",
    "ColorLabel.granitelightgraytext": "Temperaturbeständig bis 65 ° C",
    "ColorBottomSideUncoated.uncoated": "unbeschichtet (Standard)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Hinweis:",
    "ColorBottomSideMessage.message": "Vorteile und Anwendungsempfehlungen",
    "ElementNext.button": "Weiter",
    "ElementsPositionsLeft.left": "links",
    "ElementsPositionsBack.back": "hinten",
    "ElementsPositionsFront.front": "vorn",
    "ElementsPositionsRight.right": "rechts",
    "ElementsPositionsRight.warning": "Deaktiviert, bitte Abstand zwischen den Mulden vergrößern.",
    "ConfigurationListAdd.text": "Neue Konfiguration hinzufügen",
    "ListItem.rename": "Umbenennen",
    "ListItem.duplicate": "Duplizieren",
    "ListItem.delete": "Löschen",
    "ListItem.order": "Angebot",
    "ListItem.orderShow": "Zum Angebot",
    "ListItem.linkTitle": "Einstellungen",
    "ListItemDetail.price": "Gesamtpreis: 1.690,00 €",
    "ListItemDetail.offer": "Angebot",
    "ListItemDetail.order": "Bestellung",
    "ListItemDetail.date": "Zuletzt geändert am",
    "ConfigurationNewForm.button": "Weiter",
    "Warning.RequireReset.Trough": "Aufgrund von Änderungen an Ihrer Konfiguration müssen alle aufgelisteten Elemente zurückgesetzt werden, wenn Sie eine neue Mulde auswählen und die Menge erhöhen oder verringern möchten:",
    "Warning.RequireReset.Qty": "Aufgrund von Änderungen an Ihrer Konfiguration müssen alle aufgelisteten Elemente zurückgesetzt werden, wenn Sie die Menge erhöhen oder verringern möchten:",
    "Warning.RequireReset.TypeOfInstallation": "Aufgrund von Änderungen an Ihrer Konfiguration müssen alle aufgelisteten Elemente zurückgesetzt werden, wenn Sie den Installationstyp ändern möchten:",
    "Warning.RequireReset.plateDepth": "Plattentiefe",
    "Warning.RequireReset.PlateDepth": "Aufgrund von Änderungen an Ihrer Konfiguration müssen alle aufgelisteten Elemente zurückgesetzt werden, wenn Sie die Plattentiefe ändern möchten:",
    "Warning.RequireReset.distances": "Entfernungen",
    "Warning.RequireReset.cornerDesign": "Eckengestaltung",
    "Warning.RequireReset": "Zurücksetzen erforderlich:",
    "Warning.RequireReset.Default": "Aufgrund von Änderungen an Ihrer Konfiguration müssen Sie diese zurücksetzen.",
    "Warning.RequireReset.ResetAll": "Alles zurücksetzen?",
    "Warning.RequireReset.console": "Konsolen",
    "Warning.RequireReset.drain": "Ablaufzubehör",
    "Warning.RequireReset.typeOfInstallation": "Einbauart",
    "Warning.RequireReset.paperTowelDispensers": "Ausschnitt für Handtuchhalter",
    "Warning.RequireReset.plateWidth": "Plattenbreite",
    "Warning.RequireReset.siphon": "Siphon",
    "Warning.RequireReset.soapDispenserHole": "Bohrung für Seifenspender",
    "Warning.RequireReset.tapHole": "Armaturenbohrung",
    "Warning.RequireReset.tissueDispenser": "Auschnitt für Papiertuchspender",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Schwallkante / Aufkantung",
    "ConfigurationDetail.error.default": "Ihr ausgewählter Wert ist nicht zuweisbar. Bitte überprüfen Sie Ihre Eingaben.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "Ihr gewählter Wert ist nicht zuweisbar, bitte überprüfen Sie Ihre Farbunterseite.",
    "LogoTitle.default": "Konfigurationsübersicht",
    "LogoTitle.fallback": "KWC 3D Konfigurator",
    "MetaNavigationImprint.imprint": "Impressum",
    "MetaNavigationLegals.legals": "Allgemeine Geschäftsbedingungen",
    "MetaNavigationPrivacy.privacy": "Datenschutz- und Cookie-Richtlinie",
    "NavigationTrough.name": "Mulde",
    "NavigationTrough.title": "Mulde",
    "NavigationBasin.name": "Waschtischabmessungen",
    "NavigationBasin.title": "Waschtischabmessungen",
    "NavigationApron.name": "Schürze / Aufkantung",
    "NavigationApron.title": "Schürze / Aufkantung",
    "NavigationRecesses.name": "Aussparungen / Einbauteile",
    "NavigationRecesses.title": "Aussparungen / Einbauteile",
    "NavigationColour.name": "Farbe",
    "NavigationColour.title": "Farbe",
    "NavigationAssembly.name": "Montagezubehör",
    "NavigationAssembly.title": "Montagezubehör",
    "NavigationDrain.name": "Ablaufzubehör",
    "NavigationDrain.title": "Ablaufzubehör",
    "ProjectsEditFormButton.button": "Projekt Speichern",
    "ProjectListItemEdit.edit": "Bearbeiten",
    "ProjectListItemDelete.delete": "Löschen",
    "ProjectListItemLinkTitle.title": "Einstellungen",
    "projectListHeadline.headline": "Liefer- und Rechnungsadressen",
    "ProjectListAdd.addText": "Neue Adresse hinzufügen",
    "ProjectNewFormButton.button": "Projekt erstellen",
    "ProjectName.error": "Name ist ein Pflichtfeld.",
    "ProjectName.name": "Objektname:",
    "ProjectStreet.error": "Straße ist ein Pflichtfeld und sollte mindestens 2 Zeichen enthalten.",
    "ProjectStreet.name": "Straße",
    "ProjectStreetNr.error": "Hausnummer ist ein Pflichtfeld und sollte mindestens 2 Zeichen enthalten.",
    "ProjectStreetNr.name": "Hausnummer.",
    "ProjectZip.error": "PLZ ist ein Pflichtfeld und sollte mindestens 2 Zeichen enthalten.",
    "ProjectZip.name": "PLZ",
    "ProjectCity.error": "Stadt ist ein Pflichtfeld und sollte mindestens 2 Zeichen enthalten.",
    "ProjectCity.name": "Stadt",
    "ProjectCountry.error": "Land ist ein Pflichtfeld.",
    "ProjectCountry.name": "Land",
    "ProjectCountry.label": "Wählen Sie ein Land aus",
    "ProjectSelectExistingProject.text": "Vorhandenes Objekt auswählen",
    "ProjectSelectCreateProject.text": "Noch kein Objekt vorhanden, bitte erstellen Sie eins",
    "ProjectSelectButton.button": "Weiter",
    "ProjectSelectWithout.without": "Ich würde gerne ohne ein Objekt fortfahren",
    "ProjectSelectButtonTitle.title": "Objekt bearbeiten",
    "ProjectWithout.label": "Ja, ich würde gerne ohne ein Objekt fortfahren",
    "ProjectWithout.button": "Weiter",
    "SelectedTroughListButton.button": "Mulde hinzugefügt",
    "SelectedTroughListItemWidth.width": "Breite",
    "SelectedTroughListItemWidth.minWidth": "Mindestbreite",
    "SelectedTroughListItemDepth.depth": "Tiefe",
    "SelectedTroughListItemDepth.minDepth": "Mindesttiefe",
    "SelectedTroughListItemHeight.height": "Höhe",
    "TroughDetailModalButton.button": "Technische Zeichnung",
    "TroughFilterButton.button": "Auswahl aufheben",
    "TroughFilterExos.error": "EXOS. ist ausgewählt.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "VARIUSsign ist ausgewählt.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "VARIUSmed ist ausgewählt.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Eckig ist ausgewählt.",
    "TroughFilterSquare.label": "eckig",
    "TroughFilterOval.error": "Oval ist ausgewählt.",
    "TroughFilterOval.label": "oval",
    "TroughFilterRound.error": "Rund ist ausgewählt.",
    "TroughFilterRound.label": "rund",
    "TroughFilterWithOverflow.error": "Mit Überlauf ist ausgewählt.",
    "TroughFilterWithOverflow.label": "mit Überlauf",
    "TroughFilterWithoutOverflow.error": "Ohne Überlauf ist ausgewählt.",
    "TroughFilterWithoutOverflow.label": "ohne Überlauf",
    "TroughFilterWithBackwall.error": "Mit Beckenrückwand ist ausgewählt.",
    "TroughFilterWithBackwall.label": "mit Beckenrückwand",
    "TroughFilterWithoutBackwall.error": "Mit Konsole ist ausgewählt.",
    "TroughFilterWithoutBackwall.label": "mit Konsolen",
    "TroughListButtonSelect.select": "Mulde auswählen",
    "TroughListButtonClose.close": "Menü schließen",
    "TroughListButtonFilterOptions.filter": "Filteroptionen anzeigen",
    "TroughListSorryMsg.message": "Es tut uns leid, wir konnten keine Mulde finden, die Ihren ausgewählten Filteroptionen entsprechen.",
    "TroughListItemWidth.width": "Breite",
    "TroughListItemWidth.minWidth": "Mindestbreite",
    "TroughListItemDepth.depth": "Tiefe",
    "TroughListItemDepth.minDepth": "Mindesttiefe",
    "TroughListItemHeight.height": "Höhe",
    "TroughListMinValuesText.text": "min. Waschtisch Breite x Tiefe",
    "RegisterSucceededComponent.resendSucceededHeading": "Aktivierungslink erfolgreich erneut gesendet",
    "ActivationFailed.activationInvalid": "Leider ist die Aktivierung fehlgeschlagen!",
    "ActivationFailed.activationInvalidToken": "Ihr Token ist abgelaufen. Bitte überprüfen Sie, ob dieses Konto aktiviert ist und loggen Sie sich erneut ein.",
    "ActivationFailed.activationInvalidTokenButton": "Neuen Link zusenden",
    "ActivationFailed.ActivationResend": "Aktivierungslink erneut senden",
    "Configuration.Inputs.distancesInmm": "(Abstände in mm)",
    "newEmail.text": "Neue E-Mail Adresse",
    "newEmail.error": "Die eingegebene E-Mail ist nicht korrekt.",
    "AccountProfile.button": "Speichern",
    "ApronLabel.with": "mit Schürze",
    "ApronLabel.without": "ohne Schürze (Standard)",
    "SquareCustom.square": "eckig",
    "RoundCustom.round": "rund",
    "SearchPlaceholder.placeholder": "Geben Sie Ihren Suchbegriff ein",
    "ColorCheckout.white": "Alpinweiß",
    "ColorCheckout.black": "Granit Schwarz",
    "ColorCheckout.blackWhite": "Granit Schwarz-Weiß",
    "ColorCheckout.lightGray": "Granit hellgrau",
    "ConfigurationDetail.Drain.note": "Hinweis:",
    "ConfigurationDetail.Drain.noteMessage": "Keine Optionen für die ausgewählte Mulde.",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "Das Standrohrventil ist für das VARIUSmed MZB im Lieferumfang enthalten.",
    "ConfigurationDetail.Drain.noteExos": "Abzugssicherung mit InoxPlus-Beschichtung ist für EXOS. Mulden im Lieferumfang enthalten.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "E-Mail erfolgreich geändert",
    "ChangeEmailSucceededPageComponent.emailChangedText": "Sie erhalten in Kürze einen Aktivierungslink per E-Mail. Zur Aktivierung Ihres Kontos klicken Sie bitte diesen Link an.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Zurück zum Login",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Ihr Passwort wurde erfolgreich zurückgesetzt.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Bitte melden Sie sich mit Ihrem neuen Passwort an.",
    "ResetPasswordChangeSucceededPageComponent.button": "Login",
    "Warning.RequireReset.apron": "Schürze",
    "submitAsOrder.label": "SAP-Übergabe Auftrag",
    "ListItemDetail.draft": "Entwurf",
    "TroughDetailModalWidth.minWidth": "Mindestbreite",
    "TroughDetailModalDepth.minDepth": "Mindesttiefe",
    "TroughDetailModalWidth.width": "Breite",
    "TroughDetailModalDepth.depth": "Tiefe",
    "TroughDetailModalHeight.height": "Höhe",
    "ConfigurationCountry.headline": "Zu welchem Land gehört Ihre Konfiguration?",
    "ConfigurationCountry.button": "Weiter",
    "ConfigurationCountry.select": "Bitte wählen Sie ein Land aus",
    "SelectedTroughListItemHeight.minDimensions": "min. Waschtisch Breite x Tiefe",
    "TroughDetailModalDepth.minDimensions": "min. Waschtisch Breite x Tiefe",
    "TroughListItemDepth.minDimensions": "min. Waschtisch Breite x Tiefe",
    "CosmeticTissueDispenser.cosmeticTissue": "Kosmetiktuchspender",
    "PaperTowelDispenser.paperTowelDispenser": "Papierhandtuchspender",
    "CutOutLabelNone.none": "Bitte Abwurf auswählen",
    "DistancesPosition.symmetrically": "identische Ablageflächen",
    "DistancesPosition.evenly": "identische Waschplatzbreite",
    "CutOutLabel.CustomRound": "runder Abwurf",
    "CutOutLabel.CustomSquare": "eckiger Abwurf",
    "CutOutLabel.roundSleeve": "runder Abwurf mit Abwurfhülse",
    "CutOutLabel.squareSleeve": "eckiger Abwurf mit Abwurfhülse",
    "CutOutLabel.roundBasket": "runder Abwurf mit Abfallkorb",
    "CutOutLabel.roundRail": "runder Abwurf und Abfallkorb mit Auszugsrahmen",
    "CutOutLabel.squareBasket": "eckiger Abwurf mit Abfallkorb",
    "CutOutLabel.squareRail": "eckiger Abwurf und Abfallkorb mit Auszugsrahmen",
    "CutOutLabel.roundSleeveBasket": "runder Abwurf mit Abwurfhülse und Abfallkorb",
    "CutOutLabel.roundSleeveRail": "runder Abwurf mit Abwurfhülse und Abfallkorb mit Auszugsrahmen",
    "CutOutLabel.squareSleeveBasket": "eckiger Abwurf mit Abwurfhülse und Abfallkorb",
    "CutOutLabel.squareSleeveRail": "eckiger Abwurf mit Abwurfhülse und Abfallkorb mit Auszugsrahmen",
    "CutOutLabel.flap": "Abwurfklappe",
    "CutOutLabel.flapBasket": "Abwurfklappe mit Abfallkorb",
    "CutOutLabel.flapRail": "Abwurfklappe und Abfallkorb mit Auszugsrahmen",
    "CutOutLabel.provider": "Papiertuchspender",
    "ApronHeightRequiredChoiceMessage.message": "Für eine bessere Optik Ihres Waschtisches empfehlen wir Ihnen, eine Schürze zu wählen:",
    "apronHeightRequiredChoice60.60": "Schürzenhöhe auf 60 mm ändern",
    "apronHeightRequiredChoice150.150": "Schürzenhöhe auf 150 mm ändern",
    "apronHeightRequiredChoiceSkip.skip": "Schürzenhöhe beibehalten",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Schürzenhöhe beibehalten und ohne Hülse fortfahren",
    "CosmeticTissueDispenser.with": "mit Papiertuchspender",
    "PlateDimensionsDepth.470": "Empfehlung für Wandarmaturen",
    "PlateDimensionsDepth.550": "Empfehlung für Standarmaturen",
    "Warning.RequireReset.cutOutDisposals": "Abwurf",
    "checkboxPositions.noSpace": "Nicht genügend Platz vorhanden",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Ausschnitt für Papierhandtuchspender",
    "ApronAffects.position": "Achtung: Schürzenbreite von 18 mm führt zur Verschiebung der Muldenposition.",
    "DepthRequiredHint.hint": "Hinweis:",
    "DepthRequiredMessage.message": "Die von Ihnen gewählte Waschtischtiefe ist nicht ausreichend. Möchten Sie für diesen Abwurf die erforderliche Tiefe von {requiredDepth} mm einstellen?",
    "ThankYou.orderPdf": "Konfiguration Waschtisch (PDF)",
    "ThankYou.manufacturingPdf": "Zeichnung Waschtisch (PDF)",
    "ThankYou.troughPdf": "Zeichnung Mulde (PDF)",
    "PlateDimensionsRequired.hint": "Hinweis:",
    "PlateDimensionsRequired.message": "Die Breite Ihres Waschtisches ist nicht ausreichend. Um eine Schürze zu platzieren, muss die Waschtischbreite vergrößert werden. Möchten Sie fortfahren?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Wenn Sie die Schürze abwählen, werden die ursprünglichen Maße Ihrer Konfiguration wiederhergestellt.",
    "PlateDimensionsChoice.message": "Es ist nicht genügend Platz an Ihrem Waschtisch für eine Schürze vorhanden. Sie haben die folgenden Möglichkeiten, um fortzufahren:",
    "PlateDimensionsChoice.increase": "Die Breite des Waschtisches ändern",
    "PlateDimensionsChoice.move": "Die Mulde(n) verschieben und die Breite des Waschtisches behalten",
    "PlateDimensionsChoice.cancel": "Abbrechen (die Maße ohne Schürze werden beibehalten)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Um einen Handtuchhalter zu positionieren, benötigen Sie eine 150 mm Schürze. Da die Breite Ihres Waschtisches nicht ausreichend für eine Schürzenplatzierung ist, muss die Waschtischbreite vergrößert werden. Möchten Sie fortfahren?",
    "Checkout.OrderPdf": "Konfiguration Waschtisch (PDF)",
    "Checkout.ManufacturingPdf": "Zeichnung Waschtisch (PDF)",
    "submitAsRequest.label": "Angebot anfordern",
    "checkoutSave.label": "Speichern",
    "submitAsOffer.label": "SAP-Übergabe Angebot",
    "ListItemDetail.request": "Anfrage",
    "ListItem.orderPdf": "Konfiguration Waschtisch (PDF)",
    "ListItem.manufacturingPdf": "Zeichnung Waschtisch (PDF)",
    "ListItem.troughPdf": "Zeichnung Mulde (PDF)",
    "PlateDimensionsRequiredLimit.message": "Maximale Waschtischbreite erreicht. Keine Schürzenauswahl möglich.",
    "PlateDimensionsChoiceLimit.message": "Es ist nicht genügend Platz an Ihrem Waschtisch für eine Schürze vorhanden. Maximale Waschtischbreite erreicht. Sie haben die folgenden Möglichkeiten, um fortzufahren:",
    "CutoutPartDetail.name": "Name",
    "CutoutPartDetail.dimensions": "Maße",
    "CutoutPartDetail.type": "Typ",
    "CutoutPartDetail.article": "Artikelnummer",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "Um einen Handtuchhalter zu positionieren, benötigen Sie eine 150 mm Schürze. Da die Breite Ihres Waschtisches nicht ausreichend für eine Schürzenplatzierung ist, muss die Waschtischbreite vergrößert werden. Möchten Sie fortfahren?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "Um einen Kosmetiktuchspenders zu positionieren, benötigen Sie eine 150 mm Schürze. Da die Breite Ihres Waschtisches nicht ausreichend ist für eine Schürzenplatzierung, muss die Waschtischbreite vergrößert werden. Möchten Sie fortfahren?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "Um einen Abwurf zu positionieren, benötigen Sie eine 150 mm Schürze. Da die Breite Ihres Waschtisches nicht ausreichend ist für eine Schürzenplatzierung, muss die Waschtischbreite vergrößert werden. Möchten Sie fortfahren?",
    "apronHeightForTowelRailRequiredMessage.message": "Für die Auswahl eines Handtuchhalter benötigen Sie eine {requiredHeight} mm Schürze. Möchten Sie fortfahren?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Für die Auswahl eines Kosmetiktuchspenders benötigen Sie eine {requiredHeight} mm Schürze. Möchten Sie fortfahren?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Für die Auswahl eines Abwurf benötigen Sie eine {requiredHeight} mm Schürze. Möchten Sie fortfahren?",
    "ListItem.archive": "Archivieren",
    "ConfigurationSwitchView.mine": "Meine Konfigurationen",
    "FolderSwitchView.mine": "Meine Konfigurationen",
    "ConfigurationSwitchView.connected": "Zugewiesen",
    "ConfigurationSwitchView.archived": "Archiviert",
    "Archive.headline": "Sind Sie sicher, dass Sie diese Konfiguration archivieren möchten?",
    "Archive.button": "Akzeptieren",
    "Unarchive.headline": "Sind Sie sicher, dass Sie diese Konfiguration wiederherstellen möchten?",
    "Unarchive.button": "Akzeptieren",
    "ListItem.unarchive": "Wiederherstellen",
    "WithNicheHint.hint": "Hinweis:",
    "WithNicheMessage.message": "Waschtischbreite = Fertignischenmaß minus 8 mm. Bitte ziehen Sie bei der Konfiguration je Waschtischseite 4 mm ab. Bauliche Vorsprünge sind zu beachten!",
    "checkboxPositions.tissueConflict": "Abfallsystem wurde geändert",
    "CutOutLabel.cosmetic": "Kosmetiktuchspender",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "Wir haben Ihnen einen Link per E-Mail geschickt, Ihr Konto wird nach der Bestätigung aktiviert.",
    "ConsolesOverlapChoice.message": "Konfiguration so nicht möglich, bitte Abstand vergrößern oder Edelstahlkonsole auswählen.",
    "ConsolesOverlapChoice.continue": "Zurückspringen auf Ursprungswert (mit Mineralgusskonsole)",
    "ConsolesOverlapChoice.return": "Zurückspringen auf Ursprungswert (mit Mineralgusskonsole)",
    "ConsolesOverlapChoice.change": "Wechseln zu Edelstahlkonsole(n)",
    "checkoutSave.orderIsFailed": "Der Auftrag konnte nicht an das SAP-System übermittelt werden. Bitte duplizieren Sie die Konfiguration und versuchen Sie es später erneut.",
    "Warning.RequireReset.qty": "Anzahl der Mulde",
    "ConfigurationNewFormName.error": "Name ist erforderlich.",
    "ConfigurationNewFormName.label": "Name",
    "ConfigurationNewFormName.placeholder": "Name",
    "ConfigurationNewFormPricingsAccessories.error": "Zeitraum ist erforderlich.",
    "ConfigurationNewFormPricingsAccessories.label": "Zeitraum Zubehör",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Bitte wählen Sie aus...",
    "ConfigurationNewFormPricingsWashbasin.error": "Zeitraum ist erforderlich.",
    "ConfigurationNewFormPricingsWashbasin.label": "Zeitraum Waschtisch",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Bitte wählen Sie aus...",
    "checkoutParts.timePeriodNote": "Hinweis:",
    "checkoutParts.timePeriodNoteText": "Bitte wählen Sie den Zeitraum für die Preisgültigkeit",
    "checkoutParts.timePeriodAccessoriesLabel": "Zeitraum Zubehör",
    "checkoutParts.timePeriodWashbasinLabel": "Zeitraum Waschtisch",
    "checkoutSave.orderIsQueued": "Die Bestellung konnte nicht an das SAP-System übermittelt werden. Es wurde für eine spätere Übermittlung in die Warteschlange gestellt.",
    "ListItemDetail.failed": "Fehlgeschlagen",
    "ListItemDetail.queued": "In Warteschlange",
    "TroughFilterMedcare.error": "MEDCARE ist erforderlich.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "verfügbar ab August 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/de_DE/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(angelegt)",
    "Login.mustLogin": "Um eine Konfiguration zu starten, müssen Sie sich anmelden. Wenn Sie noch kein Konto haben, erstellen Sie ein neues Konto.",
    "Troughs.toStart": "Um eine Konfiguration zu starten, müssen Sie {login}. Wenn Sie noch kein Konto haben, {create}.",
    "TroughFilter.modelLine": "Linie",
    "TroughFilter.characteristics": "Eigenschaften",
    "TroughListItem.min": "min. Waschtisch",
    "TroughListItem.start": "Konfiguration starten",
    "TroughListItem.startWithLogin": "Konfiguration nach Login beginnen",
    "TroughBanner.label": "Welche Mulden sind erhältlich?",
    "TroughBanner.text": "Werfen Sie vorab einen Blick darauf.",
    "SearchPlaceholder.placeholderTroughs": "Suche nach einer Mulde",
    "Troughs.toStartLogin": "sich anmelden",
    "Troughs.toStartCreate": "erstellen Sie ein neues Konto",
    "ConfigurationDownload3D.text": "3D-Szene herunterladen",
    "ConfigurationNewFolder.newHeading": "Neuer Ordner",
    "NewButtonsNewFolder.text": "Neuer Ordner",
    "NewButtonsNewConfiguration.text": "Konfiguration erstellen",
    "FolderListHeading.text": "Ordner",
    "FolderListNone.text": "Noch keine Ordner vorhanden",
    "ConfigurationListHeading.text": "Nicht zugeordnete Konfigurationen",
    "OpportunityNumber.number": "Opportunity Nummer",
    "ListItemOpportunity.number": "Opportunity Nummer",
    "BuildingNumber.number": "Gebäudenummer",
    "ListItemBuilding.number": "Gebäudenummer",
    "FolderListSeeAll.text": "Alle Ordner anzeigen",
    "ListItem.moveToGroup": "In Ordner verschieben",
    "ListItem.goBack": "Zurück",
    "FolderSwitchView.goBack": "Zurück",
    "ListItem.downloadPdfs": "PDFs herunterladen",
    "ConfigurationDeleteFolder.cancel": "Abbrechen",
    "ConfigurationEditFolder.cancel": "Abbrechen",
    "ConfigurationNewFolder.cancel": "Abbrechen",
    "ConfigurationNewFolder.create": "Erstellen",
    "ConnectedFolder.label": "Ja, ich möchte einen neuen Ordner mit dem Objektnamen in meinem Dashboard erstellen.",
    "FolderListHeadingAll.text": "Alle Ordner",
    "FolderListToday.text": "Heute",
    "FolderList7Days.text": "Vorherige 7 Tage",
    "FolderList30Days.text": "Vorherige 30 Tage",
    "FolderListItemNestedDelete.text": "Bauabschnitt löschen",
    "ConfigurationDeleteNestedFolder.heading": "Bauabschnitt löschen",
    "ConfigurationNewFolderNested.newHeading": "Neuer Bauabschnitt",
    "ListItem.moveToThisGroup": "In diesen Ordner verschieben",
    "ConfigurationDeleteFolder.note": "Hinweis:",
    "ConfigurationDeleteNestedFolder.body": "Wenn Sie diesen Bauabschnitt löschen, bleiben die darin enthaltenen Konfigurationen erhalten, sie werden lediglich in die Ablage des Ordners verschoben.",
    "ConfigurationDeleteFolder.body": "Wenn Sie diesen Bauabschnitt löschen, bleiben die darin enthaltenen Konfigurationen erhalten, sie werden lediglich in die Ablage des Ordners verschoben.",
    "FolderListNestedHeading.test": "Bauabschnitte",
    "BuildingNumber.error": "Die Gebäudenummer ist erforderlich.",
    "OpportunityNumber.error": "Die Opportunity Nummer ist erforderlich.",
    "FolderListItemDelete.text": "Ordner löschen",
    "ConfigurationDeleteFolder.heading": "Ordner löschen",
    "ConfigurationDeleteFolder.confirm": "Bestätigen",
    "ConfigurationEditFolder.heading": "Ordner bearbeiten",
    "ConfigurationEditFolderNested.heading": "Bauabschnitt bearbeiten",
    "ConfigurationEditFolder.confirm": "Bestätigen",
    "ConfigurationListNone.text": "Noch keine Konfigurationen verfügbar",
    "ListItemDetail.basin": "Waschtisch",
    "ListItemDetail.number": "Mulden",
    "ListItem.moveToDashboard": "Zum Dashboard verschieben",
    "FolderList.SortByDate": "Nach Datum sortieren",
    "FolderList.SortByName": "Nach Name sortieren",
    "FolderName.name": "Ordnername",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "fr": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "中国 | China",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Vue d'ensemble de la configuration",
    "NavigationUser.accountName": "Connexion et sécurité",
    "NavigationUser.adressesName": "Adresse de livraison et de facturation",
    "CheckoutHeadline.checkout": "Vue d'ensemble",
    "CheckoutBackButton.checkout": "Revenir à la configuration",
    "CheckoutConfigurationHeadline.checkout": "Configuration lavabo",
    "CheckoutPartsHeadline.checkout": "Accessoires de fixation",
    "CheckoutPartsHeadlineLink.checkout": "Vue d'ensemble de la configuration",
    "Delete.headline": "Voulez-vous vraiment supprimer votre configuration ?",
    "Delete.button": "Accepter",
    "Assemblies.note": "Remarque:",
    "Assemblies.message.with": "Tous les accessoires d'assemblage sont conçus pour des murs solides uniquement.",
    "Assemblies.message.without": "Montage par le client.",
    "Assemblies.message.alwaysTriggerSafety": "Équerre murale toujours compris.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Accessoires de fixation",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Sélection",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Accessoires de fixation",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Dimensions du lavabo",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Type de montage",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Angle de la niche",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Configuration d'angle",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Dimensions du lavabo",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Position des vasques",
    "ConfigurationDetail.ApronBacksplash.apron": "Tablier",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Bord arrière casse-goutte / dosseret anti-éclaboussure",
    "ConfigurationDetail.Recesses.tapHole": "Perçage pour la robinetterie",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Perçage pour distributeur de savon",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Découpe pour déchet/ papier",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Distributeur de papier mouchoir",
    "ConfigurationDetail.Recesses.towelRail": "Porte-serviette",
    "ConfigurationDetail.plateSurface.colour": "Couleur",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Revêtement en gelcoat sur la partie de dessous du lavabo",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Tablier / dosseret",
    "ConfigurationDetail.Drain.drainTitle": "Accessoires d'évacuation",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Accessoires d'évacuation",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Configuration complète",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Perçages / éléments de montage",
    "ConfigurationDetail.colour.colourTitle": "Couleur",
    "ConfigurationDetail.troughs.troughsTitle": "Vasques",
    "ConfigurationProject.headline": "À quel projet appartient votre configuration ?",
    "ConfigurationProject.tabexisting": "Sélectionner un projet existant",
    "ConfigurationProject.tabnew": "Définir un nouveau projet",
    "ConfigurationProject.tabEXISTING": "EXISTANT",
    "ConfigurationProject.tabNEW": "NOUVEAU",
    "ConfigurationProject.tabWITHOUT": "SANS",
    "ConfigurationDuplicate.headline": "Voulez-vous dupliquer votre configuration ?",
    "ConfigurationDuplicate.button": "Dupliquer",
    "ConfigurationNew.headline": "Veuillez indiquer vos données de configuration:",
    "ConfigurationRename.headline": "Comment voulez-vous appeler votre configuration ?",
    "ChangePasswordPage.changePasswordHeading": "Créez votre nouveau mot de passe",
    "ChangePasswordPage.changePasswordText": "Assurez-vous que votre mot de passe comprend une lettre capitale et un caractère spécial.",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Votre mot de passe a été modifié avec succès",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Retournez à la page de connexion et utilisez votre nouveau mot de passe.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Revenir à la page de connexion",
    "HomeLink.imprint": "Impressum",
    "HomeLink.legals": "Conditions générales de vente",
    "HomeLink.privacy": "Politique de confidentialité",
    "Login.newUser": "Créer un nouveau compte",
    "Login.forgotPassword": "Vous avez oublié votre mot de passe ?",
    "Login.Label.Email": "E-mail",
    "Login.Placeholder.Email": "E-mail",
    "Login.Error.Email": "L' e-mail est un champ obligatoire",
    "Login.Label.Password": "Mot de passe",
    "Login.Placeholder.Password": "Mot de passe",
    "Login.Error.Password": "Le mot de passe est un champ obligatoire",
    "ResetPassword.button": "Revenir à la page de connexion",
    "ResetPasswordSucceededPageComponent.resetPassword": "Cette adresse email est incorrecte.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Veuillez vérifier votre e-mail et cliquez sur le lien de confirmation.",
    "ResetPasswordSucceededPageComponent.button": "Connexion",
    "ChangePwOld.label": "Ancien mot de passe",
    "ChangePwOld.placeholder": "Ancien mot de passe",
    "ChangePwOld.error": "Le mot de passe doit respecter au moins 2 des 3 conditions suivantes : lettres (p. ex. ABCD...) - chiffres (p. ex. 0123...) - caractères spéciaux (p. ex. # $ %...)",
    "ChangePwNew.label": "Nouveau mot de passe",
    "ChangePwNew.error": "Le mot de passe doit respecter au moins 2 des 3 conditions suivantes : lettres (p. ex. ABCD...) - chiffres (p. ex. 0123...) - caractères spéciaux (p. ex. # $ %...)",
    "ChangePwNew.placeholder": "Nouveau mot de passe",
    "ChangePwNewRepeat.label": "Saisir de nouveau le mot de passe",
    "ChangePwNewRepeat.error": "Les mots de passe saisis ne sont pas identiques.",
    "ChangePwNewRepeat.placeholder": "Saisir de nouveau le mot de passe",
    "PageNotFound.message": "Désolé, nous n'avons pas trouvé la page que vous recherchez.",
    "AccountProfile.name": "Nom",
    "AccountProfile.telephone": "Numéro de téléphone",
    "AccountProfile.street": "Rue",
    "AccountProfile.zip": "Code postal",
    "AccountProfile.surname": "Nom",
    "AccountProfile.mobile": "Numéro de téléphone portable",
    "AccountProfile.city": "Ville",
    "AccountProfile.country": "Pays",
    "AccountProfile.userbutton": "Éditer le formulaire",
    "AccountProfile.email": "Adresse e-mail",
    "AccountProfile.password": "Mot de passe",
    "AccountProfile.loginbutton": "Éditer le formulaire",
    "AccountProfile.headline": "Connexion et sécurité",
    "projectsNewHeadline.headline": "Créer un nouveau projet",
    "projectsOverviewHeadline.headline": "Pour l'élaboration de projets",
    "ProjectsDelete.headline": "Voulez-vous vraiment supprimer votre projet ?",
    "ProjectsDelete.button": "Accepter",
    "ProjectsEdit.headline": "Veuillez éditer votre projet:",
    "ProjectsNew.headline": "Veuillez indiquer le nom de votre projet :",
    "RegisterPage.registerText": "Veuillez saisir une adresse e-mail valide et le mot de passe de votre compte.",
    "RegisterPage.registerButton": "Revenir à la page de connexion",
    "RegisterMail.error": "L'e-mail est un champ obligatoire",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "Le mot de passe doit respecter au moins 2 des 3 conditions suivantes : lettres (p. ex. ABCD...) - chiffres (p. ex. 0123...) - caractères spéciaux (p. ex. # $ %...)",
    "RegisterPw.name": "Mot de passe",
    "RegisterPwRepeat.error": "Les mots de passe saisis ne sont pas identiques.",
    "RegisterPwRepeat.name": "Saisir de nouveau le mot de passe",
    "RegisterUserGender.error": "Saisie obligatoire de la civilité",
    "RegisterUserGender.label": "Civilité",
    "RegisterUserGender.mr": "M.",
    "RegisterUserGender.mrs": "Mme.",
    "registerUserFirstName.error": "La saisie de votre prénom est obligatoire et doit contenir au moins 2 caractères.",
    "registerUserFirstName.label": "Prénom",
    "registerUserLastName.error": "La saisie de votre nom est obligatoire et doit contenir au moins 2 caractères.",
    "registerUserLastName.label": "Nom",
    "registerUserPhone.label": "Téléphone",
    "registerUserMobile.label": "Téléphone portable",
    "registerUserCompany.label": "Entreprise",
    "registerUserStreet.error": "La saisie de votre rue est obligatoire et doit contenir au moins 2 caractères.",
    "registerUserStreet.label": "Rue",
    "registerUserHouse.error": "La saisie de votre numéro de rue est obligatoire et doit contenir au moins 1 caractère.",
    "registerUserHouse.label": "Numéro de rue",
    "registerUserZip.error": "La saisie de votre code postal est obligatoire et doit contenir au moins 2 caractères.",
    "registerUserZip.label": "Code postal",
    "registerUserCity.error": "La saisie de votre ville est obligatoire et doit contenir au moins 2 caractères.",
    "registerUserCity.label": "Ville",
    "registerUserAddressAdditional.label": "Complément d'adresse",
    "registerUserCountry.error": "La saisie du pays est un champ obligatoire",
    "registerUserCountry.label": "Pays",
    "registerUserCountryLabel.label": "Choisir le pays",
    "registerUserClientNr.label": "Numéro de client (le cas échéant)",
    "registerUserBranch.error": "Secteur d'activité requis.",
    "registerUserBranch.label": "Secteur d'activité",
    "registerUserBranchSanitary.label": "Grossiste d'équipements sanitaires",
    "registerUserBranchPlanner.label": "Planificateur / architecte",
    "registerUserBranchPlumber.label": "Plombier",
    "registerUserBranchRetail.label": "Client final",
    "editUserGender.error": "Saisie obligatoire de la civilité",
    "editUserGender.label": "Civilité",
    "editUserGenderMr.label": "M.",
    "editUserGenderMrs.label": "Mme.",
    "editUserFirstName.error": "La saisie de votre prénom est obligatoire et doit contenir au moins 2 caractères.",
    "editUserFirstName.label": "Prénom",
    "editUserLastName.error": "La saisie de votre nom est obligatoire et doit contenir au moins 2 caractères.",
    "editUserLastName.label": "Nom",
    "editUserPhone.label": "Téléphone",
    "editUserMobile.label": "Téléphone portable",
    "editUserStreet.error": "La saisie de votre rue est obligatoire et doit contenir au moins 2 caractères.",
    "editUserStreet.label": "Rue",
    "editUserHouse.error": "La saisie de votre numéro de rue est obligatoire et doit contenir au moins 1 caractère.",
    "editUserHouse.label": "Numéro de rue",
    "editUserAddressAdditional.label": "Complément d'adresse",
    "editUserZip.error": "La saisie de votre code postal est obligatoire et doit contenir au moins 2 caractères.",
    "editUserZip.label": "Code postal",
    "editUserCity.error": "La saisie de votre ville est obligatoire et doit contenir au moins 2 caractères.",
    "editUserCity.label": "Ville",
    "editUserCountry.error": "La saisie du pays est un champ obligatoire",
    "editUserCountry.label": "Pays",
    "editUserCountryLabel.label": "Choisir le pays",
    "RegisterSucceededComponent.registerSucceededHeading": "Merci. Votre inscription est maintenant presque terminée.",
    "RegisterSucceededComponent.registerSucceededText": "Dans quelques instants, vous recevrez un courriel de notre part contenant un lien. Après avoir <b>confirmé votre adresse e-mail en cliquant sur ce lien</b>, vous pourrez vous connecter.",
    "RegisterSucceededComponent.registerSucceededButton": "Retour au login",
    "ThankYou.headline": "Merci d'avoir réalisé votre configuration !",
    "ThankYou.message": "Nous vous avons adressé un e-mail de confirmation contenant toutes les informations détaillées relatives à votre offre.",
    "ThankYou.order": "Votre numéro de offre :",
    "ThankYou.pdfbutton": "Exporter en format PDF 2D",
    "ThankYou.tenderdocuments": "Dossier d'appel d'offres",
    "ThankYou.overviewbutton": "Aller à la vue d'ensemble de la configuration",
    "Configuration3dAlert.attention": "Comment commencer ?",
    "Configuration3dAlert.message": "Sélectionnez tout d'abord la vasque que vous préférez à l'aide du bouton. Vous pouvez ensuite commencer à personnaliser votre lavabo. Amusez-vous bien avec notre nouveau configurateur 3D !",
    "ActivationSucceeded.activationSucceededText": "Félicitation ! Votre compte a été configuré avec succès. Vous pouvez maintenant lancer l'application.",
    "ActivationSucceeded.activationSucceededButton": "C'est parti !",
    "ActivationFailed.activaionUserNotFound": "Cet utilisateur n'existe pas. Veuillez enregistrer un nouveau compte.",
    "ActivationFailed.activaionUserNotFoundButton": "S'inscrire",
    "ChangeEmailForm.button": "Modifier l'adresse e-mail",
    "ChangePassword.button": "Modifier le mot de passe",
    "LoginForm.button": "Connexion",
    "Logout.button": "Déconnexion",
    "RegisterUserDataForm.headline": "Veuillez saisir vos données personnelles ici.",
    "RegisterUserDataForm.button": "Créer un nouveau compte",
    "RegisterUserDataForm.logout": "Revenir à la connexion",
    "RegisterUserForm.button": "Créer un nouveau compte",
    "ResetPasswordForm.button": "Réinitialiser le mot de passe",
    "ResetPasswordChangeForm.button": "Réinitialiser le mot de passe",
    "Checkout.WashBasinDimensions": "Dimensions du lavabo",
    "Checkout.PlateDimensions.Width": "Largeur",
    "Checkout.PlateDimensions.Depth": "Profondeur",
    "Checkout.TypeOfInstallation": "Type de montage",
    "Checkout.TypeOfInstallation.Left": "Mur à gauche",
    "Checkout.TypeOfInstallation.Right": "Mur à droite",
    "Checkout.TypeOfInstallation.With": "Mur à gauche et à droite",
    "Checkout.CornerDesign": "Configuration d'angle",
    "Checkout.CornerDesign.Radius": "Rayon 100 mm",
    "Checkout.CornerDesign.Bevel": "Biseau, 100 mm",
    "Checkout.Left": "gauche",
    "Checkout.Right": "droite",
    "Checkout.ApronBackSplash.Headline": "Tablier / dosseret",
    "Checkout.ApronBackSplash.Apron": "Tablier: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Bord arrière casse-goutte: {position} / 3 mm",
    "Checkout.ApronBackSplash.apronBackSplash": "Dosseret: {position} / {height} mm",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Perçages / éléments de montage",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x trou de perçage pour la robinetterie",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x trou de perçage pour distributeur de savon",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x découpe “{name}”",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x découpe pour Distributeur de papier mouchoir",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x découpe pour porte-serviette",
    "Checkout.Surface.Title": "Couleur",
    "Checkout.Surface.Color": "Couleur: {color}",
    "Checkout.Surface.GelCoat": "Revêtement Gelcoat sur le côté inférieur",
    "Checkout.AssemblyAccessories.Title": "Accessoires de fixation",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x console {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x équerre latérale pour fixation sur mur latéral",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x cran de sécurité pour fixation sur mur arrière",
    "Checkout.GeneralInfo.Headline": "Vue d'ensemble",
    "Checkout.GeneralInfo.ConfName": "Nom de la configuration:",
    "Checkout.TotalPrice.Washbasin": "Lavabo",
    "Checkout.TotalPrice.Parts": "Accessoires de fixation",
    "Checkout.TotalPrice.DeliveryCosts": "Frais de port",
    "Checkout.TotalPrice.Vat": "TVA",
    "Checkout.TotalPrice.Total": "Total",
    "Checkout.TotalPrice.Note": "Remarque:",
    "Checkout.TotalPrice.NoteText": "Prix valable jusqu'au ",
    "Checkout.Trough.Headline": "Vasque",
    "Checkout.Trough.Name": "Nom de la vasque:",
    "Checkout.Trough.Qty": "Quantité:",
    "Checkout.Trough.Dimensions": "Dimensions du lavabo:",
    "checkoutPartsPdfButton.button": "Télécharger le PDF",
    "Apron.height": "Hauteur du tablier en mm",
    "ApronHeightRequiredHint.hint": "Remarque:",
    "ApronHeightRequiredMessage.message": "Vous avez besoin d'un tablier de {requiredHeight} mm pour choisir une distributeur de papier mouchoir. Voulez-vous continuer ?",
    "ApronHeightError.message": "La valeur est en dehors des mesures",
    "SurgeEdgeLabelWithout.without": "sans",
    "SurgeEdgeLabelWith.with": "avec bord casse-goutte (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "avec dosseret",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "à l'arrière (par défaut)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Hauteur du dosseret en mm",
    "WithoutAssemblyAccessories.without": "sans Accessoires de fixation",
    "WithAssemblyAccessories.with": "avec Accessoires de fixation",
    "WithAssemblyAccessoriesTooltipHint.hint": "Remarque:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Fixation par le client.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Acier inoxydable",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Console",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Équerre murale",
    "AssemblyAccessoriesListAngleBar.anglebar": "Équerre latérale",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Matériel de fixation",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Acier inoxydable blanc",
    "CornerDesignLabelWithout.without": "sans configuration des coins",
    "CornerDesignLabelRadius.radius": "Rayon (100 mm)",
    "CornerDesignLabelBevel.bevel": "Coupe en biais (100 mm)",
    "DistancesPositionOfTroughs.distances": "Saisie de la distance entre les centres des vasques",
    "DistancesPositionOfTroughsHint.hint": "Remarque:",
    "DistancesPositionOfTroughsMessage.message": "Avantages et recommandations d'utilisation",
    "DistancesPositionOfTroughsFromPlate.plate": "De lavabo jusqu´au bord arrière de la vasque",
    "PlateDimensionsWidth.width": "Largeur du lavabo en mm",
    "PlateDimensionsDepth.depth": "Profondeur du lavabo en mm",
    "PlateDimensionsDepth.depthIndividual": "Personnalisée",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "La valeur est en dehors des mesures",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Côté gauche",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Côté droit",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Possible uniquement en combinaison avec le type de montage \"avec, gauche ou droite\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Possible uniquement en combinaison avec le type de montage \"sans, gauche ou droite\".",
    "Configuration.Inputs.message": "La valeur est en dehors des mesures",
    "DrainLabelWithoutDrain.withoutdrain": "sans accessoires d'évacuation",
    "DrainLabelHoodDrain.hooddrain": "Bonde de vidage à dôme",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Hood drain valve chrome",
    "DrainLabelSieveDrain.sievedrain": "Bonde à grille",
    "DrainLabelEccentric.eccentric": "Vidage et trop plein",
    "DrainLabelSiphon.siphon": "Siphon XINX140",
    "CosmeticTissueDispenser.without": "Sans distributeur de serviette en papier",
    "CosmeticTissueDispenserSquare.square": "carré avec découpe rectangulaire (avec Gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(pour Distributeur de papier mouchoir « numéro de modèle »)",
    "CosmeticTissueDispenserPosition.position": "(position entre les vasques)",
    "CutOutLabelCustomInput.diameter": "Diamètre",
    "CutOutLabelCustomInput.width": "Largeur",
    "CutOutLabelCustomInput.depth": "Profondeur",
    "CutOutLabelSelect.select": "Veuillez sélectionner",
    "CutOutDisposalsDefaultsWithout.without": "Sans découpe pour déchets",
    "CutOutDisposalsDefaultsWith.with": "Avec découpe pour déchets",
    "SoapDispenserHoleLabelWithout.without": "sans",
    "SoapDispenserHoleLabelSD80.sd80": "pour distributeur de savon SD80",
    "SoapDispenserHoleLabelSD100.sd100": "pour distributeur de savon SD100",
    "SoapDispenserHoleLabel25.dispensers": "pour distributeurs de savon fournisseurs tiers (Ø 25 mm)",
    "TapHoleWithout.taphole": "sans perçage",
    "TapHoleWithoutDrilling.tapholedrilling": "avec perçage (Ø 35 mm)",
    "TowelRailWithout.towelrailwithout": "sans découpe",
    "TowelRailWithout.towelrailwith": "avec découpe",
    "ColorLabel.alpinewhite": "Blanc alpin (par défaut)",
    "ColorLabel.alpinewhitetext": "Résistant jusqu'à une température de 80°C",
    "ColorLabel.graniteblack": "Granite noir",
    "ColorLabel.graniteblacktext": "Résistant jusqu'à une température de 65°C",
    "ColorLabel.graniteblackwhite": "Granite noir-blanc",
    "ColorLabel.graniteblackwhitetext": "Résistant jusqu'à une température de 65°C",
    "ColorLabel.graniteLightGray": "Granite gris clair",
    "ColorLabel.granitelightgraytext": "Résistant jusqu'à une température de 65°C",
    "ColorBottomSideUncoated.uncoated": "sans revêtement (par défaut)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Remarque:",
    "ColorBottomSideMessage.message": "Avantages et recommandations d'utilisation",
    "ElementNext.button": "Suivant",
    "ElementsPositionsLeft.left": "gauche",
    "ElementsPositionsBack.back": "à l'arrière",
    "ElementsPositionsFront.front": "avant",
    "ElementsPositionsRight.right": "droite",
    "ElementsPositionsRight.warning": "Désactivé, veuillez augmenter la distance entre les vasques.",
    "ConfigurationListAdd.text": "Ajouter une nouvelle configuration",
    "ListItem.rename": "Renommer",
    "ListItem.duplicate": "Dupliquer",
    "ListItem.delete": "Supprimer",
    "ListItem.order": "Passer offre",
    "ListItem.orderShow": "Afficher la offre",
    "ListItem.linkTitle": "Paramètres",
    "ListItemDetail.price": "Prix total",
    "ListItemDetail.offer": "Offre",
    "ListItemDetail.order": "Commande",
    "ListItemDetail.date": "Dernière modification effectuée le",
    "ConfigurationNewForm.button": "Accepter",
    "Warning.RequireReset.Trough": "En raison de modifications apportées à votre configuration, si vous souhaitez choisir une autre vasque et augmenter ou diminuer la quantité, tous les objets indiqués dans la liste doivent être réinitialisés:",
    "Warning.RequireReset.Qty": "En raison de modifications apportées à votre configuration, si vous souhaitez augmenter ou diminuer la quantité, tous les objets indiqués dans la liste doivent être réinitialisés:",
    "Warning.RequireReset.TypeOfInstallation": "En raison de modifications apportées à votre configuration, si vous souhaitez modifier le type de montage, tous les objets indiqués dans la liste doivent être réinitialisés:",
    "Warning.RequireReset.plateDepth": "Profondeur du lavabo",
    "Warning.RequireReset.PlateDepth": "En raison de modifications apportées à votre configuration, si vous souhaitez modifier la profondeur du lavabo, tous les objets indiqués dans la liste doivent être réinitialisés:",
    "Warning.RequireReset.distances": "Distances",
    "Warning.RequireReset.cornerDesign": "Configuration d'angle",
    "Warning.RequireReset": "Réinitialisation obligatoire:",
    "Warning.RequireReset.Default": "En raison de modifications apportées à votre configuration, vous devez la réinitialiser.",
    "Warning.RequireReset.ResetAll": "Tout réinitialiser?",
    "Warning.RequireReset.console": "Consoles",
    "Warning.RequireReset.drain": "Accessoires d'évacuation",
    "Warning.RequireReset.typeOfInstallation": "Type de montage",
    "Warning.RequireReset.paperTowelDispensers": "Découpe pour distributeur de serviettes en papier",
    "Warning.RequireReset.plateWidth": "Largeur du lavabo",
    "Warning.RequireReset.siphon": "Siphon",
    "Warning.RequireReset.soapDispenserHole": "Perçage pour distributeur de savon",
    "Warning.RequireReset.tapHole": "Trou de perçage pour la robinetterie",
    "Warning.RequireReset.tissueDispenser": "Découpe pour distributeur de papier mouchoir",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Bord arrière casse-goutte / dosseret anti-éclaboussure",
    "ConfigurationDetail.error.default": "La valeur que vous avez sélectionnée ne peut pas être attribuée, veuillez vérifier votre saisie.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "La valeur que vous avez sélectionnée ne peut pas être attribuée, veuillez vérifier le côté inférieur coloré.",
    "LogoTitle.default": "Vue d'ensemble de la configuration",
    "LogoTitle.fallback": "Configurateur 3D de KWC",
    "MetaNavigationImprint.imprint": "Mentions légales",
    "MetaNavigationLegals.legals": "Conditions générales de vente",
    "MetaNavigationPrivacy.privacy": "Politique de confidentialité",
    "NavigationTrough.name": "Vasque",
    "NavigationTrough.title": "Vasque",
    "NavigationBasin.name": "Dimensions du lavabo",
    "NavigationBasin.title": "Dimensions du lavabo",
    "NavigationApron.name": "Tablier / dosseret",
    "NavigationApron.title": "Tablier / dosseret",
    "NavigationRecesses.name": "Perçages / éléments de montage",
    "NavigationRecesses.title": "Perçages / éléments de montage",
    "NavigationColour.name": "Couleur",
    "NavigationColour.title": "Couleur",
    "NavigationAssembly.name": "Accessoires de fixation",
    "NavigationAssembly.title": "Accessoires de fixation",
    "NavigationDrain.name": "Évacuation",
    "NavigationDrain.title": "Évacuation",
    "ProjectsEditFormButton.button": "Sauvegarder le projet",
    "ProjectListItemEdit.edit": "Éditer",
    "ProjectListItemDelete.delete": "Supprimer",
    "ProjectListItemLinkTitle.title": "Paramètres",
    "projectListHeadline.headline": "Adresse de livraison et de facturation",
    "ProjectListAdd.addText": "Ajouter une nouvelle adresse",
    "ProjectNewFormButton.button": "Créer un projet",
    "ProjectName.error": "Le nom est un champ obligatoire",
    "ProjectName.name": "Nom de l'objet:",
    "ProjectStreet.error": "La saisie de la rue est obligatoire et doit contenir au moins 2 caractères.",
    "ProjectStreet.name": "Rue",
    "ProjectStreetNr.error": "La saisie de votre numéro de rue est obligatoire et doit contenir au moins 2 caractères.",
    "ProjectStreetNr.name": "N°",
    "ProjectZip.error": "La saisie de votre code postal est obligatoire et doit contenir au moins 2 caractères.",
    "ProjectZip.name": "Code postal",
    "ProjectCity.error": "La saisie de votre ville est obligatoire et doit contenir au moins 2 caractères.",
    "ProjectCity.name": "Ville",
    "ProjectCountry.error": "La saisie du pays est un champ obligatoire",
    "ProjectCountry.name": "Pays",
    "ProjectCountry.label": "Choisir le pays",
    "ProjectSelectExistingProject.text": "Sélectionner un projet existant",
    "ProjectSelectCreateProject.text": "Aucun objet existant, veuillez en créer un",
    "ProjectSelectButton.button": "Accepter",
    "ProjectSelectWithout.without": "Je voudrais continuer sans objet",
    "ProjectSelectButtonTitle.title": "Éditer l'objet",
    "ProjectWithout.label": "Oui, je voudrais continuer sans objet",
    "ProjectWithout.button": "Accepter",
    "SelectedTroughListButton.button": "Vasque ajoutée",
    "SelectedTroughListItemWidth.width": "Largeur",
    "SelectedTroughListItemWidth.minWidth": "Min Largeur",
    "SelectedTroughListItemDepth.depth": "Profondeur",
    "SelectedTroughListItemDepth.minDepth": "Min Profondeur",
    "SelectedTroughListItemHeight.height": "Hauteur",
    "TroughDetailModalButton.button": "Schéma technique",
    "TroughFilterButton.button": "Désélectionner",
    "TroughFilterExos.error": "EXOS. sélectionnée.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "VARIUSsign sélectionnée.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "VARIUSmed sélectionnée.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Carré sélectionnée.",
    "TroughFilterSquare.label": "carré",
    "TroughFilterOval.error": "Ovale sélectionnée.",
    "TroughFilterOval.label": "ovale",
    "TroughFilterRound.error": "Ronde sélectionnée.",
    "TroughFilterRound.label": "ronde",
    "TroughFilterWithOverflow.error": "Avec trop-plein sélectionné.",
    "TroughFilterWithOverflow.label": "avec trop-plein",
    "TroughFilterWithoutOverflow.error": "Sans trop-plein sélectionné.",
    "TroughFilterWithoutOverflow.label": "sans trop-plein",
    "TroughFilterWithBackwall.error": "Avec mur arrière sélectionnée.",
    "TroughFilterWithBackwall.label": "avec mur arrière",
    "TroughFilterWithoutBackwall.error": "Avec consoles arrière sélectionnée.",
    "TroughFilterWithoutBackwall.label": "avec consoles arrière",
    "TroughListButtonSelect.select": "Sélectionner la vasque",
    "TroughListButtonClose.close": "Fermer le menu vasque",
    "TroughListButtonFilterOptions.filter": "Afficher les options de filtrage",
    "TroughListSorryMsg.message": "Désolé, nous n'avons trouvé aucune vasque correspondant aux options de filtrage que vous avez sélectionnées.",
    "TroughListItemWidth.width": "Largeur",
    "TroughListItemWidth.minWidth": "Min Largeur",
    "TroughListItemDepth.depth": "Profondeur",
    "TroughListItemDepth.minDepth": "Min Profondeur",
    "TroughListItemHeight.height": "Hauteur",
    "TroughListMinValuesText.text": "min. lavabo largeur x profondeur",
    "RegisterSucceededComponent.resendSucceededHeading": "Renvoyer le lien d'activation avec succès",
    "ActivationFailed.activationInvalid": "Malheureusement l'activation de votre compte a échoué !",
    "ActivationFailed.activationInvalidToken": "Votre jeton a expiré.Veuillez vérifier si votre compte est activé et essayez de vous reconnecter",
    "ActivationFailed.activationInvalidTokenButton": "Envoyez-moi un nouveau lien",
    "ActivationFailed.ActivationResend": "Renvoyer le lien d'activation",
    "Configuration.Inputs.distancesInmm": "(entraxes en mm)",
    "newEmail.text": "Nouvelle adresse e-mail",
    "newEmail.error": "Cet email est incorrect",
    "AccountProfile.button": "Enregistrer",
    "ApronLabel.with": "avec tablier",
    "ApronLabel.without": "sans tablier (standard)",
    "SquareCustom.square": "carré",
    "RoundCustom.round": "ronde",
    "SearchPlaceholder.placeholder": "Que cherchez vous?",
    "ColorCheckout.white": "Blanc alpin",
    "ColorCheckout.black": "Granite noir",
    "ColorCheckout.blackWhite": "Granite noir-blanc",
    "ColorCheckout.lightGray": "Granite gris clair",
    "ConfigurationDetail.Drain.note": "Remarque:",
    "ConfigurationDetail.Drain.noteMessage": "Aucune option pour la vasque sélectionnée.",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "Le tube de trop-plein est livré avec le Variusmed MZB.",
    "ConfigurationDetail.Drain.noteExos": "Cabochon antivol avec revêtement InoxPlus est pour Exos. Vasques incluses dans la livraison.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "L'e-mail a été modifié avec succès",
    "ChangeEmailSucceededPageComponent.emailChangedText": "Vous recevrez sous peu un lien d'activation par e-mail. Pour activer votre compte,veuillez cliquer sur ce lien.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Revenir à la connexion",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Votre mot de passe a été réinitalisé avec succès.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Veuillez vous connecter avec votre nouveau mot de passe.",
    "ResetPasswordChangeSucceededPageComponent.button": "S'identifier",
    "Warning.RequireReset.apron": "Tablier",
    "submitAsOrder.label": "Ordre de transfert SAP",
    "ListItemDetail.draft": "Brouillon",
    "TroughDetailModalWidth.minWidth": "Min Largeur",
    "TroughDetailModalDepth.minDepth": "Min Profondeur",
    "TroughDetailModalWidth.width": "Largeur",
    "TroughDetailModalDepth.depth": "Profondeur",
    "TroughDetailModalHeight.height": "Hauteur",
    "ConfigurationCountry.headline": "À quel pays appartient votre configuration?",
    "ConfigurationCountry.button": "Suivant",
    "ConfigurationCountry.select": "Veuillez choisir un pays",
    "SelectedTroughListItemHeight.minDimensions": "min. lavabo largeur x profondeur",
    "TroughDetailModalDepth.minDimensions": "min. lavabo largeur x profondeur",
    "TroughListItemDepth.minDimensions": "min. lavabo largeur x profondeur",
    "CosmeticTissueDispenser.cosmeticTissue": "Distributeur de papier mouchoir",
    "PaperTowelDispenser.paperTowelDispenser": "Distributeur de serviette en papier",
    "CutOutLabelNone.none": "Sélectionner votre découpe",
    "DistancesPosition.symmetrically": "Empattement identique zone de rangement",
    "DistancesPosition.evenly": "Empattement identique des vasques",
    "CutOutLabel.CustomRound": "Découpe ronde",
    "CutOutLabel.CustomSquare": "Découpe angulaire avec Gelcoat",
    "CutOutLabel.roundSleeve": "Bague cylindrique pour déchets",
    "CutOutLabel.squareSleeve": "Bague carrée pour déchets",
    "CutOutLabel.roundBasket": "Découpe ronde avec corbeille",
    "CutOutLabel.roundRail": "Découpe ronde avec corbeille à déchets avec cadre coulissant",
    "CutOutLabel.squareBasket": "Découpe angulaire avec corbeille",
    "CutOutLabel.squareRail": "Découpe angulaire avec corbeille à déchets avec cadre coulissant",
    "CutOutLabel.roundSleeveBasket": "Découpe ronde avec bague cylindrique et corbeille",
    "CutOutLabel.roundSleeveRail": "Découpe ronde avec bague cylindrique et corbeille à déchets avec cadre coulissant",
    "CutOutLabel.squareSleeveBasket": "Découpe angulaire avec bague carrée et corbeille",
    "CutOutLabel.squareSleeveRail": "Découpe angulaire avec bague carrée et corbeille à déchets avec cadre coulissant",
    "CutOutLabel.flap": "Vide-déchet",
    "CutOutLabel.flapBasket": "Vide-déchet avec panier à déchet",
    "CutOutLabel.flapRail": "Vide-déchet avec panier sur systeme de rail",
    "CutOutLabel.provider": "Distributeur de serviette en papier",
    "ApronHeightRequiredChoiceMessage.message": "Dans un souci d'esthétisme, nous vous recommandons de choisir un tablier pour votre lavabo:",
    "apronHeightRequiredChoice60.60": "Changer la hauteur du tablier à 60 mm",
    "apronHeightRequiredChoice150.150": "Changer la hauteur du tablier à 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Maintenir la hauteur du tablier",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Maintenir la hauteur du tablier et continuer sans découpe",
    "CosmeticTissueDispenser.with": "Avec distributeur de serviette en papier",
    "PlateDimensionsDepth.470": "Recommandation pour les robinetterie murales",
    "PlateDimensionsDepth.550": "Recommandation pour les robinetterie standards",
    "Warning.RequireReset.cutOutDisposals": "Découpe pour déchets",
    "checkboxPositions.noSpace": "Pas assez d'espace",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Découpe pour distributeur d'essuie-tout",
    "ApronAffects.position": "Attention: une largeur de tablier de 18 mm entraîne un décalage de la position de l'auge.",
    "DepthRequiredHint.hint": "Remarque:",
    "DepthRequiredMessage.message": "La profondeur du lavabo que vous avez choisi n'est pas suffisante. Souhaitez-vous fixer la profondeur requise de {requiredDepth} mm pour cette goutte?",
    "ThankYou.orderPdf": "Configuration lavabo (PDF)",
    "ThankYou.manufacturingPdf": "Dessin lavabo (PDF)",
    "ThankYou.troughPdf": "Dessin vasque (PDF)",
    "PlateDimensionsRequired.hint": "Remarque:",
    "PlateDimensionsRequired.message": "la largeur de votre lavabo n'est pas suffisante. Pour placer un tablier, la largeur de votre lavabo doit être augmenté. Voulez vous continuer ?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Si vous désélectionnez le tablier, les dimensions originales de votre configuration seront restaurées.",
    "PlateDimensionsChoice.message": "Il n'y pas assez d'espace à votre lavabo pour un tablier. Vous disposez des options suivantes pour continuer:",
    "PlateDimensionsChoice.increase": "Modifier la largeur du lavabo",
    "PlateDimensionsChoice.move": "Déplacer la (les) cuve (s) et conserver la largeur du lavabo",
    "PlateDimensionsChoice.cancel": "Annuler (les dimensions sans tablier sont conservées)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Pour placer un porte-serviettes, vous avez besoin d'un tablier de 150 mm. Si la largeur de votre lavabo n'est pas suffisante pour placer un tablier, il faut l'agrandir. Voulez-vous continuer?",
    "Checkout.OrderPdf": "Configuration lavabo (PDF)",
    "Checkout.ManufacturingPdf": "Dessin lavabo (PDF)",
    "submitAsRequest.label": "Demande d'offre",
    "checkoutSave.label": "Sauvegarder",
    "submitAsOffer.label": "Offre de transfert SAP",
    "ListItemDetail.request": "Demander",
    "ListItem.orderPdf": "Configuration lavabo (PDF)",
    "ListItem.manufacturingPdf": "Dessin lavabo (PDF)",
    "ListItem.troughPdf": "Dessin vasque (PDF)",
    "PlateDimensionsRequiredLimit.message": "Largeur maximale du lavabo atteinte. Aucune sélection de tablier possiblee.",
    "PlateDimensionsChoiceLimit.message": "Largeur maximale du lavabo atteinte:",
    "CutoutPartDetail.name": "Nom",
    "CutoutPartDetail.dimensions": "Dimensions",
    "CutoutPartDetail.type": "Type",
    "CutoutPartDetail.article": "Numéro de l'article",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "pour positionner un porte-serviette vous aurez besoin d'un tablier de 150 mm. Étant donné que la largeur de votre lavabo n'est pas suffisante pour un placement de tablier, la largeur du lavabo doit être auguementée. Voulez-vous continuer ?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "pour positionner une distributeur de papier mouchoir vous aurez besoin d'un tablier de 150 mm. Étant donné que la largeur de votre lavabo n'est pas suffisante pour un placement de tablier, la largeur du lavabo doit être auguementée. Voulez-vous continuer ?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "pour positionner une découpe pour déchets vous aurez besoin d'un tablier de 150 mm. Étant donné que la largeur de votre lavabo n'est pas suffisante pour un placement de tablier, la largeur du lavabo doit être auguementée. Voulez-vous continuer ?",
    "apronHeightForTowelRailRequiredMessage.message": "Vous avez besoin d'un tablier de {requiredHeight} mm pour choisir une porte-serviette. Voulez-vous continuer ?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Vous avez besoin d'un tablier de {requiredHeight} mm pour choisir une distributeur de papier mouchoir. Voulez-vous continuer ?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Vous avez besoin d'un tablier de {requiredHeight} mm pour choisir une découpe pour déchets. Voulez-vous continuer ?",
    "ListItem.archive": "Archives",
    "ConfigurationSwitchView.mine": "Mes configurations",
    "FolderSwitchView.mine": "Mes configurations",
    "ConfigurationSwitchView.connected": "Attribuées",
    "ConfigurationSwitchView.archived": "Archivées",
    "Archive.headline": "Voulez-vous vraiment archives votre configuration ?",
    "Archive.button": "Accepter",
    "Unarchive.headline": "Voulez-vous vraiment rétablir votre configuration ?",
    "Unarchive.button": "Accepter",
    "ListItem.unarchive": "Rétablir",
    "WithNicheHint.hint": "Remarque:",
    "WithNicheMessage.message": "Largeur du lavabo = dimensions de la niche finie moins 8 mm. Veuillez soustraire 4 mm par côté de lavabo lors de la configuration. Veuillez respecter les projections structurelles.",
    "checkboxPositions.tissueConflict": "Le système des déchets a changé",
    "CutOutLabel.cosmetic": "Distributeur de papier mouchoir",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "Nous vous avons envoyé un lien par e-mail, votre compte sera activé après votre confirmation.",
    "ConsolesOverlapChoice.message": "Configuration impossible ainsi, veuillez augmenter la distance ou choisir une console en acier inoxydable.",
    "ConsolesOverlapChoice.continue": "Retour à la valeur initiale (avec console en fonte minérale)",
    "ConsolesOverlapChoice.return": "Retour à la valeur initiale (avec console en fonte minérale)",
    "ConsolesOverlapChoice.change": "Passer à Console(s) en acier inoxydable",
    "checkoutSave.orderIsFailed": "La commande n'a pas pu être soumise au système SAP. Veuillez dupliquer la configuration et réessayer plus tard.",
    "Warning.RequireReset.qty": "Quantité de bassin",
    "ConfigurationNewFormName.error": "Le nom est requis.",
    "ConfigurationNewFormName.label": "Nom",
    "ConfigurationNewFormName.placeholder": "Nom",
    "ConfigurationNewFormPricingsAccessories.error": "Une période de temps est requise.",
    "ConfigurationNewFormPricingsAccessories.label": "Période pour les accessoires",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Veuillez sélectionner...",
    "ConfigurationNewFormPricingsWashbasin.error": "Une période de temps est requise.",
    "ConfigurationNewFormPricingsWashbasin.label": "Période pour le lavabo",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Veuillez sélectionner...",
    "checkoutParts.timePeriodNote": "Remarque:",
    "checkoutParts.timePeriodNoteText": "Veuillez sélectionner la période de validité du prix",
    "checkoutParts.timePeriodAccessoriesLabel": "Période pour les accessoires",
    "checkoutParts.timePeriodWashbasinLabel": "Période pour le lavabo",
    "checkoutSave.orderIsQueued": "La commande n'a pas pu être soumise au système SAP. Il a été mis en file d'attente pour une soumission ultérieure.",
    "ListItemDetail.failed": "Échoué",
    "ListItemDetail.queued": "Programmé",
    "TroughFilterMedcare.error": "MEDCARE sélectionnée.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "disponible en août 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/fr_FR/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(créé)",
    "Login.mustLogin": "Pour démarrer une configuration, vous devez vous connecter. Si vous n'avez pas encore de compte, créez un nouveau compte.",
    "Troughs.toStart": "Pour démarrer une configuration, vous devez {login}. Si vous n'avez pas encore de compte, {create}.",
    "TroughFilter.modelLine": "Ligne",
    "TroughFilter.characteristics": "Propriétés",
    "TroughListItem.min": "min. Lavabo",
    "TroughListItem.start": "Démarrer la configuration",
    "TroughListItem.startWithLogin": "Commencer la configuration après le login",
    "TroughBanner.label": "Quelles sont les cuvettes disponibles ?",
    "TroughBanner.text": "Jetez-y un coup d'œil au préalable.",
    "SearchPlaceholder.placeholderTroughs": "Rechercher une vasque",
    "Troughs.toStartLogin": "se connecter",
    "Troughs.toStartCreate": "créer un nouveau compte",
    "ConfigurationDownload3D.text": "Télécharger la scène 3D",
    "ConfigurationNewFolder.newHeading": "Nouveau dossier",
    "NewButtonsNewFolder.text": "Nouveau dossier",
    "NewButtonsNewConfiguration.text": "Créer une configuration",
    "FolderListHeading.text": "Dossier",
    "FolderListNone.text": "Aucun dossier n'existe encore",
    "ConfigurationListHeading.text": "Configurations non affectées",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "Afficher tous les dossiers",
    "ListItem.moveToGroup": "Déplacer vers un dossier",
    "ListItem.goBack": "Retourner à",
    "FolderSwitchView.goBack": "Retourner à",
    "ListItem.downloadPdfs": "Télécharger des PDF",
    "ConfigurationDeleteFolder.cancel": "Annuler",
    "ConfigurationEditFolder.cancel": "Annuler",
    "ConfigurationNewFolder.cancel": "Annuler",
    "ConfigurationNewFolder.create": "Créer",
    "ConnectedFolder.label": "Oui, je souhaite créer un nouveau dossier avec le nom de l'objet dans mon tableau de bord.",
    "FolderListHeadingAll.text": "Tous les dossiers",
    "FolderListToday.text": "Aujourd'hui",
    "FolderList7Days.text": "7 jours précédents",
    "FolderList30Days.text": "30 jours précédents",
    "FolderListItemNestedDelete.text": "Supprimer une section de construction",
    "ConfigurationDeleteNestedFolder.heading": "Supprimer une section de construction",
    "ConfigurationNewFolderNested.newHeading": "Nouvelle section de construction",
    "ListItem.moveToThisGroup": "Déplacer dans ce dossier",
    "ConfigurationDeleteFolder.note": "Remarque:",
    "ConfigurationDeleteNestedFolder.body": "Si vous supprimez cette section, les configurations qu'elle contient sont conservées, elles sont simplement déplacées vers le dossier de stockage.",
    "ConfigurationDeleteFolder.body": "Si vous supprimez cette section, les configurations qu'elle contient sont conservées, elles sont simplement déplacées vers le dossier de stockage.",
    "FolderListNestedHeading.test": "Étapes de construction",
    "BuildingNumber.error": "Building number est requis.",
    "OpportunityNumber.error": "Opportunity number est requis.",
    "FolderListItemDelete.text": "Supprimer le dossier",
    "ConfigurationDeleteFolder.heading": "Supprimer le dossier",
    "ConfigurationDeleteFolder.confirm": "Confirmer",
    "ConfigurationEditFolder.heading": "Modifier le dossier",
    "ConfigurationEditFolderNested.heading": "Editer la phase de construction",
    "ConfigurationEditFolder.confirm": "Confirmer",
    "ConfigurationListNone.text": "Aucune configuration n'est encore disponible",
    "ListItemDetail.basin": "Lavabo",
    "ListItemDetail.number": "Abreuvoirs",
    "ListItem.moveToDashboard": "Déplacer vers le tableau de bord",
    "FolderList.SortByDate": "Trier par date",
    "FolderList.SortByName": "Trier par nom",
    "FolderName.name": "Nom du dossier",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "cs": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "China | 中国",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Přehled konfigurace",
    "NavigationUser.accountName": "Přihlášení a bezpečnost",
    "NavigationUser.adressesName": "Dodací a fakturační adresy",
    "CheckoutHeadline.checkout": "Přehled",
    "CheckoutBackButton.checkout": "Zpět ke konfiguraci",
    "CheckoutConfigurationHeadline.checkout": "Konfigurace umyvadla",
    "CheckoutPartsHeadline.checkout": "Příslušenství",
    "CheckoutPartsHeadlineLink.checkout": "Přehled konfigurace",
    "Delete.headline": "Opravdu chcete smazat tuto konfiguraci?",
    "Delete.button": "Povolit",
    "Assemblies.note": "Upozornění:",
    "Assemblies.message.with": "Veškeré montážní příslušenství je určeno pouze pro masivní stěny.",
    "Assemblies.message.without": "Upevnění na místě.",
    "Assemblies.message.alwaysTriggerSafety": "Vždy s ochranným krytem odtoku.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Montážní příslušenství",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Výběr",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Montážní příslušenství",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Rozměry umyvadla",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Způsob vestavby",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Úhel výklenku",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Rohová úprava",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Rozměry desky",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Poloha prohlubní",
    "ConfigurationDetail.ApronBacksplash.apron": "Lem",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Nárazová hrana / zadní lem",
    "ConfigurationDetail.Recesses.tapHole": "Otvor pro baterii",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Otvor pro dávkovač mýdla",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Odpad",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Zásobník na papírové utěrky",
    "ConfigurationDetail.Recesses.towelRail": "Držák ručníku",
    "ConfigurationDetail.plateSurface.colour": "Barva",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Dolní strana",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Lem / zadní lem",
    "ConfigurationDetail.Drain.drainTitle": "Odtokové příslušenství",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Odtokové příslušenství",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Ukončit konfiguraci",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Výklenky / montážní díly",
    "ConfigurationDetail.colour.colourTitle": "Barva",
    "ConfigurationDetail.troughs.troughsTitle": "Prohlubně",
    "ConfigurationProject.headline": "K jakému objektu patří vaše konfigurace",
    "ConfigurationProject.tabexisting": "Zvolte stávající objekt",
    "ConfigurationProject.tabnew": "Založte nový objekt",
    "ConfigurationProject.tabEXISTING": "Existuje",
    "ConfigurationProject.tabNEW": "Novinka",
    "ConfigurationProject.tabWITHOUT": "BEZ",
    "ConfigurationDuplicate.headline": "Chcete tuto konfiguraci duplikovat?",
    "ConfigurationDuplicate.button": "Duplikovat",
    "ConfigurationNew.headline": "Zadejte konfigurační údaje:",
    "ConfigurationRename.headline": "Jak chcete konfiguraci pojmenovat?",
    "ChangePasswordPage.changePasswordHeading": "Určete nové heslo",
    "ChangePasswordPage.changePasswordText": "Heslo musí splňovat minimálně 2 ze 3 následujících podmínek: písmena (např. ABCD...) - číslice (např. 0123...) - zvláštní znaky (např. #$%...)",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Heslo bylo úspěšně změněno.",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Vraťte se k přihlášení a zadejte nové heslo.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Zpět k přihlášení",
    "HomeLink.imprint": "Impressum",
    "HomeLink.legals": "Obecné obchodní podmínky",
    "HomeLink.privacy": "Směrnice o ochraně osobních údajů a souborech Cookies",
    "Login.newUser": "Vytvořte nový účet",
    "Login.forgotPassword": "Zapomněli jste heslo?",
    "Login.Label.Email": "E-mail",
    "Login.Placeholder.Email": "E-mail",
    "Login.Error.Email": "E-mail je povinné pole.",
    "Login.Label.Password": "Heslo",
    "Login.Placeholder.Password": "Heslo",
    "Login.Error.Password": "Heslo je povinné pole.",
    "ResetPassword.button": "Zpět k přihlášení",
    "ResetPasswordSucceededPageComponent.resetPassword": "Heslo bylo úspěšně změněno.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Zkontrolujte E-mail a klepněte na potvrzovací odkaz.",
    "ResetPasswordSucceededPageComponent.button": "Přihlášení",
    "ChangePwOld.label": "Staré heslo",
    "ChangePwOld.placeholder": "Staré heslo",
    "ChangePwOld.error": "Heslo musí splňovat alespoň 2 ze 3 následujících podmínek: Písmena (např. ABCD ...) - Čísla (např. 0123 ...) - Speciální znaky (např. # $% ...)",
    "ChangePwNew.label": "Nové heslo",
    "ChangePwNew.error": "Heslo musí splňovat alespoň 2 ze 3 následujících podmínek: Písmena (např. ABCD ...) - Čísla (např. 0123 ...) - Speciální znaky (např. # $% ...)",
    "ChangePwNew.placeholder": "Nové heslo",
    "ChangePwNewRepeat.label": "Zadejte heslo znovu",
    "ChangePwNewRepeat.error": "Hesla nesouhlasí.",
    "ChangePwNewRepeat.placeholder": "Zadejte heslo znovu",
    "PageNotFound.message": "Vyskytla se chyba. Vámi hledaná stránka neexistuje.",
    "AccountProfile.name": "Název",
    "AccountProfile.telephone": "Telefonní číslo",
    "AccountProfile.street": "Ulice",
    "AccountProfile.zip": "PSČ",
    "AccountProfile.surname": "Příjmení",
    "AccountProfile.mobile": "Číslo mobilu",
    "AccountProfile.city": "Město",
    "AccountProfile.country": "Země",
    "AccountProfile.userbutton": "Zpracování formuláře",
    "AccountProfile.email": "E-mailová adresa",
    "AccountProfile.password": "Heslo",
    "AccountProfile.loginbutton": "Zpracování formuláře",
    "AccountProfile.headline": "Přihlášení a bezpečnost",
    "projectsNewHeadline.headline": "Založení nového projektu",
    "projectsOverviewHeadline.headline": "Dodací a fakturační adresy",
    "ProjectsDelete.headline": "Opravdu chcete smazat tento projekt?",
    "ProjectsDelete.button": "Povolit",
    "ProjectsEdit.headline": "Zpracování projektu:",
    "ProjectsNew.headline": "Určete název objektu:",
    "RegisterPage.registerText": "Zadejte platnou E-mailovou adresu a heslo k účtu.",
    "RegisterPage.registerButton": "Zpět k přihlášení",
    "RegisterMail.error": "E-mail je povinné pole.",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "Heslo musí splňovat alespoň 2 ze 3 následujících podmínek: Písmena (např. ABCD ...) - Čísla (např. 0123 ...) - Speciální znaky (např. # $% ...)",
    "RegisterPw.name": "Heslo",
    "RegisterPwRepeat.error": "Hesla nesouhlasí.",
    "RegisterPwRepeat.name": "Zadejte heslo znovu",
    "RegisterUserGender.error": "Oslovení je povinné pole",
    "RegisterUserGender.label": "Oslovení",
    "RegisterUserGender.mr": "Pan",
    "RegisterUserGender.mrs": "Paní",
    "registerUserFirstName.error": "Jméno je povinné pole a musí obsahovat minimálně 2 znaky.",
    "registerUserFirstName.label": "Jméno",
    "registerUserLastName.error": "Příjmení je povinné pole a musí obsahovat minimálně 2 znaky.",
    "registerUserLastName.label": "Příjmení",
    "registerUserPhone.label": "Telefon",
    "registerUserMobile.label": "Mobil",
    "registerUserCompany.label": "Společnost",
    "registerUserStreet.error": "Ulice je povinné pole a musí obsahovat minimálně 2 znaky.",
    "registerUserStreet.label": "Ulice",
    "registerUserHouse.error": "Číslo domu je povinné pole a musí obsahovat minimálně 1 znak.",
    "registerUserHouse.label": "Číslo domu",
    "registerUserZip.error": "PSČ je povinné pole a musí obsahovat minimálně 2 znaky.",
    "registerUserZip.label": "PSČ",
    "registerUserCity.error": "Město je povinné pole a musí obsahovat minimálně 2 znaky.",
    "registerUserCity.label": "Město",
    "registerUserAddressAdditional.label": "Dodatek adresy",
    "registerUserCountry.error": "Země je povinné pole.",
    "registerUserCountry.label": "Země",
    "registerUserCountryLabel.label": "Zvolte zemi",
    "registerUserClientNr.label": "Číslo zákazníka (je-li k dispozici)",
    "registerUserBranch.error": "Odvětví je povinné pole",
    "registerUserBranch.label": "Odvětví",
    "registerUserBranchSanitary.label": "Velkoobchod se sanitou",
    "registerUserBranchPlanner.label": "Projektant / architekt",
    "registerUserBranchPlumber.label": "Instalatér",
    "registerUserBranchRetail.label": "Koncový zákazník",
    "editUserGender.error": "Oslovení je povinné pole",
    "editUserGender.label": "Oslovení",
    "editUserGenderMr.label": "Pan",
    "editUserGenderMrs.label": "Paní",
    "editUserFirstName.error": "Jméno je povinné pole a musí obsahovat minimálně 2 znaky.",
    "editUserFirstName.label": "Jméno",
    "editUserLastName.error": "Příjmení je povinné pole a musí obsahovat minimálně 2 znaky.",
    "editUserLastName.label": "Příjmení",
    "editUserPhone.label": "Telefon",
    "editUserMobile.label": "Mobil",
    "editUserStreet.error": "Ulice je povinné pole a musí obsahovat minimálně 2 znaky.",
    "editUserStreet.label": "Ulice",
    "editUserHouse.error": "Číslo domu je povinné pole a musí obsahovat minimálně 1 znak.",
    "editUserHouse.label": "Číslo domu",
    "editUserAddressAdditional.label": "Dodatek adresy",
    "editUserZip.error": "PSČ je povinné pole a musí obsahovat minimálně 2 znaky.",
    "editUserZip.label": "PSČ",
    "editUserCity.error": "Město je povinné pole a musí obsahovat minimálně 2 znaky.",
    "editUserCity.label": "Město",
    "editUserCountry.error": "Země je povinné pole.",
    "editUserCountry.label": "Země",
    "editUserCountryLabel.label": "Zvolte zemi",
    "RegisterSucceededComponent.registerSucceededHeading": "Děkujeme. Vaše registrace je nyní téměř hotová.",
    "RegisterSucceededComponent.registerSucceededText": "Za několik okamžiků od nás obdržíte E-mail s odkazem. Po potvrzení E-mailové adresy klepnutím na tento odkaz se můžete přihlásit.",
    "RegisterSucceededComponent.registerSucceededButton": "Zpět k přihlášení",
    "ThankYou.headline": "Děkujeme vám za konfiguraci!",
    "ThankYou.message": "E-mailovou zprávou jsme vám zaslali potvrzení se všemi podrobnostmi vaší nabídky.",
    "ThankYou.order": "Vaše číslo nabídky:",
    "ThankYou.pdfbutton": "Exportovat jako 2D PDF",
    "ThankYou.tenderdocuments": "Texty nabídek",
    "ThankYou.overviewbutton": "K přehledu konfigurace",
    "Configuration3dAlert.attention": "Jak začít?",
    "Configuration3dAlert.message": "Vyberte si požadovanou prohlubeň klepnutím na tlačítko (Vybrat prohlubeň) a spusťte konfiguraci. Přejeme vám příjemnou zábavu při konfiguraci!",
    "ActivationSucceeded.activationSucceededText": "Gratulujeme, váš účet byl úspěšně vytvořen. Vraťte se k přihlášení a zadejte uživatelské údaje.",
    "ActivationSucceeded.activationSucceededButton": "Jdeme na to",
    "ActivationFailed.activaionUserNotFound": "Tento uživatel neexistuje. Založte nový účet.",
    "ActivationFailed.activaionUserNotFoundButton": "Registrovat",
    "ChangeEmailForm.button": "Změnit E-mailovou adresu",
    "ChangePassword.button": "Změnit heslo",
    "LoginForm.button": "Přihlášení",
    "Logout.button": "Odhlášení",
    "RegisterUserDataForm.headline": "Zde uveďte své osobní údaje.",
    "RegisterUserDataForm.button": "Vytvořit nový účet",
    "RegisterUserDataForm.logout": "Zpět k přihlášení",
    "RegisterUserForm.button": "Vytvořit nový účet",
    "ResetPasswordForm.button": "Obnovit heslo",
    "ResetPasswordChangeForm.button": "Obnovit heslo",
    "Checkout.WashBasinDimensions": "Rozměry umyvadla",
    "Checkout.PlateDimensions.Width": "Šířka",
    "Checkout.PlateDimensions.Depth": "Hloubka",
    "Checkout.TypeOfInstallation": "Způsob vestavby",
    "Checkout.TypeOfInstallation.Left": "Výklenek vlevo",
    "Checkout.TypeOfInstallation.Right": "Výklenek vpravo",
    "Checkout.TypeOfInstallation.With": "Výklenek vlevo a vpravo",
    "Checkout.CornerDesign": "Rohová úprava",
    "Checkout.CornerDesign.Radius": "Poloměr 100 mm",
    "Checkout.CornerDesign.Bevel": "Zkosení, 100 mm",
    "Checkout.Left": "vlevo",
    "Checkout.Right": "vpravo",
    "Checkout.ApronBackSplash.Headline": "Lem / zadní lem",
    "Checkout.ApronBackSplash.Apron": "Lem: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Nárazová hrana: {position} - výška: 3 mm.",
    "Checkout.ApronBackSplash.apronBackSplash": "Zadní lem: {position} - výška: {height} mm.",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Výklenky / montážní díly",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x otvory pro baterii",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x otvor pro dávkovač mýdla: {name}",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x výřez \\\"{name}\\",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x výřez pro zásobník na kosmetické utěrky",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x výřez pro držák ručníku",
    "Checkout.Surface.Title": "Barva",
    "Checkout.Surface.Color": "Barva: {color}",
    "Checkout.Surface.GelCoat": "Gelcoat dolní strana",
    "Checkout.AssemblyAccessories.Title": "Montážní příslušenství",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x konzola {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x úhlová lišta pro montáž na boční stěnu.",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x pojistný třmen pro montáž na zadní stěnu.",
    "Checkout.GeneralInfo.Headline": "Přehled",
    "Checkout.GeneralInfo.ConfName": "Název konfigurace:",
    "Checkout.TotalPrice.Washbasin": "Umyvadlo",
    "Checkout.TotalPrice.Parts": "Příslušenství",
    "Checkout.TotalPrice.DeliveryCosts": "Dopravní náklady",
    "Checkout.TotalPrice.Vat": "DPH",
    "Checkout.TotalPrice.Total": "Celková částka",
    "Checkout.TotalPrice.Note": "Upozornění:",
    "Checkout.TotalPrice.NoteText": "Ceny platné do ",
    "Checkout.Trough.Headline": "Prohlubeň",
    "Checkout.Trough.Name": "Název prohlubně:",
    "Checkout.Trough.Qty": "Počet:",
    "Checkout.Trough.Dimensions": "Rozměry prohlubní:",
    "checkoutPartsPdfButton.button": "Stáhnout PDF",
    "Apron.height": "Výška lemu v mm",
    "ApronHeightRequiredHint.hint": "Upozornění:",
    "ApronHeightRequiredMessage.message": "Pro výběr zásobníku na kosmetické utěrky budete potřebovat lem o šířce {požadovanávýška} mm. Chcete pokračovat?",
    "ApronHeightError.message": "Vaše hodnota je mimo rozsah",
    "SurgeEdgeLabelWithout.without": "bez",
    "SurgeEdgeLabelWith.with": "s nárazovou hranou (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "se zadním lemem",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "vzadu (standard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Výška zadního lemu v mm",
    "WithoutAssemblyAccessories.without": "bez montážního příslušenství",
    "WithAssemblyAccessories.with": "s montážním příslušenstvím",
    "WithAssemblyAccessoriesTooltipHint.hint": "Upozornění:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Upevnění zajišťuje zákazník.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Chromniklová ocel",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Konzola",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Ochranný kryt odtoku",
    "AssemblyAccessoriesListAngleBar.anglebar": "Úhlová lišta",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Montážní materiál",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Chromniklová ocel bílá",
    "CornerDesignLabelWithout.without": "Bez rohové úpravy",
    "CornerDesignLabelRadius.radius": "Poloměr (100 mm)",
    "CornerDesignLabelBevel.bevel": "Zkosení (boční délka 100 mm)",
    "DistancesPositionOfTroughs.distances": "Zadání vzdálenosti středu umyvadla",
    "DistancesPositionOfTroughsHint.hint": "Upozornění:",
    "DistancesPositionOfTroughsMessage.message": "Výhody a doporučení k použití",
    "DistancesPositionOfTroughsFromPlate.plate": "Od desky k zadnímu okraji umyvadla",
    "PlateDimensionsWidth.width": "Šířka desky",
    "PlateDimensionsDepth.depth": "Hloubka desky",
    "PlateDimensionsDepth.depthIndividual": "Individuální",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "Hodnota je mimo přípustný rozsah",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Levá strana",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Pravá strana",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Možné pouze v kombinaci s typem instalace \"s, vlevo nebo vpravo\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Možné pouze v kombinaci s typem instalace \"bez, vlevo nebo vpravo\".",
    "Configuration.Inputs.message": "Hodnota je mimo přípustný rozsah",
    "DrainLabelWithoutDrain.withoutdrain": "Bez odtokového příslušenství",
    "DrainLabelHoodDrain.hooddrain": "Odtokový ventil s tlačnou zátkou",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Odtokový ventil s krytkou chromovaný",
    "DrainLabelSieveDrain.sievedrain": "Sítkový odtokový ventil",
    "DrainLabelEccentric.eccentric": "Excentrická odtoková a přepadová sada",
    "DrainLabelSiphon.siphon": "Sifon XINX140",
    "CosmeticTissueDispenser.without": "bez zásobníku na papírové utěrky",
    "CosmeticTissueDispenserSquare.square": "čtvercové (s Gelcoat) 127 × 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(pro zásobník na papírové ručníky „číslo modelu“)",
    "CosmeticTissueDispenserPosition.position": "(poloha mezi prohlubněmi)",
    "CutOutLabelCustomInput.diameter": "Průměr",
    "CutOutLabelCustomInput.width": "Šířka",
    "CutOutLabelCustomInput.depth": "Hloubka",
    "CutOutLabelSelect.select": "Zvolte",
    "CutOutDisposalsDefaultsWithout.without": "bez odpadu",
    "CutOutDisposalsDefaultsWith.with": "s odpadem",
    "SoapDispenserHoleLabelWithout.without": "bez",
    "SoapDispenserHoleLabelSD80.sd80": "pro dávkovač mýdla SD80",
    "SoapDispenserHoleLabelSD100.sd100": "pro dávkovač mýdla SD100",
    "SoapDispenserHoleLabel25.dispensers": "pro dávkovač jiných výrobců (Ø 25 mm)",
    "TapHoleWithout.taphole": "bez otvoru",
    "TapHoleWithoutDrilling.tapholedrilling": "s otvorem (Ø 35 mm)",
    "TowelRailWithout.towelrailwithout": "bez výřezu",
    "TowelRailWithout.towelrailwith": "s výřezem",
    "ColorLabel.alpinewhite": "Alpská bílá (standard)",
    "ColorLabel.alpinewhitetext": "Tepelně odolná do 80 °C",
    "ColorLabel.graniteblack": "Granit černá",
    "ColorLabel.graniteblacktext": "Tepelně odolná do 65 °C",
    "ColorLabel.graniteblackwhite": "Granit černá-bílá",
    "ColorLabel.graniteblackwhitetext": "Tepelně odolná do 65 °C",
    "ColorLabel.graniteLightGray": "Granit světle šedá",
    "ColorLabel.granitelightgraytext": "Tepelně odolná do 65 °C",
    "ColorBottomSideUncoated.uncoated": "nepovrstvené (standard)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Upozornění:",
    "ColorBottomSideMessage.message": "Výhody a doporučení k použití",
    "ElementNext.button": "Další",
    "ElementsPositionsLeft.left": "vlevo",
    "ElementsPositionsBack.back": "vzadu",
    "ElementsPositionsFront.front": "vpředu       ",
    "ElementsPositionsRight.right": "vpravo",
    "ElementsPositionsRight.warning": "Deaktivováno, zvětšete vzdálenost mezi prohlubněmi.",
    "ConfigurationListAdd.text": "Přidat novou konfiguraci",
    "ListItem.rename": "Přejmenovat",
    "ListItem.duplicate": "Duplikovat",
    "ListItem.delete": "Smazat",
    "ListItem.order": "Nabídka",
    "ListItem.orderShow": "Zobrazit nabídku",
    "ListItem.linkTitle": "Nastavení",
    "ListItemDetail.price": "Celková cena:",
    "ListItemDetail.offer": "Nabídka",
    "ListItemDetail.order": "Objednávka",
    "ListItemDetail.date": "Poslední změna",
    "ConfigurationNewForm.button": "Další",
    "Warning.RequireReset.Trough": "Pokud vyberete novou prohlubeň a chcete zvýšit nebo snížit množství, je třeba kvůli změnám v konfiguraci vynulovat všechny uvedené položky:",
    "Warning.RequireReset.Qty": "Pokud chcete zvýšit nebo snížit množství, je třeba kvůli změnám v konfiguraci vynulovat všechny uvedené položky:",
    "Warning.RequireReset.TypeOfInstallation": "Pokud chcete změnit typ instalace, je třeba kvůli změnám v konfiguraci vynulovat všechny uvedené položky:",
    "Warning.RequireReset.plateDepth": "Hloubka desky",
    "Warning.RequireReset.PlateDepth": "Pokud chcete změnit hloubku desky, je třeba kvůli změnám v konfiguraci vynulovat všechny uvedené položky:",
    "Warning.RequireReset.distances": "Vzdálenosti",
    "Warning.RequireReset.cornerDesign": "Rohová úprava",
    "Warning.RequireReset": "Nutné vynulování:",
    "Warning.RequireReset.Default": "Pokud chcete provést změny konfigurace, musíte ji vynulovat.",
    "Warning.RequireReset.ResetAll": "Všechno vynulovat?",
    "Warning.RequireReset.console": "Konzoly",
    "Warning.RequireReset.drain": "Odtokové příslušenství",
    "Warning.RequireReset.typeOfInstallation": "Způsob vestavby",
    "Warning.RequireReset.paperTowelDispensers": "Výřez pro zásobník ručníků",
    "Warning.RequireReset.plateWidth": "Šířka desky",
    "Warning.RequireReset.siphon": "Sifon",
    "Warning.RequireReset.soapDispenserHole": "Otvor pro dávkovač mýdla",
    "Warning.RequireReset.tapHole": "Otvor pro baterii",
    "Warning.RequireReset.tissueDispenser": "Výřez pro zásobník na papírové ručníky",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Nárazová hrana / zadní lem",
    "ConfigurationDetail.error.default": "Zvolená hodnota není přípustná. Zkontrolujte zadání.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "Zvolená hodnota není přípustná, zkontrolujte barevnou dolní stranu.",
    "LogoTitle.default": "Přehled konfigurace",
    "LogoTitle.fallback": "3D konfigurátor KWC",
    "MetaNavigationImprint.imprint": "Impressum",
    "MetaNavigationLegals.legals": "Obecné obchodní podmínky",
    "MetaNavigationPrivacy.privacy": "Zásady ochrany osobních údajů a souborů cookie",
    "NavigationTrough.name": "Prohlubeň",
    "NavigationTrough.title": "Prohlubeň",
    "NavigationBasin.name": "Rozměry umyvadla",
    "NavigationBasin.title": "Rozměry umyvadla",
    "NavigationApron.name": "Lem / zadní lem",
    "NavigationApron.title": "Lem / zadní lem",
    "NavigationRecesses.name": "Výklenky / montážní díly",
    "NavigationRecesses.title": "Výklenky / montážní díly",
    "NavigationColour.name": "Barva",
    "NavigationColour.title": "Barva",
    "NavigationAssembly.name": "Montážní příslušenství",
    "NavigationAssembly.title": "Montážní příslušenství",
    "NavigationDrain.name": "Odtokové příslušenství",
    "NavigationDrain.title": "Odtokové příslušenství",
    "ProjectsEditFormButton.button": "Uložit projekt",
    "ProjectListItemEdit.edit": "Zpracovat",
    "ProjectListItemDelete.delete": "Smazat",
    "ProjectListItemLinkTitle.title": "Nastavení",
    "projectListHeadline.headline": "Dodací a fakturační adresy",
    "ProjectListAdd.addText": "Přidat novou adresu",
    "ProjectNewFormButton.button": "Založit projekt",
    "ProjectName.error": "Název je povinné pole.",
    "ProjectName.name": "Název objektu:",
    "ProjectStreet.error": "Ulice je povinné pole a musí obsahovat minimálně 2 znaky.",
    "ProjectStreet.name": "Ulice",
    "ProjectStreetNr.error": "Číslo domu je povinné pole a musí obsahovat minimálně 2 znaky.",
    "ProjectStreetNr.name": "Číslo domu",
    "ProjectZip.error": "PSČ je povinné pole a musí obsahovat minimálně 2 znaky.",
    "ProjectZip.name": "PSČ",
    "ProjectCity.error": "Město je povinné pole a musí obsahovat minimálně 2 znaky.",
    "ProjectCity.name": "Město",
    "ProjectCountry.error": "Země je povinné pole.",
    "ProjectCountry.name": "Země",
    "ProjectCountry.label": "Zvolte zemi",
    "ProjectSelectExistingProject.text": "Zvolit stávající objekt",
    "ProjectSelectCreateProject.text": "Todavía no hay ningún objeto disponible: cree uno",
    "ProjectSelectButton.button": "Další",
    "ProjectSelectWithout.without": "Chci pokračovat bez objektu",
    "ProjectSelectButtonTitle.title": "Zpracovat objekt",
    "ProjectWithout.label": "Ano, chci pokračovat bez objektu",
    "ProjectWithout.button": "Další",
    "SelectedTroughListButton.button": "Prohlubeň připojena",
    "SelectedTroughListItemWidth.width": "Šířka",
    "SelectedTroughListItemWidth.minWidth": "Minimální šířka",
    "SelectedTroughListItemDepth.depth": "Hloubka",
    "SelectedTroughListItemDepth.minDepth": "Minimální hloubka",
    "SelectedTroughListItemHeight.height": "Výška",
    "TroughDetailModalButton.button": "Technický výkres",
    "TroughFilterButton.button": "Zrušit výběr",
    "TroughFilterExos.error": "Je zvolen EXOS.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "Je zvolen VARIUSsign.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "Je zvolen VARIUSmed.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Je zvoleno hranaté provedení.",
    "TroughFilterSquare.label": "hranaté",
    "TroughFilterOval.error": "Je zvoleno oválné provedení.",
    "TroughFilterOval.label": "oválné",
    "TroughFilterRound.error": "Je zvoleno kruhové provedení.",
    "TroughFilterRound.label": "kruhové",
    "TroughFilterWithOverflow.error": "Je zvoleno provedení s přepadem.",
    "TroughFilterWithOverflow.label": "S přepadem",
    "TroughFilterWithoutOverflow.error": "Je zvoleno provedení bez přepadu.",
    "TroughFilterWithoutOverflow.label": "bez přepadu",
    "TroughFilterWithBackwall.error": "Je vybrána zadní stěna umyvadla.",
    "TroughFilterWithBackwall.label": "se zadní stěnou umyvadla",
    "TroughFilterWithoutBackwall.error": "Je vybrána možnost S konzolou.",
    "TroughFilterWithoutBackwall.label": "s konzolami",
    "TroughListButtonSelect.select": "Zvolit prohlubeň",
    "TroughListButtonClose.close": "Zavřít nabídku",
    "TroughListButtonFilterOptions.filter": "Zobrazit možnosti filtrů",
    "TroughListSorryMsg.message": "Bohužel jsme nenašli žádnou prohlubeň, která odpovídá zvoleným možnostem filtrů.",
    "TroughListItemWidth.width": "Šířka",
    "TroughListItemWidth.minWidth": "Minimální šířka",
    "TroughListItemDepth.depth": "Hloubka",
    "TroughListItemDepth.minDepth": "Minimální hloubka",
    "TroughListItemHeight.height": "Výška       ",
    "TroughListMinValuesText.text": "min. šířka x hloubka umyvadla",
    "RegisterSucceededComponent.resendSucceededHeading": "Aktivační odkaz byl úspěšně znovu odeslán",
    "ActivationFailed.activationInvalid": "Aktivace se bohužel nezdařila!",
    "ActivationFailed.activationInvalidToken": "Platnost tokenu vypršela. Zkontrolujte, zda je tento účet aktivován, a přihlaste se znovu.",
    "ActivationFailed.activationInvalidTokenButton": "Zaslat nový odkaz.",
    "ActivationFailed.ActivationResend": "Opětovné odeslání aktivačního odkazu",
    "Configuration.Inputs.distancesInmm": "(vzdálenosti v mm)",
    "newEmail.text": "Nový E-mail",
    "newEmail.error": "Zadaný e-mail není správný.",
    "AccountProfile.button": "Uložit",
    "ApronLabel.with": "s lemem",
    "ApronLabel.without": "bez lemu (standardní)",
    "SquareCustom.square": "hranaté",
    "RoundCustom.round": "kruhové",
    "SearchPlaceholder.placeholder": "Zadejte hledaný výraz",
    "ColorCheckout.white": "Alpská bílá",
    "ColorCheckout.black": "Granit černá",
    "ColorCheckout.blackWhite": "Granit černá-bílá",
    "ColorCheckout.lightGray": "Granit světle šedá",
    "ConfigurationDetail.Drain.note": "Upozornění:",
    "ConfigurationDetail.Drain.noteMessage": "Žádné možnosti pro vybranou prohlubeň",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "Pro VARIUSmed MZB je součástí dodávky stojánkový trubkový ventil.",
    "ConfigurationDetail.Drain.noteExos": "Ochranný kryt odtoku s povrchovou úpravou InoxPlus je pro prohlubně EXOS. součástí dodávky.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "E-mail byl úspěšně změněn",
    "ChangeEmailSucceededPageComponent.emailChangedText": "V nejbližší době obdržíte E-mailem aktivační odkaz. Pro aktivaci účtu klepněte na tento odkaz.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Zpět k přihlášení",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Vaše heslo bylo úspěšně změněno.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Přihlaste se pomocí nového hesla.",
    "ResetPasswordChangeSucceededPageComponent.button": "Přihlášení",
    "Warning.RequireReset.apron": "Lem",
    "submitAsOrder.label": "Převodní příkaz SAP",
    "ListItemDetail.draft": "Návrh",
    "TroughDetailModalWidth.minWidth": "Minimální šířka",
    "TroughDetailModalDepth.minDepth": "Minimální hloubka",
    "TroughDetailModalWidth.width": "Šířka",
    "TroughDetailModalDepth.depth": "Hloubka",
    "TroughDetailModalHeight.height": "Výška       ",
    "ConfigurationCountry.headline": "K jaké zemi patří vaše konfigurace?",
    "ConfigurationCountry.button": "Další",
    "ConfigurationCountry.select": "Vyberte zemi",
    "SelectedTroughListItemHeight.minDimensions": "min. šířka x hloubka umyvadla",
    "TroughDetailModalDepth.minDimensions": "min. šířka x hloubka umyvadla",
    "TroughListItemDepth.minDimensions": "min. šířka x hloubka umyvadla",
    "CosmeticTissueDispenser.cosmeticTissue": "Zásobník na kosmetické utěrky",
    "PaperTowelDispenser.paperTowelDispenser": "Zásobník na papírové role",
    "CutOutLabelNone.none": "Zvolte odpad",
    "DistancesPosition.symmetrically": "identické odkládací plochy",
    "DistancesPosition.evenly": "identická šířka umyvadla",
    "CutOutLabel.CustomRound": "kruhový odpad",
    "CutOutLabel.CustomSquare": "hranatý odpad",
    "CutOutLabel.roundSleeve": "kruhový odpad s hrdlem na vhazování",
    "CutOutLabel.squareSleeve": "hranatý odpad s hrdlem na vhazování",
    "CutOutLabel.roundBasket": "kruhový odpad s odpadkovým košem",
    "CutOutLabel.roundRail": "kruhový odpad a odpadkový koš s vytahovacím rámem",
    "CutOutLabel.squareBasket": "hranatý odpad s odpadkovým košem",
    "CutOutLabel.squareRail": "hranatý odpad a odpadkový koš s vytahovacím rámem",
    "CutOutLabel.roundSleeveBasket": "kruhový odpad s hrdlem na vhazování a odpadkový koš",
    "CutOutLabel.roundSleeveRail": "kruhový odpad s hrdlem na vhazování a odpadkový koš s vytahovacím rámem",
    "CutOutLabel.squareSleeveBasket": "hranatý odpad s hrdlem na vhazování a odpadkový koš",
    "CutOutLabel.squareSleeveRail": "hranatý odpad s hrdlem na vhazování a odpadkový koš s vytahovacím rámem",
    "CutOutLabel.flap": "Klapka na vhazování odpadků",
    "CutOutLabel.flapBasket": "Klapka na vhazování odpadků s odpadkovým košem",
    "CutOutLabel.flapRail": "Klapka na vhazování odpadků a odpadkový koš s vytahovacím rámem",
    "CutOutLabel.provider": "Zásobník na papírové utěrky",
    "ApronHeightRequiredChoiceMessage.message": "Pro lepší vzhled umyvadla doporučujeme zvolit lem:",
    "apronHeightRequiredChoice60.60": "Změnit výšku lemu na 60 mm",
    "apronHeightRequiredChoice150.150": "Změnit výšku lemu na 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Zachovat výšku lemu",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Zachovat výšku lemu a pokračovat bez objímky",
    "CosmeticTissueDispenser.with": "se zásobníkem na papírové utěrky",
    "PlateDimensionsDepth.470": "Doporučení pro nástěnné armatury​",
    "PlateDimensionsDepth.550": "Doporučení pro standardní armatury​",
    "Warning.RequireReset.cutOutDisposals": "Odpad",
    "checkboxPositions.noSpace": "Není k dispozici dostatek místa.",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Výřez pro zásobník na papírové ručníky",
    "ApronAffects.position": "Pozor: Šířka lemu 18 mm vede k posunu polohy umyvadla.",
    "DepthRequiredHint.hint": "Upozornění:",
    "DepthRequiredMessage.message": "Hloubka umyvadla, kterou jste zvolili, není dostatečná. Chcete pro tento výřez nastavit požadovanou hloubku {requiredDepth} mm?",
    "ThankYou.orderPdf": "Konfigurace umyvadla (PDF)",
    "ThankYou.manufacturingPdf": "Výkres umyvadla (PDF)",
    "ThankYou.troughPdf": "Výkres prohlubně (PDF)",
    "PlateDimensionsRequired.hint": "Upozornění:",
    "PlateDimensionsRequired.message": "Upozornění: Šířka umyvadla není dostatečná. Pro umístění lemu musíte šířku umyvadla zvětšit. Chcete pokračovat?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Při zrušení výběru lemu se obnoví původní rozměry konfigurace.",
    "PlateDimensionsChoice.message": "Na umyvadle není dostatek prostoru pro lem. Pro pokračování máte následující možnosti:",
    "PlateDimensionsChoice.increase": "Změnit šířku umyvadla",
    "PlateDimensionsChoice.move": "Posunout prohlubeň a zachovat šířku umyvadla",
    "PlateDimensionsChoice.cancel": "Přerušit (rozměry bez lemu jsou zachovány)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Pro umístění věšáku na ručníky potřebujete zástěru 150 mm. Protože šířka vašeho umyvadla není pro umístění zástěry dostatečná, je třeba šířku umyvadla zvětšit. Chcete pokračovat?",
    "Checkout.OrderPdf": "Konfigurace umyvadla (PDF)",
    "Checkout.ManufacturingPdf": "Výkres umyvadla (PDF)",
    "submitAsRequest.label": "Vyžádat si nabídku",
    "checkoutSave.label": "Uložit",
    "submitAsOffer.label": "Nabídka převodu SAP",
    "ListItemDetail.request": "Poptávka",
    "ListItem.orderPdf": "Konfigurace umyvadla (PDF)",
    "ListItem.manufacturingPdf": "Výkres umyvadla (PDF)",
    "ListItem.troughPdf": "Výkres prohlubně (PDF)",
    "PlateDimensionsRequiredLimit.message": "Maximální šířka umyvadla dosažena. Výběr lemu není možný.",
    "PlateDimensionsChoiceLimit.message": "Na umyvadle není dostatek prostoru pro lem. Maximální šířka umyvadla dosažena. Pro pokračování máte následující možnosti:",
    "CutoutPartDetail.name": "Název",
    "CutoutPartDetail.dimensions": "Rozměry",
    "CutoutPartDetail.type": "Typ",
    "CutoutPartDetail.article": "Číslo zboží",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "Upozornění: Pro nastavení polohy držáku ručníku potřebujete lem 150 mm. Protože umyvadlo nemá dostatečný prostor pro umístění lemu, je třeba zvětšit jeho šířku. Chcete pokračovat?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "Pro umístění zásobníku na kosmetické utěrky potřebujete lem 150 mm. Protože umyvadlo nemá dostatečný prostor pro umístění lemu, je třeba zvětšit jeho šířku. Chcete pokračovat?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "Pro umístění tohoto výřezu potřebujete lem 150 mm. Protože umyvadlo nemá dostatečný prostor pro umístění lemu, je třeba zvětšit jeho šířku. Chcete pokračovat?",
    "apronHeightForTowelRailRequiredMessage.message": "Pro výběr držáku ručníku potřebujete lem {requiredHeight}. Chcete pokračovat?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Pro výběr zásobníku na kosmetické utěrky potřebujete lem {requiredHeight}. Chcete pokračovat?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Pro výběr výřezu budete potřebovat lem o výšce {požadovanávýška} mm. Chcete pokračovat?",
    "ListItem.archive": "Archivovat",
    "ConfigurationSwitchView.mine": "Moje konfigurace",
    "FolderSwitchView.mine": "Moje konfigurace",
    "ConfigurationSwitchView.connected": "Přiřazeno",
    "ConfigurationSwitchView.archived": "Archivováno",
    "Archive.headline": "Jste si jisti, že chcete tuto konfiguraci archivovat?",
    "Archive.button": "Povolit",
    "Unarchive.headline": "Jste si jisti, že chcete tuto konfiguraci obnovit?",
    "Unarchive.button": "Povolit",
    "ListItem.unarchive": "Obnovit",
    "WithNicheHint.hint": "Upozornění:",
    "WithNicheMessage.message": "Upozornění: šířka umyvadla = rozměr hotového výklenku minus 8 mm. Při konfiguraci na každé místo umyvadla odečtěte 4 mm. Zohledněte stavební výstupky!",
    "checkboxPositions.tissueConflict": "Systém odpadu byl změněn",
    "CutOutLabel.cosmetic": "Zásobník na kosmetické utěrky",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "Odkaz jsme vám zaslali e-mailem, váš účet bude aktivován po potvrzení.",
    "ConsolesOverlapChoice.message": "Konfigurace není možná, zvětšete vzdálenost nebo zvolte konzolu z chromniklové oceli.",
    "ConsolesOverlapChoice.continue": "Návrat na původní hodnotu (s konzolou z minerální slitiny)",
    "ConsolesOverlapChoice.return": "Návrat na původní hodnotu (s konzolou z minerální slitiny)",
    "ConsolesOverlapChoice.change": "Přechod na konzolu z chromniklové oceli",
    "checkoutSave.orderIsFailed": "Objednávku nebylo možné přenést do systému SAP. Duplikujte prosím konfiguraci a zkuste to znovu později.",
    "Warning.RequireReset.qty": "Počet prohlubní",
    "ConfigurationNewFormName.error": "Název je nutný.",
    "ConfigurationNewFormName.label": "Název",
    "ConfigurationNewFormName.placeholder": "Název",
    "ConfigurationNewFormPricingsAccessories.error": "Je vyžadováno časové období.",
    "ConfigurationNewFormPricingsAccessories.label": "Časový interval příslušenství",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Zvolte...",
    "ConfigurationNewFormPricingsWashbasin.error": "Je vyžadováno časové období.",
    "ConfigurationNewFormPricingsWashbasin.label": "Časový interval umyvadla",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Zvolte...",
    "checkoutParts.timePeriodNote": "Upozornění:",
    "checkoutParts.timePeriodNoteText": "Zvolte časový interval pro platnost ceny",
    "checkoutParts.timePeriodAccessoriesLabel": "Časový interval příslušenství",
    "checkoutParts.timePeriodWashbasinLabel": "Časový interval umyvadla",
    "checkoutSave.orderIsQueued": "Objednávku nebylo možné přenést do systému SAP. Byla zařazena do fronty pro pozdější předání.",
    "ListItemDetail.failed": "Postup se nezdařil",
    "ListItemDetail.queued": "Ve frontě",
    "TroughFilterMedcare.error": "Je vyžadována služba MEDCARE.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "k dispozici od srpna 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/cz_CZ/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(vytvořeno)",
    "Login.mustLogin": "Chcete-li spustit konfiguraci, musíte se přihlásit. Pokud ještě nemáte účet, vytvořte si nový účet.",
    "Troughs.toStart": "Chcete-li spustit konfiguraci, musíte se {přihlásit}. Pokud ještě nemáte účet, {vytvořte}.",
    "TroughFilter.modelLine": "Řádek",
    "TroughFilter.characteristics": "Vlastnosti řádku",
    "TroughListItem.min": "min. Umyvadlo",
    "TroughListItem.start": "Počáteční konfigurace",
    "TroughListItem.startWithLogin": "Spuštění konfigurace po přihlášení",
    "TroughBanner.label": "Které mísy jsou k dispozici?",
    "TroughBanner.text": "Podívejte se předem.",
    "SearchPlaceholder.placeholderTroughs": "Vyhledejte mísu",
    "Troughs.toStartLogin": "Přihlaste se",
    "Troughs.toStartCreate": "Vytvořit nový účet",
    "ConfigurationDownload3D.text": "Stáhnout 3D scénu",
    "ConfigurationNewFolder.newHeading": "Nová složka",
    "NewButtonsNewFolder.text": "Nová složka",
    "NewButtonsNewConfiguration.text": "Vytvoření konfigurace",
    "FolderListHeading.text": "Složka",
    "FolderListNone.text": "Zatím nejsou k dispozici žádné složky",
    "ConfigurationListHeading.text": "Nepřiřazené konfigurace",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "Zobrazit všechny složky",
    "ListItem.moveToGroup": "Přesunout do složky nebo fáze konstrukce",
    "ListItem.goBack": "Zpět",
    "FolderSwitchView.goBack": "Zpět",
    "ListItem.downloadPdfs": "Stáhnout soubory PDF",
    "ConfigurationDeleteFolder.cancel": "Zrušit",
    "ConfigurationEditFolder.cancel": "Zrušit",
    "ConfigurationNewFolder.cancel": "Zrušit",
    "ConfigurationNewFolder.create": "Vytvořit stránku",
    "ConnectedFolder.label": "Ano, chci vytvořit novou složku s názvem objektu na svém ovládacím panelu.",
    "FolderListHeadingAll.text": "Všechny složky",
    "FolderListToday.text": "Dnes",
    "FolderList7Days.text": "Předchozích 7 dní",
    "FolderList30Days.text": "Předchozích 30 dní",
    "FolderListItemNestedDelete.text": "Smazat etapu",
    "ConfigurationDeleteNestedFolder.heading": "Smazat etapu",
    "ConfigurationNewFolderNested.newHeading": "Nová etapa",
    "ListItem.moveToThisGroup": "Přesun do složky",
    "ConfigurationDeleteFolder.note": "Poznámka:",
    "ConfigurationDeleteNestedFolder.body": "Pokud tuto etapu odstraníte, konfigurace, které obsahuje, zůstanou zachovány, pouze se přesunou do úložiště složky.",
    "ConfigurationDeleteFolder.body": "Pokud tuto etapu odstraníte, konfigurace, které obsahuje, zůstanou zachovány, pouze se přesunou do úložiště složky.",
    "FolderListNestedHeading.test": "Fáze výstavby",
    "BuildingNumber.error": "Je vyžadováno building number.",
    "OpportunityNumber.error": "Je vyžadováno opportunity number.",
    "FolderListItemDelete.text": "Odstranit složku",
    "ConfigurationDeleteFolder.heading": "Odstranit složku",
    "ConfigurationDeleteFolder.confirm": "Potvrďte",
    "ConfigurationEditFolder.heading": "Upravit složku",
    "ConfigurationEditFolderNested.heading": "Upravit fázi výstavby",
    "ConfigurationEditFolder.confirm": "Potvrďte",
    "ConfigurationListNone.text": "Zatím nejsou k dispozici žádné konfigurace",
    "ListItemDetail.basin": "Umyvadlo",
    "ListItemDetail.number": "Žlaby",
    "ListItem.moveToDashboard": "Přesunout na panel",
    "FolderList.SortByDate": "Řadit podle data",
    "FolderList.SortByName": "Řadit podle názvu",
    "FolderName.name": "Název složky",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "es": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "China | 中国",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Vista general de la configuración",
    "NavigationUser.accountName": "Inicio de sesión y seguridad",
    "NavigationUser.adressesName": "Direcciones de entrega y facturación",
    "CheckoutHeadline.checkout": "Resumen",
    "CheckoutBackButton.checkout": "Volver a la configuración",
    "CheckoutConfigurationHeadline.checkout": "Configuración del lavabo",
    "CheckoutPartsHeadline.checkout": "Accesorios",
    "CheckoutPartsHeadlineLink.checkout": "Vista general de la configuración",
    "Delete.headline": "¿Está seguro de que desea eliminar esta configuración?",
    "Delete.button": "Aceptar",
    "Assemblies.note": "Indicación:",
    "Assemblies.message.with": "Los accesorios de montaje están diseñados únicamente para paredes sólidas.",
    "Assemblies.message.without": "Montaje en situ.",
    "Assemblies.message.alwaysTriggerSafety": "El seguro de gatillo siempre está incluido.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Accesorios de montaje",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Selección",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Accesorios de montaje",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Dimensiones del lavabo",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Tipo de montaje",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Ángulo del nicho",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Diseño de esquina",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Dimensiones del panel",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Posición de las cubetas",
    "ConfigurationDetail.ApronBacksplash.apron": "Faldón",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Reborde / Ribete",
    "ConfigurationDetail.Recesses.tapHole": "Orificio para grifo",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Orificio para el dispensador de jabón",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Papelera",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Dispensador de toallas de papel",
    "ConfigurationDetail.Recesses.towelRail": "Toallero",
    "ConfigurationDetail.plateSurface.colour": "Color",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Parte inferior",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Faldón / Ribete",
    "ConfigurationDetail.Drain.drainTitle": "Accesorios de desagüe",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Accesorios de desagüe",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Cerrar configuración",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Encastres / Piezas empotradas",
    "ConfigurationDetail.colour.colourTitle": "Color",
    "ConfigurationDetail.troughs.troughsTitle": "Cubetas",
    "ConfigurationProject.headline": "¿A qué objeto pertenece su configuración?",
    "ConfigurationProject.tabexisting": "Seleccionar un objeto existente",
    "ConfigurationProject.tabnew": "Crear un nuevo objeto",
    "ConfigurationProject.tabEXISTING": "Existente",
    "ConfigurationProject.tabNEW": "Nuevo",
    "ConfigurationProject.tabWITHOUT": "SIN",
    "ConfigurationDuplicate.headline": "¿Quiere duplicar esta configuración?",
    "ConfigurationDuplicate.button": "Duplicar",
    "ConfigurationNew.headline": "Introduzca los detalles de su configuración:",
    "ConfigurationRename.headline": "¿Cómo quiere llamar a su configuración?",
    "ChangePasswordPage.changePasswordHeading": "Introduzca su nueva contraseña",
    "ChangePasswordPage.changePasswordText": "La contraseña debe incluir al menos 2 de los 3 elementos que se indican a continuación: Letras (por ejemplo, ABCD...) - Números (por ejemplo, 0123...) - Caracteres especiales (por ejemplo, #$%...)",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "¡Su contraseña se ha modificado correctamente!",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Vuelva a la página de inicio de sesión e introduzca su nueva contraseña.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Volver a la página de inicio de sesión",
    "HomeLink.imprint": "Aviso legal",
    "HomeLink.legals": "Condiciones generales de venta",
    "HomeLink.privacy": "Política de privacidad y cookies",
    "Login.newUser": "Cree una cuenta nueva",
    "Login.forgotPassword": "¿Ha olvidado su contraseña?",
    "Login.Label.Email": "Correo electrónico",
    "Login.Placeholder.Email": "Correo electrónico",
    "Login.Error.Email": "El correo electrónico es un campo obligatorio.",
    "Login.Label.Password": "Contraseña",
    "Login.Placeholder.Password": "Contraseña",
    "Login.Error.Password": "La contraseña es un campo obligatorio.",
    "ResetPassword.button": "Volver a la página de inicio de sesión",
    "ResetPasswordSucceededPageComponent.resetPassword": "¡Su contraseña se ha modificado correctamente!",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Le hemos enviado un correo electrónico con un enlace de confirmación en el que debe hacer clic para activar su cuenta.",
    "ResetPasswordSucceededPageComponent.button": "Iniciar sesión",
    "ChangePwOld.label": "Antigua contraseña",
    "ChangePwOld.placeholder": "Antigua contraseña",
    "ChangePwOld.error": "La contraseña debe incluir al menos 2 de los 3 elementos que se indican a continuación: Letras (por ejemplo, ABCD...) - Números (por ejemplo, 0123...) - Caracteres especiales (por ejemplo, #$%...)",
    "ChangePwNew.label": "Nueva contraseña",
    "ChangePwNew.error": "La contraseña debe incluir al menos 2 de los 3 elementos que se indican a continuación: Letras (por ejemplo, ABCD...) - Números (por ejemplo, 0123...) - Caracteres especiales (por ejemplo, #$%...)",
    "ChangePwNew.placeholder": "Nueva contraseña",
    "ChangePwNewRepeat.label": "Introduzca de nuevo la contraseña",
    "ChangePwNewRepeat.error": "Las contraseñas no coinciden.",
    "ChangePwNewRepeat.placeholder": "Introduzca de nuevo la contraseña",
    "PageNotFound.message": "Se ha producido un error. La página que está buscando no existe.",
    "AccountProfile.name": "Nombre",
    "AccountProfile.telephone": "Número de teléfono",
    "AccountProfile.street": "Calle",
    "AccountProfile.zip": "Código postal",
    "AccountProfile.surname": "Apellidos",
    "AccountProfile.mobile": "Número de teléfono móvil",
    "AccountProfile.city": "Ciudad",
    "AccountProfile.country": "País",
    "AccountProfile.userbutton": "Editar formulario",
    "AccountProfile.email": "Dirección de correo electrónico",
    "AccountProfile.password": "Contraseña",
    "AccountProfile.loginbutton": "Editar formulario",
    "AccountProfile.headline": "Inicio de sesión y seguridad",
    "projectsNewHeadline.headline": "Crear un nuevo proyecto",
    "projectsOverviewHeadline.headline": "Direcciones de entrega y facturación",
    "ProjectsDelete.headline": "¿Está seguro de que desea eliminar este proyecto?",
    "ProjectsDelete.button": "Aceptar",
    "ProjectsEdit.headline": "Edite su proyecto:",
    "ProjectsNew.headline": "Introduzca un nombre para su objeto:",
    "RegisterPage.registerText": "Introduzca una dirección de correo electrónico y una contraseña válida para su cuenta.",
    "RegisterPage.registerButton": "Volver a la página de inicio de sesión",
    "RegisterMail.error": "El correo electrónico es un campo obligatorio.",
    "RegisterMail.name": "Correo electrónico",
    "RegisterPw.error": "La contraseña debe incluir al menos 2 de los 3 elementos que se indican a continuación: Letras (por ejemplo, ABCD...) - Números (por ejemplo, 0123...) - Caracteres especiales (por ejemplo, #$%...)",
    "RegisterPw.name": "Contraseña",
    "RegisterPwRepeat.error": "Las contraseñas no coinciden.",
    "RegisterPwRepeat.name": "Introduzca de nuevo la contraseña",
    "RegisterUserGender.error": "El tratamiento es un campo obligatorio.",
    "RegisterUserGender.label": "Tratamiento",
    "RegisterUserGender.mr": "Señor",
    "RegisterUserGender.mrs": "Señora",
    "registerUserFirstName.error": "El nombre es un campo obligatorio y debe tener al menos 2 caracteres.",
    "registerUserFirstName.label": "Nombre",
    "registerUserLastName.error": "Los apellidos son un campo obligatorio y deben tener al menos 2 caracteres.",
    "registerUserLastName.label": "Apellidos",
    "registerUserPhone.label": "Teléfono",
    "registerUserMobile.label": "Móvil",
    "registerUserCompany.label": "Empresa",
    "registerUserStreet.error": "La calle es un campo obligatorio y debe tener al menos 2 caracteres.",
    "registerUserStreet.label": "Calle",
    "registerUserHouse.error": "El número es un campo obligatorio y debe tener al menos 1 carácter.",
    "registerUserHouse.label": "Número",
    "registerUserZip.error": "El código postal es un campo obligatorio y debe tener al menos 2 caracteres.",
    "registerUserZip.label": "Código postal",
    "registerUserCity.error": "La ciudad es un campo obligatorio y debe tener al menos 2 caracteres.",
    "registerUserCity.label": "Ciudad",
    "registerUserAddressAdditional.label": "Información adicional sobre la dirección",
    "registerUserCountry.error": "El país es un campo obligatorio.",
    "registerUserCountry.label": "País",
    "registerUserCountryLabel.label": "Seleccione un país",
    "registerUserClientNr.label": "Número de cliente (si procede)",
    "registerUserBranch.error": "El sector es un campo obligatorio.",
    "registerUserBranch.label": "Sector",
    "registerUserBranchSanitary.label": "Mayorista de productos sanitarios",
    "registerUserBranchPlanner.label": "Planificador / Arquitecto",
    "registerUserBranchPlumber.label": "Instalador",
    "registerUserBranchRetail.label": "Cliente final",
    "editUserGender.error": "El tratamiento es un campo obligatorio.",
    "editUserGender.label": "Tratamiento",
    "editUserGenderMr.label": "Señor",
    "editUserGenderMrs.label": "Señora",
    "editUserFirstName.error": "El nombre es un campo obligatorio y debe tener al menos 2 caracteres.",
    "editUserFirstName.label": "Nombre",
    "editUserLastName.error": "Los apellidos son un campo obligatorio y deben tener al menos 2 caracteres.",
    "editUserLastName.label": "Apellidos",
    "editUserPhone.label": "Teléfono",
    "editUserMobile.label": "Móvil",
    "editUserStreet.error": "La calle es un campo obligatorio y debe tener al menos 2 caracteres.",
    "editUserStreet.label": "Calle",
    "editUserHouse.error": "El número es un campo obligatorio y debe tener al menos 1 carácter.",
    "editUserHouse.label": "Número",
    "editUserAddressAdditional.label": "Información adicional sobre la dirección",
    "editUserZip.error": "El código postal es un campo obligatorio y debe tener al menos 2 caracteres.",
    "editUserZip.label": "Código postal",
    "editUserCity.error": "La ciudad es un campo obligatorio y debe tener al menos 2 caracteres.",
    "editUserCity.label": "Ciudad",
    "editUserCountry.error": "El país es un campo obligatorio.",
    "editUserCountry.label": "País",
    "editUserCountryLabel.label": "Seleccione un país",
    "RegisterSucceededComponent.registerSucceededHeading": "¡Muchas gracias! Su registro se ha guardado correctamente.",
    "RegisterSucceededComponent.registerSucceededText": "En unos minutos, recibirá un correo electrónico con un enlace. Haga clic en ese enlace para confirmar su dirección de correo electrónico. En cuanto lo haya hecho, podrá iniciar sesión.",
    "RegisterSucceededComponent.registerSucceededButton": "Volver a la página de inicio de sesión",
    "ThankYou.headline": "¡Muchas gracias por su configuración!",
    "ThankYou.message": "Le hemos enviado un correo electrónico de confirmación con todos los detalles de su oferta.",
    "ThankYou.order": "El número de su oferta:",
    "ThankYou.pdfbutton": "Exportar como PDF en 2D",
    "ThankYou.tenderdocuments": "Documentos de licitación",
    "ThankYou.overviewbutton": "Ver una vista general de la configuración",
    "Configuration3dAlert.attention": "¿Cómo empezar?",
    "Configuration3dAlert.message": "Seleccione la cubeta que desee haciendo clic en el botón «Seleccionar comedero» e inicie la configuración. ¡Esperamos que disfrute el proceso de configuración!",
    "ActivationSucceeded.activationSucceededText": "¡Enhorabuena! Su cuenta se ha creado correctamente. Vuelva a la página de inicio de sesión e introduzca sus nuevas credenciales.",
    "ActivationSucceeded.activationSucceededButton": "¡Allá vamos!",
    "ActivationFailed.activaionUserNotFound": "Este usuario no existe. Cree una cuenta nueva.",
    "ActivationFailed.activaionUserNotFoundButton": "Registrarse",
    "ChangeEmailForm.button": "Cambiar dirección de correo electrónico",
    "ChangePassword.button": "Cambiar contraseña",
    "LoginForm.button": "Iniciar sesión",
    "Logout.button": "Cerrar sesión",
    "RegisterUserDataForm.headline": "Introduzca aquí sus datos personales.",
    "RegisterUserDataForm.button": "Crear una cuenta nueva",
    "RegisterUserDataForm.logout": "Volver a la página de inicio de sesión",
    "RegisterUserForm.button": "Crear una cuenta nueva",
    "ResetPasswordForm.button": "Restablecer la contraseña",
    "ResetPasswordChangeForm.button": "Restablecer la contraseña",
    "Checkout.WashBasinDimensions": "Dimensiones del lavabo",
    "Checkout.PlateDimensions.Width": "Anchura",
    "Checkout.PlateDimensions.Depth": "Profundidad",
    "Checkout.TypeOfInstallation": "Tipo de montaje",
    "Checkout.TypeOfInstallation.Left": "Nicho izquierdo",
    "Checkout.TypeOfInstallation.Right": "Nicho derecho",
    "Checkout.TypeOfInstallation.With": "Nicho izquierdo y derecho",
    "Checkout.CornerDesign": "Diseño de esquina",
    "Checkout.CornerDesign.Radius": "Radio de 100 mm",
    "Checkout.CornerDesign.Bevel": "Bisel de 100 mm",
    "Checkout.Left": "Izquierda",
    "Checkout.Right": "Derecha",
    "Checkout.ApronBackSplash.Headline": "Faldón / Ribete",
    "Checkout.ApronBackSplash.Apron": "Faldón: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Reborde: {position} - Altura: 3 mm.",
    "Checkout.ApronBackSplash.apronBackSplash": "Ribete: {position} - Altura: {height} mm.",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Encastres / Piezas empotradas",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x orificios para grifos",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x Orificio para el dispensador de jabón",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x recorte \\\"{name}\\",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x recorte para dispensador de toallitas cosméticas",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x recorte para toallitas de papel",
    "Checkout.Surface.Title": "Color",
    "Checkout.Surface.Color": "Color: {color}",
    "Checkout.Surface.GelCoat": "Parte inferior con gelcoat",
    "Checkout.AssemblyAccessories.Title": "Accesorios de montaje",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x soporte de sujeción {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x listón angular para montaje en la pared lateral.",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x protección de gatillo para montaje en la pared trasera",
    "Checkout.GeneralInfo.Headline": "Información general",
    "Checkout.GeneralInfo.ConfName": "Nombre de la configuración:",
    "Checkout.TotalPrice.Washbasin": "Lavabo",
    "Checkout.TotalPrice.Parts": "Accesorios",
    "Checkout.TotalPrice.DeliveryCosts": "Gastos de transporte",
    "Checkout.TotalPrice.Vat": "IVA",
    "Checkout.TotalPrice.Total": "Importe total",
    "Checkout.TotalPrice.Note": "Indicación:",
    "Checkout.TotalPrice.NoteText": "Precios válidos hasta el ",
    "Checkout.Trough.Headline": "Cubeta",
    "Checkout.Trough.Name": "Nombre de la cubeta:",
    "Checkout.Trough.Qty": "Número:",
    "Checkout.Trough.Dimensions": "Dimensiones de la cubeta",
    "checkoutPartsPdfButton.button": "Descargar como PDF",
    "Apron.height": "Altura del faldón en mm",
    "ApronHeightRequiredHint.hint": "Indicación:",
    "ApronHeightRequiredMessage.message": "Para seleccionar un dispensador de toallitas cosméticas, necesita un faldón de {requiredHeight} mm. ¿Desea continuar?",
    "ApronHeightError.message": "El valor está fuera de las dimensiones",
    "SurgeEdgeLabelWithout.without": "sin",
    "SurgeEdgeLabelWith.with": "Con borde antisalpicaduras (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "Con ribete",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "Parte trasera (estándar)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Altura del salpicadero en mm",
    "WithoutAssemblyAccessories.without": "Sin accesorios de montaje",
    "WithAssemblyAccessories.with": "Con accesorios de montaje",
    "WithAssemblyAccessoriesTooltipHint.hint": "Indicación:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Fijación por parte de los clientes.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Acero inoxidable",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Soporte de sujeción",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Protección de gatillo",
    "AssemblyAccessoriesListAngleBar.anglebar": "Listón angular",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Material de fijación",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Acero inoxidable blanco",
    "CornerDesignLabelWithout.without": "Sin diseño angular",
    "CornerDesignLabelRadius.radius": "Radio (100 mm)",
    "CornerDesignLabelBevel.bevel": "Bisel (longitud lateral de 100 mm)",
    "DistancesPositionOfTroughs.distances": "Introducir la distancia al centro de la cubeta",
    "DistancesPositionOfTroughsHint.hint": "Indicación:",
    "DistancesPositionOfTroughsMessage.message": "Ventajas y recomendaciones de aplicación",
    "DistancesPositionOfTroughsFromPlate.plate": "Desde la placa hasta el borde posterior de la cubeta",
    "PlateDimensionsWidth.width": "Anchura del panel",
    "PlateDimensionsDepth.depth": "Profundidad del panel",
    "PlateDimensionsDepth.depthIndividual": "Individual",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "El valor está fuera del rango permitido",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Lado izquierdo",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Lado derecho",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Solo es posible en combinación con el tipo de instalación «con, izquierda o derecha».",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Solo es posible en combinación con el tipo de instalación «sin, izquierda o derecha».",
    "Configuration.Inputs.message": "El valor está fuera del rango permitido",
    "DrainLabelWithoutDrain.withoutdrain": "Sin accesorios de desagüe",
    "DrainLabelHoodDrain.hooddrain": "Desagüe de bóveda",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Desagüe de bóveda cromado",
    "DrainLabelSieveDrain.sievedrain": "Desagüe con colador",
    "DrainLabelEccentric.eccentric": "Piezas de montaje para instalación de excéntrica y rebosadero",
    "DrainLabelSiphon.siphon": "Sifón XINX140",
    "CosmeticTissueDispenser.without": "sin dispensador de toallas de papel",
    "CosmeticTissueDispenserSquare.square": "cuadrado (con gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(para dispensadores de toallitas cosméticas «número de modelo»)",
    "CosmeticTissueDispenserPosition.position": "(posición entre las cubetas)",
    "CutOutLabelCustomInput.diameter": "Diámetro",
    "CutOutLabelCustomInput.width": "Anchura",
    "CutOutLabelCustomInput.depth": "Profundidad",
    "CutOutLabelSelect.select": "Seleccione una opción",
    "CutOutDisposalsDefaultsWithout.without": "sin papelera",
    "CutOutDisposalsDefaultsWith.with": "con papelera",
    "SoapDispenserHoleLabelWithout.without": "sin",
    "SoapDispenserHoleLabelSD80.sd80": "para el dispensador de jabón SD80",
    "SoapDispenserHoleLabelSD100.sd100": "para el dispensador de jabón SD100",
    "SoapDispenserHoleLabel25.dispensers": "para dispensadores de otros fabricantes (Ø 25 mm)",
    "TapHoleWithout.taphole": "sin orificio",
    "TapHoleWithoutDrilling.tapholedrilling": "con orificio (Ø 35 mm)",
    "TowelRailWithout.towelrailwithout": "Sin recorte",
    "TowelRailWithout.towelrailwith": "con recorte",
    "ColorLabel.alpinewhite": "Blanco alpino (estándar)",
    "ColorLabel.alpinewhitetext": "Resistente a temperaturas de hasta 80 °C",
    "ColorLabel.graniteblack": "Granito negro",
    "ColorLabel.graniteblacktext": "Resistente a temperaturas de hasta 65 °C",
    "ColorLabel.graniteblackwhite": "Granito negro-blanco",
    "ColorLabel.graniteblackwhitetext": "Resistente a temperaturas de hasta 65 °C",
    "ColorLabel.graniteLightGray": "Granito gris claro",
    "ColorLabel.granitelightgraytext": "Resistente a temperaturas de hasta 65 °C",
    "ColorBottomSideUncoated.uncoated": "Sin revestimiento (estándar)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Indicación:",
    "ColorBottomSideMessage.message": "Ventajas y recomendaciones de aplicación",
    "ElementNext.button": "Siguiente",
    "ElementsPositionsLeft.left": "Izquierda",
    "ElementsPositionsBack.back": "Parte posterior",
    "ElementsPositionsFront.front": "frontal       ",
    "ElementsPositionsRight.right": "Derecha",
    "ElementsPositionsRight.warning": "Desactivado: aumente la distancia entre las cubetas.",
    "ConfigurationListAdd.text": "Añadir una nueva configuración",
    "ListItem.rename": "Cambiar el nombre",
    "ListItem.duplicate": "Duplicar",
    "ListItem.delete": "Eliminar",
    "ListItem.order": "Oferta",
    "ListItem.orderShow": "Ver oferta",
    "ListItem.linkTitle": "Ajustes",
    "ListItemDetail.price": "Importa total:",
    "ListItemDetail.offer": "Oferta",
    "ListItemDetail.order": "Pedido",
    "ListItemDetail.date": "Última modificación",
    "ConfigurationNewForm.button": "Siguiente",
    "Warning.RequireReset.Trough": "Debido a los cambios en su configuración, todos los elementos de la lista deben restablecerse si selecciona un nueva cubeta y desea aumentar o disminuir la cantidad:",
    "Warning.RequireReset.Qty": "Debido a los cambios en su configuración, todos los elementos de la lista deben restablecerse si desea aumentar o disminuir la cantidad:",
    "Warning.RequireReset.TypeOfInstallation": "Debido a los cambios en su configuración, todos los elementos de la lista deben restablecerse si desea aumentar o disminuir la cantidad:",
    "Warning.RequireReset.plateDepth": "Profundidad del panel",
    "Warning.RequireReset.PlateDepth": "Debido a cambios en su configuración, todos los elementos listados deben ser restablecidos si desea cambiar la profundidad de la placa:",
    "Warning.RequireReset.distances": "Distancias",
    "Warning.RequireReset.cornerDesign": "Diseño de esquina",
    "Warning.RequireReset": "Reinicio necesario:",
    "Warning.RequireReset.Default": "Debido a cambios en su configuración, es necesario restablecerla.",
    "Warning.RequireReset.ResetAll": "¿Restablecer todo?",
    "Warning.RequireReset.console": "Soportes de sujeción",
    "Warning.RequireReset.drain": "Accesorios de desagüe",
    "Warning.RequireReset.typeOfInstallation": "Tipo de montaje",
    "Warning.RequireReset.paperTowelDispensers": "Recorte para el dispensador de toallas de papel",
    "Warning.RequireReset.plateWidth": "Anchura del panel",
    "Warning.RequireReset.siphon": "Sifón",
    "Warning.RequireReset.soapDispenserHole": "Orificio para dispensador de jabón",
    "Warning.RequireReset.tapHole": "Orificio para grifo",
    "Warning.RequireReset.tissueDispenser": "Recorte para dispensador de toallas de papel",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Reborde / Ribete",
    "ConfigurationDetail.error.default": "El valor seleccionado no está permitido. Por favor, compruebe los datos introducidos.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "El valor seleccionado no está permitido. Por favor, compruebe su subpágina de color.",
    "LogoTitle.default": "Vista general de la configuración",
    "LogoTitle.fallback": "Configurador 3D KWC",
    "MetaNavigationImprint.imprint": "Aviso legal",
    "MetaNavigationLegals.legals": "Condiciones generales de venta",
    "MetaNavigationPrivacy.privacy": "Política de privacidad y cookies",
    "NavigationTrough.name": "Cubeta",
    "NavigationTrough.title": "Cubeta",
    "NavigationBasin.name": "Dimensiones del lavabo",
    "NavigationBasin.title": "Dimensiones del lavabo",
    "NavigationApron.name": "Faldón / Ribete",
    "NavigationApron.title": "Faldón / Ribete",
    "NavigationRecesses.name": "Encastres / Piezas empotradas",
    "NavigationRecesses.title": "Encastres / Piezas empotradas",
    "NavigationColour.name": "Color",
    "NavigationColour.title": "Color",
    "NavigationAssembly.name": "Accesorios de montaje",
    "NavigationAssembly.title": "Accesorios de montaje",
    "NavigationDrain.name": "Accesorios de desagüe",
    "NavigationDrain.title": "Accesorios de desagüe",
    "ProjectsEditFormButton.button": "Guardar proyecto",
    "ProjectListItemEdit.edit": "Editar",
    "ProjectListItemDelete.delete": "Eliminar",
    "ProjectListItemLinkTitle.title": "Ajustes",
    "projectListHeadline.headline": "Direcciones de entrega y facturación",
    "ProjectListAdd.addText": "Añadir una nueva dirección",
    "ProjectNewFormButton.button": "Crear un proyecto",
    "ProjectName.error": "El nombre es un campo obligatorio.",
    "ProjectName.name": "Nombre del objeto:",
    "ProjectStreet.error": "La calle es un campo obligatorio y debe tener al menos 2 caracteres.",
    "ProjectStreet.name": "Calle",
    "ProjectStreetNr.error": "El número es un campo obligatorio y debe tener al menos 2 caracteres.",
    "ProjectStreetNr.name": "Número",
    "ProjectZip.error": "El código postal es un campo obligatorio y debe tener al menos 2 caracteres.",
    "ProjectZip.name": "Código postal",
    "ProjectCity.error": "La ciudad es un campo obligatorio y debe tener al menos 2 caracteres.",
    "ProjectCity.name": "Ciudad",
    "ProjectCountry.error": "El país es un campo obligatorio.",
    "ProjectCountry.name": "País",
    "ProjectCountry.label": "Seleccione un país",
    "ProjectSelectExistingProject.text": "Seleccione un objeto existente",
    "ProjectSelectCreateProject.text": "Todavía no hay ningún objeto disponible: cree uno",
    "ProjectSelectButton.button": "Siguiente",
    "ProjectSelectWithout.without": "Quiero continuar sin objeto",
    "ProjectSelectButtonTitle.title": "Editar objeto",
    "ProjectWithout.label": "Sí, quiero continuar sin objeto",
    "ProjectWithout.button": "Siguiente",
    "SelectedTroughListButton.button": "El molde se ha añadido correctamente",
    "SelectedTroughListItemWidth.width": "Anchura",
    "SelectedTroughListItemWidth.minWidth": "Anchura mínima",
    "SelectedTroughListItemDepth.depth": "Profundidad",
    "SelectedTroughListItemDepth.minDepth": "Profundidad mínima",
    "SelectedTroughListItemHeight.height": "Altura",
    "TroughDetailModalButton.button": "Diseño técnico",
    "TroughFilterButton.button": "Deseleccionar",
    "TroughFilterExos.error": "EXOS. está seleccionado.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "VARIUSsign está seleccionado.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "VARIUSmed está seleccionado.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Cuadrado está seleccionado.",
    "TroughFilterSquare.label": "cuadrado",
    "TroughFilterOval.error": "Ovalado está seleccionado.",
    "TroughFilterOval.label": "ovalado",
    "TroughFilterRound.error": "Redondo está seleccionado.",
    "TroughFilterRound.label": "redondo",
    "TroughFilterWithOverflow.error": "Con rebosadero está seleccionado.",
    "TroughFilterWithOverflow.label": "Con rebosadero",
    "TroughFilterWithoutOverflow.error": "Sin rebosadero está seleccionado.",
    "TroughFilterWithoutOverflow.label": "sin rebosadero",
    "TroughFilterWithBackwall.error": "Se ha seleccionado con panel trasero.",
    "TroughFilterWithBackwall.label": "con pared antisalpicaduras",
    "TroughFilterWithoutBackwall.error": "Se ha seleccionado con soportes.",
    "TroughFilterWithoutBackwall.label": "con soportes de sujeción",
    "TroughListButtonSelect.select": "Seleccionar cubetas",
    "TroughListButtonClose.close": "Cerrar menú",
    "TroughListButtonFilterOptions.filter": "Mostrar opciones de filtro",
    "TroughListSorryMsg.message": "Lo sentimos, pero no hemos podido encontrar una cubeta que coincida con las opciones de filtro seleccionadas.",
    "TroughListItemWidth.width": "Anchura",
    "TroughListItemWidth.minWidth": "Anchura mínima",
    "TroughListItemDepth.depth": "Profundidad",
    "TroughListItemDepth.minDepth": "Profundidad mínima",
    "TroughListItemHeight.height": "Altura       ",
    "TroughListMinValuesText.text": "Anchura y profundidad mínima del lavabo",
    "RegisterSucceededComponent.resendSucceededHeading": "El enlace de activación se ha reenviado correctamente",
    "ActivationFailed.activationInvalid": "Lo sentimos, pero se ha producido un error durante la activación.",
    "ActivationFailed.activationInvalidToken": "Su token ha caducado. Compruebe si la cuenta está activa e inicie sesión de nuevo.",
    "ActivationFailed.activationInvalidTokenButton": "Enviar un enlace nuevo.",
    "ActivationFailed.ActivationResend": "Volver a enviar el enlace de activación",
    "Configuration.Inputs.distancesInmm": "(distancias en mm)",
    "newEmail.text": "Nuevo correo electrónico",
    "newEmail.error": "El correo electrónico introducido no es correcto.",
    "AccountProfile.button": "Guardar",
    "ApronLabel.with": "con faldón",
    "ApronLabel.without": "sin faldón (estándar)",
    "SquareCustom.square": "cuadrado",
    "RoundCustom.round": "redondo",
    "SearchPlaceholder.placeholder": "¿Qué está buscando?",
    "ColorCheckout.white": "Blanco alpino",
    "ColorCheckout.black": "Granito negro",
    "ColorCheckout.blackWhite": "Granito negro-blanco",
    "ColorCheckout.lightGray": "Granito gris claro",
    "ConfigurationDetail.Drain.note": "Indicación:",
    "ConfigurationDetail.Drain.noteMessage": "No hay ninguna opción para la cubeta seleccionada",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "La válvula de tubo vertical se incluye con el modelo VARIUSmed MZB.",
    "ConfigurationDetail.Drain.noteExos": "El protector de gatillo con revestimiento InoxPlus es para EXOS. Las cubetas están incluidas..",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "Su correo electrónico ha sido modificado correctamente.",
    "ChangeEmailSucceededPageComponent.emailChangedText": "En unos minutos, recibirá un enlace de activación por correo electrónico. Para activar su cuenta, haga clic en este enlace.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Volver a la página de inicio de sesión",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "¡Su contraseña se ha modificado correctamente!",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Inicie sesión con su nueva contraseña.",
    "ResetPasswordChangeSucceededPageComponent.button": "Iniciar sesión",
    "Warning.RequireReset.apron": "Faldón",
    "submitAsOrder.label": "Transferir el pedido al sistema SAP",
    "ListItemDetail.draft": "Borrador",
    "TroughDetailModalWidth.minWidth": "Anchura mínima",
    "TroughDetailModalDepth.minDepth": "Profundidad mínima",
    "TroughDetailModalWidth.width": "Anchura",
    "TroughDetailModalDepth.depth": "Profundidad",
    "TroughDetailModalHeight.height": "Altura       ",
    "ConfigurationCountry.headline": "¿A qué país pertenece su configuración?",
    "ConfigurationCountry.button": "Siguiente",
    "ConfigurationCountry.select": "Seleccione un país",
    "SelectedTroughListItemHeight.minDimensions": "Anchura y profundidad mínima del lavabo",
    "TroughDetailModalDepth.minDimensions": "Anchura y profundidad mínima del lavabo",
    "TroughListItemDepth.minDimensions": "Anchura y profundidad mínima del lavabo",
    "CosmeticTissueDispenser.cosmeticTissue": "Dispensador de toallitas cosméticas",
    "PaperTowelDispenser.paperTowelDispenser": "Dispensador de toallas de papel",
    "CutOutLabelNone.none": "Seleccione la papelera",
    "DistancesPosition.symmetrically": "Superfies idénticas",
    "DistancesPosition.evenly": "Anchura de la zona de lavado idéntica",
    "CutOutLabel.CustomRound": "papelera redonda",
    "CutOutLabel.CustomSquare": "papelera angular",
    "CutOutLabel.roundSleeve": "papelera redonda con manguito",
    "CutOutLabel.squareSleeve": "papelera angular con manguito",
    "CutOutLabel.roundBasket": "Papelera redonda con cesta",
    "CutOutLabel.roundRail": "Papelera redonda y cesta con rieles para basura",
    "CutOutLabel.squareBasket": "Papelera angular con cesta",
    "CutOutLabel.squareRail": "Papelera angular y cesta con rieles para basura",
    "CutOutLabel.roundSleeveBasket": "Papelera redonda con manguito y cesta",
    "CutOutLabel.roundSleeveRail": "Papelera redonda con manguito y cesta con bastidor extraíble",
    "CutOutLabel.squareSleeveBasket": "Papelera angular con manguito y cesta",
    "CutOutLabel.squareSleeveRail": "Papelera angular con manguito y cesta con bastidor extraíble",
    "CutOutLabel.flap": "Tapa de basura",
    "CutOutLabel.flapBasket": "Tapa de basura con cesta",
    "CutOutLabel.flapRail": "Tapa con sistema de rieles para basura",
    "CutOutLabel.provider": "Dispensador de toallas de papel",
    "ApronHeightRequiredChoiceMessage.message": "Para dar un mejor aspecto a su lavabo, le recomendamos que elija un faldón:",
    "apronHeightRequiredChoice60.60": "Cambiar la altura del faldón a 60 mm",
    "apronHeightRequiredChoice150.150": "Cambiar la altura del faldón a 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Mantener la altura del faldón",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Mantener la altura del faldón y continuar sin manguito",
    "CosmeticTissueDispenser.with": "con dispensador de toallas de papel",
    "PlateDimensionsDepth.470": "Recomendación para herrajes murales",
    "PlateDimensionsDepth.550": "Recomendación para herrajes autoportantes",
    "Warning.RequireReset.cutOutDisposals": "Papelera",
    "checkboxPositions.noSpace": "No hay suficiente espacio disponible.",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Recorte para dispensador de toallas de papel",
    "ApronAffects.position": "Atención: La anchura del faldón de 18 mm provoca el desplazamiento de la posición de la cubeta.",
    "DepthRequiredHint.hint": "Indicación:",
    "DepthRequiredMessage.message": "La profundidad de lavabo que ha seleccionado no es suficiente. ¿Quiere cambiarla por la profundidad mínima requerida de {requiredDepth} mm?",
    "ThankYou.orderPdf": "Configurazione lavabo (PDF)",
    "ThankYou.manufacturingPdf": "Dibujo del lavabo (PDF)",
    "ThankYou.troughPdf": "Dibujo de la cubeta (PDF)",
    "PlateDimensionsRequired.hint": "Indicación:",
    "PlateDimensionsRequired.message": "Indicación: La anchura de su lavabo no es suficiente. Para colocar un faldón, debe aumentar la anchura del lavabo. ¿Quiere continuar?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Si anula la selección del faldón, se restablecerán las dimensiones originales de su configuración.",
    "PlateDimensionsChoice.message": "No hay suficiente espacio en el lavabo para un faldón. Tiene las siguientes opciones para continuar:",
    "PlateDimensionsChoice.increase": "Modificar la anchura del lavabo",
    "PlateDimensionsChoice.move": "Desplazar la(s) cubeta(s) y mantener la anchura del lavabo",
    "PlateDimensionsChoice.cancel": "Anular (se mantienen las dimensiones sin faldón)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Para colocar un toallero, necesita un delantal de 150 mm. Como la anchura de su lavabo no es suficiente para colocar un delantal, deberá ampliar la anchura de su lavabo. ¿Desea continuar?",
    "Checkout.OrderPdf": "Configuración del lavabo (PDF)",
    "Checkout.ManufacturingPdf": "Dibujo del lavabo (PDF)",
    "submitAsRequest.label": "Solicitar oferta",
    "checkoutSave.label": "Guardar",
    "submitAsOffer.label": "Transferir oferta al sistema SAP",
    "ListItemDetail.request": "Solicitar",
    "ListItem.orderPdf": "Configuración del lavabo (PDF)",
    "ListItem.manufacturingPdf": "Dibujo del lavabo (PDF)",
    "ListItem.troughPdf": "Dibujo de la cubeta (PDF)",
    "PlateDimensionsRequiredLimit.message": "Se ha alcanzado la anchura máxima del lavabo. No es posible seleccionar ningún faldón.",
    "PlateDimensionsChoiceLimit.message": "No hay suficiente espacio en el lavabo para un faldón. Se ha alcanzado la anchura máxima del lavabo. Tiene las siguientes opciones para continuar:",
    "CutoutPartDetail.name": "Nombre",
    "CutoutPartDetail.dimensions": "Dimensiones",
    "CutoutPartDetail.type": "Tipo",
    "CutoutPartDetail.article": "Número de artículo",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "Indicación: Para colocar un toallero, se requiere un faldón de 150 mm. Como la anchura de su lavabo no es suficiente para colocar el faldón, deberá aumentar la anchura del lavabo. ¿Quiere continuar?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "Para colocar un dispensador de toallitas cosméticas, necesita un faldón de 150 mm. Como la anchura de su lavabo no es suficiente para colocar el faldón, deberá aumentar la anchura del lavabo. ¿Desea continuar?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "Para colocar un recorte, necesita un faldón de 150 mm. Como la anchura de su lavabo no es suficiente para colocar el faldón, deberá aumentar la anchura del lavabo. ¿Desea continuar?",
    "apronHeightForTowelRailRequiredMessage.message": "Para la selección de un toallero, se requiere un faldón de {requiredHeight}. ¿Quiere continuar?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Para la selección de un dispensador de toallitas cosméticas, se requiere un faldón de {requiredHeight}. ¿Quiere continuar?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Para poder seleccionar este recorte, necesita un faldón de {requiredHeight} mm. ¿Desea continuar?",
    "ListItem.archive": "Archivar",
    "ConfigurationSwitchView.mine": "Mis configuraciones",
    "FolderSwitchView.mine": "Mis configuraciones",
    "ConfigurationSwitchView.connected": "Asignado",
    "ConfigurationSwitchView.archived": "Archivado",
    "Archive.headline": "¿Está seguro de que desea archivar esta configuración?",
    "Archive.button": "Aceptar",
    "Unarchive.headline": "¿Está seguro de que desea restaurar esta configuración?",
    "Unarchive.button": "Aceptar",
    "ListItem.unarchive": "Restaurar",
    "WithNicheHint.hint": "Indicación:",
    "WithNicheMessage.message": "Indicación: Anchura del lavabo = Dimensión del nicho acabado menos 8 mm. Reste 4 mm por cada lado del lavabo en la configuración. ¡Tenga en cuenta las proyecciones estructurales!",
    "checkboxPositions.tissueConflict": "El sistema de residuos se ha modificado.",
    "CutOutLabel.cosmetic": "Dispensador de toallitas cosméticas",
    "RegisterSucceededComponent.note": "Información",
    "RegisterSucceededComponent.noteText": "Le hemos enviado un enlace de confirmación por correo electrónico. En cuanto confirme su correo electrónico, activaremos su cuenta.",
    "ConsolesOverlapChoice.message": "La configuración no es posible: aumente la distancia o seleccione el soporte de acero inoxidable.",
    "ConsolesOverlapChoice.continue": "Volver al valor original (con consola de fundición de mineral)",
    "ConsolesOverlapChoice.return": "Volver al valor original (con consola de fundición de mineral)",
    "ConsolesOverlapChoice.change": "Cambiar a soporte(s) de acero inoxidable",
    "checkoutSave.orderIsFailed": "No se ha podido transferir el pedido al sistema SAP.Por favor, duplique la configuración y vuelva a intentarlo más tarde.          ",
    "Warning.RequireReset.qty": "Número de cubetas",
    "ConfigurationNewFormName.error": "El nombre es obligatorio",
    "ConfigurationNewFormName.label": "Nombre",
    "ConfigurationNewFormName.placeholder": "Nombre",
    "ConfigurationNewFormPricingsAccessories.error": "El periodo de tiempo es obligatorio.",
    "ConfigurationNewFormPricingsAccessories.label": "Validez de los accesorios",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Seleccione una opción...",
    "ConfigurationNewFormPricingsWashbasin.error": "El periodo de tiempo es obligatorio.",
    "ConfigurationNewFormPricingsWashbasin.label": "Validez del lavabo",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Seleccione una opción...",
    "checkoutParts.timePeriodNote": "Indicación:",
    "checkoutParts.timePeriodNoteText": "Seleccione el periodo de validez del precio",
    "checkoutParts.timePeriodAccessoriesLabel": "Validez de los accesorios",
    "checkoutParts.timePeriodWashbasinLabel": "Validez del lavabo",
    "checkoutSave.orderIsQueued": "No se ha podido transferir el pedido al sistema SAP.Por lo tanto, lo hemos puesto en cola para su transferencia en una fecha posterior.",
    "ListItemDetail.failed": "Error",
    "ListItemDetail.queued": "En cola ",
    "TroughFilterMedcare.error": "MEDCARE es obligatorio.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "disponible a partir de agosto de 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/es_ES/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(creado)",
    "Login.mustLogin": "Para iniciar una configuración, debe iniciar sesión. Si aún no tiene una cuenta, cree una nueva.",
    "Troughs.toStart": "Para iniciar una configuración, debe {conectarse}. Si aún no tiene cuenta, {crear}.",
    "TroughFilter.modelLine": "Línea",
    "TroughFilter.characteristics": "Propiedades de la línea",
    "TroughListItem.min": "min. Lavabo",
    "TroughListItem.start": "Iniciar configuración",
    "TroughListItem.startWithLogin": "Iniciar configuración después de iniciar sesión",
    "TroughBanner.label": "¿Qué lavabos están disponibles?",
    "TroughBanner.text": "Eche un vistazo por adelantado.",
    "SearchPlaceholder.placeholderTroughs": "Buscar un lavabo",
    "Troughs.toStartLogin": "Iniciar sesión",
    "Troughs.toStartCreate": "Crear una nueva cuenta",
    "ConfigurationDownload3D.text": "Descargar escena 3D",
    "ConfigurationNewFolder.newHeading": "Nueva carpeta",
    "NewButtonsNewFolder.text": "Nueva carpeta",
    "NewButtonsNewConfiguration.text": "Crear configuración",
    "FolderListHeading.text": "Carpeta",
    "FolderListNone.text": "Aún no hay carpetas disponibles",
    "ConfigurationListHeading.text": "Configuraciones sin asignar",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "Mostrar todas las carpetas",
    "ListItem.moveToGroup": "Mover a carpeta o fase de construcción",
    "ListItem.goBack": "Volver",
    "FolderSwitchView.goBack": "Volver",
    "ListItem.downloadPdfs": "Descargar PDF",
    "ConfigurationDeleteFolder.cancel": "Cancelar",
    "ConfigurationEditFolder.cancel": "Cancelar",
    "ConfigurationNewFolder.cancel": "Cancelar",
    "ConfigurationNewFolder.create": "Crear",
    "ConnectedFolder.label": "Sí, me gustaría crear una nueva carpeta con el nombre del objeto en mi panel de control.",
    "FolderListHeadingAll.text": "Todas las carpetas",
    "FolderListToday.text": "Hoy",
    "FolderList7Days.text": "7 días anteriores",
    "FolderList30Days.text": "30 días anteriores",
    "FolderListItemNestedDelete.text": "Eliminar etapa",
    "ConfigurationDeleteNestedFolder.heading": "Eliminar etapa",
    "ConfigurationNewFolderNested.newHeading": "Nueva etapa",
    "ListItem.moveToThisGroup": "Mover a carpeta",
    "ConfigurationDeleteFolder.note": "Nota:",
    "ConfigurationDeleteNestedFolder.body": "Si eliminas esta etapa, las configuraciones que contiene se conservan, simplemente se mueven al almacén de carpetas.",
    "ConfigurationDeleteFolder.body": "Si eliminas esta etapa, las configuraciones que contiene se conservan, simplemente se mueven al almacén de carpetas.",
    "FolderListNestedHeading.test": "Fases de la construcción",
    "BuildingNumber.error": "Se requiere building number.",
    "OpportunityNumber.error": "Se requiere opportunity number.",
    "FolderListItemDelete.text": "Eliminar carpeta",
    "ConfigurationDeleteFolder.heading": "Eliminar carpeta",
    "ConfigurationDeleteFolder.confirm": "Confirme",
    "ConfigurationEditFolder.heading": "Editar carpeta",
    "ConfigurationEditFolderNested.heading": "Editar la fase de construcción",
    "ConfigurationEditFolder.confirm": "Confirme",
    "ConfigurationListNone.text": "Aún no hay configuraciones disponibles",
    "ListItemDetail.basin": "Lavabo",
    "ListItemDetail.number": "Comederos",
    "ListItem.moveToDashboard": "Mover al tablero",
    "FolderList.SortByDate": "Ordenar por fecha",
    "FolderList.SortByName": "Ordenar por nombre",
    "FolderName.name": "Nombre de carpeta",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "it": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "China | 中国",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Panoramica configurazione",
    "NavigationUser.accountName": "Login e sicurezza",
    "NavigationUser.adressesName": "Indirizzi di consegna e fatturazione",
    "CheckoutHeadline.checkout": "Panoramica",
    "CheckoutBackButton.checkout": "Torna alla configurazione",
    "CheckoutConfigurationHeadline.checkout": "Configurazione lavabo",
    "CheckoutPartsHeadline.checkout": "Accessori",
    "CheckoutPartsHeadlineLink.checkout": "Panoramica configurazione",
    "Delete.headline": "Cancellare questa configurazione?",
    "Delete.button": "Accetta",
    "Assemblies.note": "Nota:",
    "Assemblies.message.with": "L'intero accessorio di montaggio è previsto solo per pareti massicce.",
    "Assemblies.message.without": "Fissaggio in proprio.",
    "Assemblies.message.alwaysTriggerSafety": "Fermo corsa sempre incluso.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Accessorio di montaggio",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Selezione",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Accessorio di montaggio",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Dimensioni lavabo",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Tipo di montaggio",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Angolo della nicchia",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Esecuzione degli angoli anteriori a",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Dimensioni piastra",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Posizione delle vasche",
    "ConfigurationDetail.ApronBacksplash.apron": "Grembiule",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Bordo sagomato / alzatina",
    "ConfigurationDetail.Recesses.tapHole": "Foro rubinetteria",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Foro distributore di sapone",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Gettarifiuti",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Distributore di asciugamani di carta",
    "ConfigurationDetail.Recesses.towelRail": "Portasciugamani",
    "ConfigurationDetail.plateSurface.colour": "Colore",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Lato inferiore",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Grembiule / alzatina",
    "ConfigurationDetail.Drain.drainTitle": "Accessorio scarico",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Accessorio scarico",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Termina configurazione",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Spazi liberi / parti di montaggio",
    "ConfigurationDetail.colour.colourTitle": "Colore",
    "ConfigurationDetail.troughs.troughsTitle": "Vasche",
    "ConfigurationProject.headline": "Di quale oggetto fa parte la configurazione",
    "ConfigurationProject.tabexisting": "Seleziona oggetto esistente",
    "ConfigurationProject.tabnew": "Crea nuovo oggetto",
    "ConfigurationProject.tabEXISTING": "Esiste",
    "ConfigurationProject.tabNEW": "Nuovo",
    "ConfigurationProject.tabWITHOUT": "Senza",
    "ConfigurationDuplicate.headline": "Duplicare questa configurazione?",
    "ConfigurationDuplicate.button": "Duplica",
    "ConfigurationNew.headline": "Inserire i dettagli della configurazione:",
    "ConfigurationRename.headline": "Dare un nome alla configurazione?",
    "ChangePasswordPage.changePasswordHeading": "Definire una nuova password",
    "ChangePasswordPage.changePasswordText": "La password deve soddisfare almeno 2 delle 3 condizioni indicate di seguito: lettere (per es. ABCD...) - numeri (per es. 0123...) - caratteri speciali (per es. #$%...)",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "La password è stata modificata correttamente.",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Ritornare al login e inserire la nuova password.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Torna al login",
    "HomeLink.imprint": "Informazioni societarie",
    "HomeLink.legals": "Condizioni generali di contratto",
    "HomeLink.privacy": "Informativa sulla privacy e sui cookie",
    "Login.newUser": "Creare un nuovo account",
    "Login.forgotPassword": "Password dimenticata?",
    "Login.Label.Email": "E-mail",
    "Login.Placeholder.Email": "E-mail",
    "Login.Error.Email": "L'e-mail è un campo obbligatorio.",
    "Login.Label.Password": "Password",
    "Login.Placeholder.Password": "Password",
    "Login.Error.Password": "La password è un campo obbligatorio.",
    "ResetPassword.button": "Torna al login",
    "ResetPasswordSucceededPageComponent.resetPassword": "La password è stata modificata correttamente.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Controllare l'e-mail e fare clic sul link di conferma.",
    "ResetPasswordSucceededPageComponent.button": "Login",
    "ChangePwOld.label": "Vecchia password",
    "ChangePwOld.placeholder": "Vecchia password",
    "ChangePwOld.error": "La password deve soddisfare almeno 2 delle 3 condizioni indicate di seguito: lettere (per es. ABCD...) - numeri (per es. 0123...) - caratteri speciali (per es. #$%...)",
    "ChangePwNew.label": "Nuova password",
    "ChangePwNew.error": "La password deve soddisfare almeno 2 delle 3 condizioni indicate di seguito: lettere (per es. ABCD...) - numeri (per es. 0123...) - caratteri speciali (per es. #$%...)",
    "ChangePwNew.placeholder": "Nuova password",
    "ChangePwNewRepeat.label": "Inserire di nuovo la password",
    "ChangePwNewRepeat.error": "Le password non coincidono.",
    "ChangePwNewRepeat.placeholder": "Inserire di nuovo la password",
    "PageNotFound.message": "Si è verificato un errore. La pagina cercata non esiste.",
    "AccountProfile.name": "Nome",
    "AccountProfile.telephone": "Numero di telefono",
    "AccountProfile.street": "Via",
    "AccountProfile.zip": "CAP",
    "AccountProfile.surname": "Cognome",
    "AccountProfile.mobile": "Numero di cellulare",
    "AccountProfile.city": "Città",
    "AccountProfile.country": "Paese",
    "AccountProfile.userbutton": "Modifica modulo",
    "AccountProfile.email": "Indirizzo e-mail",
    "AccountProfile.password": "Password",
    "AccountProfile.loginbutton": "Modifica modulo",
    "AccountProfile.headline": "Login e sicurezza",
    "projectsNewHeadline.headline": "Crea nuovo progetto",
    "projectsOverviewHeadline.headline": "Indirizzi di consegna e fatturazione",
    "ProjectsDelete.headline": "Cancellare questo progetto?",
    "ProjectsDelete.button": "Accetta",
    "ProjectsEdit.headline": "Modifica progetto:",
    "ProjectsNew.headline": "Stabilire un nome per l'oggetto:",
    "RegisterPage.registerText": "Inserire un indirizzo e-mail valido e una password per l'account.",
    "RegisterPage.registerButton": "Torna al login",
    "RegisterMail.error": "L'e-mail è un campo obbligatorio.",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "La password deve soddisfare almeno 2 delle 3 condizioni indicate di seguito: lettere (per es. ABCD...) - numeri (per es. 0123...) - caratteri speciali (per es. #$%...)",
    "RegisterPw.name": "Password",
    "RegisterPwRepeat.error": "Le password non coincidono.",
    "RegisterPwRepeat.name": "Inserire di nuovo la password",
    "RegisterUserGender.error": "Il titolo è un campo obbligatorio",
    "RegisterUserGender.label": "Titolo",
    "RegisterUserGender.mr": "Signor",
    "RegisterUserGender.mrs": "Signora",
    "registerUserFirstName.error": "Il nome è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "registerUserFirstName.label": "Nome",
    "registerUserLastName.error": "Il cognome è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "registerUserLastName.label": "Cognome",
    "registerUserPhone.label": "Telefono",
    "registerUserMobile.label": "Cellulare",
    "registerUserCompany.label": "Azienda",
    "registerUserStreet.error": "La via è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "registerUserStreet.label": "Via",
    "registerUserHouse.error": "Il numero civico è un campo obbligatorio e deve contenere almeno 1 carattere.",
    "registerUserHouse.label": "Numero civico",
    "registerUserZip.error": "Il CAP è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "registerUserZip.label": "CAP",
    "registerUserCity.error": "La città è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "registerUserCity.label": "Città",
    "registerUserAddressAdditional.label": "Aggiunte indirizzo",
    "registerUserCountry.error": "Il Paese è un campo obbligatorio.",
    "registerUserCountry.label": "Paese",
    "registerUserCountryLabel.label": "Selezionare un Paese",
    "registerUserClientNr.label": "Numero cliente (se presente)",
    "registerUserBranch.error": "Il settore è un campo obbligatorio",
    "registerUserBranch.label": "Settore",
    "registerUserBranchSanitary.label": "Commercio all'ingrosso sanitari",
    "registerUserBranchPlanner.label": "Progettista / architetto",
    "registerUserBranchPlumber.label": "Installatore",
    "registerUserBranchRetail.label": "Cliente finale",
    "editUserGender.error": "Il titolo è un campo obbligatorio",
    "editUserGender.label": "Titolo",
    "editUserGenderMr.label": "Signor",
    "editUserGenderMrs.label": "Signora",
    "editUserFirstName.error": "Il nome è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "editUserFirstName.label": "Nome",
    "editUserLastName.error": "Il cognome è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "editUserLastName.label": "Cognome",
    "editUserPhone.label": "Telefono",
    "editUserMobile.label": "Cellulare",
    "editUserStreet.error": "La via è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "editUserStreet.label": "Via",
    "editUserHouse.error": "Il numero civico è un campo obbligatorio e deve contenere almeno 1 carattere.",
    "editUserHouse.label": "Numero civico",
    "editUserAddressAdditional.label": "Aggiunte indirizzo",
    "editUserZip.error": "Il CAP è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "editUserZip.label": "CAP",
    "editUserCity.error": "La città è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "editUserCity.label": "Città",
    "editUserCountry.error": "Il Paese è un campo obbligatorio.",
    "editUserCountry.label": "Paese",
    "editUserCountryLabel.label": "Selezionare un Paese",
    "RegisterSucceededComponent.registerSucceededHeading": "Grazie. La registrazione è ora quasi conclusa.",
    "RegisterSucceededComponent.registerSucceededText": "A breve riceverà un'e-mail che contiene un link. Dopo aver confermato l'indirizzo e-mail facendo clic su questo link, sarà possibile effettuare il login.",
    "RegisterSucceededComponent.registerSucceededButton": "Torna al login",
    "ThankYou.headline": "Grazie per la configurazione.",
    "ThankYou.message": "Abbiamo inviato via e-mail una conferma con tutti i dettagli relativi all'offerta.",
    "ThankYou.order": "Il Suo numero di offerta:",
    "ThankYou.pdfbutton": "Esporta come 2D PDF",
    "ThankYou.tenderdocuments": "Testi bando",
    "ThankYou.overviewbutton": "Vai alla panoramica configurazione",
    "Configuration3dAlert.attention": "Come iniziare?",
    "Configuration3dAlert.message": "Selezionare la vasca desiderata con un clic sul pulsante (Selezionare vasca) e iniziare la configurazione. Buon divertimento!",
    "ActivationSucceeded.activationSucceededText": "Congratulazioni, l'account è stato configurato correttamente. Ritornare al login e inserire i dati utente.",
    "ActivationSucceeded.activationSucceededButton": "Iniziamo",
    "ActivationFailed.activaionUserNotFound": "Questo utente non esiste. Creare un nuovo account.",
    "ActivationFailed.activaionUserNotFoundButton": "Registra",
    "ChangeEmailForm.button": "Modifica indirizzo e-mail",
    "ChangePassword.button": "Modifica password",
    "LoginForm.button": "Login",
    "Logout.button": "Logout",
    "RegisterUserDataForm.headline": "Inserire i dati personali.",
    "RegisterUserDataForm.button": "Crea nuovo account",
    "RegisterUserDataForm.logout": "Torna al login",
    "RegisterUserForm.button": "Crea nuovo account",
    "ResetPasswordForm.button": "Resetta password",
    "ResetPasswordChangeForm.button": "Resetta password",
    "Checkout.WashBasinDimensions": "Dimensioni lavabo",
    "Checkout.PlateDimensions.Width": "Larghezza",
    "Checkout.PlateDimensions.Depth": "Profondità",
    "Checkout.TypeOfInstallation": "Tipo di montaggio",
    "Checkout.TypeOfInstallation.Left": "Nicchia sinistra",
    "Checkout.TypeOfInstallation.Right": "Nicchia destra",
    "Checkout.TypeOfInstallation.With": "Nicchia sinistra e destra",
    "Checkout.CornerDesign": "Esecuzione degli angoli anteriori a",
    "Checkout.CornerDesign.Radius": "Raggio 100 mm",
    "Checkout.CornerDesign.Bevel": "Taglio obliquo, 100 mm",
    "Checkout.Left": "a sinistra",
    "Checkout.Right": "a destra",
    "Checkout.ApronBackSplash.Headline": "Grembiule / alzatina",
    "Checkout.ApronBackSplash.Apron": "Grembiule: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Bordo sagomato: {position} - altezza: 3 mm.",
    "Checkout.ApronBackSplash.apronBackSplash": "Alzatina: {position} - altezza: {height}mm.",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Spazi liberi / parti di montaggio",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x fori rubinetteria",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x foro distributore di sapone",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x apertura \\\"{name}\\",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x apertura per distributore di fazzoletti di carta",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x apertura per portasciugamani",
    "Checkout.Surface.Title": "Colore",
    "Checkout.Surface.Color": "Colore: {color}",
    "Checkout.Surface.GelCoat": "Lato inferiore gelcoat",
    "Checkout.AssemblyAccessories.Title": "Accessorio di montaggio",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x staffa {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x listello angolare per il montaggio sulla parete laterale.",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x fermo corsa per il montaggio sulla parete posteriore",
    "Checkout.GeneralInfo.Headline": "Panoramica",
    "Checkout.GeneralInfo.ConfName": "Nome configurazione:",
    "Checkout.TotalPrice.Washbasin": "Lavabo",
    "Checkout.TotalPrice.Parts": "Accessori",
    "Checkout.TotalPrice.DeliveryCosts": "Costi di trasporto",
    "Checkout.TotalPrice.Vat": "IVA",
    "Checkout.TotalPrice.Total": "Importo totale",
    "Checkout.TotalPrice.Note": "Nota:",
    "Checkout.TotalPrice.NoteText": "Prezzi validi fino al ",
    "Checkout.Trough.Headline": "Vasca",
    "Checkout.Trough.Name": "Nome della vasca:",
    "Checkout.Trough.Qty": "Numero:",
    "Checkout.Trough.Dimensions": "Dimensioni vasca",
    "checkoutPartsPdfButton.button": "Scarica PDF",
    "Apron.height": "Altezza del grembiule in mm",
    "ApronHeightRequiredHint.hint": "Nota:",
    "ApronHeightRequiredMessage.message": "Per scegliere un distributore di salviette rinfrescanti è necessario un grembiule da {requiredHeight} mm. Proseguire?",
    "ApronHeightError.message": "Il valore non rientra nelle dimensioni",
    "SurgeEdgeLabelWithout.without": "senza       ",
    "SurgeEdgeLabelWith.with": "con bordo sagomato (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "con alzatina",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "lato posteriore (standard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Altezza dell'alzatina in mm",
    "WithoutAssemblyAccessories.without": "senza accessorio di montaggio",
    "WithAssemblyAccessories.with": "con accessorio di montaggio",
    "WithAssemblyAccessoriesTooltipHint.hint": "Nota:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Fissaggio a opera del cliente.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Acciaio inox",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Staffa/e",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Fermo corsa",
    "AssemblyAccessoriesListAngleBar.anglebar": "Mensola/e per lato/i in nicchia",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Materiale di fissaggio",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Acciaio inox bianco",
    "CornerDesignLabelWithout.without": "Senza sistemazione angolare",
    "CornerDesignLabelRadius.radius": "Raggio (100 mm)",
    "CornerDesignLabelBevel.bevel": "Taglio obliquo (lunghezza laterale 100 mm)",
    "DistancesPositionOfTroughs.distances": "Inserimento della distanza centro vasca",
    "DistancesPositionOfTroughsHint.hint": "Nota:",
    "DistancesPositionOfTroughsMessage.message": "Vantaggi e consigli di applicazione",
    "DistancesPositionOfTroughsFromPlate.plate": "Dalla piastra al bordo posteriore della vasca",
    "PlateDimensionsWidth.width": "Larghezza piastra",
    "PlateDimensionsDepth.depth": "Profondità piastra",
    "PlateDimensionsDepth.depthIndividual": "Personalizzato",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "Il valore non rientra nel range ammesso",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Lato sinistro",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Lato destro",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Possibile solo in combinazione con il tipo di installazione \"con, a sinistra o a destra\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Possibile solo in combinazione con il tipo di installazione \"senza, a sinistra o a destra\".",
    "Configuration.Inputs.message": "Il valore non rientra nel range ammesso",
    "DrainLabelWithoutDrain.withoutdrain": "Senza accessorio scarico",
    "DrainLabelHoodDrain.hooddrain": "Piletta di scarico con copertura",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Piletta di scarico cromata",
    "DrainLabelSieveDrain.sievedrain": "Piletta con filtro blocca-sporco",
    "DrainLabelEccentric.eccentric": "Set piletta e troppopieno eccentrici",
    "DrainLabelSiphon.siphon": "Sifone XINX140",
    "CosmeticTissueDispenser.without": "senza distributore di asciugamani di carta",
    "CosmeticTissueDispenserSquare.square": "quadrato (con gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(per distributore di salviette asciugamani \"numero modello\")",
    "CosmeticTissueDispenserPosition.position": "(posizione tra le vasche)",
    "CutOutLabelCustomInput.diameter": "Diametro",
    "CutOutLabelCustomInput.width": "Larghezza",
    "CutOutLabelCustomInput.depth": "Profondità",
    "CutOutLabelSelect.select": "Selezionare",
    "CutOutDisposalsDefaultsWithout.without": "senza gettarifiuti",
    "CutOutDisposalsDefaultsWith.with": "con gettarifiuti",
    "SoapDispenserHoleLabelWithout.without": "senza       ",
    "SoapDispenserHoleLabelSD80.sd80": "per distributore di sapone SD80",
    "SoapDispenserHoleLabelSD100.sd100": "per distributore di sapone SD100",
    "SoapDispenserHoleLabel25.dispensers": "per distributore di prodotti terzi (Ø 25 mm)",
    "TapHoleWithout.taphole": "senza foro",
    "TapHoleWithoutDrilling.tapholedrilling": "con foro",
    "TowelRailWithout.towelrailwithout": "senza apertura",
    "TowelRailWithout.towelrailwith": "con apertura",
    "ColorLabel.alpinewhite": "Bianco alpino (standard)",
    "ColorLabel.alpinewhitetext": "Resistente a temperature fino a 80 °C",
    "ColorLabel.graniteblack": "Granito nero",
    "ColorLabel.graniteblacktext": "Resistente a temperature fino a 65 °C",
    "ColorLabel.graniteblackwhite": "Granito nero-bianco",
    "ColorLabel.graniteblackwhitetext": "Resistente a temperature fino a 65 °C",
    "ColorLabel.graniteLightGray": "Granito grigio chiaro",
    "ColorLabel.granitelightgraytext": "Resistente a temperature fino a 65 °C",
    "ColorBottomSideUncoated.uncoated": "senza rivestimento (standard)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Nota:",
    "ColorBottomSideMessage.message": "Vantaggi e consigli di applicazione",
    "ElementNext.button": "Continua",
    "ElementsPositionsLeft.left": "a sinistra",
    "ElementsPositionsBack.back": "lato posteriore",
    "ElementsPositionsFront.front": "lato anteriore",
    "ElementsPositionsRight.right": "a destra",
    "ElementsPositionsRight.warning": "Disattivato, aumentare la distanza tra le vasche.",
    "ConfigurationListAdd.text": "Aggiungi nuova configurazione",
    "ListItem.rename": "Modifica nome",
    "ListItem.duplicate": "Duplica",
    "ListItem.delete": "Cancella",
    "ListItem.order": "Offerta",
    "ListItem.orderShow": "Mostra offerta",
    "ListItem.linkTitle": "Impostazioni",
    "ListItemDetail.price": "Prezzo totale:",
    "ListItemDetail.offer": "Offerta",
    "ListItemDetail.order": "Ordine",
    "ListItemDetail.date": "Ultima modifica",
    "ConfigurationNewForm.button": "Continua",
    "Warning.RequireReset.Trough": "A causa delle modifiche alla configurazione è necessario resettare tutti gli elementi elencati se si desidera selezionare una nuova vasca e aumentare o diminuire la quantità:",
    "Warning.RequireReset.Qty": "A causa delle modifiche alla configurazione è necessario resettare tutti gli elementi elencati se si desidera aumentare o diminuire la quantità:",
    "Warning.RequireReset.TypeOfInstallation": "A causa delle modifiche alla configurazione è necessario resettare tutti gli elementi elencati se si desidera aumentare o diminuire la quantità:",
    "Warning.RequireReset.plateDepth": "Profondità piastra",
    "Warning.RequireReset.PlateDepth": "A causa delle modifiche alla configurazione è necessario resettare tutti gli elementi elencati se si desidera modificare la profondità piastra:",
    "Warning.RequireReset.distances": "Distanze",
    "Warning.RequireReset.cornerDesign": "Esecuzione degli angoli anteriori a",
    "Warning.RequireReset": "Reset necessario:",
    "Warning.RequireReset.Default": "A causa delle modifiche alla configurazione è necessario resettare quest'ultima.",
    "Warning.RequireReset.ResetAll": "Resettare tutto?",
    "Warning.RequireReset.console": "Staffa/e",
    "Warning.RequireReset.drain": "Accessorio scarico",
    "Warning.RequireReset.typeOfInstallation": "Tipo di montaggio",
    "Warning.RequireReset.paperTowelDispensers": "Apertura per distributore di asciugamani",
    "Warning.RequireReset.plateWidth": "Larghezza piastra",
    "Warning.RequireReset.siphon": "Sifone",
    "Warning.RequireReset.soapDispenserHole": "Foro per distributore di sapone",
    "Warning.RequireReset.tapHole": "Foro rubinetteria",
    "Warning.RequireReset.tissueDispenser": "Taglio per distributore di salviette asciugamani",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Bordo sagomato / alzatina",
    "ConfigurationDetail.error.default": "Il valore selezionato non è ammesso. Controllare i valori inseriti.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "Il valore selezionato non è ammesso. Controllare il lato inferiore colorato.",
    "LogoTitle.default": "Panoramica configurazione",
    "LogoTitle.fallback": "Configuratore 3D KWC",
    "MetaNavigationImprint.imprint": "Informazioni societarie",
    "MetaNavigationLegals.legals": "Condizioni generali di contratto",
    "MetaNavigationPrivacy.privacy": "Linee guida in materia di protezione dei dati e cookie",
    "NavigationTrough.name": "Vasca",
    "NavigationTrough.title": "Vasca",
    "NavigationBasin.name": "Dimensioni lavabo",
    "NavigationBasin.title": "Dimensioni lavabo",
    "NavigationApron.name": "Grembiule / alzatina",
    "NavigationApron.title": "Grembiule / alzatina",
    "NavigationRecesses.name": "Spazi liberi / parti di montaggio",
    "NavigationRecesses.title": "Spazi liberi / parti di montaggio",
    "NavigationColour.name": "Colore",
    "NavigationColour.title": "Colore",
    "NavigationAssembly.name": "Accessorio di montaggio",
    "NavigationAssembly.title": "Accessorio di montaggio",
    "NavigationDrain.name": "Accessorio scarico",
    "NavigationDrain.title": "Accessorio scarico",
    "ProjectsEditFormButton.button": "Salva progetto",
    "ProjectListItemEdit.edit": "Modifica",
    "ProjectListItemDelete.delete": "Cancella",
    "ProjectListItemLinkTitle.title": "Impostazioni",
    "projectListHeadline.headline": "Indirizzi di consegna e fatturazione",
    "ProjectListAdd.addText": "Aggiungi nuovo indirizzo",
    "ProjectNewFormButton.button": "Crea progetto",
    "ProjectName.error": "Il nome è un campo obbligatorio.",
    "ProjectName.name": "Nome oggetto:",
    "ProjectStreet.error": "La via è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "ProjectStreet.name": "Via",
    "ProjectStreetNr.error": "Il numero civico è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "ProjectStreetNr.name": "Numero civico",
    "ProjectZip.error": "Il CAP è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "ProjectZip.name": "CAP",
    "ProjectCity.error": "La città è un campo obbligatorio e deve contenere almeno 2 caratteri.",
    "ProjectCity.name": "Città",
    "ProjectCountry.error": "Il Paese è un campo obbligatorio.",
    "ProjectCountry.name": "Paese",
    "ProjectCountry.label": "Selezionare un Paese",
    "ProjectSelectExistingProject.text": "Selezionare un oggetto presente",
    "ProjectSelectCreateProject.text": "Nessun oggetto ancora presente. Crearne uno",
    "ProjectSelectButton.button": "Continua",
    "ProjectSelectWithout.without": "Vorrei proseguire senza oggetto",
    "ProjectSelectButtonTitle.title": "Modifica oggetto",
    "ProjectWithout.label": "Si, vorrei proseguire senza oggetto",
    "ProjectWithout.button": "Continua",
    "SelectedTroughListButton.button": "Vasca aggiunta",
    "SelectedTroughListItemWidth.width": "Larghezza",
    "SelectedTroughListItemWidth.minWidth": "Larghezza minima",
    "SelectedTroughListItemDepth.depth": "Profondità",
    "SelectedTroughListItemDepth.minDepth": "Profondità minima",
    "SelectedTroughListItemHeight.height": "Altezza",
    "TroughDetailModalButton.button": "Disegno tecnico",
    "TroughFilterButton.button": "Deseleziona",
    "TroughFilterExos.error": "È selezionato EXOS.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "È selezionato VARIUSsign.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "È selezionato VARIUSmed.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "È selezionata la versione quadrata.",
    "TroughFilterSquare.label": "Quadrato",
    "TroughFilterOval.error": "È selezionata la versione ovale.",
    "TroughFilterOval.label": "Ovale",
    "TroughFilterRound.error": "È selezionata la versione tonda.",
    "TroughFilterRound.label": "Tondo",
    "TroughFilterWithOverflow.error": "È selezionata la versione con troppopieno.",
    "TroughFilterWithOverflow.label": "Con troppopieno",
    "TroughFilterWithoutOverflow.error": "È selezionata la versione senza troppopieno.",
    "TroughFilterWithoutOverflow.label": "Senza troppopieno",
    "TroughFilterWithBackwall.error": "Selezionato con parete posteriore lavabo.",
    "TroughFilterWithBackwall.label": "con parete posteriore vasca",
    "TroughFilterWithoutBackwall.error": "Selezionato con staffa.",
    "TroughFilterWithoutBackwall.label": "con staffe",
    "TroughListButtonSelect.select": "Seleziona vasca",
    "TroughListButtonClose.close": "Chiudi menu",
    "TroughListButtonFilterOptions.filter": "Mostra le opzioni del filtro",
    "TroughListSorryMsg.message": "Purtroppo non è possibile trovare vasche che corrispondono alle opzioni del filtro selezionate.",
    "TroughListItemWidth.width": "Larghezza",
    "TroughListItemWidth.minWidth": "Larghezza minima",
    "TroughListItemDepth.depth": "Profondità",
    "TroughListItemDepth.minDepth": "Profondità minima",
    "TroughListItemHeight.height": "Altezza       ",
    "TroughListMinValuesText.text": "Larghezza x profondità min. lavabo",
    "RegisterSucceededComponent.resendSucceededHeading": "Link di attivazione reinviato con successo",
    "ActivationFailed.activationInvalid": "Purtroppo l'attivazione non è riuscita.",
    "ActivationFailed.activationInvalidToken": "Il token è scaduto. Controllare se questo account è attivato ed effettuare di nuovo il login.",
    "ActivationFailed.activationInvalidTokenButton": "Invia nuovo link.",
    "ActivationFailed.ActivationResend": "Invia nuovamente il link di attivazione",
    "Configuration.Inputs.distancesInmm": "(distanze in mm)",
    "newEmail.text": "Nuova e-mail",
    "newEmail.error": "L'e-mail inserita non è corretta.",
    "AccountProfile.button": "Salva",
    "ApronLabel.with": "con grembiule",
    "ApronLabel.without": "senza grembiule (standard)",
    "SquareCustom.square": "quadrato",
    "RoundCustom.round": "tondo",
    "SearchPlaceholder.placeholder": "Inserire il termine di ricerca",
    "ColorCheckout.white": "Bianco alpino",
    "ColorCheckout.black": "Granito nero",
    "ColorCheckout.blackWhite": "Granito nero-bianco",
    "ColorCheckout.lightGray": "Granito grigio chiaro",
    "ConfigurationDetail.Drain.note": "Nota:",
    "ConfigurationDetail.Drain.noteMessage": "Nessuna opzione per la vasca selezionata",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "Il tubo di troppopieno è compreso nella fornitura per VARIUSmed MZB.",
    "ConfigurationDetail.Drain.noteExos": "Il fermo corsa con rivestimento InoxPlus è per EXOS. Vasche comprese nella fornitura.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "E-mail modificata correttamente",
    "ChangeEmailSucceededPageComponent.emailChangedText": "A breve riceverà un link per l'attivazione via e-mail. Per l'attivazione dell'account, fare clic su questo link.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Torna al login",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "La password è stata resettata correttamente.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Effettuare il login con la nuova password.",
    "ResetPasswordChangeSucceededPageComponent.button": "Login",
    "Warning.RequireReset.apron": "Grembiule",
    "submitAsOrder.label": "Trasferimento SAP ordine",
    "ListItemDetail.draft": "Bozza",
    "TroughDetailModalWidth.minWidth": "Larghezza minima",
    "TroughDetailModalDepth.minDepth": "Profondità minima",
    "TroughDetailModalWidth.width": "Larghezza",
    "TroughDetailModalDepth.depth": "Profondità",
    "TroughDetailModalHeight.height": "Altezza       ",
    "ConfigurationCountry.headline": "A quale Paese è destinata la configurazione?",
    "ConfigurationCountry.button": "Continua",
    "ConfigurationCountry.select": "Selezionare un Paese",
    "SelectedTroughListItemHeight.minDimensions": "Larghezza x profondità min. lavabo",
    "TroughDetailModalDepth.minDimensions": "Larghezza x profondità min. lavabo",
    "TroughListItemDepth.minDimensions": "Larghezza x profondità min. lavabo",
    "CosmeticTissueDispenser.cosmeticTissue": "Distributore di fazzoletti di carta",
    "PaperTowelDispenser.paperTowelDispenser": "Distributore di salviette asciugamani di carta",
    "CutOutLabelNone.none": "Selezionare il gettarifiuti",
    "DistancesPosition.symmetrically": "Superfici di appoggio identiche",
    "DistancesPosition.evenly": "Larghezza del posto di lavaggio identica",
    "CutOutLabel.CustomRound": "gettarifiuti tondo",
    "CutOutLabel.CustomSquare": "gettarifiuti quadrato",
    "CutOutLabel.roundSleeve": "gettarifiuti tondo con cornice per foro gettarifiuti",
    "CutOutLabel.squareSleeve": "gettarifiuti quadrato con cornice per foro gettarifiuti",
    "CutOutLabel.roundBasket": "gettarifiuti tondo con cestino",
    "CutOutLabel.roundRail": "gettarifiuti tondo e cestino con telaio estraibile",
    "CutOutLabel.squareBasket": "gettarifiuti quadrato con cestino",
    "CutOutLabel.squareRail": "gettarifiuti quadrato e cestino con telaio estraibile",
    "CutOutLabel.roundSleeveBasket": "gettarifiuti tondo con cornice per foro gettarifiuti e cestino",
    "CutOutLabel.roundSleeveRail": "gettarifiuti tondo con cornice per foro gettarifiuti e cestino con telaio estraibile",
    "CutOutLabel.squareSleeveBasket": "gettarifiuti quadrato con cornice per foro gettarifiuti e cestino",
    "CutOutLabel.squareSleeveRail": "gettarifiuti quadrato con cornice per foro gettarifiuti e cestino con telaio estraibile",
    "CutOutLabel.flap": "Ribalta gettarifiuti",
    "CutOutLabel.flapBasket": "Ribalta gettarifiuti con cestino",
    "CutOutLabel.flapRail": "Ribalta gettarifiuti e cestino con telaio estraibile",
    "CutOutLabel.provider": "Distributore di asciugamani di carta",
    "ApronHeightRequiredChoiceMessage.message": "Per una migliore estetica del lavabo, consigliamo di scegliere un grembiule:",
    "apronHeightRequiredChoice60.60": "Modifica l'altezza grembiule portandola a 60 mm",
    "apronHeightRequiredChoice150.150": "Modifica l'altezza grembiule portandola a 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Mantieni l'altezza grembiule",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Mantieni l'altezza grembiule e prosegui senza cornice",
    "CosmeticTissueDispenser.with": "con distributore di asciugamani di carta",
    "PlateDimensionsDepth.470": "Consiglio per rubinetterie a parete​",
    "PlateDimensionsDepth.550": "Consiglio per rubinetterie a bordo lavabo​",
    "Warning.RequireReset.cutOutDisposals": "Gettarifiuti",
    "checkboxPositions.noSpace": "Non è presente spazio a sufficienza.",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x Apertura per distributore di salviette asciugamani di carta",
    "ApronAffects.position": "Attenzione: la larghezza del grembiule (18 mm) causa lo spostamento della posizione della vasca.",
    "DepthRequiredHint.hint": "Nota:",
    "DepthRequiredMessage.message": "La profondità selezionata del lavabo non è sufficiente. Impostare la profondità necessaria di {requiredDepth} mm per questo gettarifiuti?",
    "ThankYou.orderPdf": "Configurazione lavabo (PDF)",
    "ThankYou.manufacturingPdf": "Disegno lavabo (PDF)",
    "ThankYou.troughPdf": "Disegno vasca (PDF)",
    "PlateDimensionsRequired.hint": "Nota:",
    "PlateDimensionsRequired.message": "Nota: la larghezza del lavabo non è sufficiente. Per posizionare un grembiule, è necessario aumentare la larghezza del lavabo. Proseguire?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Deselezionando il grembiule, vengono ripristinate le dimensioni originarie della configurazione.",
    "PlateDimensionsChoice.message": "Sul lavabo non è presente spazio a sufficienza per un grembiule. Sono disponibili le seguenti possibilità per proseguire:",
    "PlateDimensionsChoice.increase": "Modificare la larghezza del lavabo",
    "PlateDimensionsChoice.move": "Spostare la vasca/le vasche e mantenere la larghezza del lavabo",
    "PlateDimensionsChoice.cancel": "Annullare (vengono mantenute le dimensioni senza grembiule)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Per posizionare un portasciugamani, è necessario un grembiule di 150 mm. Poiché la larghezza del lavabo non è sufficiente per il posizionamento del grembiule, è necessario aumentare la larghezza del lavabo. Volete continuare?",
    "Checkout.OrderPdf": "Configurazione lavabo (PDF)",
    "Checkout.ManufacturingPdf": "Disegno lavabo (PDF)",
    "submitAsRequest.label": "Richiedi offerta",
    "checkoutSave.label": "Salva",
    "submitAsOffer.label": "Trasferimento SAP offerta",
    "ListItemDetail.request": "Richiesta",
    "ListItem.orderPdf": "Configurazione lavabo (PDF)",
    "ListItem.manufacturingPdf": "Disegno lavabo (PDF)",
    "ListItem.troughPdf": "Disegno vasca (PDF)",
    "PlateDimensionsRequiredLimit.message": "Larghezza massima del lavabo raggiunta. Non è possibile selezionare il grembiule.",
    "PlateDimensionsChoiceLimit.message": "Sul lavabo non è presente spazio a sufficienza per un grembiule. Larghezza lavabo massima raggiunta. Sono disponibili le seguenti possibilità per proseguire:",
    "CutoutPartDetail.name": "Nome",
    "CutoutPartDetail.dimensions": "Misure",
    "CutoutPartDetail.type": "Tipo",
    "CutoutPartDetail.article": "Codice articolo",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "Nota: per posizionare il portasciugamani, è necessario un grembiule di 150 mm. Poiché la larghezza del lavabo non è sufficiente per il posizionamento di un grembiule, è necessario aumentare la larghezza del lavabo. Proseguire?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "Per posizionare un distributore di salviette rinfrescanti, è necessario un grembiule di 150 mm. Poiché la larghezza del lavabo non è sufficiente per il posizionamento del grembiule, è necessario aumentare la larghezza del lavabo. Proseguire?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "Per posizionare un gettarifiuti, è necessario un grembiule di 150 mm. Poiché la larghezza del lavabo non è sufficiente per il posizionamento del grembiule, è necessario aumentare la larghezza del lavabo. Proseguire?",
    "apronHeightForTowelRailRequiredMessage.message": "Per scegliere un portasalviette, è necessario un grembiule di {requiredHeight}. Proseguire?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Per scegliere un distributore di fazzoletti di carta, è necessario un grembiule di {requiredHeight}. Proseguire?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Per selezionare un gettarifiuti è necessario un grembiule da {requiredHeight} mm. Proseguire?",
    "ListItem.archive": "Archivia",
    "ConfigurationSwitchView.mine": "Le mie configurazioni",
    "FolderSwitchView.mine": "Le mie configurazioni",
    "ConfigurationSwitchView.connected": "Assegnato",
    "ConfigurationSwitchView.archived": "Archiviato",
    "Archive.headline": "Archiviare questa configurazione?",
    "Archive.button": "Accetta",
    "Unarchive.headline": "Ripristinare questa configurazione?",
    "Unarchive.button": "Accetta",
    "ListItem.unarchive": "Ripristina",
    "WithNicheHint.hint": "Nota:",
    "WithNicheMessage.message": "Nota: larghezza del lavabo = dimensioni della nicchia pronta meno 8 mm. Alla configurazione sottrarre 4 mm per ogni lato del lavabo. Prestare attenzione alle sporgenze costruttive.",
    "checkboxPositions.tissueConflict": "Il sistema gettarifiuti è stato modificato",
    "CutOutLabel.cosmetic": "Distributore di fazzoletti di carta",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "Abbiamo inviato un link via e-mail. L'account verrà attivato dopo la conferma.",
    "ConsolesOverlapChoice.message": "Configurazione impossibile in questa modalità, aumentare la distanza o selezionare la staffa in acciaio inox.",
    "ConsolesOverlapChoice.continue": "Tornare la valore originario (con staffa in mineralguss)",
    "ConsolesOverlapChoice.return": "Tornare la valore originario (con staffa in mineralguss)",
    "ConsolesOverlapChoice.change": "Passa a staffa/staffe in acciaio inox",
    "checkoutSave.orderIsFailed": "Impossibile trasmettere l'ordine al sistema SAP. Duplicare la configurazione e riprovare in un secondo momento.",
    "Warning.RequireReset.qty": "Numero vasche",
    "ConfigurationNewFormName.error": "Il nome è necessario",
    "ConfigurationNewFormName.label": "Nome",
    "ConfigurationNewFormName.placeholder": "Nome",
    "ConfigurationNewFormPricingsAccessories.error": "È necessario un lasso di tempo.",
    "ConfigurationNewFormPricingsAccessories.label": "Lasso di tempo accessorio",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Selezionare...",
    "ConfigurationNewFormPricingsWashbasin.error": "È necessario un lasso di tempo.",
    "ConfigurationNewFormPricingsWashbasin.label": "Lasso di tempo lavabo",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Selezionare...",
    "checkoutParts.timePeriodNote": "Nota:",
    "checkoutParts.timePeriodNoteText": "Selezionare il periodo di validità del prezzo",
    "checkoutParts.timePeriodAccessoriesLabel": "Lasso di tempo accessorio",
    "checkoutParts.timePeriodWashbasinLabel": "Lasso di tempo lavabo",
    "checkoutSave.orderIsQueued": "Impossibile trasmettere l'ordinativo al sistema SAP. È in coda per una trasmissione successiva.",
    "ListItemDetail.failed": "Non riuscito",
    "ListItemDetail.queued": "In coda",
    "TroughFilterMedcare.error": "MEDCARE è necessario.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "disponibile a partire da agosto 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/it_IT/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(creato)",
    "Login.mustLogin": "Per avviare una configurazione, è necessario effettuare il login. Se non si dispone ancora di un account, crearne uno nuovo.",
    "Troughs.toStart": "Per avviare una configurazione, è necessario {login}. Se non si dispone ancora di un account, {creare}.",
    "TroughFilter.modelLine": "Linea",
    "TroughFilter.characteristics": "Proprietà della linea",
    "TroughListItem.min": "min. Lavabo",
    "TroughListItem.start": "Avvia configurazione",
    "TroughListItem.startWithLogin": "Avvia la configurazione dopo il login",
    "TroughBanner.label": "Quali sono le vasche disponibili?",
    "TroughBanner.text": "Date un'occhiata in anticipo.",
    "SearchPlaceholder.placeholderTroughs": "Cercare una bacinella",
    "Troughs.toStartLogin": "Effettuare il login",
    "Troughs.toStartCreate": "creare un nuovo account",
    "ConfigurationDownload3D.text": "Scarica la scena 3D",
    "ConfigurationNewFolder.newHeading": "Nuova cartella",
    "NewButtonsNewFolder.text": "Nuova cartella",
    "NewButtonsNewConfiguration.text": "Crea configurazione",
    "FolderListHeading.text": "Cartella",
    "FolderListNone.text": "Nessuna cartella disponibile",
    "ConfigurationListHeading.text": "Configurazioni non assegnate",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "Mostra tutte le cartelle",
    "ListItem.moveToGroup": "Sposta nella cartella o nella fase di costruzione",
    "ListItem.goBack": "Indietro",
    "FolderSwitchView.goBack": "Indietro",
    "ListItem.downloadPdfs": "Scarica i PDF",
    "ConfigurationDeleteFolder.cancel": "Annullare",
    "ConfigurationEditFolder.cancel": "Annullare",
    "ConfigurationNewFolder.cancel": "Annullare",
    "ConfigurationNewFolder.create": "Creare",
    "ConnectedFolder.label": "Sì, desidero creare una nuova cartella con il nome dell'oggetto nella mia dashboard.",
    "FolderListHeadingAll.text": "Tutte le cartelle",
    "FolderListToday.text": "Oggi",
    "FolderList7Days.text": "7 giorni precedenti",
    "FolderList30Days.text": "30 giorni precedenti",
    "FolderListItemNestedDelete.text": "Cancellare la fase",
    "ConfigurationDeleteNestedFolder.heading": "Cancellare la fase",
    "ConfigurationNewFolderNested.newHeading": "Nuovo stadio",
    "ListItem.moveToThisGroup": "Sposta nella cartella",
    "ConfigurationDeleteFolder.note": "Nota:",
    "ConfigurationDeleteNestedFolder.body": "se si elimina questo stage, le configurazioni in esso contenute vengono mantenute, semplicemente spostate nella cartella di archiviazione.",
    "ConfigurationDeleteFolder.body": "se si elimina questo stage, le configurazioni in esso contenute vengono mantenute, semplicemente spostate nella cartella di archiviazione.",
    "FolderListNestedHeading.test": "Fasi di costruzione",
    "BuildingNumber.error": "È richiesto building number.",
    "OpportunityNumber.error": "È richiesto opportunity number.",
    "FolderListItemDelete.text": "Elimina cartella",
    "ConfigurationDeleteFolder.heading": "Elimina cartella",
    "ConfigurationDeleteFolder.confirm": "Confermare",
    "ConfigurationEditFolder.heading": "Modifica cartella",
    "ConfigurationEditFolderNested.heading": "Modifica Fase di costruzione",
    "ConfigurationEditFolder.confirm": "Confermare",
    "ConfigurationListNone.text": "Non sono ancora disponibili configurazioni",
    "ListItemDetail.basin": "Lavabo",
    "ListItemDetail.number": "Abbeveratoi",
    "ListItem.moveToDashboard": "Sposta nel dashboard",
    "FolderList.SortByDate": "Ordina per data",
    "FolderList.SortByName": "Ordina per nome",
    "FolderName.name": "Nome della cartella",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "nl": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "China | 中国",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Configuratieoverzicht",
    "NavigationUser.accountName": "Inloggen en veiligheid",
    "NavigationUser.adressesName": "Bezorg- en factuuradressen",
    "CheckoutHeadline.checkout": "Overzicht",
    "CheckoutBackButton.checkout": "Terug naar configuratie",
    "CheckoutConfigurationHeadline.checkout": "Configuratie wastafel",
    "CheckoutPartsHeadline.checkout": "Toebehoren",
    "CheckoutPartsHeadlineLink.checkout": "Configuratieoverzicht",
    "Delete.headline": "Weet u zeker dat u deze configuratie wilt wissen?",
    "Delete.button": "Accepteren",
    "Assemblies.note": "Opmerking:",
    "Assemblies.message.with": "Alle montagetoebehoren zijn alleen bedoeld voor massieve wanden.",
    "Assemblies.message.without": "Bevestiging ter plekke.",
    "Assemblies.message.alwaysTriggerSafety": "Aftrekbeveiliging altijd inbegrepen.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Montagetoebehoren",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Kiezen",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Montagetoebehoren",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Afmetingen wastafel",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Soort montage",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Hoek van de nis",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Hoekvormgeving",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Bladafmetingen",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Positie van de wasbakken",
    "ConfigurationDetail.ApronBacksplash.apron": "Spatbescherming",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Overlooprand / opstaande rand aan achterzijde",
    "ConfigurationDetail.Recesses.tapHole": "Kraangat",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Gat voor zeepdispenser",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "Afvalopening",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "Dispenser voor papieren doekjes",
    "ConfigurationDetail.Recesses.towelRail": "Handdoekhouder",
    "ConfigurationDetail.plateSurface.colour": "Kleur",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Onderzijde",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Rand aan onderzijde / opstaande rand aan achterzijde",
    "ConfigurationDetail.Drain.drainTitle": "Afvoertoebehoren",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Afvoertoebehoren",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Configuratie afsluiten",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Uitsparingen / inbouwelementen",
    "ConfigurationDetail.colour.colourTitle": "Kleur",
    "ConfigurationDetail.troughs.troughsTitle": "Wasbakken",
    "ConfigurationProject.headline": "Bij welk object hoort uw configuratie",
    "ConfigurationProject.tabexisting": "Bestaand object kiezen",
    "ConfigurationProject.tabnew": "Nieuw object maken",
    "ConfigurationProject.tabEXISTING": "Bestaand",
    "ConfigurationProject.tabNEW": "Nieuw",
    "ConfigurationProject.tabWITHOUT": "Zonder",
    "ConfigurationDuplicate.headline": "Wilt u deze configuratie dupliceren?",
    "ConfigurationDuplicate.button": "Dupliceren",
    "ConfigurationNew.headline": "Voer de configuratiedetails in:",
    "ConfigurationRename.headline": "Hoe wilt u uw configuratie noemen?",
    "ChangePasswordPage.changePasswordHeading": "Maak een nieuw wachtwoord aan",
    "ChangePasswordPage.changePasswordText": "Het wachtwoord moet minimaal 2 van de 3 volgende soorten tekens bevatten: letters (bijv. ABCD...) - cijfers (bijv. 0123...) - speciale tekens (bijv. #$%...)",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Uw wachtwoord is gewijzigd.",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Ga terug naar de inlogpagina en voer uw nieuwe wachtwoord in.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Terug naar inlogpagina",
    "HomeLink.imprint": "Impressum",
    "HomeLink.legals": "Algemene voorwaarden",
    "HomeLink.privacy": "Privacy- en cookiebeleid",
    "Login.newUser": "Maak een nieuw account aan",
    "Login.forgotPassword": "Wachtwoord vergeten?",
    "Login.Label.Email": "E-mail",
    "Login.Placeholder.Email": "E-mail",
    "Login.Error.Email": "E-mail is een verplicht veld.",
    "Login.Label.Password": "Wachtwoord",
    "Login.Placeholder.Password": "Wachtwoord",
    "Login.Error.Password": "Wachtwoord is een verplicht veld.",
    "ResetPassword.button": "Terug naar inlogpagina",
    "ResetPasswordSucceededPageComponent.resetPassword": "Uw wachtwoord is gewijzigd.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Controleer uw e-mail en klik op de bevestigingslink.",
    "ResetPasswordSucceededPageComponent.button": "Inloggen",
    "ChangePwOld.label": "Oud wachtwoord",
    "ChangePwOld.placeholder": "Oud wachtwoord",
    "ChangePwOld.error": "Het wachtwoord moet minimaal 2 van de 3 volgende soorten tekens bevatten: letters (bijv. ABCD...) - cijfers (bijv. 0123...) - speciale tekens (bijv. #$%...)",
    "ChangePwNew.label": "Nieuw wachtwoord",
    "ChangePwNew.error": "Het wachtwoord moet minimaal 2 van de 3 volgende soorten tekens bevatten: letters (bijv. ABCD...) - cijfers (bijv. 0123...) - speciale tekens (bijv. #$%...)",
    "ChangePwNew.placeholder": "Nieuw wachtwoord",
    "ChangePwNewRepeat.label": "Wachtwoord opnieuw invoeren",
    "ChangePwNewRepeat.error": "Wachtwoorden komen niet overeen.",
    "ChangePwNewRepeat.placeholder": "Wachtwoord opnieuw invoeren",
    "PageNotFound.message": "Er is een fout opgetreden. De door u gezochte pagina bestaat niet.",
    "AccountProfile.name": "Naam",
    "AccountProfile.telephone": "Telefoonnummer",
    "AccountProfile.street": "Straat",
    "AccountProfile.zip": "Postcode",
    "AccountProfile.surname": "Achternaam",
    "AccountProfile.mobile": "Mobiel nummer",
    "AccountProfile.city": "Plaats",
    "AccountProfile.country": "Land",
    "AccountProfile.userbutton": "Formulier bewerken",
    "AccountProfile.email": "E-mailadres",
    "AccountProfile.password": "Wachtwoord",
    "AccountProfile.loginbutton": "Formulier bewerken",
    "AccountProfile.headline": "Inloggen en veiligheid",
    "projectsNewHeadline.headline": "Nieuw project aanmaken",
    "projectsOverviewHeadline.headline": "Bezorg- en factuuradressen",
    "ProjectsDelete.headline": "Weet u zeker dat u dit project wilt wissen?",
    "ProjectsDelete.button": "Accepteren",
    "ProjectsEdit.headline": "Uw project bewerken:",
    "ProjectsNew.headline": "Voer een naam in voor uw object:",
    "RegisterPage.registerText": "Voer een geldig e-mailadres en een wachtwoord in voor uw account.",
    "RegisterPage.registerButton": "Terug naar inlogpagina",
    "RegisterMail.error": "E-mail is een verplicht veld.",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "Het wachtwoord moet minimaal 2 van de 3 volgende soorten tekens bevatten: letters (bijv. ABCD...) - cijfers (bijv. 0123...) - speciale tekens (bijv. #$%...)",
    "RegisterPw.name": "Wachtwoord",
    "RegisterPwRepeat.error": "Wachtwoorden komen niet overeen.",
    "RegisterPwRepeat.name": "Wachtwoord opnieuw invoeren",
    "RegisterUserGender.error": "Aanhef is een verplicht veld",
    "RegisterUserGender.label": "Aanhef",
    "RegisterUserGender.mr": "Dhr.",
    "RegisterUserGender.mrs": "Mevrouw",
    "registerUserFirstName.error": "First name is required and should contain at least 2 characters.",
    "registerUserFirstName.label": "Voornaam",
    "registerUserLastName.error": "Achternaam is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "registerUserLastName.label": "Achternaam",
    "registerUserPhone.label": "Telefoon",
    "registerUserMobile.label": "Mobiel",
    "registerUserCompany.label": "Bedrijf",
    "registerUserStreet.error": "Straat is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "registerUserStreet.label": "Straat",
    "registerUserHouse.error": "Huisnummer is een verplicht veld en moet minimaal uit 1 teken bestaan.",
    "registerUserHouse.label": "Huisnummer",
    "registerUserZip.error": "Postcode is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "registerUserZip.label": "Postcode",
    "registerUserCity.error": "Plaats is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "registerUserCity.label": "Plaats",
    "registerUserAddressAdditional.label": "Adrestoevoeging",
    "registerUserCountry.error": "Land is een verplicht veld.",
    "registerUserCountry.label": "Land",
    "registerUserCountryLabel.label": "Kies een land",
    "registerUserClientNr.label": "Klantnummer (indien aanwezig)",
    "registerUserBranch.error": "Branche is een verplicht veld",
    "registerUserBranch.label": "Branche",
    "registerUserBranchSanitary.label": "Sanitairgroothandel",
    "registerUserBranchPlanner.label": "Ontwerper / architect",
    "registerUserBranchPlumber.label": "Installateur",
    "registerUserBranchRetail.label": "Eindklant",
    "editUserGender.error": "Aanhef is een verplicht veld",
    "editUserGender.label": "Aanhef",
    "editUserGenderMr.label": "Dhr.",
    "editUserGenderMrs.label": "Mevrouw",
    "editUserFirstName.error": "Voornaam is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "editUserFirstName.label": "Voornaam",
    "editUserLastName.error": "Achternaam is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "editUserLastName.label": "Achternaam",
    "editUserPhone.label": "Telefoon",
    "editUserMobile.label": "Mobiel",
    "editUserStreet.error": "Straat is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "editUserStreet.label": "Straat",
    "editUserHouse.error": "Huisnummer is een verplicht veld en moet minimaal uit 1 teken bestaan.",
    "editUserHouse.label": "Huisnummer",
    "editUserAddressAdditional.label": "Adrestoevoeging",
    "editUserZip.error": "Postcode is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "editUserZip.label": "Postcode",
    "editUserCity.error": "Plaats is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "editUserCity.label": "Plaats",
    "editUserCountry.error": "Land is een verplicht veld.",
    "editUserCountry.label": "Land",
    "editUserCountryLabel.label": "Kies een land",
    "RegisterSucceededComponent.registerSucceededHeading": "Bedankt. Uw registratie is nu bijna voltooid.",
    "RegisterSucceededComponent.registerSucceededText": "In enkele ogenblikken ontvangt u van ons een e-mail met een link. Nadat u uw e-mailadres hebt bevestigd door op de link te klikken, kunt u inloggen.",
    "RegisterSucceededComponent.registerSucceededButton": "Terug naar inlogpagina",
    "ThankYou.headline": "Bedankt voor uw configuratie!",
    "ThankYou.message": "We hebben per e-mail een bevestiging naar u opgestuurd met alle details over uw offerte.",
    "ThankYou.order": "Uw offertenummer:",
    "ThankYou.pdfbutton": "Exporteren als 2D PDF",
    "ThankYou.tenderdocuments": "Aanbestedingsdocumenten",
    "ThankYou.overviewbutton": "Naar configuratieoverzicht",
    "Configuration3dAlert.attention": "Hoe te beginnen?",
    "Configuration3dAlert.message": "Kies de door u gewenste wasbak door op de knop (Wasbak kiezen) te klikken en begin met uw configuratie. Veel plezier bij het configureren!",
    "ActivationSucceeded.activationSucceededText": "Gefeliciteerd, uw account is ingesteld. Ga terug naar de inlogpagina en voer uw gebruikersgegevens in.",
    "ActivationSucceeded.activationSucceededButton": "Aan de slag",
    "ActivationFailed.activaionUserNotFound": "Deze gebruiker bestaat niet. Maak een nieuw account aan.",
    "ActivationFailed.activaionUserNotFoundButton": "Registreren",
    "ChangeEmailForm.button": "E-mailadres wijzigen",
    "ChangePassword.button": "Wachtwoord wijzigen",
    "LoginForm.button": "Inloggen",
    "Logout.button": "Uitloggen",
    "RegisterUserDataForm.headline": "Voer uw persoonsgegevens in.",
    "RegisterUserDataForm.button": "Nieuw account aanmaken",
    "RegisterUserDataForm.logout": "Terug naar inlogpagina",
    "RegisterUserForm.button": "Nieuw account aanmaken",
    "ResetPasswordForm.button": "Wachtwoord resetten",
    "ResetPasswordChangeForm.button": "Wachtwoord resetten",
    "Checkout.WashBasinDimensions": "Afmetingen wastafel",
    "Checkout.PlateDimensions.Width": "Breedte",
    "Checkout.PlateDimensions.Depth": "Diepte",
    "Checkout.TypeOfInstallation": "Soort montage",
    "Checkout.TypeOfInstallation.Left": "Nis links",
    "Checkout.TypeOfInstallation.Right": "Nis rechts",
    "Checkout.TypeOfInstallation.With": "Nis links en rechts",
    "Checkout.CornerDesign": "Hoekvormgeving",
    "Checkout.CornerDesign.Radius": "Radius 100 mm",
    "Checkout.CornerDesign.Bevel": "Afschuining, 100 mm",
    "Checkout.Left": "links",
    "Checkout.Right": "rechts",
    "Checkout.ApronBackSplash.Headline": "Rand aan onderzijde / opstaande rand aan achterzijde",
    "Checkout.ApronBackSplash.Apron": "Rand aan onderzijde: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Overlooprand: {position} - hoogte: 3 mm.",
    "Checkout.ApronBackSplash.apronBackSplash": "Opstaande rand aan achterzijde: {position} - hoogte: {height} mm.",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Uitsparingen / inbouwelementen",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x kraangat",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x gat voor zeepdispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x uitsparing \\\"{name}\\",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x uitsparing voor tissuedispenser",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x uitsparing voor handdoekhouder",
    "Checkout.Surface.Title": "Kleur",
    "Checkout.Surface.Color": "Kleur: {color}",
    "Checkout.Surface.GelCoat": "Gelcoat onderzijde",
    "Checkout.AssemblyAccessories.Title": "Montagetoebehoren",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x console {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x hoeklijst voor montage aan zijwand.",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x aftrekbeveiliging voor montage aan de achterwand",
    "Checkout.GeneralInfo.Headline": "Overzicht",
    "Checkout.GeneralInfo.ConfName": "Naam van configuratie:",
    "Checkout.TotalPrice.Washbasin": "Wastafel",
    "Checkout.TotalPrice.Parts": "Toebehoren",
    "Checkout.TotalPrice.DeliveryCosts": "Transportkosten",
    "Checkout.TotalPrice.Vat": "Btw",
    "Checkout.TotalPrice.Total": "Totaalbedrag",
    "Checkout.TotalPrice.Note": "Opmerking:",
    "Checkout.TotalPrice.NoteText": "Prijzen geldig t/m ",
    "Checkout.Trough.Headline": "Wasbak",
    "Checkout.Trough.Name": "Naam van wasbak:",
    "Checkout.Trough.Qty": "Aantal:",
    "Checkout.Trough.Dimensions": "Afmetingen wasbak",
    "checkoutPartsPdfButton.button": "PDF downloaden",
    "Apron.height": "Hoogte van de rand aan de onderzijde in mm",
    "ApronHeightRequiredHint.hint": "Opmerking:",
    "ApronHeightRequiredMessage.message": "U heeft een rand van {vereisteHoogte} mm nodig om een cosmetische tissuedispenser te kunnen kiezen. Wilt u doorgaan?",
    "ApronHeightError.message": "De waarde ligt buiten de afmetingen",
    "SurgeEdgeLabelWithout.without": "zonder       ",
    "SurgeEdgeLabelWith.with": "met overlooprand (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "met opstaande rand aan achterzijde",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "achter (standaard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Hoogte van de achterzijde in mm",
    "WithoutAssemblyAccessories.without": "zonder montagetoebehoren",
    "WithAssemblyAccessories.with": "met montagetoebehoren",
    "WithAssemblyAccessoriesTooltipHint.hint": "Opmerking:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Bevestiging door klant.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "Chroomnikkelstaal",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Console",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Aftrekbeveiliging",
    "AssemblyAccessoriesListAngleBar.anglebar": "Hoeklijst",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Bevestigingsmateriaal",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Chroomnikkelstaal wit",
    "CornerDesignLabelWithout.without": "Zonder hoekvormgeving",
    "CornerDesignLabelRadius.radius": "Radius (100 mm)",
    "CornerDesignLabelBevel.bevel": "Afschuining (lengte van zijde 100 mm)",
    "DistancesPositionOfTroughs.distances": "Invoeren van de afstand tot het midden van de bak",
    "DistancesPositionOfTroughsHint.hint": "Opmerking:",
    "DistancesPositionOfTroughsMessage.message": "Voordelen en toepassingsadviezen",
    "DistancesPositionOfTroughsFromPlate.plate": "Van de plaat tot de achterrand van de bak",
    "PlateDimensionsWidth.width": "Breedte van werkblad",
    "PlateDimensionsDepth.depth": "Diepte van werkblad",
    "PlateDimensionsDepth.depthIndividual": "Individueel",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "De door u gekozen waarde ligt buiten het toegestane bereik",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Linkerzijde",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Rechterzijde",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Alleen mogelijk in combinatie met de montagewijze \"met, links of rechts\".",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Alleen mogelijk in combinatie met de montagewijze \"zonder, links of rechts\".",
    "Configuration.Inputs.message": "De door u gekozen waarde ligt buiten het toegestane bereik",
    "DrainLabelWithoutDrain.withoutdrain": "Zonder afvoertoebehoren",
    "DrainLabelHoodDrain.hooddrain": "Afvoerplug met kap",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Afvoerplug met kap verchroomd",
    "DrainLabelSieveDrain.sievedrain": "Afvoerplug met zeef",
    "DrainLabelEccentric.eccentric": "Excentrische af- en overloopset",
    "DrainLabelSiphon.siphon": "Sifon XINX140",
    "CosmeticTissueDispenser.without": "zonder dispenser voor papieren doekjes",
    "CosmeticTissueDispenserSquare.square": "vierkant (met gelcoat) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(voor tissuedispenser \"modelnummer\")",
    "CosmeticTissueDispenserPosition.position": "(positie tussen de wasbakken)",
    "CutOutLabelCustomInput.diameter": "Diameter",
    "CutOutLabelCustomInput.width": "Breedte",
    "CutOutLabelCustomInput.depth": "Diepte",
    "CutOutLabelSelect.select": "Maak een keuze",
    "CutOutDisposalsDefaultsWithout.without": "zonder afvalopening",
    "CutOutDisposalsDefaultsWith.with": "met afvalopening",
    "SoapDispenserHoleLabelWithout.without": "zonder       ",
    "SoapDispenserHoleLabelSD80.sd80": "voor zeepdispenser SD80",
    "SoapDispenserHoleLabelSD100.sd100": "voor zeepdispenser SD100",
    "SoapDispenserHoleLabel25.dispensers": "voor dispenser van andere fabrikanten (Ø 25 mm)",
    "TapHoleWithout.taphole": "zonder gat",
    "TapHoleWithoutDrilling.tapholedrilling": "met gat",
    "TowelRailWithout.towelrailwithout": "zonder uitsparing",
    "TowelRailWithout.towelrailwith": "met uitsparing",
    "ColorLabel.alpinewhite": "Alpinewit (standaard)",
    "ColorLabel.alpinewhitetext": "Temperatuurbestendig tot 80 °C",
    "ColorLabel.graniteblack": "Graniet zwart",
    "ColorLabel.graniteblacktext": "Temperatuurbestendig tot 65 °C",
    "ColorLabel.graniteblackwhite": "Graniet zwart-wit",
    "ColorLabel.graniteblackwhitetext": "Temperatuurbestendig tot 65 °C",
    "ColorLabel.graniteLightGray": "Graniet lichtgrijs",
    "ColorLabel.granitelightgraytext": "Temperatuurbestendig tot 65 °C",
    "ColorBottomSideUncoated.uncoated": "zonder coating (standaard)",
    "ColorBottomSideGelcoat.gelcoat": "Gelcoat",
    "ColorBottomSideHint.hint": "Opmerking:",
    "ColorBottomSideMessage.message": "Voordelen en toepassingsadviezen",
    "ElementNext.button": "Verder",
    "ElementsPositionsLeft.left": "links",
    "ElementsPositionsBack.back": "achter",
    "ElementsPositionsFront.front": "voor       ",
    "ElementsPositionsRight.right": "rechts",
    "ElementsPositionsRight.warning": "Gedeactiveerd, vergroot de afstand tussen de wasbakken.",
    "ConfigurationListAdd.text": "Nieuwe configuratie toevoegen",
    "ListItem.rename": "Hernoemen",
    "ListItem.duplicate": "Dupliceren",
    "ListItem.delete": "Wissen",
    "ListItem.order": "Offerte",
    "ListItem.orderShow": "Naar het aanbod",
    "ListItem.linkTitle": "Instellingen",
    "ListItemDetail.price": "Totaalprijs:",
    "ListItemDetail.offer": "Offerte",
    "ListItemDetail.order": "Bestelling",
    "ListItemDetail.date": "Laatst gewijzigd",
    "ConfigurationNewForm.button": "Verder",
    "Warning.RequireReset.Trough": "Vanwege wijzigingen in uw configuratie moeten alle vermelde elementen worden gereset als u een nieuwe wasbak kiest en het aantal wilt verhogen of verlagen:",
    "Warning.RequireReset.Qty": "Vanwege wijzigingen in uw configuratie moeten alle vermelde elementen worden gereset als u het aantal wilt verhogen of verlagen:",
    "Warning.RequireReset.TypeOfInstallation": "Vanwege wijzigingen in uw configuratie moeten alle vermelde elementen worden gereset als u de montagewijze wilt wijzigen:",
    "Warning.RequireReset.plateDepth": "Diepte van werkblad",
    "Warning.RequireReset.PlateDepth": "Vanwege wijzigingen in uw configuratie moeten alle vermelde elementen worden gereset als u de diepte van het werkblad wilt wijzigen:",
    "Warning.RequireReset.distances": "Afstanden",
    "Warning.RequireReset.cornerDesign": "Hoekvormgeving",
    "Warning.RequireReset": "Resetten vereist:",
    "Warning.RequireReset.Default": "Vanwege wijzigingen in uw configuratie moet deze worden gereset.",
    "Warning.RequireReset.ResetAll": "Alles resetten?",
    "Warning.RequireReset.console": "Consoles",
    "Warning.RequireReset.drain": "Afvoertoebehoren",
    "Warning.RequireReset.typeOfInstallation": "Soort montage",
    "Warning.RequireReset.paperTowelDispensers": "Uitsparing voor handdoekdispenser",
    "Warning.RequireReset.plateWidth": "Breedte van werkblad",
    "Warning.RequireReset.siphon": "Sifon",
    "Warning.RequireReset.soapDispenserHole": "Gat voor zeepdispenser",
    "Warning.RequireReset.tapHole": "Kraangat",
    "Warning.RequireReset.tissueDispenser": "Uitsparing voor tissuedispenser",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Overlooprand / opstaande rand aan achterzijde",
    "ConfigurationDetail.error.default": "De door u gekozen waarde is niet toegestaan. Controleer uw invoer.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "De door u gekozen waarde is niet toegestaan, controleer de gekleurde onderzijde.",
    "LogoTitle.default": "Configuratieoverzicht",
    "LogoTitle.fallback": "KWC 3D-configurator",
    "MetaNavigationImprint.imprint": "Impressum",
    "MetaNavigationLegals.legals": "Algemene voorwaarden",
    "MetaNavigationPrivacy.privacy": "Privacy- en cookiebeleid",
    "NavigationTrough.name": "Wasbak",
    "NavigationTrough.title": "Wasbak",
    "NavigationBasin.name": "Afmetingen wastafel",
    "NavigationBasin.title": "Afmetingen wastafel",
    "NavigationApron.name": "Rand aan onderzijde / opstaande rand aan achterzijde",
    "NavigationApron.title": "Rand aan onderzijde / opstaande rand aan achterzijde",
    "NavigationRecesses.name": "Uitsparingen / inbouwelementen",
    "NavigationRecesses.title": "Uitsparingen / inbouwelementen",
    "NavigationColour.name": "Kleur",
    "NavigationColour.title": "Kleur",
    "NavigationAssembly.name": "Montagetoebehoren",
    "NavigationAssembly.title": "Montagetoebehoren",
    "NavigationDrain.name": "Afvoertoebehoren",
    "NavigationDrain.title": "Afvoertoebehoren",
    "ProjectsEditFormButton.button": "Project opslaan",
    "ProjectListItemEdit.edit": "Bewerken",
    "ProjectListItemDelete.delete": "Wissen",
    "ProjectListItemLinkTitle.title": "Instellingen",
    "projectListHeadline.headline": "Bezorg- en factuuradressen",
    "ProjectListAdd.addText": "Nieuw adres toevoegen",
    "ProjectNewFormButton.button": "Project aanmaken",
    "ProjectName.error": "Naam is een verplicht veld.",
    "ProjectName.name": "Objectnaam:",
    "ProjectStreet.error": "Straat is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "ProjectStreet.name": "Straat",
    "ProjectStreetNr.error": "Huisnummer is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "ProjectStreetNr.name": "Huisnummer",
    "ProjectZip.error": "Postcode is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "ProjectZip.name": "Postcode",
    "ProjectCity.error": "Plaats is een verplicht veld en moet minimaal uit 2 tekens bestaan.",
    "ProjectCity.name": "Plaats",
    "ProjectCountry.error": "Land is een verplicht veld.",
    "ProjectCountry.name": "Land",
    "ProjectCountry.label": "Kies een land",
    "ProjectSelectExistingProject.text": "Bestaand object kiezen",
    "ProjectSelectCreateProject.text": "Nog geen object aanwezig, maak er een aan",
    "ProjectSelectButton.button": "Verder",
    "ProjectSelectWithout.without": "Ik wil graag doorgaan zonder object",
    "ProjectSelectButtonTitle.title": "Object bewerken",
    "ProjectWithout.label": "Ja, ik wil doorgaan zonder object",
    "ProjectWithout.button": "Verder",
    "SelectedTroughListButton.button": "Wasbak toegevoegd",
    "SelectedTroughListItemWidth.width": "Breedte",
    "SelectedTroughListItemWidth.minWidth": "Minimale breedte",
    "SelectedTroughListItemDepth.depth": "Diepte",
    "SelectedTroughListItemDepth.minDepth": "Minimumdiepte",
    "SelectedTroughListItemHeight.height": "Hoogte",
    "TroughDetailModalButton.button": "Technische tekening",
    "TroughFilterButton.button": "Keuze ongedaan maken",
    "TroughFilterExos.error": "EXOS. is geselecteerd.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "VARIUSsign is geselecteerd.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "VARIUSmed is geselecteerd.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Hoekig is geselecteerd.",
    "TroughFilterSquare.label": "Hoekig",
    "TroughFilterOval.error": "Ovaal is geselecteerd.",
    "TroughFilterOval.label": "Ovaal",
    "TroughFilterRound.error": "Rond is geselecteerd.",
    "TroughFilterRound.label": "Rond",
    "TroughFilterWithOverflow.error": "Met overloop is geselecteerd.",
    "TroughFilterWithOverflow.label": "Met overloop",
    "TroughFilterWithoutOverflow.error": "Zonder overloop is geselecteerd.",
    "TroughFilterWithoutOverflow.label": "Zonder overloop",
    "TroughFilterWithBackwall.error": "Met wastafel achterwand is geselecteerd.",
    "TroughFilterWithBackwall.label": "met wastafelachterpaneel",
    "TroughFilterWithoutBackwall.error": "Met Console is geselecteerd.",
    "TroughFilterWithoutBackwall.label": "met consoles",
    "TroughListButtonSelect.select": "Wasbak kiezen",
    "TroughListButtonClose.close": "Menu sluiten",
    "TroughListButtonFilterOptions.filter": "Filteropties weergeven",
    "TroughListSorryMsg.message": "Sorry, we kunnen geen wasbak vinden die overeenkomt met de door u gekozen filteropties.",
    "TroughListItemWidth.width": "Breedte",
    "TroughListItemWidth.minWidth": "Minimale breedte",
    "TroughListItemDepth.depth": "Diepte",
    "TroughListItemDepth.minDepth": "Minimumdiepte",
    "TroughListItemHeight.height": "Hoogte      ",
    "TroughListMinValuesText.text": "min. breedte x diepte wastafel",
    "RegisterSucceededComponent.resendSucceededHeading": "Activeringslink succesvol opnieuw verzonden",
    "ActivationFailed.activationInvalid": "Helaas is de activering mislukt!",
    "ActivationFailed.activationInvalidToken": "Uw token is verlopen. Controleer of uw account is geactiveerd en log opnieuw in.",
    "ActivationFailed.activationInvalidTokenButton": "Nieuwe link versturen.",
    "ActivationFailed.ActivationResend": "Activatielink opnieuw verzenden",
    "Configuration.Inputs.distancesInmm": "(afstanden in mm)",
    "newEmail.text": "Nieuwe e-mail",
    "newEmail.error": "Het ingevoerde e-mailadres is onjuist.",
    "AccountProfile.button": "Opslaan",
    "ApronLabel.with": "met rand",
    "ApronLabel.without": "zonder rand (standaard)",
    "SquareCustom.square": "hoekig",
    "RoundCustom.round": "rond",
    "SearchPlaceholder.placeholder": "Zoeken...",
    "ColorCheckout.white": "Alpinewit",
    "ColorCheckout.black": "Graniet zwart",
    "ColorCheckout.blackWhite": "Graniet zwart-wit",
    "ColorCheckout.lightGray": "Graniet lichtgrijs",
    "ConfigurationDetail.Drain.note": "Opmerking:",
    "ConfigurationDetail.Drain.noteMessage": "Geen opties voor de gekozen wasbak",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "De standpijpplug is bij de VARIUSmed multifunctionele wasbak bij levering inbegrepen.",
    "ConfigurationDetail.Drain.noteExos": "Aftrekbeveiliging met InoxPlus-coating is bij EXOS. wasbakken bij levering inbegrepen.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "E-mail gewijzigd",
    "ChangeEmailSucceededPageComponent.emailChangedText": "U ontvangt dadelijk per e-mail een activeringslink. Klik op deze link om uw account te activeren.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Terug naar inlogpagina",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Uw wachtwoord is gereset.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Meld u aan met uw nieuwe wachtwoord.",
    "ResetPasswordChangeSucceededPageComponent.button": "Inloggen",
    "Warning.RequireReset.apron": "Spatbescherming",
    "submitAsOrder.label": "SAP overdrachtsorder",
    "ListItemDetail.draft": "Ontwerp",
    "TroughDetailModalWidth.minWidth": "Minimale breedte",
    "TroughDetailModalDepth.minDepth": "Minimumdiepte",
    "TroughDetailModalWidth.width": "Breedte",
    "TroughDetailModalDepth.depth": "Diepte",
    "TroughDetailModalHeight.height": "Hoogte       ",
    "ConfigurationCountry.headline": "Bij welk land hoort uw configuratie?",
    "ConfigurationCountry.button": "Verder",
    "ConfigurationCountry.select": "Kies een land",
    "SelectedTroughListItemHeight.minDimensions": "min. breedte x diepte wastafel",
    "TroughDetailModalDepth.minDimensions": "min. breedte x diepte wastafel",
    "TroughListItemDepth.minDimensions": "min. breedte x diepte wastafel",
    "CosmeticTissueDispenser.cosmeticTissue": "Tissuedispenser",
    "PaperTowelDispenser.paperTowelDispenser": "Dispenser voor papieren handdoekjes",
    "CutOutLabelNone.none": "Kies een afvalopening",
    "DistancesPosition.symmetrically": "identieke oppervlakten",
    "DistancesPosition.evenly": "identieke wasplaatsbreedte",
    "CutOutLabel.CustomRound": "ronde afvalopening",
    "CutOutLabel.CustomSquare": "hoekige afvalopening",
    "CutOutLabel.roundSleeve": "ronde afvalopening met afvalkoker",
    "CutOutLabel.squareSleeve": "hoekige afvalopening met afvalkoker",
    "CutOutLabel.roundBasket": "ronde afvalopening met afvalmand",
    "CutOutLabel.roundRail": "ronde afvalopening en afvalmand met uittrekbaar frame",
    "CutOutLabel.squareBasket": "hoekige afvalopening met afvalmand",
    "CutOutLabel.squareRail": "hoekige afvalopening en afvalmand met uittrekbaar frame",
    "CutOutLabel.roundSleeveBasket": "ronde afvalopening met afvalkoker en afvalmand",
    "CutOutLabel.roundSleeveRail": "ronde afvalopening met afvalkoker en afvalmand met uittrekbaar frame",
    "CutOutLabel.squareSleeveBasket": "hoekige afvalopening met afvalkoker en afvalmand",
    "CutOutLabel.squareSleeveRail": "hoekige afvalopening met afvalkoker en afvalmand met uittrekbaar frame",
    "CutOutLabel.flap": "Afvalklep",
    "CutOutLabel.flapBasket": "Afvalklep met afvalmand",
    "CutOutLabel.flapRail": "Afvalklep en afvalmand met uittrekbaar frame",
    "CutOutLabel.provider": "Dispenser voor papieren doekjes",
    "ApronHeightRequiredChoiceMessage.message": "Om de wastafel er mooier uit te laten zien, raden wij aan een rand aan de onderzijde te kiezen:",
    "apronHeightRequiredChoice60.60": "Randhoogte wijzigen in 60 mm",
    "apronHeightRequiredChoice150.150": "Randhoogte wijzigen in 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Randhoogte behouden",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Randhoogte behouden en doorgaan zonder koker",
    "CosmeticTissueDispenser.with": "met dispenser voor papieren doekjes",
    "PlateDimensionsDepth.470": "Advies voor wandkranen",
    "PlateDimensionsDepth.550": "Advies voor staande kranen",
    "Warning.RequireReset.cutOutDisposals": "Afvalopening",
    "checkboxPositions.noSpace": "Onvoldoende ruimte.",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x uitsparing voor dispenser voor papieren handdoekjes",
    "ApronAffects.position": "Let op: Een randbreedte van 18 mm leidt tot verplaatsing van de bakpositie.",
    "DepthRequiredHint.hint": "Opmerking:",
    "DepthRequiredMessage.message": "De diepte van de wastafel die u heeft gekozen is niet voldoende. Wilt u de vereiste diepte van {requiredDepth} mm instellen voor deze afvalbak?",
    "ThankYou.orderPdf": "Configuratie wastafel (PDF)",
    "ThankYou.manufacturingPdf": "Tekening wastafel (PDF)",
    "ThankYou.troughPdf": "Tekening wasbak (PDF)",
    "PlateDimensionsRequired.hint": "Opmerking:",
    "PlateDimensionsRequired.message": "Opmerking: Uw wastafel is niet breed genoeg. Om een rand aan de onderzijde te plaatsen, moet de wastafelbreedte worden vergroot. Wilt u doorgaan?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Als u uw keuze van de randen aan de onderzijde ongedaan maakt, worden de oorspronkelijke afmetingen van uw configuratie hersteld.",
    "PlateDimensionsChoice.message": "Er is niet genoeg ruimte bij uw wastafel voor een rand aan de onderzijde. U hebt de volgende mogelijkheden om door te gaan:",
    "PlateDimensionsChoice.increase": "De breedte van de wastafel aanpassen",
    "PlateDimensionsChoice.move": "De wasbak(ken) verplaatsen en de breedte van de wastafel behouden",
    "PlateDimensionsChoice.cancel": "Annuleren (de afmetingen zonder rand aan de onderzijde worden behouden)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Om een handdoekhouder te plaatsen, heb je een schort van 150 mm nodig. Omdat de breedte van je wastafel niet voldoende is voor een schort, moet je de breedte van je wastafel vergroten. Wilt u verdergaan?",
    "Checkout.OrderPdf": "Configuratie wastafel (PDF)",
    "Checkout.ManufacturingPdf": "Tekening wastafel (PDF)",
    "submitAsRequest.label": "Een offerte aanvragen",
    "checkoutSave.label": "Opslaan",
    "submitAsOffer.label": "SAP Overdrachtsaanbod",
    "ListItemDetail.request": "Aanvraag",
    "ListItem.orderPdf": "Configuratie wastafel (PDF)",
    "ListItem.manufacturingPdf": "Tekening wastafel (PDF)",
    "ListItem.troughPdf": "Tekening wasbak (PDF)",
    "PlateDimensionsRequiredLimit.message": "Maximale breedte van de wastafel bereikt. Geen randselectie mogelijk.",
    "PlateDimensionsChoiceLimit.message": "Er is niet genoeg ruimte bij uw wastafel voor een rand aan de onderzijde. Maximale wastafelbreedte bereikt. U hebt de volgende mogelijkheden om door te gaan:",
    "CutoutPartDetail.name": "Naam",
    "CutoutPartDetail.dimensions": "Afmetingen",
    "CutoutPartDetail.type": "Type",
    "CutoutPartDetail.article": "Artikelnummer",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "Opmerking: Om een handdoekhouder te kunnen plaatsen, hebt u aan de onderzijde een rand van 150 mm nodig. Omdat uw wastafel niet breed genoeg is voor een rand aan de onderzijde, moet de wastafelbreedte worden vergroot. Wilt u doorgaan?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "Om een cosmetische tissuedispenser te plaatsen, heeft u een rand van 150 mm nodig. Als de breedte van uw wastafel niet voldoende is voor het plaatsen van een rand, moet u de breedte van de wastafel vergroten. Wilt u doorgaan?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "Om een afvalbak te plaatsen, heeft u een rand van 150 mm nodig. Als de breedte van uw wastafel niet voldoende is voor het plaatsen van een rand, moet u de breedte van de wastafel vergroten. Wilt u doorgaan?",
    "apronHeightForTowelRailRequiredMessage.message": "Om een handdoekhouder te kunnen kiezen, hebt u aan de onderzijde een rand van {requiredHeight} nodig. Wilt u doorgaan?",
    "apronHeightForTissueDispenserRequiredMessage.message": "Om een tissuedispenser te kunnen kiezen, hebt u aan de onderzijde een rand van {requiredHeight} nodig. Wilt u doorgaan?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Om een afvalbak te selecteren, heeft u een rand van {requiredHeight} mm nodig. Wilt u doorgaan?",
    "ListItem.archive": "Archiveren",
    "ConfigurationSwitchView.mine": "Mijn configuraties",
    "FolderSwitchView.mine": "Mijn configuraties",
    "ConfigurationSwitchView.connected": "Toegewezen",
    "ConfigurationSwitchView.archived": "Gearchiveerd",
    "Archive.headline": "Weet u zeker dat u deze configuratie wilt archiveren?",
    "Archive.button": "Accepteren",
    "Unarchive.headline": "Weet u zeker dat u deze configuratie wilt herstellen?",
    "Unarchive.button": "Accepteren",
    "ListItem.unarchive": "Herstellen",
    "WithNicheHint.hint": "Opmerking:",
    "WithNicheMessage.message": "Opmerking: Wastafelbreedte = nisafmeting minus 8 mm. Trek bij de configuratie per wastafelzijde 4 mm af. Houd rekening met uitstekende delen!",
    "checkboxPositions.tissueConflict": "Het afvalsysteem is veranderd",
    "CutOutLabel.cosmetic": "Tissuedispenser",
    "RegisterSucceededComponent.note": "Info",
    "RegisterSucceededComponent.noteText": "We hebben u een link per e-mail gestuurd. Na bevestiging wordt uw account geactiveerd.",
    "ConsolesOverlapChoice.message": "Configuratie is zo niet mogelijk. Vergroot de afstand of kies een console van chroomnikkelstaal.",
    "ConsolesOverlapChoice.continue": "Teruggaan naar oorspronkelijke waarde (met console van gegoten mineraal materiaal)",
    "ConsolesOverlapChoice.return": "Teruggaan naar oorspronkelijke waarde (met console van gegoten mineraal materiaal)",
    "ConsolesOverlapChoice.change": "Wisselen naar console(s) van chroomnikkelstaal",
    "checkoutSave.orderIsFailed": "De order kon niet naar het SAP-systeem worden verzonden. Dupliceer de configuratie en probeer het later opnieuw.",
    "Warning.RequireReset.qty": "Aantal wasbakken",
    "ConfigurationNewFormName.error": "Naam is vereist",
    "ConfigurationNewFormName.label": "Naam",
    "ConfigurationNewFormName.placeholder": "Naam",
    "ConfigurationNewFormPricingsAccessories.error": "Tijdsperiode is vereist.",
    "ConfigurationNewFormPricingsAccessories.label": "Periode toebehoren",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Maak een keuze...",
    "ConfigurationNewFormPricingsWashbasin.error": "Tijdsperiode is vereist.",
    "ConfigurationNewFormPricingsWashbasin.label": "Periode wastafel",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Maak een keuze...",
    "checkoutParts.timePeriodNote": "Opmerking:",
    "checkoutParts.timePeriodNoteText": "Kies de periode voor de geldigheid van de prijzen",
    "checkoutParts.timePeriodAccessoriesLabel": "Periode toebehoren",
    "checkoutParts.timePeriodWashbasinLabel": "Periode wastafel",
    "checkoutSave.orderIsQueued": "De order kon niet naar het SAP-systeem worden verzonden. Het is in de wachtrij geplaatst voor verzending op een later tijdstip.",
    "ListItemDetail.failed": "Mislukt",
    "ListItemDetail.queued": "In de wachtrij",
    "TroughFilterMedcare.error": "MEDCARE is vereist.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "verkrijgbaar vanaf augustus 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/nl_NL/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(aangemaakt)",
    "Login.mustLogin": "Om een configuratie te starten, moet je inloggen. Als je nog geen account hebt, maak dan een nieuw account aan.",
    "Troughs.toStart": "Om een configuratie te starten, moet je {aanmelden}. Als je nog geen account hebt, {create}.",
    "TroughFilter.modelLine": "Regel",
    "TroughFilter.characteristics": "Lijneigenschappen",
    "TroughListItem.min": "min. Wastafel",
    "TroughListItem.start": "Configuratie starten",
    "TroughListItem.startWithLogin": "Start configuratie na inloggen",
    "TroughBanner.label": "Welke waskommen zijn beschikbaar?",
    "TroughBanner.text": "Kijk vooraf.",
    "SearchPlaceholder.placeholderTroughs": "Een waskom zoeken",
    "Troughs.toStartLogin": "Inloggen",
    "Troughs.toStartCreate": "nieuw account aanmaken",
    "ConfigurationDownload3D.text": "3D scène downloaden",
    "ConfigurationNewFolder.newHeading": "Nieuwe map",
    "NewButtonsNewFolder.text": "Nieuwe map",
    "NewButtonsNewConfiguration.text": "Configuratie maken",
    "FolderListHeading.text": "Map",
    "FolderListNone.text": "Nog geen mappen beschikbaar",
    "ConfigurationListHeading.text": "Niet-toegewezen configuraties",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "Alle mappen weergeven",
    "ListItem.moveToGroup": "Verplaatsen naar map of bouwfase",
    "ListItem.goBack": "Terug",
    "FolderSwitchView.goBack": "Terug",
    "ListItem.downloadPdfs": "PDF's downloaden",
    "ConfigurationDeleteFolder.cancel": "Annuleren",
    "ConfigurationEditFolder.cancel": "Annuleren",
    "ConfigurationNewFolder.cancel": "Annuleren",
    "ConfigurationNewFolder.create": "Maak",
    "ConnectedFolder.label": "Ja, ik wil een nieuwe map aanmaken met de objectnaam in mijn dashboard.",
    "FolderListHeadingAll.text": "Alle mappen",
    "FolderListToday.text": "Vandaag",
    "FolderList7Days.text": "Vorige 7 dagen",
    "FolderList30Days.text": "Vorige 30 dagen",
    "FolderListItemNestedDelete.text": "Etappe verwijderen",
    "ConfigurationDeleteNestedFolder.heading": "Etappe verwijderen",
    "ConfigurationNewFolderNested.newHeading": "Nieuwe etappe",
    "ListItem.moveToThisGroup": "Verplaatsen naar map",
    "ConfigurationDeleteFolder.note": "Opmerking:",
    "ConfigurationDeleteNestedFolder.body": "Als je dit stadium verwijdert, blijven de configuraties die het bevat behouden, ze worden gewoon verplaatst naar de mapopslag.",
    "ConfigurationDeleteFolder.body": "Als je dit stadium verwijdert, blijven de configuraties die het bevat behouden, ze worden gewoon verplaatst naar de mapopslag.",
    "FolderListNestedHeading.test": "Bouwfasen",
    "BuildingNumber.error": "Building number is vereist.",
    "OpportunityNumber.error": "Opportunity number is vereist.",
    "FolderListItemDelete.text": "Map verwijderen",
    "ConfigurationDeleteFolder.heading": "Map verwijderen",
    "ConfigurationDeleteFolder.confirm": "Bevestig",
    "ConfigurationEditFolder.heading": "Map bewerken",
    "ConfigurationEditFolderNested.heading": "Bewerk bouwfase",
    "ConfigurationEditFolder.confirm": "Bevestig",
    "ConfigurationListNone.text": "Nog geen configuraties beschikbaar",
    "ListItemDetail.basin": "Wastafel",
    "ListItemDetail.number": "Troggen",
    "ListItem.moveToDashboard": "Verplaatsen naar Dashboard",
    "FolderList.SortByDate": "Sorteren op datum",
    "FolderList.SortByName": "Sorteren op naam",
    "FolderName.name": "Mapnaam",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  },
  "pl": {
    "localsAD.label": "Andorra",
    "localsAE.label": "United Arab Emirates",
    "localsAF.label": "Afghanistan",
    "localsAG.label": "Antigua y Barbuda | Antigua & Barbuda",
    "localsAI.label": "Anguilla",
    "localsAL.label": "Albania",
    "localsAM.label": "Հայաստան",
    "localsAN.label": "Dutch Antilles",
    "localsAO.label": "Angola",
    "localsAQ.label": "Antarctica",
    "localsAR.label": "Argentina",
    "localsAS.label": "American Samoa",
    "localsAT.label": "Österreich",
    "localsAU.label": "Australia",
    "localsAW.label": "Aruba",
    "localsAZ.label": "Azərbaycan",
    "localsBA.label": "Bosnia & Herzegovina | Bosna i Hercegovina",
    "localsBB.label": "Barbados",
    "localsBD.label": "Bangladesh",
    "localsBE.label": "Belgium | Belgique | België",
    "localsBF.label": "Burkina Faso",
    "localsBG.label": "България",
    "localsBH.label": "Bahrain",
    "localsBI.label": "Burundi",
    "localsBJ.label": "Benin",
    "localsBM.label": "Bermuda",
    "localsBN.label": "Brunei Daruss.",
    "localsBO.label": "Bolivia",
    "localsBR.label": "Brasil",
    "localsBS.label": "Bahamas",
    "localsBT.label": "Bhutan",
    "localsBV.label": "Bouvet Islands",
    "localsBW.label": "Botswana",
    "localsBY.label": "Belarus",
    "localsBZ.label": "Belice | Belize",
    "localsCA.label": "Canada",
    "localsCC.label": "Coconut Islands",
    "localsCD.label": "Congo-Kinshasa",
    "localsCF.label": "CAR",
    "localsCG.label": "Congo-Brazzaville",
    "localsCH.label": "Switzerland | Schweiz | Suisse | Svizzera",
    "localsCI.label": "Côte d’Ivoire",
    "localsCK.label": "Cook Islands",
    "localsCL.label": "Chile",
    "localsCM.label": "Cameroun",
    "localsCN.label": "China | 中国",
    "localsCO.label": "Colombia",
    "localsCR.label": "Costa Rica",
    "localsCS.label": "Montenegro",
    "localsCU.label": "Cuba",
    "localsCV.label": "Cape Verde",
    "localsCX.label": "Christmas Island",
    "localsCY.label": "Cyprus",
    "localsCZ.label": "Česká republika",
    "localsDE.label": "Deutschland",
    "localsDJ.label": "Djibouti",
    "localsDK.label": "Danmark",
    "localsDM.label": "Dominica",
    "localsDO.label": "Dominican Republic | República Dominicana",
    "localsDZ.label": "Algérie",
    "localsEC.label": "Ecuador",
    "localsEE.label": "Eesti",
    "localsEG.label": "Egypt | مصر",
    "localsEH.label": "West Sahara",
    "localsER.label": "Eritrea",
    "localsES.label": "España",
    "localsET.label": "Ethiopia",
    "localsFI.label": "Suomi",
    "localsFJ.label": "Fiji",
    "localsFK.label": "Falkland Islnds",
    "localsFM.label": "Micronesia",
    "localsFO.label": "Færøerne",
    "localsFR.label": "France",
    "localsFX.label": "France",
    "localsGA.label": "Gabon",
    "localsGB.label": "United Kingdom",
    "localsGD.label": "Grenada | Granada",
    "localsGE.label": "Georgia | საქართველო",
    "localsGF.label": "French Guayana",
    "localsGH.label": "Ghana",
    "localsGI.label": "Gibraltar",
    "localsGL.label": "Greenland | Kalaallit Nunaat",
    "localsGM.label": "Gambia",
    "localsGN.label": "Guinea",
    "localsGP.label": "Guadeloupe",
    "localsGQ.label": "Equatorial Guinea",
    "localsGR.label": "Greece | Ελλάδα",
    "localsGS.label": "S. Sandwich Ins",
    "localsGT.label": "Guatemala",
    "localsGU.label": "Guam",
    "localsGW.label": "Guinea-Bissau",
    "localsGY.label": "Guyana",
    "localsHK.label": "Hong Kong SAR China",
    "localsHM.label": "Heard/McDon.Isl",
    "localsHN.label": "Honduras",
    "localsHR.label": "Croatia",
    "localsHT.label": "Haiti | Haïti | Haití",
    "localsHU.label": "Magyarország",
    "localsID.label": "Indonesia",
    "localsIE.label": "Ireland",
    "localsIL.label": "Israel",
    "localsIN.label": "India | भारत",
    "localsIO.label": "British Indian Ocean Territory",
    "localsIQ.label": "Iraq",
    "localsIR.label": "Iran | ایران",
    "localsIS.label": "Iceland | Ísland",
    "localsIT.label": "Italia",
    "localsJM.label": "Jamaica",
    "localsJO.label": "Jordan",
    "localsJP.label": "Japan | 日本",
    "localsKE.label": "Kenya",
    "localsKG.label": "Киргизия",
    "localsKH.label": "Cambodia",
    "localsKI.label": "Kiribati",
    "localsKM.label": "Comoros",
    "localsKN.label": "St. Kitts & Nevis | San Cristóbal y Nieves",
    "localsKP.label": "North Korea",
    "localsKR.label": "South Korea | 대한민국",
    "localsKW.label": "Kuwait",
    "localsKY.label": "Cayman Islands",
    "localsKZ.label": "Kazakhstan | Қазақстан | Казахстан",
    "localsLA.label": "Laos",
    "localsLB.label": "Lebanon",
    "localsLC.label": "St. Lucia | Santa Lucía",
    "localsLI.label": "Liechtenstein",
    "localsLK.label": "Sri Lanka",
    "localsLR.label": "Liberia",
    "localsLS.label": "Lesotho",
    "localsLT.label": "Lietuva",
    "localsLU.label": "Luxemburg",
    "localsLV.label": "Latvija",
    "localsLY.label": "ليبيا",
    "localsMA.label": "Maroc",
    "localsMC.label": "Monaco",
    "localsMD.label": "Moldova",
    "localsME.label": "Serbia/Monten.",
    "localsMF.label": "Reunion",
    "localsMG.label": "Madagascar",
    "localsMH.label": "Marshall Islands",
    "localsMK.label": "Macedonia",
    "localsML.label": "Mali",
    "localsMM.label": "Myanmar (Burma)",
    "localsMN.label": "Mongolia | Монгол",
    "localsMO.label": "Macau",
    "localsMP.label": "N.Mariana Islnd",
    "localsMQ.label": "Martinique",
    "localsMR.label": "Mauretania",
    "localsMS.label": "Montserrat",
    "localsMT.label": "Malta",
    "localsMU.label": "Mauritius",
    "localsMV.label": "Maldives",
    "localsMW.label": "Malawi",
    "localsMX.label": "México",
    "localsMY.label": "Malaysia",
    "localsMZ.label": "Mozambique",
    "localsNA.label": "Namibia",
    "localsNC.label": "New Caledonia",
    "localsNE.label": "Niger",
    "localsNF.label": "Norfolk Island",
    "localsNG.label": "Nigeria",
    "localsNI.label": "Nicaragua",
    "localsNL.label": "Nederland",
    "localsNO.label": "Noreg",
    "localsNP.label": "Nepal",
    "localsNR.label": "Nauru",
    "localsNU.label": "Niue",
    "localsNZ.label": "New Zealand",
    "localsOM.label": "Oman",
    "localsPA.label": "Panama | Panamá",
    "localsPE.label": "Peru",
    "localsPF.label": "French Polynesia",
    "localsPG.label": "Papua New Guinea",
    "localsPH.label": "Philippines",
    "localsPK.label": "Pakistan",
    "localsPL.label": "Polska",
    "localsPM.label": "St.Pier,Miquel.",
    "localsPN.label": "Pitcairn Islands",
    "localsPR.label": "Puerto Rico",
    "localsPS.label": "Palestinian Territories",
    "localsPT.label": "Portugal",
    "localsPW.label": "Palau",
    "localsPY.label": "Paraguay",
    "localsQA.label": "Qatar",
    "localsRE.label": "Reunion",
    "localsRO.label": "România",
    "localsRS.label": "Serbia | Србија | Serbien",
    "localsRU.label": "Russia | Россия",
    "localsRW.label": "Rwanda",
    "localsSA.label": "Saudi Arabia",
    "localsSB.label": "Solomon Islands",
    "localsSC.label": "Seychelles",
    "localsSD.label": "Sudan | السودان",
    "localsSE.label": "Sverige",
    "localsSG.label": "Singapore",
    "localsSH.label": "St. Helena",
    "localsSI.label": "Slovenia | Slovenija",
    "localsSJ.label": "Svalbard",
    "localsSK.label": "Slovensko",
    "localsSL.label": "Sierra Leone",
    "localsSM.label": "San Marino",
    "localsSN.label": "Sénégal",
    "localsSO.label": "Somalia",
    "localsSR.label": "Suriname | Surinam",
    "localsST.label": "São Tomé e Príncipe",
    "localsSV.label": "El Salvador",
    "localsSY.label": "Syria",
    "localsSZ.label": "Swaziland",
    "localsTC.label": "Turks & Caicos Islands",
    "localsTD.label": "Chad",
    "localsTF.label": "French S.Territ",
    "localsTG.label": "Togo",
    "localsTH.label": "Thailand | ไทย",
    "localsTJ.label": "Tajikistan",
    "localsTK.label": "Tokelau Islands",
    "localsTL.label": "Timor-Leste",
    "localsTM.label": "Туркменистан",
    "localsTN.label": "Tunisie",
    "localsTO.label": "Tonga",
    "localsTP.label": "East Timor",
    "localsTR.label": "Türkiye",
    "localsTT.label": "Trinidad & Tobago | Trinidad y Tobago",
    "localsTV.label": "Tuvalu",
    "localsTW.label": "Taiwan | 台湾",
    "localsTZ.label": "Tanzania",
    "localsUA.label": "Україна",
    "localsUG.label": "Uganda",
    "localsUK.label": "United Kingdom",
    "localsUM.label": "Minor Outl.Isl.",
    "localsUS.label": "USA",
    "localsUY.label": "Uruguay",
    "localsUZ.label": "Uzbekistan | Узбекистан | Oʻzbekiston",
    "localsVA.label": "Vatican City",
    "localsVC.label": "St. Vincent",
    "localsVE.label": "Venezuela",
    "localsVG.label": "Brit.Virgin Is.",
    "localsVI.label": "Amer.Virgin Is.",
    "localsVN.label": "Vietnam | Việt Nam",
    "localsVU.label": "Vanuatu",
    "localsWF.label": "Wallis,Futuna",
    "localsWS.label": "Samoa",
    "localsYE.label": "Yemen",
    "localsYT.label": "Mayotte",
    "localsZA.label": "South Africa",
    "localsZM.label": "Zambia",
    "localsZW.label": "Zimbabwe",
    "NavigationUser.configurationName": "Przegląd konfiguracji",
    "NavigationUser.accountName": "Logowanie i bezpieczeństwo",
    "NavigationUser.adressesName": "Adresy dostawy i adresy rozliczeniowe",
    "CheckoutHeadline.checkout": "Przegląd",
    "CheckoutBackButton.checkout": "Powrót do konfiguracji",
    "CheckoutConfigurationHeadline.checkout": "Konfiguracja umywalki",
    "CheckoutPartsHeadline.checkout": "Akcesoria",
    "CheckoutPartsHeadlineLink.checkout": "Przegląd konfiguracji",
    "Delete.headline": "Czy na pewno chcą Państwo usunąć tę konfigurację?",
    "Delete.button": "Akceptuj",
    "Assemblies.note": "Wskazówka:",
    "Assemblies.message.with": "Wszystkie akcesoria montażowe są przeznaczone wyłącznie do ścian pełnych.",
    "Assemblies.message.without": "Mocowanie przez inwestora.",
    "Assemblies.message.alwaysTriggerSafety": "Zabezpieczenie spustu jest zawsze dostępne w zestawie.",
    "ConfigurationDetail.ApronBacksplash.assemblyTitle": "Akcesoria montażowe",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnSelection": "Wybór",
    "ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories": "Akcesoria montażowe",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions": "Wymiary umywalki",
    "ConfigurationDetail.WashBasinDimension.typeOfInstallation": "Rodzaj montażu",
    "ConfigurationDetail.WashBasinDimension.angleOfNiche": "Kąt wnęki",
    "ConfigurationDetail.WashBasinDimension.cornerDesign": "Wykończenie narożnika",
    "ConfigurationDetail.WashBasinDimension.plateDimensions": "Wymiary płyty",
    "ConfigurationDetail.WashBasinDimension.distancesInMM": "Pozycja komór",
    "ConfigurationDetail.ApronBacksplash.apron": "Fartuch",
    "ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash": "Krawędź przyścienna / ścianka przeciwbryzgowa",
    "ConfigurationDetail.Recesses.tapHole": "Otwór na baterię",
    "ConfigurationDetail.Recesses.soapDispenserHole": "Otwór na dozownik do mydła",
    "ConfigurationDetail.Recesses.paperTowelDispenserHole": "otwór do wyrzucania odpadów",
    "ConfigurationDetail.Recesses.cosmeticTissueDispenser": "podajnik ręczników papierowych",
    "ConfigurationDetail.Recesses.towelRail": "Wieszak na ręczniki",
    "ConfigurationDetail.plateSurface.colour": "Kolor",
    "ConfigurationDetail.plateSurface.colorBottomSide": "Spód",
    "ConfigurationDetail.ApronBacksplash.apronTitle": "Fartuch / ścianka przeciwbryzgowa",
    "ConfigurationDetail.Drain.drainTitle": "Akcesoria do odpływu",
    "ConfigurationDetail.Drain.drainBtnDrainAccessories": "Akcesoria do odpływu",
    "ConfigurationDetail.Drain.drainBtnCompleteConfiguration": "Zakończ konfigurację",
    "ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle": "Wgłębienia / elementy wbudowane",
    "ConfigurationDetail.colour.colourTitle": "Kolor",
    "ConfigurationDetail.troughs.troughsTitle": "Komory",
    "ConfigurationProject.headline": "Którego obiektu dotyczy Państwa konfiguracja?",
    "ConfigurationProject.tabexisting": "Wybierz istniejący obiekt",
    "ConfigurationProject.tabnew": "Utwórz nowy obiekt",
    "ConfigurationProject.tabEXISTING": "Istnieje",
    "ConfigurationProject.tabNEW": "Nowy",
    "ConfigurationProject.tabWITHOUT": "brak",
    "ConfigurationDuplicate.headline": "Czy chcą Państwo zduplikować tę konfigurację?",
    "ConfigurationDuplicate.button": "Duplikuj",
    "ConfigurationNew.headline": "Proszę wprowadzić szczegóły konfiguracji:",
    "ConfigurationRename.headline": "Jak chcą Państwo nazwać swoją konfigurację?",
    "ChangePasswordPage.changePasswordHeading": "Proszę ustawić nowe hasło",
    "ChangePasswordPage.changePasswordText": "Hasło musi spełniać co najmniej 2 z 3 poniższych warunków: litery (np. ABCD...) - cyfry (np. 0123...) - znaki specjalne (np. #$%...)",
    "ChangePasswordSucceededPageComponent.passwordChangedHeading": "Państwa hasło zostało pomyślnie zmienione.",
    "ChangePasswordSucceededPageComponent.passwordChangedText": "Proszę wrócić do logowania i wprowadzić nowe hasło.",
    "ChangePasswordSucceededPageComponent.passwordChangedButton": "Powrót do logowania",
    "HomeLink.imprint": "Impressum",
    "HomeLink.legals": "Ogólne warunki handlowe",
    "HomeLink.privacy": "Polityka prywatności i stosowania plików cookie",
    "Login.newUser": "Utwórz nowe konto",
    "Login.forgotPassword": "Nie pamiętasz hasła?",
    "Login.Label.Email": "E-mail",
    "Login.Placeholder.Email": "E-mail",
    "Login.Error.Email": "E-mail jest polem wymaganym.",
    "Login.Label.Password": "Hasło",
    "Login.Placeholder.Password": "Hasło",
    "Login.Error.Password": "Hasło jest polem wymaganym.",
    "ResetPassword.button": "Powrót do logowania",
    "ResetPasswordSucceededPageComponent.resetPassword": "Państwa hasło zostało pomyślnie zmienione.",
    "ResetPasswordSucceededPageComponent.resetPasswordSucceeded": "Proszę sprawdzić swój adres e-mail i kliknąć link potwierdzający.",
    "ResetPasswordSucceededPageComponent.button": "Logowanie",
    "ChangePwOld.label": "Stare hasło",
    "ChangePwOld.placeholder": "Stare hasło",
    "ChangePwOld.error": "Hasło musi spełniać co najmniej 2 z 3 poniższych warunków: litery (np. ABCD...) - cyfry (np. 0123...) - znaki specjalne (np. #$%...)",
    "ChangePwNew.label": "Nowe hasło",
    "ChangePwNew.error": "Hasło musi spełniać co najmniej 2 z 3 poniższych warunków: litery (np. ABCD...) - cyfry (np. 0123...) - znaki specjalne (np. #$%...)",
    "ChangePwNew.placeholder": "Nowe hasło",
    "ChangePwNewRepeat.label": "Proszę wprowadzić hasło ponownie",
    "ChangePwNewRepeat.error": "Hasła nie są zgodne.",
    "ChangePwNewRepeat.placeholder": "Proszę wprowadzić hasło ponownie",
    "PageNotFound.message": "Wystąpił błąd. Wyszukiwana przez Państwa strona nie istnieje.",
    "AccountProfile.name": "Nazwa",
    "AccountProfile.telephone": "Numer telefonu",
    "AccountProfile.street": "Ulica",
    "AccountProfile.zip": "Kod pocztowy",
    "AccountProfile.surname": "Nazwisko",
    "AccountProfile.mobile": "Numer tel. kom.",
    "AccountProfile.city": "Miasto",
    "AccountProfile.country": "Kraj",
    "AccountProfile.userbutton": "Edytuj formularz",
    "AccountProfile.email": "Adres e-mail",
    "AccountProfile.password": "Hasło",
    "AccountProfile.loginbutton": "Edytuj formularz",
    "AccountProfile.headline": "Logowanie i bezpieczeństwo",
    "projectsNewHeadline.headline": "Utwórz nowy projekt",
    "projectsOverviewHeadline.headline": "Adresy dostawy i adresy rozliczeniowe",
    "ProjectsDelete.headline": "Czy na pewno chcą Państwo usunąć ten projekt?",
    "ProjectsDelete.button": "Akceptuj",
    "ProjectsEdit.headline": "Edytuj projekt:",
    "ProjectsNew.headline": "Proszę podać nazwę swojego obiektu:",
    "RegisterPage.registerText": "Proszę wprowadzić prawidłowy adres e-mail i hasło do swojego konta.",
    "RegisterPage.registerButton": "Powrót do logowania",
    "RegisterMail.error": "E-mail jest polem wymaganym.",
    "RegisterMail.name": "E-mail",
    "RegisterPw.error": "Hasło musi spełniać co najmniej 2 z 3 poniższych warunków: litery (np. ABCD...) - cyfry (np. 0123...) - znaki specjalne (np. #$%...)",
    "RegisterPw.name": "Hasło",
    "RegisterPwRepeat.error": "Hasła nie są zgodne.",
    "RegisterPwRepeat.name": "Proszę wprowadzić hasło ponownie",
    "RegisterUserGender.error": "Zwrot grzecznościowy jest polem obowiązkowym",
    "RegisterUserGender.label": "Zwrot grzecznościowy",
    "RegisterUserGender.mr": "Pan",
    "RegisterUserGender.mrs": "Pani",
    "registerUserFirstName.error": "Imię jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "registerUserFirstName.label": "Imię",
    "registerUserLastName.error": "Nazwisko jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "registerUserLastName.label": "Nazwisko",
    "registerUserPhone.label": "Telefon",
    "registerUserMobile.label": "Tel. kom.",
    "registerUserCompany.label": "Przedsiębiorstwo",
    "registerUserStreet.error": "Ulica jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "registerUserStreet.label": "Ulica",
    "registerUserHouse.error": "Numer domu jest polem obowiązkowym i musi zawierać co najmniej 1 znak.",
    "registerUserHouse.label": "Numer domu",
    "registerUserZip.error": "Kod pocztowy jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "registerUserZip.label": "Kod pocztowy",
    "registerUserCity.error": "Miasto jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "registerUserCity.label": "Miasto",
    "registerUserAddressAdditional.label": "Uzupełnienie adresu",
    "registerUserCountry.error": "Kraj jest polem obowiązkowym.",
    "registerUserCountry.label": "Kraj",
    "registerUserCountryLabel.label": "Wybierz kraj",
    "registerUserClientNr.label": "Numer klienta (jeśli istnieje)",
    "registerUserBranch.error": "Branża jest polem obowiązkowym",
    "registerUserBranch.label": "Branża",
    "registerUserBranchSanitary.label": "sprzedaż hurtowa artykułów sanitarnych",
    "registerUserBranchPlanner.label": "projektant / architekt",
    "registerUserBranchPlumber.label": "monter",
    "registerUserBranchRetail.label": "klient końcowy",
    "editUserGender.error": "Zwrot grzecznościowy jest polem obowiązkowym",
    "editUserGender.label": "Zwrot grzecznościowy",
    "editUserGenderMr.label": "Pan",
    "editUserGenderMrs.label": "Pani",
    "editUserFirstName.error": "Imię jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "editUserFirstName.label": "Imię",
    "editUserLastName.error": "Nazwisko jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "editUserLastName.label": "Nazwisko",
    "editUserPhone.label": "Telefon",
    "editUserMobile.label": "Tel. kom.",
    "editUserStreet.error": "Ulica jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "editUserStreet.label": "Ulica",
    "editUserHouse.error": "Numer domu jest polem obowiązkowym i musi zawierać co najmniej 1 znak.",
    "editUserHouse.label": "Numer domu",
    "editUserAddressAdditional.label": "Uzupełnienie adresu",
    "editUserZip.error": "Kod pocztowy jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "editUserZip.label": "Kod pocztowy",
    "editUserCity.error": "Miasto jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "editUserCity.label": "Miasto",
    "editUserCountry.error": "Kraj jest polem obowiązkowym.",
    "editUserCountry.label": "Kraj",
    "editUserCountryLabel.label": "Wybierz kraj",
    "RegisterSucceededComponent.registerSucceededHeading": "Dziękujemy. Rejestracja jest już prawie zakończona.",
    "RegisterSucceededComponent.registerSucceededText": "Za kilka chwil otrzymają Państwo od nas wiadomość e-mail zawierającą link. Po potwierdzeniu adresu e-mail poprzez kliknięcie tego linku mogą się Państwo zalogować.",
    "RegisterSucceededComponent.registerSucceededButton": "Powrót do logowania",
    "ThankYou.headline": "Dziękujemy za dokonanie konfiguracji!",
    "ThankYou.message": "Wysłaliśmy wiadomość e-mail z potwierdzeniem i wszystkimi szczegółami oferty.",
    "ThankYou.order": "Twój numer oferty",
    "ThankYou.pdfbutton": "Eksportuj jako PDF 2D",
    "ThankYou.tenderdocuments": "Tekst dokumentów przetargowych",
    "ThankYou.overviewbutton": "Do przeglądu konfiguracji",
    "Configuration3dAlert.attention": "Jak zacząć?",
    "Configuration3dAlert.message": "Proszę wybrać żądaną komorę, klikając przycisk (Wybierz komorę) i rozpocząć konfigurację. Życzymy przyjemnej konfiguracji!",
    "ActivationSucceeded.activationSucceededText": "Gratulacje, Państwa konto zostało utworzone pomyślnie. Proszę wrócić do logowania i wprowadzić swoje dane użytkownika.",
    "ActivationSucceeded.activationSucceededButton": "Zaczynamy",
    "ActivationFailed.activaionUserNotFound": "Ten użytkownik nie istnieje. Utwórz nowe konto.",
    "ActivationFailed.activaionUserNotFoundButton": "Zarejestruj",
    "ChangeEmailForm.button": "Zmień adres e-mail",
    "ChangePassword.button": "Zmień hasło",
    "LoginForm.button": "Logowanie",
    "Logout.button": "Wyloguj",
    "RegisterUserDataForm.headline": "Wprowadź tutaj swoje dane osobowe.",
    "RegisterUserDataForm.button": "Utwórz nowe konto",
    "RegisterUserDataForm.logout": "Powrót do logowania",
    "RegisterUserForm.button": "Utwórz nowe konto",
    "ResetPasswordForm.button": "Zresetuj hasło",
    "ResetPasswordChangeForm.button": "Zresetuj hasło",
    "Checkout.WashBasinDimensions": "Wymiary umywalki",
    "Checkout.PlateDimensions.Width": "Szerokość",
    "Checkout.PlateDimensions.Depth": "Głębokość",
    "Checkout.TypeOfInstallation": "Rodzaj montażu",
    "Checkout.TypeOfInstallation.Left": "Wnęka po lewej stronie",
    "Checkout.TypeOfInstallation.Right": "Wnęka po prawej stronie",
    "Checkout.TypeOfInstallation.With": "Wnęka po lewej i po prawej stronie",
    "Checkout.CornerDesign": "Wykończenie narożnika",
    "Checkout.CornerDesign.Radius": "Promień 100 mm",
    "Checkout.CornerDesign.Bevel": "Fazowanie, 100 mm",
    "Checkout.Left": "z lewej strony",
    "Checkout.Right": "z prawej strony",
    "Checkout.ApronBackSplash.Headline": "Fartuch / ścianka przeciwbryzgowa",
    "Checkout.ApronBackSplash.Apron": "Fartuch: {position} / {height} mm",
    "Checkout.ApronBackSplash.SurgeEdge": "Krawędź przyścienna: {position} - wysokość: 3 mm.",
    "Checkout.ApronBackSplash.apronBackSplash": "Ścianka przeciwbryzgowa: {position} - wysokość: {height} mm.",
    "Checkout.BuiltInParts.BuiltInPartsTitle": "Wgłębienia / elementy wbudowane",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps": "{qty}x otwory na baterię",
    "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap": "{qty}x otwór na dozownik do mydła",
    "Checkout.BuiltInParts.BuiltInPartsCutOut": "{qty}x wycięcie \\„{name}\\”",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser": "{qty}x wycięcie na podajnik chusteczek kosmetycznych",
    "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail": "{qty}x wycięcie na wieszak na ręczniki",
    "Checkout.Surface.Title": "Kolor",
    "Checkout.Surface.Color": "Kolor: {color}",
    "Checkout.Surface.GelCoat": "Spód z powłoką żelkotową",
    "Checkout.AssemblyAccessories.Title": "Akcesoria montażowe",
    "Checkout.AssemblyAccessories.Consoles": "{qty}x wspornik {part}",
    "Checkout.AssemblyAccessories.AngleBar": "{qty}x listwa kątowa do montażu na ścianie bocznej.",
    "Checkout.AssemblyAccessories.SafetyCatch": "{qty}x zabezpieczenie spustu do montażu na tylnej ściance",
    "Checkout.GeneralInfo.Headline": "Przegląd",
    "Checkout.GeneralInfo.ConfName": "Nazwa konfiguracji:",
    "Checkout.TotalPrice.Washbasin": "Umywalka",
    "Checkout.TotalPrice.Parts": "Akcesoria",
    "Checkout.TotalPrice.DeliveryCosts": "Koszty transportu",
    "Checkout.TotalPrice.Vat": "Podatek VAT",
    "Checkout.TotalPrice.Total": "Łączna suma",
    "Checkout.TotalPrice.Note": "Wskazówka:",
    "Checkout.TotalPrice.NoteText": "Ceny obowiązują do ",
    "Checkout.Trough.Headline": "Komora",
    "Checkout.Trough.Name": "Nazwa komory:",
    "Checkout.Trough.Qty": "Liczba",
    "Checkout.Trough.Dimensions": "Wymiary komory",
    "checkoutPartsPdfButton.button": "Pobierz PDF",
    "Apron.height": "Wysokość fartucha w mm",
    "ApronHeightRequiredHint.hint": "Wskazówka:",
    "ApronHeightRequiredMessage.message": "Aby wybrać dozownik chusteczek kosmetycznych, potrzebny będzie fartuch {requiredHeight} mm. Czy chcesz kontynuować?",
    "ApronHeightError.message": "Wartość wykracza poza wymiary",
    "SurgeEdgeLabelWithout.without": "brak",
    "SurgeEdgeLabelWith.with": "z krawędzią przyścienną (3 mm)",
    "SurgeEdgeLabelWithBackSplash.withbacksplash": "ze ścianką przeciwbryzgową",
    "SurgeEdgeLabelWithBackSplashBack.withbacksplashback": "z tyłu (standard)",
    "SurgeEdgeLabelWithBackSplashBackHeight.withbacksplashbackheight": "Wysokość ścianki przeciwbryzgowej w mm",
    "WithoutAssemblyAccessories.without": "bez akcesoriów montażowych",
    "WithAssemblyAccessories.with": "z akcesoriami montażowymi",
    "WithAssemblyAccessoriesTooltipHint.hint": "Wskazówka:",
    "WithAssemblyAccessoriesTooltipMessage.message": "Mocowanie przez klienta.",
    "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel": "stal chromowo-niklowa",
    "AssemblyAccessoriesLabelMiranit.miranit": "Miranit",
    "AssemblyAccessoriesListConsole.console": "Wspornik",
    "AssemblyAccessoriesListTriggerProtection.triggerprotection": "Zabezpieczenie spustu",
    "AssemblyAccessoriesListAngleBar.anglebar": "Listwa kątowa",
    "AssemblyAccessoriesListFixingMaterial.fixingmaterial": "Zestaw montażowy",
    "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite": "Stal chromowo-niklowa biała",
    "CornerDesignLabelWithout.without": "Bez wykończenia narożnika",
    "CornerDesignLabelRadius.radius": "Promień (100 mm)",
    "CornerDesignLabelBevel.bevel": "Fazowanie (długość boku 100 mm)",
    "DistancesPositionOfTroughs.distances": "Wprowadzanie odległości od środka komory",
    "DistancesPositionOfTroughsHint.hint": "Wskazówka:",
    "DistancesPositionOfTroughsMessage.message": "Korzyści i zalecenia dotyczące stosowania",
    "DistancesPositionOfTroughsFromPlate.plate": "Od płyty do tylnej krawędzi komory",
    "PlateDimensionsWidth.width": "Szerokość płyty",
    "PlateDimensionsDepth.depth": "Głębokość płyty",
    "PlateDimensionsDepth.depthIndividual": "Indywidualnie",
    "Configuration.Inputs.BasinDimenisons.PlateDimensions": "Wprowadzona wartość wykracza dopuszczalny zakres",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Left": "Lewa strona",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.Right": "Prawa strona",
    "Configuration.Inputs.BasinDimenisons.AngleOfNiche.NotSelectAble": "Jest to możliwe tylko w połączeniu z rodzajem instalacji „z, po lewej lub po prawej stronie”.",
    "Configuration.Inputs.BasinDimenisons.CornerDesign.NotSelectAble": "Jest to możliwe tylko w połączeniu z rodzajem instalacji „bez, lewy lub prawy”.",
    "Configuration.Inputs.message": "Wprowadzona wartość wykracza dopuszczalny zakres",
    "DrainLabelWithoutDrain.withoutdrain": "Bez akcesoriów do odpływu",
    "DrainLabelHoodDrain.hooddrain": "Zawór odpływowy",
    "DrainLabelHoodChromeDrain.hoodchromedrain": "Zawór odpływowy chromowany",
    "DrainLabelSieveDrain.sievedrain": "Zawór odpływowy z sitkiem",
    "DrainLabelEccentric.eccentric": "Mimośrodowy zestaw odpływowo-przelewowy",
    "DrainLabelSiphon.siphon": "Syfon XINX140",
    "CosmeticTissueDispenser.without": "bez podajnika ręczników papierowych",
    "CosmeticTissueDispenserSquare.square": "prostokątny (z żelkotem) 127 x 38 mm",
    "CosmeticTissueDispenserSquareModel.squaremodel": "(do podajnika ręczników papierowych „numer modelu”)",
    "CosmeticTissueDispenserPosition.position": "(pozycja między komorami)",
    "CutOutLabelCustomInput.diameter": "Średnica",
    "CutOutLabelCustomInput.width": "Szerokość",
    "CutOutLabelCustomInput.depth": "Głębokość",
    "CutOutLabelSelect.select": "Proszę wybrać",
    "CutOutDisposalsDefaultsWithout.without": "bez otworu do wyrzucania odpadów",
    "CutOutDisposalsDefaultsWith.with": "z otworem do wyrzucania odpadów",
    "SoapDispenserHoleLabelWithout.without": "brak",
    "SoapDispenserHoleLabelSD80.sd80": "na dozownik do mydła SD80",
    "SoapDispenserHoleLabelSD100.sd100": "na dozownik do mydła SD100",
    "SoapDispenserHoleLabel25.dispensers": "na dozowniki innych producentów (Ø 25 mm)",
    "TapHoleWithout.taphole": "bez otworu",
    "TapHoleWithoutDrilling.tapholedrilling": "z otworem",
    "TowelRailWithout.towelrailwithout": "bez wycięcia",
    "TowelRailWithout.towelrailwith": "z wycięciem",
    "ColorLabel.alpinewhite": "Biały alpejski (standard)",
    "ColorLabel.alpinewhitetext": "Odporność na temperaturę do 80°C",
    "ColorLabel.graniteblack": "Granit czarny",
    "ColorLabel.graniteblacktext": "Odporność na temperaturę do 65°C",
    "ColorLabel.graniteblackwhite": "Granit czarno-biały",
    "ColorLabel.graniteblackwhitetext": "Odporność na temperaturę do 65°C",
    "ColorLabel.graniteLightGray": "Granite light Gray",
    "ColorLabel.granitelightgraytext": "Odporność na temperaturę do 65°C",
    "ColorBottomSideUncoated.uncoated": "bez powłoki (standard)",
    "ColorBottomSideGelcoat.gelcoat": "Żelkot",
    "ColorBottomSideHint.hint": "Wskazówka:",
    "ColorBottomSideMessage.message": "Korzyści i zalecenia dotyczące stosowania",
    "ElementNext.button": "Dalej",
    "ElementsPositionsLeft.left": "z lewej strony",
    "ElementsPositionsBack.back": "z tyłu",
    "ElementsPositionsFront.front": "z przodu",
    "ElementsPositionsRight.right": "z prawej strony",
    "ElementsPositionsRight.warning": "Dezaktywowano, należy zwiększyć odległość między komorami.",
    "ConfigurationListAdd.text": "Dodaj nową konfigurację",
    "ListItem.rename": "Zmień nazwę",
    "ListItem.duplicate": "Duplikuj",
    "ListItem.delete": "Usuń",
    "ListItem.order": "Oferta",
    "ListItem.orderShow": "Do oferty",
    "ListItem.linkTitle": "Ustawienia",
    "ListItemDetail.price": "Łączna cena:",
    "ListItemDetail.offer": "Oferta",
    "ListItemDetail.order": "Zamówienie",
    "ListItemDetail.date": "Ostatnia modyfikacja",
    "ConfigurationNewForm.button": "Dalej",
    "Warning.RequireReset.Trough": "Ze względu na zmiany w konfiguracji, wszystkie wymienione pozycje muszą zostać zresetowane, jeśli wybiorą Państwo nową komorę i postanowią zwiększyć lub zmniejszyć ilość:",
    "Warning.RequireReset.Qty": "Ze względu na zmiany w konfiguracji, wszystkie wymienione pozycje muszą zostać zresetowane, jeśli postanowią Państwo zwiększyć lub zmniejszyć ilość:",
    "Warning.RequireReset.TypeOfInstallation": "Ze względu na zmiany w konfiguracji, wszystkie wymienione pozycje muszą zostać zresetowane, jeśli postanowią Państwo zmienić rodzaj instalacji:",
    "Warning.RequireReset.plateDepth": "Głębokość płyty",
    "Warning.RequireReset.PlateDepth": "Ze względu na zmiany w konfiguracji, wszystkie wymienione pozycje muszą zostać zresetowane, jeśli postanowią Państwo zmienić głębokość płyty:",
    "Warning.RequireReset.distances": "Odległości",
    "Warning.RequireReset.cornerDesign": "Wykończenie narożnika",
    "Warning.RequireReset": "Wymagany reset:",
    "Warning.RequireReset.Default": "Ze względu na zmiany w konfiguracji konieczne jest jej zresetowanie.",
    "Warning.RequireReset.ResetAll": "Zresetować wszystko?",
    "Warning.RequireReset.console": "Wsporniki",
    "Warning.RequireReset.drain": "Akcesoria do odpływu",
    "Warning.RequireReset.typeOfInstallation": "Rodzaj montażu",
    "Warning.RequireReset.paperTowelDispensers": "Wycięcie na podajnik ręczników",
    "Warning.RequireReset.plateWidth": "Szerokość płyty",
    "Warning.RequireReset.siphon": "Syfon",
    "Warning.RequireReset.soapDispenserHole": "Otwór na dozownik do mydła",
    "Warning.RequireReset.tapHole": "Otwór na baterię",
    "Warning.RequireReset.tissueDispenser": "Wycięcie na podajnik ręczników papierowych",
    "Warning.RequireReset.surgeEdgeOrBackSplash": "Krawędź przyścienna / ścianka przeciwbryzgowa",
    "ConfigurationDetail.error.default": "Wybrana wartość jest niedozwolona. Proszę sprawdzić wprowadzone dane.",
    "ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable": "Wybrana wartość jest niedozwolona, proszę sprawdzić podstronę koloru.",
    "LogoTitle.default": "Przegląd konfiguracji",
    "LogoTitle.fallback": "Konfigurator 3D KWC",
    "MetaNavigationImprint.imprint": "Impressum",
    "MetaNavigationLegals.legals": "Ogólne warunki handlowe",
    "MetaNavigationPrivacy.privacy": "Polityka prywatności i plików cookie",
    "NavigationTrough.name": "Komora",
    "NavigationTrough.title": "Komora",
    "NavigationBasin.name": "Wymiary umywalki",
    "NavigationBasin.title": "Wymiary umywalki",
    "NavigationApron.name": "Fartuch / ścianka przeciwbryzgowa",
    "NavigationApron.title": "Fartuch / ścianka przeciwbryzgowa",
    "NavigationRecesses.name": "Wgłębienia / elementy wbudowane",
    "NavigationRecesses.title": "Wgłębienia / elementy wbudowane",
    "NavigationColour.name": "Kolor",
    "NavigationColour.title": "Kolor",
    "NavigationAssembly.name": "Akcesoria montażowe",
    "NavigationAssembly.title": "Akcesoria montażowe",
    "NavigationDrain.name": "Akcesoria do odpływu",
    "NavigationDrain.title": "Akcesoria do odpływu",
    "ProjectsEditFormButton.button": "Zapisz projekt",
    "ProjectListItemEdit.edit": "Edytuj",
    "ProjectListItemDelete.delete": "Usuń",
    "ProjectListItemLinkTitle.title": "Ustawienia",
    "projectListHeadline.headline": "Adresy dostawy i adresy rozliczeniowe",
    "ProjectListAdd.addText": "Dodaj nowy adres",
    "ProjectNewFormButton.button": "Utwórz projekt",
    "ProjectName.error": "Nazwa jest polem wymaganym.",
    "ProjectName.name": "Nazwa obiektu:",
    "ProjectStreet.error": "Ulica jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "ProjectStreet.name": "Ulica",
    "ProjectStreetNr.error": "Numer domu jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "ProjectStreetNr.name": "Numer domu",
    "ProjectZip.error": "Kod pocztowy jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "ProjectZip.name": "Kod pocztowy",
    "ProjectCity.error": "Miasto jest polem obowiązkowym i musi zawierać co najmniej 2 znaki.",
    "ProjectCity.name": "Miasto",
    "ProjectCountry.error": "Kraj jest polem obowiązkowym.",
    "ProjectCountry.name": "Kraj",
    "ProjectCountry.label": "Wybierz kraj",
    "ProjectSelectExistingProject.text": "Wybierz istniejący obiekt",
    "ProjectSelectCreateProject.text": "Żaden obiekt nie jest jeszcze dostępny, utwórz obiekt",
    "ProjectSelectButton.button": "Dalej",
    "ProjectSelectWithout.without": "Chciałabym/-łbym kontynuować bez obiektu",
    "ProjectSelectButtonTitle.title": "Edytuj obiekt",
    "ProjectWithout.label": "Tak, chcę kontynuować bez obiektu",
    "ProjectWithout.button": "Dalej",
    "SelectedTroughListButton.button": "Dodano komorę",
    "SelectedTroughListItemWidth.width": "Szerokość",
    "SelectedTroughListItemWidth.minWidth": "Minimalna szerokość",
    "SelectedTroughListItemDepth.depth": "Głębokość",
    "SelectedTroughListItemDepth.minDepth": "Minimalna głębokość",
    "SelectedTroughListItemHeight.height": "Wysokość",
    "TroughDetailModalButton.button": "Rysunek techniczny",
    "TroughFilterButton.button": "Usuń zaznaczenie",
    "TroughFilterExos.error": "Wybrano EXOS.",
    "TroughFilterExos.label": "EXOS.",
    "TroughFilterVarius.error": "Wybrano VARIUSsign.",
    "TroughFilterVarius.label": "VARIUSsign",
    "TroughFilterVariusmed.error": "Wybrano VARIUSmed.",
    "TroughFilterVariusmed.label": "VARIUSmed",
    "TroughFilterSquare.error": "Wybrano wariant prostokątny.",
    "TroughFilterSquare.label": "Prostokątny",
    "TroughFilterOval.error": "Wybrano wariant owalny.",
    "TroughFilterOval.label": "Owalny",
    "TroughFilterRound.error": "Wybrano wariant okrągły.",
    "TroughFilterRound.label": "Okrągły",
    "TroughFilterWithOverflow.error": "Wybrano wariant z przelewem.",
    "TroughFilterWithOverflow.label": "Z przelewem",
    "TroughFilterWithoutOverflow.error": "Wybrano wariant bez przelewu.",
    "TroughFilterWithoutOverflow.label": "Bez przelewu",
    "TroughFilterWithBackwall.error": "Wybrano opcję z tylną ścianką komory.",
    "TroughFilterWithBackwall.label": "z tylną ścianą komory",
    "TroughFilterWithoutBackwall.error": "Wybrano opcję ze wspornikiem.",
    "TroughFilterWithoutBackwall.label": "ze wspornikami",
    "TroughListButtonSelect.select": "Wybierz komorę",
    "TroughListButtonClose.close": "Zamknij menu",
    "TroughListButtonFilterOptions.filter": "Pokaż opcje filtrowania",
    "TroughListSorryMsg.message": "Przykro nam, ale nie udało nam się znaleźć komory pasującej do wybranych opcji filtrowania.",
    "TroughListItemWidth.width": "Szerokość",
    "TroughListItemWidth.minWidth": "Minimalna szerokość",
    "TroughListItemDepth.depth": "Głębokość",
    "TroughListItemDepth.minDepth": "Minimalna głębokość",
    "TroughListItemHeight.height": "Wysokość",
    "TroughListMinValuesText.text": "min. szerokość x głębokość umywalki",
    "RegisterSucceededComponent.resendSucceededHeading": "Link aktywacyjny został pomyślnie wysłany ponownie",
    "ActivationFailed.activationInvalid": "Niestety aktywacja nie powiodła się!",
    "ActivationFailed.activationInvalidToken": "Ważność Państwa tokena wygasła. Proszę sprawdzić, czy konto jest aktywne i zalogować się ponownie.",
    "ActivationFailed.activationInvalidTokenButton": "Prześlij nowy link.",
    "ActivationFailed.ActivationResend": "Wyślij ponownie link aktywacyjny",
    "Configuration.Inputs.distancesInmm": "(odległości w mm)",
    "newEmail.text": "Nowy adres e-mail",
    "newEmail.error": "Wprowadzony adres e-mail jest nieprawidłowy.",
    "AccountProfile.button": "Zapisz",
    "ApronLabel.with": "z fartuchem",
    "ApronLabel.without": "bez fartucha (standard)",
    "SquareCustom.square": "prostokątny",
    "RoundCustom.round": "okrągły",
    "SearchPlaceholder.placeholder": "Wprowadź wyszukiwane hasło",
    "ColorCheckout.white": "Biały alpejski",
    "ColorCheckout.black": "Granit czarny",
    "ColorCheckout.blackWhite": "Granit czarno-biały",
    "ColorCheckout.lightGray": "Granit jasnoszary",
    "ConfigurationDetail.Drain.note": "Wskazówka:",
    "ConfigurationDetail.Drain.noteMessage": "Brak opcji dla wybranej komory",
    "ConfigurationDetail.Drain.noteVARIUSmedMZB": "Rurka przelewowa wchodzi w zakres dostawy VARIUSmed MZB.",
    "ConfigurationDetail.Drain.noteExos": "Zabezpieczenie spustu z powłoką InoxPlus wchodzi w zakres dostawy komór EXOS.",
    "ChangeEmailSucceededPageComponent.emailChangedHeading": "Adres e-mail został pomyślnie zmieniony",
    "ChangeEmailSucceededPageComponent.emailChangedText": "Wkrótce otrzymają Państwo link aktywacyjny w wiadomości e-mail. Aby aktywować konto, proszę kliknąć ten link.",
    "ChangeEmailSucceededPageComponent.emailChangedButton": "Powrót do logowania",
    "ResetPasswordChangeSucceededPageComponent.resetPassword": "Państwa hasło zostało pomyślnie zresetowane.",
    "ResetPasswordChangeSucceededPageComponent.resetPasswordSucceeded": "Proszę zalogować się przy użyciu nowego hasła.",
    "ResetPasswordChangeSucceededPageComponent.button": "Logowanie",
    "Warning.RequireReset.apron": "Fartuch",
    "submitAsOrder.label": "Zlecenie przeniesienia SAP",
    "ListItemDetail.draft": "Projekt",
    "TroughDetailModalWidth.minWidth": "Minimalna szerokość",
    "TroughDetailModalDepth.minDepth": "Minimalna głębokość",
    "TroughDetailModalWidth.width": "Szerokość",
    "TroughDetailModalDepth.depth": "Głębokość",
    "TroughDetailModalHeight.height": "Wysokość",
    "ConfigurationCountry.headline": "Którego kraju dotyczy Państwa konfiguracja?",
    "ConfigurationCountry.button": "Dalej",
    "ConfigurationCountry.select": "Proszę wybrać kraj",
    "SelectedTroughListItemHeight.minDimensions": "min. szerokość x głębokość umywalki",
    "TroughDetailModalDepth.minDimensions": "min. szerokość x głębokość umywalki",
    "TroughListItemDepth.minDimensions": "min. szerokość x głębokość umywalki",
    "CosmeticTissueDispenser.cosmeticTissue": "Podajnik chusteczek kosmetycznych",
    "PaperTowelDispenser.paperTowelDispenser": "Podajnik ręczników papierowych",
    "CutOutLabelNone.none": "Proszę wybrać rodzaj otworu do wyrzucania odpadów",
    "DistancesPosition.symmetrically": "identyczne powierzchnie do odkładania",
    "DistancesPosition.evenly": "identyczna szerokość stanowiska do mycia",
    "CutOutLabel.CustomRound": "okrągły otwór do wyrzucania odpadów",
    "CutOutLabel.CustomSquare": "prostokątny otwór do wyrzucania odpadów",
    "CutOutLabel.roundSleeve": "okrągły otwór do wyrzucania odpadów ze zsypem",
    "CutOutLabel.squareSleeve": "prostokątny otwór do wyrzucania odpadów ze zsypem",
    "CutOutLabel.roundBasket": "okrągły otwór do wyrzucania odpadów z koszem na odpady",
    "CutOutLabel.roundRail": "okrągły otwór do wyrzucania odpadów i kosz na odpady z wysuwaną ramą",
    "CutOutLabel.squareBasket": "prostokątny otwór do wyrzucania odpadów z koszem na odpady",
    "CutOutLabel.squareRail": "prostokątny otwór do wyrzucania odpadów i kosz na odpady z wysuwaną ramą",
    "CutOutLabel.roundSleeveBasket": "okrągły otwór do wyrzucania odpadów ze zsypem i koszem na odpady",
    "CutOutLabel.roundSleeveRail": "okrągły otwór do wyrzucania odpadów ze zsypem i koszem na odpady z wysuwaną ramą",
    "CutOutLabel.squareSleeveBasket": "prostokątny otwór do wyrzucania odpadów ze zsypem i koszem na odpady",
    "CutOutLabel.squareSleeveRail": "prostokątny otwór do wyrzucania odpadów ze zsypem i koszem na odpady z wysuwaną ramą",
    "CutOutLabel.flap": "klapa otworu do wyrzucania odpadów",
    "CutOutLabel.flapBasket": "klapa otworu do wyrzucania odpadów z koszem na odpady",
    "CutOutLabel.flapRail": "klapa otworu do wyrzucania odpadów i kosz na odpady z wysuwaną ramą",
    "CutOutLabel.provider": "podajnik ręczników papierowych",
    "ApronHeightRequiredChoiceMessage.message": "W celu uzyskania estetycznego wyglądu umywalki zalecamy wybór fartucha:",
    "apronHeightRequiredChoice60.60": "Zmień wysokość fartucha na 60 mm",
    "apronHeightRequiredChoice150.150": "Zmień wysokość fartucha na 150 mm",
    "apronHeightRequiredChoiceSkip.skip": "Zachowaj aktualną wysokość fartucha",
    "apronHeightRequiredChoiceNoSleeve.nosleeve": "Zachowaj aktualną wysokość fartucha i kontynuuj bez tulei",
    "CosmeticTissueDispenser.with": "z podajnikiem ręczników papierowych",
    "PlateDimensionsDepth.470": "zalecenia dotyczące armatury ściennej",
    "PlateDimensionsDepth.550": "zalecenia dotyczące armatury umywalkowej​",
    "Warning.RequireReset.cutOutDisposals": "otwór do wyrzucania odpadów",
    "checkboxPositions.noSpace": "Niewystarczająca ilość wolnego miejsca.",
    "localsIC1.label": "Intercompany FAR IC",
    "localsIC2.label": "Intercompany FAH IC",
    "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser": "{qty}x wycięcie na podajnik ręczników papierowych",
    "ApronAffects.position": "Uwaga: Szerokość fartucha 18 mm prowadzi do przesunięcia pozycji komory.",
    "DepthRequiredHint.hint": "Wskazówka:",
    "DepthRequiredMessage.message": "Wybrana głębokość umywalki jest niewystarczająca. Czy chcesz ustawić wymaganą głębokość {requiredDepth} mm dla tego otworu wrzutowego?",
    "ThankYou.orderPdf": "Konfiguracja umywalki (PDF)",
    "ThankYou.manufacturingPdf": "Rysunek umywalki (PDF)",
    "ThankYou.troughPdf": "Rysunek komory (PDF)",
    "PlateDimensionsRequired.hint": "Wskazówka:",
    "PlateDimensionsRequired.message": "Wskazówka: Szerokość umywalki nie jest wystarczająca. Aby zamontować fartuch, należy zwiększyć szerokość umywalki. Chcą Państwo kontynuować?",
    "UserList.deleteUser": "Width",
    "ApronForcedWidthIncrease.message": "Odznaczenie fartucha spowoduje przywrócenie oryginalnych wymiarów konfiguracji.",
    "PlateDimensionsChoice.message": "Na umywalce nie ma wystarczającej ilości miejsca na fartuch. Dostępne są następujące możliwości, aby kontynuować:",
    "PlateDimensionsChoice.increase": "Zmienić szerokość umywalki",
    "PlateDimensionsChoice.move": "Przesunąć komorę (komory) i zachować szerokość umywalki",
    "PlateDimensionsChoice.cancel": "Anulować (wymiary bez fartucha zostaną zachowane)",
    "ApronHeightAndDimensionsRequiredMessage.message": "Aby umieścić wieszak na ręczniki, potrzebny jest fartuch o szerokości 150 mm. Ponieważ szerokość umywalki nie jest wystarczająca do umieszczenia fartucha, należy zwiększyć szerokość umywalki. Czy chcesz kontynuować?",
    "Checkout.OrderPdf": "Konfiguracja umywalki (PDF)",
    "Checkout.ManufacturingPdf": "Rysunek umywalki (PDF)",
    "submitAsRequest.label": "Poproś o ofertę",
    "checkoutSave.label": "Zapisz",
    "submitAsOffer.label": "Oferta przeniesienia SAP",
    "ListItemDetail.request": "Zapytanie",
    "ListItem.orderPdf": "Konfiguracja umywalki (PDF)",
    "ListItem.manufacturingPdf": "Rysunek umywalki (PDF)",
    "ListItem.troughPdf": "Rysunek komory (PDF)",
    "PlateDimensionsRequiredLimit.message": "Osiągnięto maksymalną szerokość umywalki. Brak możliwości wyboru fartucha.",
    "PlateDimensionsChoiceLimit.message": "Na umywalce nie ma wystarczającej ilości miejsca na fartuch. Osiągnięto maksymalną szerokość umywalki. Dostępne są następujące możliwości, aby kontynuować:",
    "CutoutPartDetail.name": "Nazwa",
    "CutoutPartDetail.dimensions": "Wymiary",
    "CutoutPartDetail.type": "Typ",
    "CutoutPartDetail.article": "Numer artykułu",
    "apronHeightAndDimensionsForTowelRailRequiredMessage.message": "Wskazówka: Aby zamocować wieszak na ręczniki, potrzebny jest fartuch o szerokości 150 mm. Ponieważ szerokość umywalki nie jest wystarczająca do montażu fartucha, należy zwiększyć szerokość umywalki. Chcą Państwo kontynuować?",
    "apronHeightAndDimensionsForTissueDispenserRequiredMessage.message": "Do umiejscowienia dozownika chusteczek kosmetycznych potrzebny jest fartuch 150 mm. Ponieważ szerokość umywalki jest niewystarczająca do umieszczenia fartucha, należy zwiększyć szerokość umywalki. Czy chcesz kontynuować?",
    "apronHeightAndDimensionsForCutOutDisposalRequiredMessage.message": "Do umiejscowienia otworu wrzutowego potrzebny jest fartuch 150 mm. Ponieważ szerokość umywalki jest niewystarczająca do umieszczenia fartucha, należy zwiększyć szerokość umywalki. Czy chcesz kontynuować?",
    "apronHeightForTowelRailRequiredMessage.message": "W przypadku wyboru wieszaka na ręczniki wymagany jest fartuch {requiredHeight}. Chcą Państwo kontynuować?",
    "apronHeightForTissueDispenserRequiredMessage.message": "W przypadku wyboru podajnika chusteczek kosmetycznych wymagany jest fartuch {requiredHeight}. Chcą Państwo kontynuować?",
    "apronHeightForCutOutDisposalRequiredMessage.message": "Aby wybrać otwór wrzutowy, potrzebny jest fartuch {requiredHeight} mm. Czy chcesz kontynuować?",
    "ListItem.archive": "Archiwizuj",
    "ConfigurationSwitchView.mine": "Moje konfiguracje",
    "FolderSwitchView.mine": "Moje konfiguracje",
    "ConfigurationSwitchView.connected": "Przypisane",
    "ConfigurationSwitchView.archived": "Zarchiwizowane",
    "Archive.headline": "Czy na pewno chcesz zarchiwizować tę konfigurację?",
    "Archive.button": "Akceptuj",
    "Unarchive.headline": "Czy na pewno chcesz przywrócić tę konfigurację?",
    "Unarchive.button": "Akceptuj",
    "ListItem.unarchive": "Przywróć",
    "WithNicheHint.hint": "Wskazówka:",
    "WithNicheMessage.message": "Wskazówka: Szerokość umywalki = wymiar gotowej wnęki minus 8 mm. Podczas konfiguracji należy odjąć 4 mm z każdej strony umywalki. Należy uwzględnić występy konstrukcyjne!",
    "checkboxPositions.tissueConflict": "System gospodarowania odpadami został zmieniony",
    "CutOutLabel.cosmetic": "Podajnik chusteczek kosmetycznych",
    "RegisterSucceededComponent.note": "Informacja",
    "RegisterSucceededComponent.noteText": "W wiadomości e-mail wysłaliśmy Ci link, po którego potwierdzeniu Twoje konto zostanie aktywowane.",
    "ConsolesOverlapChoice.message": "Konfiguracja nie jest możliwa, należy zwiększyć odstęp lub wybrać wspornik ze stali chromowo-niklowej.",
    "ConsolesOverlapChoice.continue": "Przywróć pierwotną wartość (ze wspornikiem z odlewu mineralnego)",
    "ConsolesOverlapChoice.return": "Przywróć pierwotną wartość (ze wspornikiem z odlewu mineralnego)",
    "ConsolesOverlapChoice.change": "Zmień na wspornik(i) ze stali chromowo-niklowej",
    "checkoutSave.orderIsFailed": "Zamówienie nie mogło zostać przesłane do systemu SAP. Zduplikuj konfigurację i spróbuj ponownie później.",
    "Warning.RequireReset.qty": "Liczba komór",
    "ConfigurationNewFormName.error": "Nazwa jest wymagana",
    "ConfigurationNewFormName.label": "Nazwa",
    "ConfigurationNewFormName.placeholder": "Nazwa",
    "ConfigurationNewFormPricingsAccessories.error": "Wymagane jest podanie okresu.",
    "ConfigurationNewFormPricingsAccessories.label": "Okres - akcesoria",
    "ConfigurationNewFormPricingsAccessories.placeholder": "Proszę wybrać",
    "ConfigurationNewFormPricingsWashbasin.error": "Wymagane jest podanie okresu.",
    "ConfigurationNewFormPricingsWashbasin.label": "Okres - umywalka",
    "ConfigurationNewFormPricingsWashbasin.placeholder": "Proszę wybrać",
    "checkoutParts.timePeriodNote": "Wskazówka:",
    "checkoutParts.timePeriodNoteText": "Proszę wybrać okres obowiązywania ceny",
    "checkoutParts.timePeriodAccessoriesLabel": "Okres - akcesoria",
    "checkoutParts.timePeriodWashbasinLabel": "Okres - umywalka",
    "checkoutSave.orderIsQueued": "Zamówienie nie mogło zostać przesłane do systemu SAP. Zostało ono umieszczone w kolejce do późniejszego przesłania.",
    "ListItemDetail.failed": "Nieudane",
    "ListItemDetail.queued": "W kolejce",
    "TroughFilterMedcare.error": "Wymagana jest linia MEDCARE.",
    "TroughFilterMedcare.label": "MEDCARE",
    "TroughListItemHeight.unavailable": "dostępność od sierpnia 2023",
    "MetaNavigationLegals.legalsLink": "https://kwc.com/pl_PL/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
    "ConfigurationCountry.running": "(skapad)",
    "Login.mustLogin": "För att starta en konfiguration måste du logga in. Om du ännu inte har ett konto kan du skapa ett nytt konto.",
    "Troughs.toStart": "För att starta en konfiguration måste du {logga in}. Om du ännu inte har något konto, {skapa}.",
    "TroughFilter.modelLine": "Linje",
    "TroughFilter.characteristics": "Egenskaper för linje",
    "TroughListItem.min": "min. Tvättställ",
    "TroughListItem.start": "Starta konfiguration",
    "TroughListItem.startWithLogin": "Starta konfigurationen efter inloggning",
    "TroughBanner.label": "Vilka skålar är tillgängliga?",
    "TroughBanner.text": "Ta en titt i förväg.",
    "SearchPlaceholder.placeholderTroughs": "Sök efter en skål",
    "Troughs.toStartLogin": "Logga in",
    "Troughs.toStartCreate": "Skapa ett nytt konto",
    "ConfigurationDownload3D.text": "Pobierz scenę 3D",
    "ConfigurationNewFolder.newHeading": "Nowy folder",
    "NewButtonsNewFolder.text": "Nowy folder",
    "NewButtonsNewConfiguration.text": "Utwórz konfigurację",
    "FolderListHeading.text": "Folder",
    "FolderListNone.text": "Foldery nie są jeszcze dostępne",
    "ConfigurationListHeading.text": "Nieprzypisane konfiguracje",
    "OpportunityNumber.number": "Opportunity number",
    "ListItemOpportunity.number": "Opportunity number",
    "BuildingNumber.number": "Building number",
    "ListItemBuilding.number": "Building number",
    "FolderListSeeAll.text": "Pokaż wszystkie foldery",
    "ListItem.moveToGroup": "Przenieś do folderu lub etapu budowy",
    "ListItem.goBack": "Powrót",
    "FolderSwitchView.goBack": "Powrót",
    "ListItem.downloadPdfs": "Pobieranie plików PDF",
    "ConfigurationDeleteFolder.cancel": "Anuluj",
    "ConfigurationEditFolder.cancel": "Anuluj",
    "ConfigurationNewFolder.cancel": "Anuluj",
    "ConfigurationNewFolder.create": "Utwórz",
    "ConnectedFolder.label": "Tak, chcę utworzyć nowy folder z nazwą obiektu w moim pulpicie nawigacyjnym.",
    "FolderListHeadingAll.text": "Wszystkie foldery",
    "FolderListToday.text": "Dzisiaj",
    "FolderList7Days.text": "Poprzednie 7 dni",
    "FolderList30Days.text": "Poprzednie 30 dni",
    "FolderListItemNestedDelete.text": "Usuń etap",
    "ConfigurationDeleteNestedFolder.heading": "Usuń etap",
    "ConfigurationNewFolderNested.newHeading": "Nowy etap",
    "ListItem.moveToThisGroup": "Przenieś do folderu",
    "ConfigurationDeleteFolder.note": "Uwaga:",
    "ConfigurationDeleteNestedFolder.body": "Jeśli usuniesz ten etap, zawarte w nim konfiguracje zostaną zachowane, zostaną po prostu przeniesione do folderu przechowywania.",
    "ConfigurationDeleteFolder.body": "Jeśli usuniesz ten etap, zawarte w nim konfiguracje zostaną zachowane, zostaną po prostu przeniesione do folderu przechowywania.",
    "FolderListNestedHeading.test": "Fazy budowy",
    "BuildingNumber.error": "Wymagany jest building number.",
    "OpportunityNumber.error": "Wymagany jest opportunity number.",
    "FolderListItemDelete.text": "Usuń folder",
    "ConfigurationDeleteFolder.heading": "Usuń folder",
    "ConfigurationDeleteFolder.confirm": "Potwierdzenie",
    "ConfigurationEditFolder.heading": "Edytuj folder",
    "ConfigurationEditFolderNested.heading": "Edycja fazy budowy",
    "ConfigurationEditFolder.confirm": "Potwierdzenie",
    "ConfigurationListNone.text": "Konfiguracje nie są jeszcze dostępne",
    "ListItemDetail.basin": "Umywalka",
    "ListItemDetail.number": "Koryta",
    "ListItem.moveToDashboard": "Przenieś na pulpit",
    "FolderList.SortByDate": "Sortuj według daty",
    "FolderList.SortByName": "Sortuj według nazwy",
    "FolderName.name": "Nazwa folderu",
    "TermsModal.heading": "Terms & Conditions",
    "TermsModal.market": "Which market do you belong to?",
    "TermsModal.language": "Please select from an available language:"
  }
};

export default translations;